/* eslint-disable prettier */
/* eslint-disable max-len */
/**
 * English resource file
 */

import {
	ArcTimeLineValidationTypes,
	ArcTimelineGroups,
	Entity,
	GAComponentDocumentStatus,
	GALinkStatus,
	GARoleTypeId,
	TaskListTypes,
	actionTypes,
	activityType,
	assignmentTypes,
	bulkAssignment,
	bulkAssignmentConstants,
	clientRequestNoteTab,
	confidentialityTypes,
	filters,
	financialStatementType,
	gaRecommendationType,
	gaScopes,
	groupSummaryTabs,
	independenceActionIds,
	instructionStatus,
	instructionType,
	ipFilterType,
	ipInputType,
	linkType,
	milestoneBuildTaskIds,
	notesFilter,
	reviewNoteRoutes,
	rnhFilterTypeQuery,
	rnhQuickFilter,
	snapshotComparisonIds,
	syncStatus,
	todoListTimeframeOptions,
	trialBalanceType,
	uiViews,
	receiveInstructionSwitcherIds
} from "../util/uiconstants";

export const labels = {

	//Review notes tile 2

	reviewNoteTileGraphHeader: 'Open review notes by due date',
	reviewNoteTileGraphHeaderAssignedToMe: 'Assigned open notes, by due date',
	reviewNoteTileGraphHeaderAuthoredByMe: 'Authored open notes, by due date',
	reviewNoteYAxisLabel: 'Review notes',
	overDueCatFirst: 'Overdue >90',
	overDueCatSecond: 'Overdue 31-90',
	overDueCatThird: 'Overdue 10-30',
	overDueCatFourth: 'Overdue <10',
	catFifth: '<10',
	catSixth: '10-30',
	catSeventh: '31-90',
	catEighth: '>90',
	noNotesAvailable: 'No notes available',

	//ReviewNoteTiles
	totalOpen: "Total open",
	totalCleared: "Total cleared",
	changeDueDate: "Change due date",
	reviewNoteHashValue: '#',

	//Rejected PSPs
	rejectedPSPsTitle: 'Rejected PSPs',
    noRejectedPSPs: 'No rejected PSPs',
    updateRejectedPSPs: 'Update rejected PSPs',

	//CRA Build Step 2 Labels
	inherentRiskTypeId: 'Inherent risk assessment',
	controlRiskTypeId: 'Control risk assessment',
	viewUnRelatedWCGWs: 'View unrelated WCGWs',
	unrelatedWCGWsInstruction: "The WCGWs listed below are not related to any assertions. They should be related to at least one assertion or deleted. To easily find these WCGWs in the 'Relate WCGWs to assertions' modal, select \'Unrelated WCGWs'\ from the SCOTs dropdown. If the WCGW is no longer relevant or needs to be edited, click the \'Identify WCGWs and controls'\ link on the underlying page to make those changes.",
	relatedWCGWsInstruction: "Relate WCGWs to the selected assertion. Select a SCOT to relate WCGWs from a specific SCOT, or select an option from All SCOTs. For a list of WCGWs that need to be related to an assertion, select \'Unrelated WCGWs'\.",
	allScots: " All SCOTs",
	allWCGWs: "All WCGWs",
	unRelatedWCGWs: " Unrelated WCGWs",
	//CRA Build Step 4 Header Label
	craValue: "CRA",
	incompleteCraValue: 'Incomplete CRA',
	// Panel Headers
	taskCategories: 'Task navigation',
	taskCategoryExecution: 'Execution',
	taskList: 'Task list',
	taskDetails: 'Task details',
	fullScreen: 'Fullscreen',
	exitFullScreen: 'Exit fullscreen',
	defaultDropdown: 'Dropdown Menu',
	status: 'Status',
	language: 'Language',
	channel: 'Channel',
	header: 'Header',
	headerName: 'Header name',
	sectionCustomLabelLabel: 'Custom Label',
	sectionNamePlaceHolder: 'Enter Section title',
	showRelatedObjectLabel: 'Show Related Objects',
	errorBanner: '{0} Error(s)',
	customize: 'Customize',
	customized: 'Customized',
	custom: 'Custom',
	description: 'Description',
	seeDescription: 'See description',
	section: 'Section',
	entities: 'Entities',
	edit: 'Edit',
	delete: 'Delete',
	collapse: 'Collapse',
	collapseAll: 'Collapse all',
	expand: 'Expand',
	expandAll: 'Expand all',
	incompleteResponse: 'Incomplete response',
	unresolvedComments: 'Unresolved comments',
	saving: 'Saving...',
	tasks: 'tasks',
	requests: 'requests',

	//BodyType Placeholder
	numericValuePlaceholder: 'Enter amount',

	//Modal
	addButton: 'Add button',
	evidence: 'Evidence',
	temporary: 'Temporary',
	temporaryFiles: 'Temporary files',
	priorPeriod: 'Prior period',
	externaldocuments: 'External documents',
	eydocuments: 'EY documents',
	clientRequestClientAnalytics: 'Analytic name',
	groupdocuments: 'Group documents',
	name: 'Name',
	reason: 'Reason',
	browse: 'browse',
	uploadFile: 'Upload files',
	uploadDocument: 'Upload Document',
	duplicateDocumentHeader: 'One or more documents with the same name already exist in this engagement (either as Evidence or Temporary files).',
	duplicateDocumentInstruction: 'Select ‘Overwrite’ to upload the document and replace the existing file or ‘Discard’ to cancel. If this existing file is in Evidence, then the document will be uploaded to Evidence. If the existing file is in Temporary files, then the document will be uploaded to Temporary files.',
	overwriteLabel: 'Overwrite',
	discardLabel: 'Discard',
	discardChangesLabel: 'Discard changes',
	note: 'Note',
	notes: 'Notes',
	signOffs: 'Sign-offs',
	related: 'Related',
	attributes: 'Attributes',
	approveChanges: 'Approve changes',
	nodocumentsAdded: 'No documents available',
	noEntitiesAvailable: 'No entities available',
	noDocumentsUpload: 'No documents are being uploaded',
	noSections: 'No sections available',
	noRequestMessage: 'There are no Requests or External Tasks in this engagement',
	noResultFound: 'No results found.',
	noRequestsFound: 'No requests found',
	noTimePhasesFound: 'No time phases available',
	noEntitiesFound: 'No results.',
	relatedEntities: 'Related entities',
	noClickableRelatedEntities: 'Related entities cannot be edited for this task',
	taskByEntityLabel: 'Tasks by entity',
	relEntityLabel: 'Entity',
	singleEntity: '{0} entity',
	multipleEntity: '{0} entities',
	engagementDeliveryLabel: 'Tasks by engagement',
	onlyShowRelEntities: 'Show only related entities',
	engDeliveryDescription: 'This task is associated to all entities in the engagement.',
	relEntitiesDescription: 'View entities related to the task. Related entities can only be edited for OSP and OST tasks.',
	relEntitiesPSTorPSPDesc: 'View entities related to the task. Related entities cannot be edited for PST and PSP tasks.',
	warningRelMsg: 'Task must be related to one or more entities. To make the task engagement-wide, change the Task by entity toggle.',
	reldetailDescription: 'By default, OSP and OST tasks are engagement-wide and related to all entities. Tasks can be related to one or more entities by enabling Tasks by entity.',
	results: 'results',
	searchPlaceholder: 'Search',
	searchDocPlaceholder: 'Search document',
	searchCanvasForms: 'Search Canvas forms',
	searchControlForms: 'Search SCOTs',
	canvasFormListDescription: 'Select a Canvas Form from the list below to view related Canvas Form reports.',
	controlFormListDescription: 'Select a SCOT to see its related control forms.',
	object: 'Object',
	relateCollaboration: 'Relate Collaboration',
	reviewNote: 'Review notes',
	reviewNoteSingle: 'Review note',
	documentReviewNotes: 'Document notes',
	noEvidenceFilesAssociated: 'There are no evidence files associated to this task',
	taskReviewNoteWithParenthesess: 'Task note(s)',
	taskNotes: 'Task notes',
	documentsNotes: 'Document notes',
	addNewDocumentNote: 'Add document note',
	selectDocument: 'Select a document',
	taskReviewNotes: 'Task note',
	showCleared: 'Show cleared',
	Replied: 'Replied:',
	showClosed: 'Show closed',
	allNotes: 'All notes',
	myNotes: 'My notes',
	noTasksAvailable: 'No available tasks',
	noWCGWAvailableForTask: 'No ROMM available',
	noSubstantiveTasksAvailable: 'No related substantive tasks',
	noNotesAssociatedWithDocument: 'There are no notes associated to this document',
	noNotesAssociatedWithTak: 'There are no notes associated to this task',
	otherEngagementNotes: 'Other engagement notes',
	to: 'to',
	deleteReviewNote: 'Delete',
	missingToUserError: 'Required',
	missingReviewNoteTextError: 'Review note text is required',
	invalidReviewNoteTextError: 'Text entered exceeds the limit',
	dueDateRequiredTextError: 'Due date is required',
	saveNoteTextError: 'Save or Cancel in order to proceed',
	engagementName: 'Engagement name:',
	assignmentsCountLabel: 'Assignments',
	AssignmentsDays: 'Days',
	closedOnTime: 'Closed on time',
	daysToPrepare: 'Days to prepare',
	daysToReview: 'Days to review',
	totalAssignments: 'Total <br>assignments',
	currentlyAssigned: 'Currently <br>assigned',
	UpcomingAssignments: 'Upcoming',
	authoredByMe: 'Authored by me',
	commentsLabel: 'Review notes',
	clearedOnTime: 'Cleared on time',
	daysToClear: 'Days to clear',
	daysToClose: 'Days to close',
	totalLabel: 'Total notes',

	criticalAndHighRn: 'Critical and high notes',
	criticalAndHighComments: 'Critical and high notes',
	lowAndMediumComments: 'Medium and low notes',
	metricsInstructionalText: 'View performance metrics for your assignments and notes below. <br>Select a team member to see their metrics or choose <b>Engagement view</b> to see an overall summary.',
	metricsNewInstructionalText: 'Select a team member to see their review notes and assignments or choose <b>Engagement view</b> to see an overall summary.',
	switchToViewPlaceholder: 'There is no data to display.<br>Select another team member or switch to the <b>Engagement view.</b>',
	tasksClosedOnTime: 'Tasks closed on time',
	daysDetailReview: 'Days to detail review',
	daysGeneralReview: 'Days to general review',
	totalDaysReview: 'Total days to review',
	metricsInstructionalTextconfiguration: 'View an overall summary of performance metrics for assignments and notes below.',

	//document download
	docSizeMB: 'MB',
	docSizeKB: 'KB',
	labelForExpiredPackage: 'Package is expired.',
	headerForDocumentDownload: 'Click on the filename to download',
	labelForNoFiles: 'There were no files in the selected categories.',
	labelForProcessing: 'Files are being processed.',

	//create dropdown texts
	create: 'Create',
	addRequestText: 'Request',
	addExternalTaskText: 'External task',
	addFindingText: 'Finding',
	show: 'Show: ',
	riskTypeHeader: 'Risk Type',
	wcgwHeader: 'WCGW',
	hasNotes: 'open notes',
	hasNote: 'open note',
	noNotes: '(0 open notes)',
	addTemporaryFiles: 'Add temporary files',
	addPriorPeriodEvidence: 'Add prior period',
	addExternalDocuments: 'Add external documents',
	//Nav
	navHeaderTasks: 'Tasks',
	quickFilterAllCompletedTasks: 'All completed tasks',
	quickFilterMyCompletedAssignmnets: 'My completed assignments',
	quickFilterMyUpcomingAssignments: 'My upcoming assignments',
	navHeaderTaskCategory: 'Task categories',
	navFilterBy: 'Filter options',
	navHeaderDocuments: 'Documents',
	navHeaderCollaboration: 'Collaboration',
	navHeaderAssignments: 'Assignments',
	navHeaderAutomation: 'Automation',
	navHeaderMore: 'More',
	navDashboard: "Dashboard",
	navReviewnotes: 'Review notes',
	navHeaderManageteam: 'Manage team',
	navHeaderMangeteamNew: 'Manage team - New',
	mangeteam: 'Manage team',
	postArchive: 'Post archive',
	addmember: 'Add member',
	addnewmember: 'Add new member',
	addPriorPeriodMembers: 'Add inactive members',
	addPriorPeriodUsers: 'Add inactive members',
	createPackage: 'Create package',
	engagementrole: 'Engagement role',
	noPendingPriorPeriodUsers: 'No inactive members to invite',
	sendPriorPeriodUserInvitesWithCount: 'Send ({0}) invites',
	sendPriorPeriodUserInvitesWithoutCount: 'Send invites',
	priorPeriodMembersModalHeaderMessage: 'Select the inactive members that you would like to add to your engagement. Members will be granted permissions they previously had within the engagement upon reactivation.',
	priorPeriodIndependenceModalHeaderMessage: 'Select the inactive independence only members that you would like to add to your engagement.',
	disabledPriorPeriodMembersButtonToolTip: 'Insufficient rights to add prior members.  Speak with an engagement team member with the appropriate rights to take this action.',
	disabledNewMembersButtonToolTip: 'Insufficient rights to add new members. Speak with an engagement team member with the appropriate rights to take this action.',
	disabledNewMembersButtonToolTipThirdpartyuser: 'Insufficient rights to add new third party members. Speak with an engagement team member with the appropriate rights to take this action.',
	rbacNoRightsForContentUpdateToolTip: 'Insufficient permissions to perform content update. Contact your engagement administrator and request permission to initiate a content update.',
	deactivateInternalUsersWithCount: '{0} members selected',
	canvasFormSelectionMessageSingular: '{0} Canvas form selected',
	canvasFormSelectionMessagePlural: '{0} Canvas forms selected',
	pspAccountSelectionMessageSingular: '{0} Account selected',
	pspAccountSelectionMessagePlural: '{0} Accounts selected',
	manageTeamGroupLabel: ' group',
	manageTeamGroupsLabel: ' groups',
	allAccessGroups: 'all access groups',
	reactivate: 'Reactivate',
	deactivate: 'Deactivate',
	unselect: 'Deselect all',
	deactivateInternalModalTitle: 'Deactivate internal members',
	deactivateInternalModalMessage: 'Are you sure that you want to deactivate the following team members?',
	deactivateInternalUsersSuccessMessage: '{0} Members have been successfully deactivated.',
	deactivateExternalModalTitle: 'Deactivate external members',
	deactivateExternalModalMessage: 'Are you sure that you want to deactivate the following team members from {0}? Items assigned will be reassigned to the respective access groups.',
	deactivateExternalSuccessMessage: 'Members have been successfully deactivated.',
	internalMember: 'Internal members',
	addinternalmember: 'Add internal member',
	addThirdPartymember: 'Add third-party member',
	missingResponsiblePerson: 'Missing responsible person',
	sentRequests: 'Sent',
	receivedRequests: 'Received',
	syncProfileNotAllowed: 'Sync profile not permitted',
	allSyncProfileNotAllowedMessage: 'Sync profile is not permitted. Form not available for this profile.',
	allCanvasFormsContentUpdateMessage: 'Content cannot be delivered for EY Canvas FIT enablement activities that are shared. Please unlink those activities to continue content updates.',
	someFormContentUpdateMessage: 'Some of the forms cannot be synced to engagement profile as there is no content',
	linkedFormContentUpdateMessage: 'Content will not be delivered for the EY Canvas FIT enablement activities that are shared. To update content for them, please unlink those activities.',
	leaveUsFeedback: 'Leave us feedback',

	notApplicableLabel: 'N/A',
	addThirdPartyMemberDescription: "This functionality should only be used to grant third-party reviewers access to this EY Canvas engagement. Appropriate approvals and authorization should be acquired from Professional Practice.",
	hasOverallResponsibilityDescription: "A member of the audit or engagement team who takes overall responsibility for the direction, supervision and performance of the audit or engagement and for the report and/or interoffice conclusion being appropriate in the circumstances.",
	partnerInChargeHeader: "Partner in charge / Executive in charge",
	picFlag: "PIC",
	CannotUpdatePicInArchivedEngagement: 'Cannot process edits to restricted fields. Refresh and try again.',

	noGroupFound: 'No access groups have been created in this engagement. Select \'Add access group\' to create a new external team member access group.',
	addGroup: 'Add group',
	deleteGroup: 'Delete access group',
	deleteGroupMessage: 'Are you sure that you want to delete the {0} access group?',
	addAccessGroup: 'Add access group',
	accessGroupCreated: 'New access group {0} has been created successfully.',
	accessGroupUpdated: 'Changes to access group {0} have been successfully saved.',
	editAccessGroup: 'Edit access group',
	sharedGroupwarning: 'This is a shared access group and changes to this will be reflected for all associated engagements.',
	groups: 'Groups',
	addExternalMembers: 'All external members',
	members: 'Members',
	externalMember: 'External members',
	member: 'Member',
	role: 'Role',
	actions: 'Actions',
	internalUserEdit: 'Edit',
	internalUserDeactivate: 'Deactivate',
	usersFilter: 'Filter',
	externalUserEdit: 'Edit',
	externalUserDeactivate: 'Deactivate',
	externalUserGroupLabel: 'groups',
	externalNoUserInGroup: 'No members have been added to this access group.',
	externalNoUserInAllGroup: 'No members have been added to this engagement.',
	alias: 'Alias',
	independence: 'Independence',
	navManagegroup: 'Manage group',
	navCRAsummary: 'CRA summary',
	navAuditplan: 'Audit plan',
	navWorkplan: 'Work plan',
	navSEM: 'Substantive evaluation matrix',
	nav440GL: 'Changes after report date',
	navFindings: 'Findings',
	navCanvasformupdates: 'Canvas form updates',
	navPSPContentUpdates: 'PSP content updates',
	navCopyhubNew: 'Copy hub - NEW',
	navCopyhub: 'Copy hub',
	navArchiveChecklist: 'Archive checklist',
	navExporthub: 'Export hub',
	navReporting: 'Reporting',
	navAccountSummary: 'Account summary',
	navScotSummary: 'SCOT summary',
	navItSummary: 'IT summary',
	navGroupInstructionSummary: 'Group instructions',
	navGroupInvolvement: 'Group involvement',
	navHelixProjects: 'EY Helix connections',
	navContentUpdates: 'Content update',
	contentUpdateErrorMsg: 'You do not have permissions to save changes. Reach out to other team members with these permissions to make changes.',
	contentUpdateTitleTip: 'Insufficient permissions to perform content update. Contact your engagement administrator and request permission to initiate a content update.',
	noPreviousUpdates: 'No previous updates',
	noContentUpdateResults: 'No results found',
	noPSPAccountsToUpdate: 'No accounts to be updated',
	rbcaUnavailableMsg: 'EY Canvas could not save changes at this time. Try again and if the issue persists, contact the Help Desk',
	showErrInProgressMsg: '29007 - Content updates cannot be started while other updates are in progress. Wait until the current content update completes, or refresh the page and try again.',
	navHelp: 'General help',
	validationNavHelp: 'Validation help',
	searchUserText: 'Search user',
	superModelTitle: 'Engagement objects',
	superModelText: 'Super modal',
	independenceOnlyMembers: 'Independence only members',
	noIndependenceOnlyPriorPeriodUsers: 'No inactive independence only members to invite',

	//Copyright
	copyRight: 'Copyright © <year> all rights reserved',

	//Copyhub List labels
	moreRecipient: 'more',
	copyHubPackageName: 'Package name',
	copyHubSentBy: 'Sent by',
	copyHubSentTo: 'Sent to',
	copyHubReceivedBy: 'Received by',
	copyHubDate: 'Date',
	copyHubRemainingTime: 'Remaining time',
	copyHubAvailableFor: 'Available for',
	copyHubStatus: 'Status',
	noCopyHubSentPackages: 'No copy packages have been created yet. Select Create package to create a new data package.',
	noCopyHubReceivedPackages: 'No copy packages are available for this engagement',
	remainingTimeTooltip: 'Items will be permanently removed at the time of archive, or 10 days after creation',
	copyHubDeleteText: 'Delete',
	appendDays: ' days',
	generalInformation: 'General Information',
	copyDocuments: 'Documents',
	copyFiles: 'Files',
	scots: 'SCOTs',
	accounts: 'Accounts',
	copyHubImport: 'Import',
	copyHubPackageType: 'Package type: ',
	copyHubCreatedModal: 'Created: ',
	copyHubRemainingTimeModal: 'Remaining time: ',
	copyHubAvailableForModal: 'Available for: ',
	copyHubInstructionModal: 'Instructions: ',
	copyHubCategories: 'Categories',
	copyHubPendingDeletion: 'Pending Deletion',
	copyHubVersionMismatchCat: 'Cannot show categories due to package version mismatch',
	copyHubVersionMismatchPersonInfo: 'Cannot show sender and receiver information due to package version mismatch',
	copyHubViewLegacyPacakgeDetails: 'This is legacy copy package for which detailed information is unavailable',
	associateTasks: 'Associate tasks',
	backToForms: 'Back to forms',
	noTaskSelected: 'At least one task has to be selected',
	taskLabel: 'Task : ',
	taskMessage: ' You need to associate Task with these import forms.',
	importSuccessMessage: 'Import request queued successfully',
	taskSelectedText: 'Tasks selected',
	insufficientPermissionsToImport: 'Insufficient permissions to import copy package. Contact your engagement administrator and request permission to import copy package.',
	cannotImportExpiredPackage: 'Cannot import expired copy package.',
	cannotImportWhileInProgress: 'Cannot import copy package that is already in progress.',
	deletePackageHeader: 'Delete package',
	copyPackageDeleted: 'The package has been deleted',
	copyPackageDeleteConfirmation: 'Are you sure you want to delete this package?',
	insufficientPermissionsToDelete: 'Insufficient permissions to delete copy package. Contact your engagement administrator and request permission to delete copy package.',
	insufficientPermissions: 'Insufficient permissions',
	GuidedWorkflowsPackageDisplayText: 'Selecting import will update matching Guided workflows from the copy to this engagement. Guided workflows without a match will not be imported.',
	copyRequestStatusInQueue: 'In queue',
	GuidedWorkflowImportError: 'Guided workflows import is not available for multi-entity engagements',

	//TopHeaderLayout.js
	topHeaderLayoutMilestoneText: 'Mile Stone Agree or reconcile the financial information with the underlying accounting records Obtain evidence that the interim financial information agrees or reconciles with the underlying accounting records. ',
	//TaskLayoutHeader
	taskLayoutHeaderSearchPlaceholder: 'Search tasks',
	taskLayoutHeaderAssignments: 'Assignments',
	taskLayoutHeaderAddTask: 'New task',
	wcgwSearchPlaceholder: 'Search WCGW',
	//TaskListHeader
	taskTypeHeader: 'Type',
	taskNameHeader: 'Name',
	taskDueDateHeader: 'Due date',
	reviewNoteChangeDueDate: 'Change due date',
	taskListHeaderSortByDueDate: 'Due date',
	taskListHeaderSortByTaskName: 'Task name',
	sortBy: 'Sort by:',
	ascending: 'Ascending',
	descending: 'Descending',
	taskListHeaderSortByKnowledge: 'Audit plan',
	taskListHeaderDeleteWarning: 'Are you sure want to delete selected tasks.',
	taskListHeaderSortText: 'Sort',
	taskListHeaderSortOrderText: 'Sort Order',
	taskListHeaderTimePhaseText: 'Set time phase',
	taskListHeaderBookMarkText: 'Bookmark',
	taskListHeaderFavoriteText: 'Favorite',
	taskListHeaderEditText: 'Edit task title',
	moreMenu: 'More',
	taskListHeaderMoveTaskText: 'Change task group',
	taskGroupIconHoverText: 'Change task group',
	taskGroupLabel: 'Change group',
	task: 'Task',
	toc: 'TOC',
	tenNotes: '10 Notes',
	source: 'Source',
	nature: 'Nature',
	assertion: 'Assertions',
	relatedAccounts: 'Related accounts',
	testOfDetail: 'Test of details',
	testOfControl: 'Test of control',
	substantiveAnalyticalProcedure: 'Substantive analytical procedure',
	tod: 'TOD',
	sap: 'SAP',
	int: 'INT',
	ext: 'EXT',
	notSel: 'NOT SELECTED',
	internal: 'Internal',
	external: 'External',
	notSelected: 'Not Selected',
	documentCannotOpen: 'This document cannot be opened from Task Details. Navigate to the Documents List to open this document.',
	//TaskPanelLayout
	emptyTaskDetailsMessage: 'Select a task to view details.',
	multiTaskSelectedMessage: 'To enable bulk controls, use the control key and select multiple tasks. \n If you would like to work on an individual task, select that task from the task list.',
	emptyAndMultiSelectedMessage: 'To enable bulk controls, use the checkbox to select one or more tasks. Use the shift key to select several tasks at once. If you would like to work on an individual task, then select that task from the list.',
	//Evidence
	evidenceDragAndDrop: 'Drag and drop or',
	//Timephases
	noResultTimePhase: 'No results found.',
	//handoff
	handoff: 'Hand-off',
	handoffConfirmButtonText: 'Hand-off',
	handoffModalTitle: 'Hand-off task',
	handoffTitle: 'Hand-off to the next team member',
	handoffTextLine2: 'To sign-off on an evidence file, select from the options below.',
	return: 'Return',
	returnDisabledMessage: 'This task cannot be returned because: (1) you are the assigned preparer, (2) the task status is not “In review” or “Complete”, or (3) there is no preparer assigned.',
	handOffTitleTip: 'Hand-off for review',
	//Mark Complete
	markCompleteTitleTip: 'Mark complete',
	markCompleteTitle: 'Mark task complete',
	markCompleteText: 'Your sign-off will be applied to the evidence associated to this task as indicated below. This task will be marked complete.',
	markCompleteTextLine1: 'Hand-off this task to the next team member.',
	markCompleteTextLine2: 'To sign-off on an evidence file, select from the options below. If you have an assignment for this task and have completed it, select <b>Yes</b> to close it. If this task requires PIC or EQR sign-off, select from the options below.',
	markCompleteConfirm: 'Mark complete',
	signOffAs: 'Sign-off on all as:',
	additionalSignOff: 'Additional required sign-offs',
	additionalTaskStatus: 'Close my assignment',
	markCompleteModalHeaderTextPart1: 'This task will be marked complete.',
	markCompleteModalHeaderTextPart2: 'To sign-off on an evidence file, select from the options below. If you have an assignment for this task and have completed it, select <b>Yes</b> to close it. If this task requires PIC or EQR sign-off, select from the options below.',
	ep: 'PIC',
	eqr: 'EQR',
	closeMyAssignment: 'Close my assignment',
	tempMarkCompleteMessage: 'Task cannot be marked complete. Refresh the page and try again. If the issue persists contact the Help Desk.',
	tempMarkCompleteEnable: 'Mark Complete-enable',
	tempMarkCompleteDisable: 'Mark Complete-disable',
	//TaskDetails
	seeTask: 'See tasks',
	NoTasksFound: 'No tasks found',
	taskDetailsAddRelate: 'Add/Relate',
	taskDetailsDocument: 'Document',
	taskDetailsAutomationRequest: 'Automation request',
	taskDetailsExternalTask: 'External task',
	taskDetailsFinding: 'Finding',
	taskDetailsRequest: 'Request',
	taskDetailsNotes: 'Notes',
	taskDetailsRelatedTask: 'Related task',
	epeqr: 'PIC/EQR',
	epeqrsignoffheader: 'Sign-off required',
	addTaskGroupLabel: 'Add task group',
	itgcTaskDescription: 'Perform our designed tests of ITGCs to obtain sufficient appropriate audit evidence of their operating effectiveness throughout the period of reliance.',
	//create assignment
	createassignmentheaderLine1: 'The selected team member does not have an assignment for this task.',
	createassignmentheaderLine2: 'Create an assignment here. If another team member already has an incomplete assignment of the same type,',
	createassignmentheaderLine3: 'select ',
	createassignmentheaderLine4: ' to replace it with this assignment.',
	overwriteIncompleAssignments: 'Overwrite incomplete assignments',
	//Create Assignment
	createassignmentheader1: 'The selected team member does not have an assignment for this task.',
	createassignmentheader2: 'Create an assignment here.',
	//Guidance
	atlasLink: 'Atlas link',
	automationLink: 'Smart Automation link',
	otherLink: 'Other link',
	helixLink: 'Helix link',
	relatedAutomations: 'Related automations',
	noSuggestedAutomationLabel: 'There are no suggested automations for this task.',
	noSuggestedItemLabel: 'There are no suggested items for this task.',
	noAutomationRequestLabel: 'This task is not related to any automations. To get started, create a new automation or relate an existing automation.',
	relateAutomation: 'Relate',
	relateAutomationModelHeader: 'Relate Smart Automations',
	automationSolution: 'Solution',
	automationName: 'Automation name',
	relateAutomationTextLine1: 'Relate a Smart Automation to this task.',
	relateAutomationTextLine2: 'Once related, you can view the automation from task details and click to open it.',
	noSamrtAutomationForEngagement: 'No Smart Automations have been created for your engagement.',
	searchAutomationLabel: 'Search automations',

	//RelatedItemHeader
	relatedItemsHeader: 'Related items',
	relateButtonText: 'Relate',
	createButtonText: 'Create',
	relatedItemREQ: 'Request',
	relatedItemET: 'External task',
	relatedItemATM: 'Automation',
	relatedItemRelatedTask: 'Related task', //ex. PST
	relateObjectsToTaskTitle: 'Relate objects to this task',
	relateObjectsToTaskSubTitle: 'Relate one or more objects to this task. These objects will appear in the Related items section of task details.',
	relateObjectOptionsHeaderPSPOSP: 'Accounts, assertions, and limited risk accounts',
	relateObjectOptionsHeaderITWalkthrough: 'IT processes',
	relateObjectOptionsHeaderITControl: 'IT controls (ITGCs and ITSPs)',
	// SDM Nextwave services
	scheduledServicesText: 'Related services',
	suggestedServicesText: 'Suggested services',
	suggestedServicesDefaultMessage: 'There are suggested NextWave services for this task. Click the',
	suggestedServicesDefaultMessage1: '+',
	suggestedServicesDefaultMessage2: ' icon to get started.',
	suggestedServicesPlaceholderMessage: 'There are no suggested services for this task.',
	nextWaveServiceOfferingLabel: 'Service',
	nextWaveServiceStatusLabel: 'Status',
	nextWaveServiceStartDateLabel: 'Start',
	nextWaveServiceDueDateLabel: 'Due',
	nextWaveServiceRequestCreate: 'Create request',
	nextWaveServiceRequests: 'Centralized service requests',
	nextWaveServiceGatewayRequests: 'Service Gateway requests',
	onlyShowSelectedTask: 'Only show selected task',
	sdmRestrictAddTaskLabel: 'Click continue to proceed to the next step. Task selection can occur after the service offering has been accepted and the GDS process based team manager reaches out to discuss the work to be completed.',
	//Links
	linksText: 'Links',
	//Forms
	formsText: 'Forms',
	/*Accounts*/
	associatedTasks: 'Tasks associated to WCGW item',
	noAssertionsChecked: 'Select an assertion to view related WCGW',
	noAccountsCreated: 'No accounts created',
	noDesignationSelected: 'No designation selected',
	noRelatedAccounts: 'No related accounts',
	manageAccount: 'Manage accounts and disclosures',
	/*Risks*/
	risk: 'Risk',
	risks: 'Risks',
	wcgw: 'WCGW',
	riskWcgw: 'Risk: WCGW',
	wcgwTasks: 'WCGW: Task',
	riskWcgwLabel: 'Relate risks to WCGWs',
	wcgwTasksLabel: 'Relate WCGW to Task',
	noRiskTypes: 'No Risk types found',
	saveRisk: 'Save',
	noRisksFound: 'No risks found',
	haveBeenIdentified: 'have been identified',
	noAssertionFound: 'No related assertions applicable to this engagement',
	noAssertionApplicable: 'No Assertions applicable to this engagement have been associated',
	noWCGWFound: 'There are no WCGWs related to this risk. Click on Edit Associations to relate one or more WCGWs.',
	noRelatedWCGWs: 'No related WCGWs',
	noRelatedControls: "No related controls",
	noRelatedRisks: "No related IT risks",
	noRelatedITGCs: "No related ITGCs",
	iTriskVal: 'IT risk',
	iTrisksVal: 'IT risks',
	iTGCVal: 'ITGC',
	iTGCsVal: 'ITGCs',
	iTSPVal: 'ITSP',
	iTSPsVal: 'ITSPs',
	iTGCname: 'ITGC name',
	iTSPname: 'ITSP name',
	noWCGWAvailable: 'No ROMM available for the selected assertion(s)',
	relevantWcgwCountHint: 'The count displayed beside the account name should be read as the number of WCGWs related to assertions with a control risk assessment of not rely or assertions related to higher risk estimates, which have been associated to a substantive procedure, compared to the total number of these WCGWs.',
	noAccountsFound: 'No records found',
	selectAssertionToRelateWCGW: 'Select Assertion to relate Risk to WCGW',
	significantAccounts: 'Significant Accounts',
	riskName: 'Risk: ',
	accountName: 'Account: ',
	noScotsFound: 'No related Scots',
	relatedwcgw: 'Related WCGWs',
	relatedRisks: 'Related risks',
	noRelatedAssertionsLabel: 'No assertions selected for the account',
	boltIconTitle: 'Related Risk',
	instructions: 'Instructions',
	expandRisk: '1. Expand a risk',
	selectAssertion: '2. Select an assertion',
	identifyRelatedWCGW: '3. Identify WCGWs related to the risk',
	clickAccount: '1. Click on an account',
	selectWCGW: '2. Select a WCGW',
	identifyRelatedTask: '3. Identify the tasks that respond to the WCGW',
	information: 'Information',
	requiredAssertions: 'Required assertions',
	wcgwWithoutTasks: 'WCGW without tasks',
	found: 'found',
	editAssociations: 'Edit Associations',
	riskWCGW: 'Risk:WCGW relationship',
	wcgwTask: 'WCGW:Task relationship',
	requireTaskToBeRelated: 'Require a task to be related',
	expandCollapse: 'Click here to expand/collapse',
	requiredAssertionsInfo: 'Show only assertions with a control risk assessment of not rely and assertions related to higher risk estimates',
	wCGWwithoutTasksInfo: 'Show only WCGWs related to an assertion with a control risk assessment of not rely and assertions related to higher risk estimates, that do not have any responsive substantive tasks associated',
	noBuildStepsAvailable: 'No build steps available to be presented.',
	accountRiskAssessmentSummary: 'Accounts and disclosures',
	manageRisk: 'Manage risks',
	addResponsivePSPOSP: 'Add responsive PSP/OSP',
	assertionlbl: 'Assertion',
	addResponsiveControl: 'Add responsive control',
	addResponsiveTOC: 'Add responsive TOC',
	showOnlyRelatedItems: 'Show only related',
	relatedControlCounter: '{0} control',
	relatedControlsCounter: '{0} controls',
	noControlsAvailableForRelateItem: 'No controls available',
	relateControlName: 'Controls',
	relateContolsAPIErrorMessage: 'Control cannot be related to the assertion.  Refresh the page and try again. If the issue persists contact the Help Desk.',
	relateTasksAPIErrorMessage: 'Task cannot be related to the assertion.  Refresh the page and try again. If the issue persists contact the Help Desk.',
	toggleFilterWarningMessage: 'Show only accounts and disclosures without any substantive procedures ',
	toggleFilterWarningMessageForRisk: 'Show only risks without any responsive substantive procedures or controls/TOCs ',
	warningIconHoverText: 'Risk without any responsive substantive procedures or controls/TOCs',
	filterYes: 'Yes',
	filterNo: 'No',

	/*OrphanedControls*/
	orphanedControls: 'View unrelated controls',
	unRelatedOrphanControls: 'Unrelated controls',
	noOrphanedControlsDataLabel: "No unrelated controls available",
	noOrphanedControlsResultLabel: "No unrelated controls available",
	noControlSelected: 'At least one control must be selected for deletion.',
	controlsDeleteConformation: 'Are you sure that you want to delete the selected controls?',
	controlDeleteConformation: 'Are you sure that you want to delete the selected control?',
	deleteControlModalHeader: 'Confirm deletion of selected control',
	deleteControlsModalHeader: 'Confirm deletion of selected controls',

	/*SEM*/
	select: 'Select',
	selectAnAccountFromTheDropDown: '1. Select an account from the drop-down',
	applyAsertionsFilters: '2. Apply assertion filters',
	reviewTheTasksThatRespondToTheRisks: '3. Review the task(s) that respond to the risk(s)',
	riskOfMaterialMisstatement: 'Risks of material misstatement',
	expandScot: '1. Expand a SCOT',
	selectWCGWToDisplayTheResponsiveTask: '2. Select the risk of material misstatement to display the responsive tasks',
	tasksWithNoRelatedWCGW: 'Tasks with no related risks of material misstatement',
	selected: 'selected',
	clearSelections: 'Deselect all',
	romm: 'ROMM',
	selectAccount: 'Account',
	selectHeader: 'Select Header',
	riskOfMaterialMisstatementsWithoutRelatedTask: 'Risks of material misstatement without related tasks',
	selectOneOrMoreTasksToSeeTheRelatedROMM: 'Select one or more tasks to see the related ROMM',
	invalidRelatedEntity: 'Related account cannot be found. Refresh the page and try again. Contact the Help Desk if the issue persists.',
	scrollUp: 'Scroll up',
	scrollDown: 'Scroll down',
	duplicate: 'Duplicate',
	showIndex: 'Show index',
	noContentAvailable: 'No content available',
	navigateTo: 'Navigate to',
	/*validations */
	semValidation: 'SEM Validation',
	riskWCGWValidation: 'Risk WCGW Validation',
	showValidation: 'Validations',
	wcgwWithNoRelatedTask: 'WCGW with no related substantive task',
	riskWithNoRelatedWCGW: 'Risk with no related WCGW',
	noValidationIdentified: 'No validations identified',
	onlyShowScotWithNoControlNoWCGW: 'Show only SCOTs without related WCGW or control',
	/*CRA Badge*/
	ir: 'IR',
	cr: 'CR',
	cra: 'CRA',
	selectToEdit: 'Select to edit',
	both: 'Both',
	prefix: 'Prefix',
	suffix: 'Suffix',
	optional: '(optional)',
	title: 'Title',
	charLimitExceeded: 'Character limit is exceeded',
	requiredField: 'Required field',
	Lastmodifiedby: 'Last modified by',
	fileSize: " | {1} KB",
	fileSizeInKB: "{1} KB",
	fileSizeHeader: "File Size",
	daysAgo: 'days ago',
	weekAgo: 'week ago',
	weeksAgo: 'weeks ago',
	monthAgo: 'month ago',
	monthsAgo: 'months ago',
	yearAgo: 'year ago',
	yearsAgo: 'years ago',
	currentlyBeingModifiedBy: 'Currently being modified by',
	beingEditedInCoeditModeError: 'Being edited in multi-user edit',
	beingEditedInCoeditMode: 'Being edited in multi-user edit. Edit started by {0} ',
	beingEditedInCoeditModeOn: 'on {0}.',
 	coEditModeAutomaticallyEnds: 'Multi-user editing. {0} days until multi-user editing automatically ends.',
	coEditModeIsEnding: 'Multi-user editing is ending',
	coEditMode: 'Multi-user editing',
	checkInInProgressMessage: 'Check-in in progress. It may take up to 20 minutes for the document to be checked in. Please refresh for updates',
	checkOutInProgressMessage: 'Check-out in progress. It may take up to 20 minutes for the document to be checked out. Please refresh for updates',
	daasErrorMessage: 'Operation cannot be complete at this time. Refresh the page and try again. If the issue persists contact the Help Desk',
	coEditModeIsStarting: 'Multi-user editing is starting',
	daasOpenDocumentWarning: 'Multi-user editing may have been ended by another user. Refresh the page and try again.',
	daasStartCollaborationModeWarning: 'Collaboration mode may have been started by another user. Refresh the page and try again.',
	documentCurrentlyBeingModifiedTitle: 'Document currently being modified',
	documentCurrentlyBeingModifiedHeader: 'This document is currently being modified by {0}. This user opened the document',
	documentCurrentlyBeingModifiedBody: 'Starting multi-user edit mode could cause conflicts, so we recommend discussing with {0} before proceeding. Select {1} to start the multi-user edit mode or {2} to return without starting multi-user edit mode.',
	documentEndMultiUserEditingTitle: 'Confirm you want to end multi-user editing',
	documentEndMultiUserEditingHeader: 'Warning: Other users may be actively editing this document.  This can be checked by opening the document and seeing if other users are currently in the file. Please confirm that all changes are complete before ending multi-user mode. File changes in multi-user mode may take up to 1 minute to be processed. Therefore, please wait at least 1 minute after exiting the file before ending multi-user mode.',
	documentEndMultiUserEditingBody: 'Select {0} to end the multi-user edit mode or {1} to return without ending multi-user edit mode.',
	startMultiuserEditing: 'Start',
	continue: 'Continue',
	openReadOnly: 'Open read-only',
	takeControlFromTeam: 'Take control from current team member',
	itapplication: 'IT application',
	aggregateITevaluation: 'Aggregate IT evaluation:',
	control: 'Control',
	itgcitsp: 'ITGC/ITSP',
	limitedRisk: 'Limited risk account',
	so: 'SO',
	itApp: 'IT App',
	itAppType: 'IT app',
	deleteTaskModalHeader: 'Confirm deletion of selected task',
	deleteTasksModalHeader: 'Confirm deletion of selected tasks',
	deleteTaskModalMessage: 'Are you sure that you want to delete the selected task? ',
	deleteTaskModalMessage1: 'Related evidence that is not related to any other tasks in this engagement will be moved to temporary files. Findings and response tasks that are not related to any other evidence will be deleted.',
	deleteTasksModalMessage: 'Are you sure that you want to delete the selected tasks? ',
	someTasksCannotBeDeleted: 'Some tasks cannot be deleted',
	onlySomeTasksCanBeDeleted: 'Only some of the tasks that you selected can be deleted.',
	tasksThatCanBeDeleted: 'If you choose to proceed, <b>the tasks listed below will be removed</b> from your engagement. Evidence that is not related to other tasks in your engagement will be moved to temporary files. Findings and response tasks that are not related to other evidence will also be deleted.',
	tasksThatCannnotBeDeleted: '<b>The tasks listed below cannot be removed</b> from your engagement but may be rejected from the Audit Plan if required.',
	accountHeader: 'Accounts',
	noAccountsIdentified: 'No accounts have been identified.',
	noRisksIdentified: 'No Risks have been identified',
	noAssertionsIdentified: 'No Assertions have been identified',
	noWcgwsIdentified: 'No WCGW have been identified',
	// Tasks/TaskDetails/Evidence
	addEvidence: 'Add evidence',
	relateEvidence: 'Relate evidence',
	relateTemporary: 'Relate temporary files',
	relatePriorPeriod: 'Relate prior period evidence',
	relateExtDoc: 'Relate external documents',
	relateFile: 'Relate files',
	relateAnalytics: 'Relate analytics',
	quickAddButton: 'Quick Add',
	createPaperProfile: 'Create paper profile',
	paperProfileInformationMessage: 'We prepare all documentation electronically, including preparation and review sign-offs. Only those documents that are provided to us by management or a third party in paper form and for which an electronic copy is not available (e.g., copy of a signed contract between the entity and a third party) are permitted as paper documentation in our workpapers.',
	paperProfileName: 'Paper profile name',
	paperProfileAdd: 'Add',
	paperProfileError: 'Please enter a valid paper profile name',
	otherEngagementsInWorkspace: 'Other engagements in this workspace',
	relateDescription: 'Relate a document from this engagement or from another engagement in this workspace.',
	onlyShowRelatedDocuments: 'Show only related documents',
	relateDescriptionTemp: 'Relate a document from this engagement.',
	added: 'Added',
	documentLocation: 'Document location',
	documentIneligibleForSharingMessage: 'Confidential documents are not eligible to be shared.',
	confidentialityNotAppropiateForSharing: 'You do not have the appropriate confidentiality level to send this document.',
	documentIsCheckedOut: 'Document is in co-edit mode and cannot be shared. End co-edit mode to share the document.',
	addCanvasFormNew: 'Add Canvas form NEW',
	documentCount: '{0} document',
	documentsCount: '{0} documents',
	fitDocumentCannotbeSelected: 'FIT documents are unable to be shared between engagements.',
	// Task/TaskDetail/Description
	noDescriptionAvailable: 'No description available.',
	knowledge: 'Knowledge',
	knowledgeDescription: 'Knowledge description',
	descriptionInstructions: 'Description from instructions',
	fromInstructions: 'From instructions',
	customizeDescription: 'Customized description',
	custimizeTaskDescription: 'Customize task description',
	editTaskDescription: 'Edit task description',
	saveLabel: 'Save',
	okLabel: 'Ok',
	cancelLabel: 'Cancel',
	leaveCommentLabel: 'Leave a comment',
	addLabel: 'Add',
	closeLabel: 'Close',
	editText: 'Edit',
	enterReply: 'Enter reply',
	reply: 'Reply',
	deleteTagDesc: 'Deleting tag cannot be undone, are you sure that you want to continue?',
	requiredText: 'Text is required',
	descriptionEmptyError: 'Description is required',
	descriptionMaxLengthError: 'Description length exceeded maximum allowed length',
	assignmentDueDate: 'Assignment due date',
	navigateToGuidedWorkflow: 'Navigate to EY Canvas FIT enablement',
	openInTasksPage: 'Open in Tasks',
	copyTaskLink: 'Copy task link',
	copyReviewNoteLink: 'Copy review note link',
	urlCopiedLabel: 'Link copied successfully',
	//Related Tasks
	showOnlyRelatedTask: 'Show only related',
	noTaskAvailable: 'No tasks available',

	// Client Request / Client Request Detail /  Client Request Drawer
	openInCollaborationPage: 'Open in Collaboration',
	copyRequestLink: 'Copy request link',
	requestType2MessageTitleDrawer: 'This request has additional functionality.',
	requestType2MessageSubtitleDrawer1: 'Please',
	requestType2MessageSubtitleDrawer2: 'click here',
	requestType2MessageSubtitleDrawer3: 'to navigate to it.',

	// SeeMore component
	showMore: 'Show more',
	showLess: 'Show less',
	showMoreEllipsis: 'Show more...',
	showLessEllipsis: 'Show less...',

	// Request Description
	saveAndCloseButtonLabel: 'Save and close',
	saveButtonLabel: 'Save',
	cancelButtonLabel: 'Close',

	// Request Description Modal labels
	discardChangesModalText: 'Discard changes',
	inlineSaveUnsavedChanges: 'There are unsaved changes, do you want to continue?',

	// RelateWCGWModal labels
	wcgwName: 'WCGW name',
	wcgwByScot: 'WCGWs by SCOT',
	unrelatedSCOTsHeader: 'Unrelated SCOTs',
	unrelatedSCOTPlaceholder: 'No unrelated SCOTs',
	noWcgwPlaceholder: 'No WCGWs have been created',
	showOnlyUnrelatedWCGW: 'Show only unrelated',

	// CharCount component.
	of: 'of',
	characters: 'characters',
	fromUserLabel: 'From',
	toUserLabel: 'To',
	handoffto: 'Hand-off to',
	priorityLabel: 'Priority',
	addNoteLabel: 'Add',
	replyNoteLabel: 'Reply',
	characterCountLabel: ' of 4000 characters',
	taskNotePlacehodler: 'Enter task note',
	documentNotePlacehodler: 'Enter document note',
	taskNoteStatusBy: 'by:',
	addNewReviewNoteButtonText: 'New note',
	fromKnowledge: 'From Knowledge',
	/*day labels*/
	mon: 'Mon',
	tues: 'Tues',
	wed: 'Wed',
	thurs: 'Thu',
	fri: 'Fri',
	sat: 'Sat',
	sun: 'Sun',
	/*month labels*/
	jan: 'January',
	feb: 'February',
	march: 'March',
	april: 'April',
	may: 'May',
	june: 'June',
	july: 'July',
	august: 'August',
	sept: 'September',
	oct: 'October',
	nov: 'November',
	dec: 'December',
	/*Rename*/
	documentDropdown: 'Document dropdown',
	fileNameRequired: 'File name is required',
	invalidCharacters: 'File name cannot include: */:<>\\?|"',
	existingFileName: 'File name is not unique. Refresh the page or rename the file to remove this message.',
	unknowError: 'An unexpected error has occurred. Refresh the page to remove this message.',
	maxLengthExceeded: 'The document name cannot exceed 115 characters.',
	documentNameSyncErrorMessage: 'Document name could not be synced to the Canvas Client Portal. Refresh the page and try again.',
	/*Delete*/
	deleteFileTitle: 'Delete document',
	deleteFileCloseBtnTitle: 'Cancel',
	deleteFileConfirmBtnTitle: 'Delete',
	deleteFileCloseTitle: 'Close',
	deleteFileModalMessage: 'Are you sure that you want to delete the selected document?',
	none: 'None',
	/*Unlink*/
	unlinkFileTitle: 'Unlink shared evidence',
	unlinkSource: 'Source',
	unlinkTarget: 'Target',
	unlinkFileCloseBtnTitle: 'Cancel',
	unlinkFileConfirmBtnTitle: 'Confirm',
	unlinkFileCloseTitle: 'Close',
	unlinkFileModalMessage: 'Are you sure that you want to unlink this shared evidence file?',
	/*Relate Tasks*/
	relateTasksTitle: 'Relate tasks',
	relateTaskSearchPlaceholder: 'Enter to search',
	relateTaskInstructionalText: 'Add or remove tasks that the document should be related to. If the document is evidence, removing it from the last task will move it to temporary files.',
	relatedTaskInstructionalText: 'The document is related to the following tasks in this engagement. Click on a task name to navigate to it.',
	relateTaskName: 'Task name',
	relateTaskType: 'Type',
	relatedTaskCounter: '{0} task',
	relatedTasksCounter: '{0} tasks',
	/*Relate Entities*/
	relateEntitiesTitle: 'Relate entities',
	relateEntitiesSearchPlaceholder: 'Enter to search by name',
	relateEntitiesName: 'Entity name',
	relateEntitiesIndex: 'Entity standard index',
	relatedEntitiesCounter: '{0} entities',
	relatedEntityCounter: '{0} entities',
	onlyShowRelatedEntities: 'Only show related entities',
	unableToRemoveSystemAssociatedRelatedEntity: 'Unable to remove system relationships between documents and entities',
	/* Finalize document */
	document: 'Document',
	finalize: 'Finalize',
	finalizeDocument: 'Finalize document',
	finalizeDocumentTitle: 'Are you sure that you want to notify the primary team that this document is finalized?',
	finalizeDocumentSubtitle: 'Finalizing a document informs the primary team that you do not expect to send any additional versions of the document and changes the document status to <b>Final version sent</b>.  In the event that you make changes to a finalized document, you are still able to send a new version to the primary team.',
	/* Remove From Task */
	removeEvidenceModalTitle: 'Remove from task',
	remove: 'Remove',
	removeFromTaskModalContent: 'Are you sure that you want to remove the selected document from this task? This document is not associated to any other task in this engagement and therefore will be moved to temporary files.',
	sharedEvidenceRemoveFromTaskModalContent: 'Are you sure that you want to remove the selected document from this task? This document is shared and is not associated to any other task in this engagement. It will no longer be available in your engagement if it is removed.',
	/*AddDocumentToTasksModal*/
	modalCheckboxHeading: 'Add to evidence for one or more tasks',
	modalRadioHeading: 'Associate document to one or more tasks',
	confirm: 'Confirm',
	proceed: 'Proceed',
	modalCheckboxMessage: 'Select relevant tasks to add this document to.',
	selectedDocument: 'Selected document',
	modalRadioMessage: 'This document has previously been added to evidence or temporary files.',
	modalRadioMessage1: 'Adding this document again will create a duplicate copy. Select whether to associate an existing copy of this document or create a new copy of this document.',
	option: 'Option',
	option1Message: 'Associate existing document to this task',
	option2Message: 'Create a new copy of this document',
	addToEvidenceSelectAll: 'Select all',
	currentTask: 'Current task:',
	createNewCopy: 'Create a new copy',
	fileNameMaxLenError: (maxFileLen) => `File name is limited to ${maxFileLen} characters.`,
	/* Confidentiality */
	confidentiality: 'Confidentiality',
	confidentialityType: 'Confidentiality (optional)',
	confidentialityTitle: 'Document confidentiality',
	confidentialityPlaceholder: 'Select confidentiality',
	confidentialityText: 'Set the level of access required for this document to be opened. Access levels are set by Engagement Administrators in the Manage Team page. If confidentiality has already been set for this document, only those that can open the document can change it.',
	confidentialityNotOpenable: 'Document cannot be opened because your engagement rights are insufficient. Access levels are set by Engagement Administrators in Manage Team.',
	confidentialityTargetNotOpenable: 'Confidential documents can only be opened from the source engagement.',
	/*Sign-off requirements*/
	signOffRequirements: 'Sign-off requirements',
	signoffRequirementsModalTitle: 'Sign-off requirements',
	signoffRequirementsModalDescription1: 'Adjust this document\'s executive sign-off requirements below.',
	signoffRequirementsModalDescription2: 'Some sign-off requirements cannot be adjusted because they are required by EY Canvas.',
	signoffRequirementsModalSaveLabel: 'Save',
	signoffRequirementsModalCancelLabel: 'Cancel',
	signoffRequirementsModalCloseLabel: 'Close',
	signoffRequirementsModalPICLabel: 'PIC',
	signoffRequirementsModalEQRLabel: 'EQR',
	/*SEM summary*/
	nextAccount: '>',
	prevAccount: '<',
	reviewedBy: 'Reviewed by',
	displaytoc: 'Display TOC',
	viewBy: 'View by',
	substantiveEvaluation: 'Substantive evaluation matrix',
	reviewed: 'Reviewed',
	estimate: 'Estimate',
	/*440GL*/
	FourFortyTitle: 'Evidence modified after report date ({0})',
	LeftContainerTitle440GL: 'Reasons for change',
	approvals: 'Approvals',
	approveChangesColumnTitle: 'Approve changes',
	approveChangesButton: 'Approve changes',
	deleteApproval: 'Remove approval',
	unauthorizedAction: 'Action can only be performed by engagement executives',
	reasonColumnTitle: 'Reason',
	approvedBy: 'Approved by: ',
	approvedByPeople: 'people',
	noChangeReasonCommentAvailable: 'Click edit reason from the document cog wheel options to enter the reason for change.',
	changeReasonModalTitle: 'Edit reason for change',
	changeReasonModalText: 'Select the reason for the change(s) made to the document after the report date. If multiple administrative changes have been made, select the most significant change from the drop-down below. If both administrative changes and non-administrative changes have been made, select non-administrative below.',
	changeReasonUploadModalTitle: 'Reason for document upload',
	changeReasonUploadModalText: 'Select the reason for the change(s) made to the document after the report date. If multiple administrative changes have been made, select the most significant change from the drop-down below. If both administrative changes and non-administrative changes have been made, select non-administrative below.',
	changeReasonModalComboPlaceholder: 'Select',
	changeReasonModalAnnotationText: 'Document the circumstances encountered and the reasons for adding the information; new or additional audit procedures performed, audit evidence obtained and conclusions reached, and the effect on our auditor’s report.',
	changeReasonUploadModalAnnotationText: 'Document the circumstances encountered and the reasons for adding the information; new or additional audit procedures performed, audit evidence obtained and conclusions reached, and the effect on our auditor’s report.',
	changeReasonModalAnnotationPlaceHolder: 'Enter reason for change',
	changeReasonModalChangeReasonRequired: 'Change reason to save.',
	noDocumentsModifiedAfterReportDate: 'No documents modified after report date',
	noReasonSelected: 'No reason for change selected',
	fileSizeColumn: 'File size',
	changePercent: '% change',
	toolTipChangePercent: 'The change in file size is calculated using the file size as of the report date and the current file size',
	/*Account Conclusion*/
	AccountConclusion: 'Account Conclusion',
	AccountDetails: 'Details',
	Conclusions: 'Conclusions',
	accountDetailsTab: 'details',
	conclusionsTab: 'conclusions',
	accountConclusionNoContentText: 'Content has not been delivered for this Form. Go to Canvas Form Updates from the Global Navigation More menu and manually update the content.',
	validations: 'Validations',
	/*RelatedFindings*/
	deficiency: '{0} Related deficiencies',
	misstatement: '{0} Related misstatements',
	relatedDeficiency: '{0} Related deficiency',
	relatedMisstatement: '{0} Related misstatement',
	deficiencies: 'Deficiencies',
	misstatements: 'Misstatements',
	pagingShowtext: 'Show',
	documentOpenModelLabel: 'Document currently being modified',
	openedLabelText: 'Opened ',
	modelDocumentOpenedText: 'This document is currently being modified by ',
	modelUserOpenedTheDocumentText: 'This user opened the document ',
	modelOpenedDocumentConflictText: 'Opening the document could cause conflicts, so we recommend opening as read-only. If you would like to become the editor of this document, then ',
	clickHereEnabledText: 'click here.',
	reviewNotesTemporeryFilesTitle: 'Review notes for temporary files',
	addNewReviewNoteTitle: 'Task notes',
	/*Assignments*/
	assignedTo: 'Assigned to',
	createAssignment: 'Create assignment',
	createAssignments: 'Create assignments',
	editAssignments: 'Edit assignments',
	deleteAssignments: 'Delete assignments',
	removeAssignments: 'Remove assignments',
	noTimephaseSelected: 'Not selected',
	unassigned: 'unassigned',
	unassignedCapitalized: 'Unassigned',
	dueDateBlank: 'due',
	reviewerAssignment: 'Reviewer assignments',
	manageAssignments: 'Manage task assignments',
	manageTaskAssignments: 'Create assignments',
	selectedTasks: 'selected tasks',
	someTasksCannotBeMoved: 'Some tasks cannot be moved',
	onlySomeTaskCanMoveToOtherGroup: 'Only some of the tasks that you selected can be moved to another task group.',
	taskThatCanBeMovedToOtherGroup: 'If you choose to proceed, <b>the tasks listed below will be moved</b> to the task group that you selected.',
	tasksThatCannotBeMovedToOtherGroup: '<b>The tasks listed below cannot be moved</b> to another task group.',
	taskGroupSectionNotFound: 'No results found',
	placeholderForSearch: 'Search',
	taskFilter: 'Filter',
	noResultsAvavilable: 'No results found',
	noTasksAvavilable: 'No tasks available',
	clearAll: 'Clear all',
	engagementPhase: 'Audit phase',
	noOptionAvailable: 'No options available',
	noTimePhase: 'No assigned time phase',
	roles: 'Roles',
	users: 'Team members',
	rommAssociatedWNotRelyAssertion: 'ROMM is associated to an Assertion with Control Risk of Not Rely or an Assertion with Inherent Risk of Higher where the Account has an estimate',
	hasRiskAssociated: 'Risk Associated',
	canvas: 'Canvas',
	workingoffline: 'Working Offline',
	syncinprogress: 'Sync in progress',
	prepareoffline: 'Preparing data for offline',
	connectionavilable: 'Connection available',
	createAnAssignment: 'Create an assignment',
	createAssignmentEnd: 'for this task to get started.',
	// Manage Assignments
	step01: 'Step 01',
	step02: 'Step 02',
	step03: 'Step 03',
	step04: 'Step 04',
	step05: 'Step 05',
	manageAssigmentsStep1: 'Select an action',
	manageAssigmentsStep2: 'Edit task assignment',
	editAssignment: 'Edit assignment',
	deleteAssignment: 'Delete assignment',
	manageAssigmentsStep3: 'Complete assignment',
	taskAssigmentStatusHeader: 'Assignment status',
	taskAssigmentStatusTileHeader: 'Task and assignment status',
	taskAssignmentName: 'Assignment',
	dueDateAssigment: 'Due',
	editDueDate: 'Optional: Edit days prior to end date',
	teamMemberAssigmentLabel: 'Team member',
	currentAssigmentLabel: 'Current',
	handOffToAssigmentLabel: 'Handed off to:',
	priorToEndDateLabel: 'prior to end date',
	noTimePhaseAssigmentLabel: 'No assigned time phase',
	closedByAssigmentLabel: 'Closed by ',
	onAssingmentLabel: 'on',
	preparerAssigmentOpenTitleTip: 'Hand off this task to close your task assignment',
	reviewerAssigmentOpenTitleTip: 'Mark task assignment as closed',
	reviewerAssigmentClosedTitleTip: 'Mark task assignment as open',
	AssigmentLabel: 'Hand off this task to close your task assignment',
	noEvidenceReviewerAssigmentTitleTip: 'Add evidence to mark task assignment as closed',
	noTaskEvidencesHandoffModal: 'There are no evidence files associated to this task.',
	back: 'Back',
	savecontinue: 'Save & continue',
	finish: 'finish',
	save: 'Save',
	emptyManageAssignmentStep: '...',
	selectAssignmentActionToContinue: 'Select an action to continue.',
	createNewTaskAssingment: 'Create new task assignment',
	deleteTaskAssingment: 'Delete task assignment',
	createTaskAssingment: 'Create task assignment',
	editExistingTaskAssingment: 'Edit existing task assignment',
	editTaskAssingment: 'Edit task assignment',
	removeExistingTaskAssingment: 'Remove existing task assignment',
	warningPopUpPreparerAssignmentTitle: ' Overwrite existing preparer assignment',
	warningPopUpPreparerAssignmentText: 'There is already a preparer assignment for this task.  Are you sure that you want to overwrite this assignment?',
	warningPopUpPreparerAssignmentConfirm: 'Confirm',
	warningPopUpPreparerAssignmentCancel: 'Cancel',
	selectTaskAssingment: 'Select task assignment',
	viewHistoryAndConflicts: 'View history',
	noHistoryAvailable: 'No history available',
	teamMember: 'Team member',
	dateEdited: 'Last modified',
	viewHistoryHeader: "This document's version history is displayed below.",
	viewHistorySubHeader: "Click on a team member's name to open a previous version of this document in read-only mode. Any changes made to this previous version will not be saved to EY Canvas.",
	docConflictedMessage: 'There are conflicts associated with this document. Navigate to the Conflicts tab of the Documents list to resolve.',
	removeTaskAssingment: 'Remove task assignment',
	addAssignmentInstructionalText: 'Enter a new task assignment name here (e.g., Detail reviewer, General reviewer)',
	addNewAssingmentName: 'Add new assignment name',
	addTaskAssignmentName: 'Add task assignment name',
	assignmentName: 'Assignment name',
	selectedTask: 'selected task',
	createTaskAssignmentHeading: 'Create a new assignment here.',
	createTaskAssignmentHeading1: "Enter the assignment details below and select <b>Save and close</b> to finish. To create another assignment, select <b>Save and add another</b>.",
	saveDelete: "Save & delete",
	createTaskAssignmentFinishLabel: "Save & close",
	createTaskAssignment: 'Save & add',
	editTaskAssignment: 'Save & manage another',
	createTaskAssignmentSaveAndContinueLabel: "Save & manage another",
	daysPriorToEndDate: 'Days prior to end date',
	daysdue: 'Days due',
	daysPriorToEndDateOptional: 'Days prior to end date (optional)',
	timephase: 'Time phase',
	timephasesLabel: 'Time phases',
	manageTimePhase: 'Manage time phases',
	removeTaskAssingmentSingleTaskHeading: 'Select the assignment that you would like to delete.',
	removeTaskAssingmentSingleTaskHeading2: "Click 'Save & close' if you are done or click 'Save & manage another' if you wish to manage another task assignment.",
	removeTaskAssingmentMultipleTaskHeading: 'If the assignment and team member combination exists for a selected task, then the assignment will be deleted. Make your selections and select <b>Save & close</b> to finish. To delete another assignment, select <b>Save & delete</b>.',
	editTaskAssingnmentStep2Heading: 'Select the task assignment that you would like to edit.',
	selectedAssignment: 'Selected assignment: ',
	editTaskAssingmentBulkHeading: 'Select the assignment that you would like to edit.',
	editTaskAssingmentBulkSubHeading1: "If the assignment and team member combination exist for a selected task, then the task will be reassigned. You have the option to edit the <b>Days prior to end date</b>. If you edit this value, then it will be updated for all reassigned tasks. Make your edits and select <b>Save & close</b> to finish. To edit another assignment, select <b>Save & manage another</b>.",
	noResultInCategory: 'No results found within this task category',
	searchTaskList: 'Search task list',
	searchCanvasFormList: 'Search',
	clearHoverText: 'Clear',
	filtersWarningMessage: 'Filter limit exceeded. Only 25 filters can be applied at one time.',
	reviewNotesWarningMessage: 'An error has occurred retrieving the data.  Try again and if the issue persists, contact the Help Desk.',
	editTaskAssingmentSept3Header: 'Edit the selected assignment.',
	editTaskAssingmentSept3Header2: "Click 'Save & close' if you are done or click 'Save & manage another' if you wish to manage another task assignment.",
	editTaskAssignmentHeaderPart1: "Edit the assignment details below and select <b>Save changes</b>.",
	calculatedDate: "Calculated date",
	saveAndAddbtn: "Save and add another",

	//Calendar Toggle Labels
	daysPriorToEndDateRequired: "Days prior to end date (required)",
	dueDateRequired: "Due date (required)",
	selectDate: "Select date",
	calculateDate: "Calculate date",

	/* Bulk TimePhase*/
	taskText: 'Task',
	timephasesetsuccess: '{0} time phase set successfully.',
	timephasessetsuccess: '{0} time phases set successfully.',
	addTimephaseLabel: "Add time phase",
	infoSetTimePhase: "<h3>Set time phases</h3><p>Drag and drop from onto a time phase to set that time phase for the selected items</p>",
	infoEditTimePhase: "<h3>Edit time phase</h3><p>Click on the overflow menu (three dots) and select Edit to edit the time phase properties.</p>",
	infoAddTimePhase: "<h3>Add time phase</h3><p>Click on Add time phase to create a new time phase.</p>",
	infoDeleteTimePhase: "<h3>Delete time phase</h3><p>Click on the overflow menu (three dots) and select Delete to delete the time phase.</p>",
	deletedTimePhaseFilterWarningMessage: "Time phase has been deleted by different user.",

	//Set assignment dates modal labels
	setAssignmentTitle: 'Set assignment(s) due date',
	setAssignmentDesc: 'You have not defined assignment(s) due date. Select the due date(s) for the assignment(s) below to continue.',
	setAssignmentDesc2: 'One or more tasks have a time phase date earlier than your selected due date of {0}. Adjust the due dates of tasks or timephase due date to continue.',
	timePhaseNameLabel: 'Time phase',
	timephaseEndDate: 'Time phase end date',
	tasksLabel: 'No. of tasks',
	assignmentDateLabel: 'Assignment',
	noAssignedTimePhase: 'No assigned time phase',
	endDate: 'End date',
	calendarDateError: 'Due date should be less than time phase end date',

	/* Events*/
	addEventLabel: "Add event",
	sharedWithClient: "Shared",
	noEventsMessage: 'No events have been identified.',
	naLabel: 'N/A',
	deleteEventModalTitle: 'Delete event',
	deleteEventDescription: ' Are you sure that you want to delete this event?',
	showEventeName: 'Event',
	eventDateLabel: 'Date',
	eventDatesLabel: 'Dates',
	showEventStartDate: 'Start date',
	showEventEndDate: 'End date',
	deleteEventSuccessMessage: 'Event deleted successfully.',
	eventTypeLabel: 'Event type',
	singleDayEventLabel: 'Single day',
	multiDayEventLabel: 'Multiple days',
	dateRangeEventLabel: 'Date range',
	eventSharedWithClientLabel: 'Shared with client',
	editEventLabel: 'Edit event',
	eventUpdateSuccessMessage: 'Event updated successfully.',
	noTimephasesMessage: 'No time phases have been identified.',

	/* Review Notes */
	showAll: "All",
	reviewNotesLabel: 'Review Notes',
	athoredByMeLabel: 'Authored by me',
	assignedToMe: 'Assigned to me',
	assignedToOpen: 'Assigned to (Open)',
	authoredByCleared: 'Authored by (Cleared)',
	totalOpenReviewLabel: 'Total open review notes',
	totalClearedReviewLabel: 'Total cleared review notes',
	agingLabel: 'Aging',
	openLabel: 'Open',
	clearedLabel: 'Cleared',
	noUsersFoundLabel: 'No results found',
	chartDataLabel: 'No data available.',
	noClientDataAvailable: 'No data available',
	DaysLessThan10: '<10 days',
	Days11To30: '<30 days',
	Days31To60: '<60 days',
	Days61To90: '<90 days',
	DaysMoreThan90: '> 90 days',
	noReviewNotesFound: 'No review notes found',

	formMaxLength: 'Text cannot exceed {number} characters.',
	voiceNote: 'Voice note',
	microphoneBlockedMessage: 'Allow browser to access your microphone to use voice notes. If already allowed, please refresh and try again.',
	microphoneBlockedOnVideoMessage: 'Allow browser to access your microphone to use voice in screen recording. If already allowed, please refresh and try again.',
	notInMainWindowVoice: 'Voice recordings are not allowed inside the drawer, please open the document in a new tab to perform the action.',
	notInMainWindowScreen: 'Screen recordings are not allowed inside the drawer, please open the document in a new tab to perform the action.',
	screenRecord: 'Screen recording',
	playbackReview: 'Playback review',
	recording: 'Recording',

	/* Sign Offs */
	preparerHoverText: 'Sign-off as preparer',
	reviewerHoverText: 'Sign-off as reviewer',
	preparerTitle: 'Preparer sign-offs',
	reviewerTitle: 'Reviewer sign-offs',
	preparerLetter: 'P',
	reviewerLetter: 'R',
	deleteHoverText: 'Remove sign-off',
	signoffsrequired: 'Sign-offs required',
	signoffsOptional: 'PIC/EQR optional',
	eqrLabel: 'EQR',
	partnerInChargeLabel: 'PIC',

	landingPage: 'Landing Page',
	dashboardPage: 'Dashboard',
	tasksPage: 'Tasks',
	documentsPage: 'Documents',
	collaborationPage: 'Collaboration',
	automationPage: 'Automation',
	newContentUpdate: 'Content update',
	contentUpdatesHistory: 'History',
	history: 'History',
	contentUpdateType: 'Content update type',
	iniciatedBy: 'Initiated by',
	date: 'Date',
	clickForOptions: 'Click for more options',
	offline: 'Offline',
	eyServiceGateway: 'EY Service Gateway',
	eyAutomation: 'EY Automation',
	eyserviceGatewayAutomation: 'EY Service Gateway & Automation',

	// ContentUpdates
	contentUpdate: 'Content updates',
	canvasFormUpdates: 'Canvas form updates',
	syncFormProfile: 'Sync form profile',
	documentName: 'Document name',
	analyticName: 'Analytic name',
	formType: 'Type of form',
	dateOfContent: 'Date of content',
	formStatus: 'Status',
	formsWarningMessage: 'One or more EY Canvas forms must be selected for update',
	formsUpdateSuccessMessage: 'EY Canvas form update submitted',
	filterTypeOfFormLabel: 'Type of form',
	filterSourceOfFormLabel: 'Source of form',
	documentSelectionRequired: 'Select a document to overwrite',
	overwriteForm: 'Overwrite form',
	overwriteFormInstructionalText: 'Select a form to overwrite the responses with the data from the current Canvas form. Note the current Canvas form will be moved to Temporary Files.',
	confirmOverwrite: 'Confirm overwrite',
	confirmOverwriteAreYouSure: 'Are you sure that you want to copy the content of the \'{0}\' form to the \'{1}\' form?',
	confirmOverwriteDesc: 'Responses will be overwritten in the \'{1}\' form, but related evidence and objects will not. Applicable related evidence and objects should be re-associated to the \'{1}\' form after the overwrite has been completed. \'{0}\' form will retain its existing profiling/GAM layers, therefore, if that profiling is different from \'{1}\' form, please review and clean up the copied content.',
	confirmOverwriteDoNotClose: 'Do not close the browser or navigate away while the overwrite process is in progress. After the overwrite process has completed, the \'{0}\' form will be moved to Temporary files. This action cannot be undone.',
	sourceDocument: 'source document',
	targetDocument: 'target document',
	profileLayers: 'GAM layers',
	pspAccountWarningMessage: 'One or more accounts must be selected for update',
	pspAccountUpdateSuccessMessage: 'PSP content update submitted',
	pspAccountconfirmUpdateMessage: "Updating these accounts may have a significant impact on the content. Once started, no additional content updates can be performed until these complete.",
	est: 'has estimate',
	bookmarkTaskModalHeader: 'Unable to download selected tasks',
	bookmarkTaskModalMessage: 'The selected tasks cannot be downloaded for working offline.',
	noGuidanceAvailable: 'No Guidance available',
	next: 'Next',
	previous: 'Previous',
	guidanceLink: 'Link',
	addToEvidenceLabel: 'Add to evidence',
	otherEngagements: 'Other engagements',
	navigationView: 'Navigation view',
	listView: 'List view',
	detailsView: 'Details view',
	closeguidance: 'Close guidance',
	reviewNotesModalClose: 'Close',
	gamGuidanceLinkLabel: 'GAM Guidance',
	inProgess: 'In progress',
	upcomingReview: 'For upcoming review',
	teamSummaryEmptyTaskDetailsMesage1: 'Use the Team Summary to view preparer and reviewer assignments for each team member by status. To manage all assignments for your engagement, select ',
	teamSummaryEmptyTaskDetailsMesage2: 'Manage assignments.',
	teamSummaryEmptyTaskDetailsMesage3: 'To enable bulk controls, use the checkbox to select one or more tasks. Use the shift key to select several tasks at once. If you would like to work on an individual task, then select that task from the list.',
	taskSummaryPoint1: 'Select "To prepare" to view a list of preparer assignments for each team member.',
	taskSummaryPoint2: 'Select "To review" to view a list of reviewer assignments for each team member.',
	taskSummaryPoint3: 'Assignments are sorted by assignment status (not started, in process, and done).',
	noLinksfound: 'No links available for this task.',
	noFormsfound: 'No forms available for this task.',
	workofflinemsg: 'This will download the latest versions of your selected tasks and allow you to continue editing offline. You may sync your changes later by reconnecting.',
	workonlinemsg: 'Going back online will automatically sync your changes. Make sure an internet connection is available before reconnecting.',
	workoffline: 'Work offline',
	workonline: 'Work online',
	duplicateFileNames: 'Duplicate file names',
	training: 'Training',
	duplicateFileNameValidationMessage: 'The file that you are attempting to add to this engagement has the same name as an existing file in this engagement. Rename one of the files in order to proceed.',
	documentHelperConnectionIssue: 'An issue has been detected with EY Canvas Document Helper. Click <a style="color: #467cbe" href="https://eyt.service-now.com/kb_view.do?sysparm_article=KB0486774" target="_blank">here</a> for instructions of how to resolve this issue.',
	incompleteCra: 'Incomplete CRA',
	noteItemCreated: 'Created:',
	NetworkErrorMessage: 'The application network is experiencing an error. Refresh the page and try again later. Contact the Help Desk if the error persists.',
	saveClose: 'Save and close',
	contentupdatePSPs: 'Content update - PSPs',
	/* PAANS */
	paansIsNotReachable: 'The EY Policy Authoring, Approvals and Notification Service​ is unavailable at this time.  We are unable to confirm if all relevant policies have been completed.  If you have not reviewed the relevant policies, refresh the page and try again.  If the issue persists, contact the Help Desk.',

	/* Add New Task */
	standardtask: 'Standard task – OST',
	substantivetask: 'Substantive task – OSP',
	walkthroughtask: 'Walkthrough task – WT',
	controltask: 'Control task – TOC',
	addnewTask: 'Add new task',
	taskType: 'Task type',
	taskTypeError: 'Please select task type',
	selectTaskTypeHeader: 'Select a task type to continue.',
	selectTaskType: 'Select task type',
	enterTaskDetails: 'Enter task details',
	assignTask: 'Assign task',
	taskGroup: 'Task group',
	finishLabel: 'Save & close',
	addTaskContinueLabel: 'Save and assign',
	AssignTaskStepSaveandContinueLabel: 'Save & add another',
	addTaskDetailsHeader: 'Enter task details in order to proceed.',
	addTaskAssignmentHeader: 'Optional: Create an assignment for this task.',
	addTaskDetailsSubHeader: "Click <b>Save and assign</b> if you wish to assign this task now or click <b>Save and close</b> if you wish to assign this task later.",
	addTaskAssignmentSubHeader: "Enter the assignment details below and select Save & close to finish. To create another assignment, select Save & add.",
	addTaskAssignmentSubHeader1: "Enter the assignment details below and select <b>Save & close</b> to finish. To create another assignment, select <b>Save & add.</b>",
	addTaskGroup: "Add a new task group here. Once added, you can select this task group when creating new tasks as well as move existing OST tasks into this task group.",
	relateObjectHeaderAccount: 'Select one or more assertions for a significant account or disclosure, or select a limited risk account.',
	relateObjectSubHeaderAccount: 'Tasks can only be related to one account or disclosure.',
	relateObjectHeader: 'Relate one or more objects in order to proceed.',
	limitedRiskAccount: 'Limited risk account',
	onlyShowAddedObject: 'Only show added objects',
	relateObjectRequiredError: 'One or more objects must be selected in order to proceed.',
	invalidSelectionWarning: 'Tasks can only be related to one account or disclosure. Remove the selected assertions or limited risk account to relate the task to assertions for a different account or disclosure or a different limited risk account.',
	invalidSelctionCRA: 'Select a single object type',
	relateObjectOptionsHeaderAccountTask: 'Assertions and limited risk accounts',
	relateObjectOptionsHeaderITWalkthroughTask: 'IT/SO processes',
	relateObjectOptionsHeaderITControlTask: 'IT general controls',
	relateObjectOptionsHeaderITSubstantiveTask: 'IT substantive procedures',
	relateObjectOptionsHeaderSCOTControlTask: 'Controls',
	relateObjectOptionsHeaderSCOTWalkthroughTask: 'SCOTs',
	StrategyTypeControls: 'Controls',
	StrategyTypeSubstantive: 'Substantive',

	//Manage quick filters labels
	manageQuickFilterHeader: 'Select a saved or suggested filter as a default.',
	manageQuickFilterText: 'If you select a default, then this filter will be applied when you navigate to the task list.',
	noDefaultFilter: 'No default filter',
	suggestedFiltersHeading: 'Suggested filters',
	savedFiltersHeading: 'Saved filters',
	manageQuickFilters: 'Manage quick filters',
	manageLabel: 'Manage',


	/* RNH Labels */
	emptyNoteDetailsMessage: 'Select a note to view details. To enable bulk controls, use the control or shift key and select multiple review notes. If you would like to work on an individual note, then select that note from the list.',
	emptyRepliesMessage: 'No replies yet',
	emptyRepliesMessageAlt: 'No replies',
	reviewNotes: 'Review notes',
	reviewNotesStatus: 'Review note status',
	reviewNotesStatusAssignedToMe: 'Status of review notes assigned to me',
	reviewNotesStatusAuthoredByMe: 'Status of review notes authored by me',
	comments: 'Review notes',
	showHideNotes: 'Show/Hide notes',
	fileType: 'File type',
	noteType: 'Type',
	statusId: 'Status',
	rnhPriority: 'Priority',
	rnhDueDate: 'Due: ',
	rnhModifiedDate: 'Modified',
	textAreaPlaceholder: 'Enter note',
	requiredFieldErrorMessage: 'This is a required field.',
	meLabel: 'Me ',
	editIconHoverText: 'Edit',
	deleteIconHoverText: 'Delete',
	deleteIconModalTitle: 'Delete note',
	deleteIconCommentModalTitle: 'Delete note',
	deleteReplyIconModalTitle: 'Delete reply',
	deleteIconModalConfirmMessage: 'Are you sure that you want to delete your reply to this note?',
	deleteIconModalConfirmMessageParent: 'Are you sure that you want to delete the selected note?',
	deleteIconModalCommentConfirmMessage: 'Are you sure that you want to delete this reply?',
	deleteIconModalCommentConfirmMessageParent: 'Are you sure that you want to delete this note? All replies to this note will also be deleted.',
	deleteIconModalAcceptText: 'Delete',
	replyInputPlaceholder: 'Reply to this note',
	changeStatus: 'Change status',
	emptyReplyErrorMsg: 'Add text or a voice note to continue',
	lengthReplyErrorMsg: 'The reply cannot exceed 4,000 characters.',
	closeTitle: 'Close',
	closedBy: 'Closed by',
	ClearedBy: 'Cleared by',
	ReopenedBy: 'Reopened by',
	commentTitle: 'Note',
	noteDueDateLabel: 'Due',
	reopen: 'Reopen',
	noNotesAssociatedWithDocumentLabel: 'Leave a note by using the inputs below. Assign the note to a user and specify the priority and due date.',
	noNotesFound: 'No notes found',

	/* Add new review note RNH */
	addNewNoteButtonTitle: 'New note',
	addNewNoteModalTitle: 'Add a new note',
	addNewNoteModalClose: 'Close',
	backButtonLabel: 'Back',
	cancelButtonLabel: 'Cancel',
	addNewNoteStep1Title: 'Select note type',
	addNewNoteStep2Title: 'Select document or task',
	addNewNoteStep3Title: 'Enter note details',
	editNoteModalTitle: 'Edit note',
	editReplyModelTitle: 'Edit reply',
	voiceNoteButtonLabel: 'Voice note',
	stopRecordingButtonLabel: 'Stop',
	enterText: 'Enter text',

	/* RNH Review note hub Step 1 */
	step1Title: 'Select a note type to continue.',
	step1Subtitle: 'You can only add document and task note here. Canvas form comments must be added within the respective Canvas form.',
	step1NoTypeSelectedError: 'Select a note type in order to proceed.',

	/* RNH Review note hub Step 2 */
	step2DocumentTitle: 'Select the document that you would like to add a note to.',
	step2TaskTitle: 'Select the task that you would like to add a note to.',
	step2SearchTitle: 'Search',
	step2SearchClearTitleTip: 'Clear',
	step2ErrorMessageTop: 'Select an item in order to proceed.',
	step2ErrorMessageBottom: 'Complete the required fields identified above in order to proceed.',
	step2EmptySearch: 'No results found',

	/* RNH Review note hub Step 3 */
	step3InstructionalText: 'Enter the note details for the selected document or task.',
	step3InstructionalSubTitle: 'Click <b>Save & close</b> when you are done, or click <b>Save & add another</b> if you wish to add another note to the selected document or task.',
	step3SelectedDocument: 'Selected document:',
	step3SelectedTask: 'Selected task:',
	step3SaveAndContinue: 'Save & add another',
	step3SaveAndClose: 'Save & close',

	/* RNH List Layout Labels*/
	searchReviewNotes: 'Search notes',
	searchReviewNotesResultsNotFound: 'No results found within this note category',
	searchReviewNotesNotAvailable: 'No notes available',
	notesRepliesNotFound: 'No Replies found for the notes selected.',

	selectValueToContinue: 'Please select a value to continue',
	required: 'Required',
	invalidEngagementId: 'Engagement ID is invalid. Refresh the page and try again. Contact the Help Desk if the error persists.',
	accessDenied: 'Access denied',
	annotationDeletedError: 'The selected note has been deleted. Refresh the page and try again.',

	/* RNH Filters */
	rnhClearAll: 'Clear all',
	rnhShowMore: 'more',
	rnhFilter: 'Filter',
	hideFiltersLabel: 'Hide',
	noDocumentChangeTypes: 'No results found',
	selectatasktype: 'Select a task type',
	importfromknowledge: 'Import from Knowledge',
	assigntaskoptional: 'Assign task (optional)',
	relateanobject: 'Relate an object',
	account: 'Account',
	userOrRole: 'User or role',
	userSummary: 'User summary',
	other: 'Other',
	userNotFound: 'User not found',
	dueOnOrBefore: 'Due on or before',
	dueOnOrAfter: 'Due on or after',

	/*Dashboard - Milestone tile*/
	milestonesLabel: 'Milestones',
	scopeAndStrategy: 'Scope & strategy',
	scopeAndStrategyTabLabel: 'Scope & strategy',
	executionTabLabel: 'Execution',
	conclusionTabLabel: 'Conclusion',
	viewAllTabLabel: 'View all',
	noTaskAssociatedToMilestoneMsg: 'There are no tasks associated to the milestones in this audit phase.',
	overdueLabel: 'Overdue',
	upcomingLabel: 'Due date upcoming',
	quickLinkText: 'Quick links',
	inreviewLabel: 'In review',
	CompleteLabel: 'Complete',
	completeLabel: 'complete',
	startLabel: 'Start',
	endLabel: 'End',
	auditPhaseSummary: 'Audit phase summary',
	milestoneView: 'Milestone view',
	timePhaseView: 'Time phase view',
	localLandingPageHeader: 'This page displays only EY Canvas Engagements which are available in this data center.',
	localLandingPage: 'LOCAL LANDING PAGE',
	noEngagementsAvailable: 'No engagements available in this data center',
	engagements: 'Engagements',
	/* Document List */
	docListRelatedTasks: 'Related tasks',
	temporaryFilesTab: 'Temporary files',
	priorPeriodEvidenceTab: 'Prior period evidence',
	conflictsTab: 'Conflicts',
	recentlyDeletedTab: 'Recently deleted',
	docListSelectedDocument: '{0} document selected',
	docListSelectedDocuments: '{0} documents selected',
	shared: 'Shared',
	shareStatusOwned: 'Owned by this engagement.',
	shareStatusShared: 'Shared into this engagement.',
	unlinkInprogress: 'Unlink in progress',
	unlinkError: 'Unlink error',
	documentList: 'Documents',
	restoreModalTitle: 'Restore to temporary files',
	restoreModalText: 'Restore to return this document to temporary files.',
	permanentlyDeleteModalTitle: 'Permanently delete',
	permanentlyDeleteModalText: 'Permanently deleting the document will remove it from EY Canvas and cannot be undone. Click Permanently delete to continue.',
	misstatementsInstructionalText: 'The document is related to the following Misstatements in this engagement. Click on a Misstatement to navigate to it.',
	deficienciesInstructionalText: 'The document is related to the following Deficiencies in this engagement. Click on a Deficiency to navigate to it.',
	referenceId: 'ID',
	findingDescription: 'Description',
	deficienciesModalTitle: 'Related deficiencies',
	misstatementsModalTitle: 'Related misstatements',
	startsWith: 'Starts with',
	contains: 'Contains',
	documentsWherePICEQRSignOffIsRequired: 'Documents where PIC/EQR sign-off is required',
	otherDocuments: 'Other documents',
	documentsWherePICSignOffIsRequired: 'Documents where PIC sign-off is required',
	documentSignoffRequiredLabel: 'Sign-offs required from:',
	timePhaseFilterLabel: 'Timephase',
	drillDownTimePhaseFilterLabel: 'View by time phase',
	auditPhasesLabel: 'Audit phase',
	openedLabel: 'Opened',

	clientApprovals: 'External sign-offs',
	noTeamsAvailable: 'No teams have been created yet.  Create a team and send a link request to get started.',
	noDocumentRecieved: 'No documents received yet.',
	team: 'Team',
	pendingEvidence: 'Pending evidence',
	noTimePhasePlaceHolder: 'No timephases',

	regionComponentEvidence: 'Region and component evidence',
	preparersignoffs: 'Preparer sign-offs',
	reviewersignoffs: 'Reviewer sign-offs',
	receivedon: 'Received on: ',
	nosignoffsyet: 'No sign-offs yet.',
	noRegionComponentEvidence: 'No documents have been received yet. To see a list of regions and components that have not sent documents yet, select <b>Documentation pending</b>.',
	noComponentEvidence: 'No documents have been received yet.',
	assignToRegionOrComponent: 'Assign to region or component',
	assignRegionComponentModalText: 'Select the region or component to which you would like to assign this document.',
	documentAssignedToPGT: 'This document has already been assigned to another region or component.  Therefore, it is not available for assignment.',
	assignedToRegionComponent: 'Assigned region or component:',
	noRegionComponentsAvailable: 'No regions or components available',
	documentUnassignedFromComponent: '{0} has been unassigned from {1}.',
	documentUnassigned: '{0} has been unassigned.',
	documentReturnedToComponent: '{0} has been returned to {1}.',
	documentReturned: '{0} has been returned.',
	regionComponentName: 'Region or component name',
	relatedReviewNoteCount: '1 open note from other engagements',
	relatedReviewNotesCount: '{0} open notes from other engagements',

	deleteVersion: 'Delete version',
	deleteVersionMessage: "Select a version in order to proceed.",
	deleteVersionDisabledMessage: 'History versions can only be deleted from the source engagement of the document by engagement administrators.',
	deleteVersionTitle: 'Delete document version',
	deleteVersionPlaceholder: 'Are you sure you want to delete this history version? This action cannot be undone',

	childDocumentsCountLabel: 'Existing copies',
	childDocumentsModalTitle: 'Existing copies',
	childDocumentsModalDescription: 'The documents below were created from the original document.',
	childDocumentsModalColumnDocumentName: 'Document name',
	childDocumentsModalColumnDocumentType: 'Document type',
	childDocumentsModalColumnRelatedTasks: 'Related tasks',
	childDocumentsModalColumnSignoffs: 'Sign-offs',

	bulkAddToEvidenceDescription1: 'Create a new copy of the documents presented as evidence, or select an existing copy if available.',
	bulkAddToEvidenceDescription2: 'By default, newly created documents will be added to all the tasks and Canvas Forms the old document was related to. Use "Advanced options" to manually select the tasks and Canvas Forms to associate the new document to. Use the find and replace feature to replace certain parts of the new document\'s name (e.g., the year); this feature can be used multiple times.',
	bulkAddToEvidenceDescription3: 'When an existing document is selected, it will only be added to the current task. If only one existing document is available, that has been pre-selected; otherwise choose an existing copy to add.',
	bulkAddToEvidenceAdvancedOn: 'Advanced options',
	bulkAddToEvidenceAdvancedOff: 'Off',
	bulkAddToEvidenceFindText: 'Find text',
	bulkAddToEvidenceFindTextRequired: 'Please enter a valid Find text.',
	bulkAddToEvidenceReplaceWith: 'Replace with',
	bulkAddToEvidenceReplaceSuccess: 'Replaced {0} with {1}.',
	bulkAddToEvidenceUseExisting: 'Use existing',
	bulkAddToEvidenceCreateNew: 'Create new',
	bulkAddToEvidenceDocumentName: 'Document name',
	bulkAddToEvidenceExistingDocument: 'Existing document',
	bulkAddToEvidenceSelectANewOrExistingCopy: 'Select a new or existing copy',
	bulkAddToEvidenceAssociateToTasks: 'Associate to tasks',
	bulkAddToEvidenceAssociateToCanvasForms: 'Associate to Canvas Forms',
	bulkAddToEvidenceOtherRelatedTasks: 'Other related tasks',
	bulkAddToEvidenceAssociateToTasksPlaceholder: 'Only newly created documents can be associated to tasks. Existing documents will be automatically associated to the current task.',
	bulkAddToEvidenceSelectedTask: '{0} related task',
	bulkAddToEvidenceSelectedTasks: '{0} related tasks',
	bulkAddToEvidenceSelectedTasksPlaceholder: 'No related task available',
	bulkAddToEvidenceAssociateToCanvasFormsPlaceholder: 'Only newly created documents can be associated to Canvas Forms.',
	bulkAddToEvidenceRelatedCanvasForms: 'Related Canvas Forms',
	bulkAddToEvidenceSelectedForm: '{0} related Canvas Form',
	bulkAddToEvidenceSelectedForms: '{0} related Canvas Forms',
	bulkAddToEvidenceSelectedFormsPlaceholder: 'No related Canvas Forms',
	picRequiredValidation: 'PIC sign-off required document is not related to a PIC task',
	eqrRequiredValidation: 'EQR sign-off required document is not related to an EQR task',
	picEqrRequiredValidation: 'PIC/EQR sign-off required document is not related to a PIC/EQR task',

	viewSwitcherDefault: 'Default view',
	viewSwitcherEntity: 'Entity view',
	viewSwitcherAllEntities: 'All Entities',
	viewByEntities: 'View by entities',

	/* bulk delete modal */
	bulkDeleteFilesModalMessage: 'Are you sure that you want to delete the selected documents?',
	bulkDeleteFIlesModalMessageSub: 'Documents which cannot be deleted are indicated below and will not be deleted.',
	bulkDeleteModalLabel: 'Delete documents',
	bulkDeleteSuccessMessage: 'documents deleted succesfully',
	bulkDeleteValidDocumentsHeader: 'The following documents will be deleted',
	bulkDeleteInvalidDocumentsHeader: 'The documents listed below cannot be deleted',

	/* Bulk sign-off requirements modal */
	bulkSignOffRequirementsModalMessage: 'Adjust the selected documents\' executive sign-off requirements below. Some sign-off requirements cannot be adjusted because they are required by EY Canvas.',
	bulkSignOffRequirementsResultMessage: '{0} document sign-off requirements updated successfully',


	bulkOpenCountWarning: 'The number of documents selected exceeds the maximum allowed. Only the first {0} will be opened',

	/* Pending evidence modal */
	pendingEvidenceInstructionalText: 'The teams listed below have not sent any group documents yet.',
	pendingEvidenceDueDate: 'Due date',
	searchRegionComponentLabel: 'Search regions and components',

	/* Review Notes Count */
	noReviewNotesAssignedOrAuthored: 'There are no notes for the selected team member.',
	noUserSelected: 'Select a user to see details. You cannot assign notes to roles in EY Canvas.',
	reviewNotesText: 'review notes',
	assigned: 'Assigned',
	authored: 'Authored',
	overdue: 'overdue',
	comingDue: 'Coming due',
	cleared: 'Cleared',
	open: "Open",
	closed: 'Closed',
	noTaskAssignedToUser: 'There are no tasks assigned to the selected team member or role.',
	preparer: 'Preparer',
	reviewer: 'Reviewer',
	assignments: 'assignments',
	notStarted: 'Not started',
	inProgress: 'In progress',
	done: 'Done',
	forUpcomingReview: 'Upcoming',
	noTaskOrNotesAssigned: 'There are no tasks or notes for the selected team member or role.',
	fromTo: 'From / To',

	/* Collaboration grid */
	overdueCollaboration: 'Overdue',
	comingDueCollaboration: 'Coming due',

	/*Document Conflict*/
	documentConflict: 'Document conflict',
	documentConflictModalConfirm: 'Retain this version',
	documentConflictModalClose: 'Cancel',
	documentConflictInstruction: 'To resolve the conflict, select the version of the document that should be retained.',
	documentConflictMessage: 'Click on a team member\'s name to open a previous version of this document in read-only mode. Any changes made to this previous version will not be saved to EY Canvas.',
	lastmodifiedDate: 'Last modified date',
	modifiedBy: 'Modified by',
	documentConflictErrorMessage: 'Select a version in order to proceed.',
	currentVersion: 'Current version',
	documentConflictError: 'Document conflict error message',
	documentConflictHeader: 'This document has a conflict.',
	viewHistory: 'View History',
	confirmButtonToolTip: 'You must have permission to resolve conflicts for group documents. Contact an engagement administrator and request permission to take this action.',
	documentHistoryHeader: 'This document\'s version history is displayed below.',
	documentHistoryMessage: 'Click on a team member\'s name to open a previous version of this document in read-only mode. Any changes made to this previous version will not be saved to EY Canvas.',

	documentHistoryInstruction: 'If a previous version should be the current version, select that version and click "Update version"',
	documentHistoryAdminInstruction: 'If a version is not required, select the version and click "Delete version".',

	documentHistoryModalConfirm: 'Update version',
	documentHistoryModalClose: 'Close',
	documentHistoryErrorMessage: 'Document has a conflict, please resolve it before proceding.',

	/* Dashboard  - Collaboration Tile*/
	clientCollboration: 'Client Collaboration',
	nextwaveServices: 'Centralized Services',
	receivedStatusLabel: 'Received',
	acceptedStatusLabel: 'Accepted',
	outstandingStatusLabel: 'Outstanding',
	collaborationNonUsageMessage1: 'Use Collaboration to send requests and external tasks to external team members directly in EY Canvas. To activate Collaboration, first enroll your client in EY Canvas Client Portal. Next, set up access groups. Then, create requests and/or assign external tasks. Click ',
	collaborationNonUsageMessage2: ' for enablement on how to get started.',
	collaborationNonUsageMessageHyperlinkText: 'here',
	collaborationNonSentMessage1: 'Navigate to ',
	collaborationNonSentMessage2: ' and send drafts to get started.',
	collaborationNonSentMessageHyperlinkText: 'Collaboration',
	noBodies: 'No bodies',
	editResponse: 'Edit response',
	unsentDrafts: 'unsent drafts',
	unsentDraft: 'unsent draft',
	noUnsentDrafts: 'No unsent drafts',
	requestsSent: 'Requests sent',
	nextWavetotalTasks: 'TOTAL TASKS',
	comingDueTimeframe: 'Time frame',
	otherTimeframeDataAvailableMessage: 'Select another timeframe to view data',

	/* Dashboard Engagement Metrics */
	engagementMetricsTileHeader: 'Engagement metrics',
	overdueColumnHeader: 'Overdue',
	comingDueColumnHeader: 'Coming due',
	whatsNewColumnHeader: "What's new",
	placeholderMessageNoContentInSpecifiedTimeframe: 'Select another timeframe to view data',
	placeholderMessageNoEngagementMetrics: 'There are no metrics available for your engagement.',
	performanceMetrics: 'Performance metrics',
	reviewNotesAndAssignments: 'Review notes and assignments',
	/*Dashboard Engagement overview*/
	engagementOverview: 'Engagement overview',
	engagementOverviewInstructionalText: "Review your engagement's progress by audit phase below.",

	/*Dashboard Milestone tile*/
	milestoneprogressTileHeader: 'Milestones',
	milestoneprogressSubHeader: "Select an audit phase below to view task completion by milestone. To view task completion by time phase, select <b>View by time phase</b>. To see detailed progress for each milestone or time phase, select <b>Show details.</b>",
	tasksStatus: 'Tasks status',
	preparerAssignments: 'Preparer assignments',
	reviewerAssignments: 'Reviewer assignments',
	openComments: 'Open notes',
	/* Dashboard Profile Page */
	groupAudit: 'Group audit',
	groupStatus: 'Group status',
	viewInstructions: 'View instructions',
	instructionsInstructionalText: "Instructions received from the primary team are displayed below. Select a link to view the instructions.",
	noInstructionsAccepted: "No instructions have been accepted yet.",

	/* Dashboard SDM Summary */
	nextWaveservices: 'Centralized Services',
	totalTasksLabel: 'Total tasks',
	tasksUsingNextWaveservices: ' tasks using Centralized Services',
	tasksSuggestedForNextwaveUse: ' tasks suggested for Centralized Services',
	outOf: 'out of',
	tasksUsing: 'tasks using',
	suggestedFor: 'suggested for',
	nextwaveUse: 'Centralized Services',
	draftRequests: 'draft requests',
	draftRequest: 'draft request',
	createRequests: 'Create requests',
	noRequestCreated: 'There are no requests created yet. Create and send a request to get started.',

	/* RNH Bulk Controls */
	rnhBulkAssignPriorityTitle: 'Change priority',
	rnhBulkAssignPriorityTooltip: 'Priority',
	rnhBulkDueDateTooltip: 'Due date',
	rnhBulkAssignPriorityModalHeader: 'Unable to edit the selected notes',
	rnhBulkAssignPriorityModalContent: 'You can only change the priority of notes with Open status. Reopen notes with Cleared or Closed status in order to change the priority.',
	rnhBulkAssignDueDateModalContent: 'You can only change the due date of notes with Open status. Reopen notes with Cleared or Closed status in order to change the due date.',
	rnhBulkAssignUserTooltip: 'Reassign',
	rnhBulkAssignUserSearch: 'Search',
	rnhBulkAssignUserTitle: 'Unable to edit the selected review notes',
	rnhBulkAssignUserText: 'You can only re-assign review notes with Open status. Reopen review notes with Cleared or Closed status in order to re-assign.',
	rnhBulkAssignStatusTooltip: 'Status',
	rnhBulkAssignUserNoFound: 'No results found',
	rnhBulkDueDatePlaceholder: 'Pick a date',
	rnhBulkDeleteTextCorrect: 'Are you sure that you want to delete the selected notes? Once a review note is deleted, you will no longer be able to access it.',
	rnhBulkDeleteTextIncorrect: 'You can only delete notes with Closed status. Close notes with Open or Cleared status in order to delete.',
	rhnBulkDeleteTitleCorrect: 'Delete selected notes',
	rhnBulkDeleteTitleIncorrect: 'Unable to delete the selected notes',
	rnhBulkDeleteTextIncorrectComment: 'You can only delete review notes with Closed status. Close review notes with Open or Cleared status in order to delete.',
	rhnBulkDeleteDescriptionAuthorComment: 'You can only delete notes that you have authored.',
	rnhBulkDeleteEngagementComment: 'Are you sure that you want to delete the selected review notes? Once a review note is deleted, you will no longer be able to access it.',
	rhnBulkDeleteTitleCorrectEngagementComment: 'Delete selected notes',
	rhnBulkDeleteTitleCommentCloseStatus: 'Unable to delete the selected notes',


	fourFortyFilters: 'filters',
	fourFortySearch: 'Search',

	/* Add External Member Start*/
	addExternalModalTitle: "Add external member",
	accessGroupSelection: "Access group selection",
	noRecordinGroups: "No results found",
	permission: "Permissions",
	permissionProjectManagement: "Project Management",
	permissionProjectManagementDesc: "Ability to view the status of client requests and external tasks in EY Canvas Client Portal. This external member will not be able to access details of client requests and external tasks.",
	permissionInfoTooltip: "list of all permissions",
	groupInfoTooltip: "List of groups",
	groupRequired: "Please select group(s)",
	firstnameRequired: "First name required",
	lastnameRequired: "Last name required",
	initialsRequired: "Initials required",
	roleRequired: 'Engagement role required',
	confidentialityRequired: 'Confidentiality level required',
	groupLabel: "Access groups",
	firstnameLabel: "First name",
	lastnameLabel: "Last name",
	initialsLabel: "Initials",
	userinfo: "User Info",
	userinfoDescription: "Enter the first name, last name or email address of the team member you want to invite and press enter.",
	inviteAndClose: "Invite & close",
	inviteAndAddOther: "Invite & add another",
	addAndClose: "Invite & close",
	addAndAddOther: "Invite & add another",
	externalUserCreatedSuccessMessage: "You have successfully added ",
	accessGroupSelectionMessage: "Access Groups allow teams to manage who on the external team can see Requests that are sent to EY Canvas Client Portal. Agree with your client on the list of Access Groups and users that will have access to EY Canvas Client Portal. When a Request is assigned to an external user who is part of the group, it will be visible to EVERY member of that group.",
	accessGroupSectionMessage1: "External team members must be registered using the My EY Admin Portal prior to adding them to EY Canvas. Click ",
	accessGroupSectionMessage2: " to access the My EY Admin Portal and get started.",
	accessGroupMessageHyperlinkText: "here",
	accessGroupUserMessage1: "For more information about onboarding users click ",
	accessGroupUserMessage2: " to access EY Atlas.",
	noRecordForExternalMember1: "Email address could not be found.",
	noRecordForExternalMember2: "Ensure that the external team member is registered with My EY.",

	/* Add External Member End*/

	/* Edit External Member Start*/

	editExternalModalTitle: "Edit external member",
	editExternalaccessGroupSelection: "Access group selection",
	editExternalGroupInfoTooltip: "List of groups",
	editExternalGroupLabel: "Access groups",
	editExternalGroupRequired: "Please select group(s)",
	editExternalNoRecordinGroups: "No results found",
	editExternalUserinfo: "User Infomation",
	editExternalUserinfoDescription: "Edit the first name, last name, or initials.",
	editExternalEmailLabel: "Email",
	editExternalFirstnameLabel: "First name",
	editExternalLastnameLabel: "Last name",
	editExternalInitialsLabel: "Initials",
	editExternalSaveLabel: "Save",
	editExternalUsersSuccessMessage: "Changes to {0} {1} have been successfully saved.",
	editExternalUsersCloseLabel: "Close",

	/* Edit External Member End*/



	/*access group*/
	groupName: "Group name",
	groupNameHelp: "A name is required in order to create an access group.",
	groupNameHelpOnEdit: "Name is required",
	groupNameReq: "Group name required",
	groupNameInvalidCharacter: "Invalid characters",
	grpDomainManage: 'Manage domains',
	grpDomainHelp: 'Domains restrict the users that can be added to this Access Group. At least one domain is required to create an Access Group. Domain refers to the characters after @ symbol. Use * for wildcard (e.g., *.ey.com).',
	btnAddNewDomain: 'Add new domain',
	btnAddExistingDomain: 'Add existing domain',
	domainValidation01: 'At least one valid domain is required',
	domainValidation02: "Choose a domain",
	domainValidation03: "Duplicate entry",
	domainValidation04: "Invalid domain name",
	domainValidation05: "Domain name required",
	domainName: 'Domain name',
	emailDomain: 'Email domain',
	groupDeletionErrorPendingReqMsg: 'An error occurred while deleting the access group. Ensure that there are no requests/external tasks assigned to this group or to the members of this group and try again',
	groupDeletionSuccessMsg: '{0} has been successfully deleted. All active members have been deactivated.',

	/* uncommon values for internal mem */
	editInternalMember: 'Edit internal member',
	editThirdPartyMember: 'Edit third-party member',
	listOfAllPerm: 'List of all permissions',
	internalPermiInviteExt: 'Invite internal members',
	internalPermiInviteInt: 'Invite external members',
	internalPermiAssignPer: 'Assign permissions',
	internalPermiDeleteEng: 'Delete engagement',
	internalPermiArchEng: 'Archive engagement',
	internalPermiUpdateContet: 'Update content',

	internalPermiInviteExtToolTp: 'Ability to invite internal team members to the engagement',
	internalPermiInviteIntToolTp: 'Ability to invite external team members to the engagement',
	internalPermiAssignPerToolTp: 'Ability to assign these permissions to internal and external team members in the engagement',
	internalPermiDeleteEngToolTp: 'Ability to delete the engagement',
	internalPermiArchEngToolTp: 'Ability to archive the engagement',
	internalPermiUpdateContetToolTp: 'Ability to edit the profile and accept a content update',
	internalMemberInviteSuccessMessage: 'You have successfully sent an invite to {0} {1}',
	internalMemberPostArchivalAdditionSuccessMessage: 'You have successfully added {0} {1}',
	invitePriorPeriodUsersSuccessMessage: "You have successfully sent an invite to inactive users",
	editInternalUsersSuccessMessage: "Your changes to {0} {1} have been successfully saved",
	rbacErrorEditUser: "Cannot save changes at the moment. Try again and if the issue persists, contact the Help Desk.",
	universalQueueErrorEditUser: "The EY Canvas Landing Page is not accessible at this time and is required to edit.  Try again and if the issue persists, contact the Help Desk",
	removeExternalUsersSuccessMessage: "{0} {1} has been removed successfully.",
	reActivateExternalUsersSuccessMessage: "{0} {1} has been reactivated in the following access group(s): {2}",

	/*user search component*/
	seachInputRequired: 'Search input required',
	nameOrEmail: "Name or email",
	emailForExternal: "Email",
	noRecord: "No results found",
	userSearchPlaceholder: "Enter name or email and press enter to see results.",
	userSearchPlaceholderForExternal: "Enter email and press enter to see results.",
	clearAllValues: 'Clear all values',
	inValidEmail: 'Please enter valid email',

	maxLengthForEditResponse: 'Maximum characters, including rich text formatting tags, is 30,000.  Remove unnecessary formatting and try again.',
	clickEditResponseToContinue: 'Click edit response to continue',
	bodyDescriptionFromKnowledge: 'Body description from knowledge',
	execution: 'Execution',
	cannotpasteimages: 'Cannot paste images',
	pastingImagesNotAllowed: 'Pasting of images is not allowed. If images are required upload them as evidence and refer to them.',
	saveResponse: 'There are unsaved changes, do you want to continue',
	conclusion: 'Conclusion',
	referenceDocsPlaceHolder: 'Quickly open frequently-accessed files by adding them here.',
	referenceDocsTeamPlaceHolder: "No team reference documents have been added in this engagement. Click 'Add document' to get started.",
	referenceDocsMyPlaceHolder: "You have not added any reference documents. Click 'Add document' to get started.",
	teamDocuments: 'Team pinned',
	myDocuments: 'My pinned',
	teamDocumentsModalTitle: 'Team documents',
	myDocumentsModalTitle: 'My documents',
	referenceDocuments: 'Team pinned',

	/* PinnedDocument  */
	PinnedDocument: 'Pinned documents',
	PinnedDocumentSubTite: "Create a list of frequently accessed documents by pinning items to either your own list or your team's list below. To modify the list, select <b>Add document</b>.",
	PinnedDocPaceholder: 'You have not pinned any documents. <br> Select <b>Add document</b> to pin documents here.',
	PinnedTeamDocPlaceholder: "Your team has not pinned any documents. <br> Select <b>Add document</b> to pin documents here.",
	PinnedDocAddDocHeaderText: 'Select evidence and temporary files to customize the list of pinned documents.',
	onlyShowPinnedDocuments: 'Only show pinned documents',
	pinned: 'Pinned',
	/* Arc Timeline */
	arcTitle: 'Archive checklist',
	arcCompleted: 'completed',
	arcSubmit: 'Submit archive',
	arcDescription: 'Complete all items on the checklist to archive this engagement',
	invalidEngagementCode: 'Invalid engagement code',
	invalidClientCode: 'Invalid client code',
	arcCheckBox: 'Archive override',
	arcUnlinkEvidenceButtonText: 'Unlink all',
	arcUnlinkEvidenceModalTitle: 'Unlink all shared evidence',
	arcUnlinkEvidenceModalText: 'Are you sure that you want to unlink all shared evidence in this engagement from other engagements in this workspace? Once you complete this operation, it cannot be undone.',
	arcUnlinkEvidenceModalConfirmButton: 'Unlink all',
	arcUnlinkEvidenceModalCancelButton: 'Cancel',
	arcUnlinkEvidenceButtonUnlinkInProgress: 'Unlink in progress',
	arcUnlinkEvidenceButtonUnlinkError: 'Unlink error',
	arcUnlinkGroupEngagementButtonText: 'Unlink from group',
	arcUnlinkGroupEngagementModalTitle: 'Unlink this engagement from the group',
	arcUnlinkGroupEngagementModalText: 'Are you sure that you want to unlink this engagement from other engagements in this workspace? Once you complete this operation, it cannot be undone.',
	arcUnlinkGroupEngagementModalConfirmButton: 'Unlink',
	arcUnlinkGroupEngagementModalCancelButton: 'Cancel',
	arcUnlinkGroupEngagementButtonUnlinkInProcess: 'Unlink in progress',
	arcModalTitle: 'Existing ARC record',
	arcProceedWithArchive: 'Proceed with archive',
	arcModalBodyText: 'You are attempting to archive a restored engagement file. This file already exists in the Archive Records Center (ARC). Are you sure that you want to proceed?',
	noDataAvailabel: 'No data available at this time. Refresh the page and try again. Contact the Help Desk if the error persists.',
	reportDateBeforeCurrentDate: 'The engagement report date must be on or before the current date. Update the report date in order to proceed. To update the report date, click on the "Confirm the accuracy of key engagement dates" link.',

	/*Helix Projects*/
	linkedProjects: 'Linked projects',
	suggestedAnalyzers: 'Suggested analyzers',
	linkSelected: 'Link selected',
	noLinkedProjectsAvailable: 'There are no linked projects',
	helixProjectTitle: 'EY Helix Projects',
	findProjects: 'Find projects',
	findProjectsModalTitle: "Find EY Helix projects",
	selectProjectsToLink: 'Select one or more EY Helix projects below to create a link with your Canvas engagement. You can manually search by client code to find other EY Helix projects.',
	newSearch: 'New search',
	noResultsFound: 'No results found',
	enterClientCode: 'Enter a client code to search again.',
	enterClientCodeToDisplayAnalizers: 'Enter a client code to display a list of available analyzers.',
	defaultClientCodeIsInvalid: 'The default client code {0} for this engagement is invalid. Enter a valid client code to display a list of available analyzers.',
	mirrorCodesNotAccepted: 'Note that mirror codes are not accepted.',
	helixProjectSearch: 'Search',
	helixProjectsSearchPlaceholderText: 'Enter client code to search',
	helixWizardProjectsSearchPlaceholderText: 'Search analyzer by client code',
	selectOneOrMoreProjects: 'Select one or more Helix projects from the list to link',
	noPermissionLabel: 'You must have Archive permissions to submit this engagement for archive',
	linkProject: 'Link project',
	oneAnalyzerMustBeSelected: 'One analyzer must be selected.',
	selectAnAnalyzer: 'Select an analyzer',
	selectOneAnalyzer: 'Select an EY Helix analyzer below to create a link with your EY Canvas engagement. You can manually search by client code to find EY Helix projects and the related analyzer(s).',
	selectAnalyzerModalTitle: 'Select Analyzer for',
	selectAnalyzerModalBodyText: 'Select an EY Helix analyzer to link with your EY Canvas engagement',
	selectAnalyzerModalSubmitButtonLabel: 'Link Project',
	projectCanNotBeLikedTootip: "This EY Helix project is not available because it’s location does not match the location of the EY Canvas Engagement.",
	unlinkProjectConfirmationModalTitle: 'Warning - unlink project',
	unlinkProjectConfirmationModalBodyText: 'The EY Helix analyzer being unlinked has client bookmarks associated to this engagement. Unlinking this analyzer will result in those bookmarks no longer being available.  This action cannot be undone. Do you want to continue?',
	defineConnectionSettings: 'Define connection settings',

	helixConnectionPageTitle: 'EY Helix connections',
	helixConnectionPageSubtitle: 'Connected EY Helix analyzers, their imported data, and the percent of GL accounts that have been mapped to EY accounts. Click on the percentage mapped to adjust mapping. The mapped percentage can be different between the connection and the imported data. For instance, if mapping occurred after the imported date. Re-import the data to get the latest mapping.',
	helixIntegrationPageNoConnectedAnalyzerLabel: 'No connected analyzers',
	helixIntegrationPageTitle: 'EY Helix integration',
	helixIntegrationPageSubtitle: 'Relate one or more EY Helix analyzers to your EY Canvas engagement.',
	helixIntegrationPageNoHelixProjectLinkedLabel1: 'No related analyzers. To relate a new analyzer,',
	helixIntegrationPageNoHelixProjectLinkedLabel2: '  click here.',
	helixIntegrationPageColumnConnectionName: 'Connection name',
	helixIntegrationPageColumnConnectionType: 'Connection type',
	helixIntegrationPageColumnAnalysisPeriod: 'Analysis date',
	helixIntegrationPageColumnAnalyzerName: 'EY Helix analyzer name',
	helixIntegrationPageColumnLastConnectedBy: 'Last connected by',
	connectAnalyzer: 'Connect analyzer',
	dataImportModalTitle: 'Import confirmation',
	dataImportModalBodyLabel: "A 'Scope & strategy' import already exists in this engagement. Only a single 'Scope & strategy' import is allowed per engagement. Importing this data will replace the existing 'Scope & strategy' import. Do you want to continue? This action cannot be undone.",
	dataImportModalBodyLabelMest: "A 'Scope & strategy' import already exists for this entity. Only a single 'Scope & strategy' import is allowed per entity. Importing this data will replace the existing 'Scope & strategy' import. Do you want to continue? This action cannot be undone.",
	dataImportModalCancelButtonLabel: 'Cancel',
	dataImportModalCloseButtonLabel: 'Close',
	dataImportModalConfirmButtonLabel: 'Import',
	dataImportModalImportError: 'An error occurred related to the connected EY Helix analyzer. Data cannot be imported. Refresh the page and try again. If the issue persists, contact the Help Desk.',

	//Entites to Business Mapping Modal
	entityMappingModalTitle: 'Entity mapping',
	entityMappingModalCancelLabel: 'Cancel',
	entityMappingModalSaveLabel: 'Save',
	entityMappingModalDescription: 'Manage the mapping between entities and business units for this connection. Each business unit can be mapped to a single entity only.',
	entityMappingModalBusinessUnitsPlaceholder: 'Business unit(s)',
	entityMappingModalAllBusinessUnitsLabel: 'All business units',
	entityMappingModalBusinessUnitSelectedCount: '{0} business unit',
	entityMappingModalBusinessUnitsSelectedCount: '{0} business units',
	entityMappingModalNoResultsFound: 'No results found',
	entityMappingModalNoEntitiesLabel1: 'No entities exists in the engagement.',
	entityMappingModalNoEntitiesLabel2: 'Create an entity to get started.',
	entityMappingModalBusinessUnitAlreadyMapped: 'A business unit can be related to only one entity. Unrelate from other entities to enable.',
	/*Entites to Business Table*/
	entityMappingTableEntityColumnLabel: 'Entity',
	entityMappingTableBusinessUnitsColumnLabel: 'Business unit(s)',

	helixProjectPageTitle: 'EY Helix projects',
	helixProjectPageSubtitle: 'Link the EY Helix project(s) relevant to this EY Canvas engagement. When more than one EY Helix project is linked, select one as the primary project to enable data integration into EY Canvas. Only the primary project can be integrated into EY Canvas, so it must contain all journal entry activity for the date that is relevant to the engagement.',
	helixProjectPageNoHelixProjectLinkedLabel1: 'There are currently no EY Helix projects linked to the engagement.',
	helixProjectPageNoHelixProjectLinkedLabel2: 'Add new EY Helix project',
	helixProjectPageNoHelixProjectLinkedLabel3: ' to get started.',
	helixProjectPageNoHelixProjectLinkedLabel4: 'Click ',
	linkToHelixProject: 'Open in EY Helix',
	addNewEYHelixProject: 'Add new EY Helix project',
	eyHelixSetup: 'Integrate EY Helix data',
	existingConnectionDetectedModalTitle: 'Existing connection(s) detected',
	existingConnectionDetectedDescription: 'The selected analyzer has previously been connected to this EY Canvas engagement. You can either create a new connection or select an existing connection below.',
	selectExistingConnection: 'Select an existing connection',
	selectCreateNewConnection: 'Create a new connection',
	connectionNoRecords: 'No connections found',
	selectOneOfTheOptionsToProceed: 'Select one of the options to proceed.',
	saveHelixProjectErrorMessage: 'Could not save the selected analyzer. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	noResultFoundForAnalyzerSelection: 'Ensure that the analyzer you are searching for is in a valid state and that you have been granted access to the analyzer. Contact an EY Helix administrator for more details. Enter a client code to search again.',

	/*Helix Analyzer Details Drawer*/
	connectButtonLabel: 'Connect',
	reConnectButtonLabel: 'Re-connect',
	demoteFromFinancialStatementsOptionLabel: 'Demote from financial statements',
	promoteToFinancialStatementsOptionLabel: 'Promote to financial statements',
	deleteOptionLabel: 'Delete',
	projectAndAnalyzerDetailsSectionTitle: 'Project and analyzer details',
	projectNameLabel: 'Project name',
	clientCodeLabel: 'Client code',
	analyzerNameLabel: 'Analyzer name',
	periodEndDateLabel: 'Date end date',
	analysisDateLabel: 'Analysis date',
	lastConnectedByLabel: 'Last connected by',
	connectionSettingsSectionTitle: 'Connection settings',
	connectionTypesLabel: 'Connection type(s)',
	currencyTypeLabel: 'Currency type',
	currencyLabel: 'Currency',
	currencyCodeLabel: 'Currency code',
	businessUnitsLabel: 'Business unit(s)',
	entitiesLabel: 'Entities',
	analysisPeriodLabel: 'Analysis date',
	comparativePeriod1Label: 'Comparative date 1',
	comparativePeriod2Label: 'Comparative date 2',
	manageAccountMappingSectionTitle: 'Manage account mapping',
	manageAccountMappingButtonLabel: 'Manage account mapping',
	mappedGLAccountsLabel: '% mapped GL accounts: ',
	updateSettingsButtonLabel: 'Update settings',
	deleteConnection: 'Delete connection',
	deleteConnectionQuestion: 'Are you sure that you want to delete the selected connection? All previously integrated data related to this connection will be deleted. This action cannot be undone.',
	deleteConnectionWithAnalyticsQuestion: 'Are you sure that you want to delete the selected connection? All previously integrated data related to this connection will be deleted. Additionally, the selected connection has client bookmarks associated to this engagement. Deleting the connection will result in those bookmarks no longer being available. This action cannot be undone.',

	/*Helix Projects Table*/
	tableShowing: 'Showing results for: ',
	tableClientCode: ' - Client code: ',
	tableEngagementCode: 'Engagement code',
	tableEngagementCodeName: 'Engagement name',
	tableProjectID: 'Project ID',
	tableProjectName: 'Project name',
	tableAnalyzerName: 'Analyzer name',
	tablePeriodEndDate: 'Period end date',
	tableEYHelixPeriodEndDate: 'End date',
	tableAnalysisDate: 'Analysis date',
	tableEYHelixAnalysisDate: 'Analysis date',
	tableAssignedPartner: 'Assigned partner',
	tableProjectLinked: 'Project linked',
	tableTooltipAnalizerIsDeleted: 'Analyzer has been deleted within EY Helix. To permanently delete the connection, click to open the details drawer. Please consider if another analyzer should be connected.',
	tableTooltipAnalizerIsUnavailable: 'Analyzer is unavailable within EY Helix. Contact an EY Helix administrator for more details. To permanently delete the connection, click to open the details drawer. Please consider if another analyzer should be connected.',
	tableTooltipNotValidUser: 'You are not an authorized team member of the selected analyzer. Contact the EY Helix project administrator to gain access and try again.',

	/*Helix Project Cards*/
	cardAnalyzerConnectionLabel: 'Connections',
	cardAnalyzerHelixLabel: 'EY Helix analyzers',
	cardAnalyzerMappedGLAccountsLabel: 'Mapped GL accounts',
	cardAnalyzerEntityMappingLabel: 'Entity mapping',
	cardAnalyzerManageGLAccountsLink: 'Manage account mapping',
	cardAnalyzerSectionScopeAndStrategy: 'Scope & strategy',
	cardAnalyzerSectionFinancialStatements: 'Financial statements',
	cardAnalyzerSectionButtonLink: 'here',
	cardAnalyzerSectionButtonDisconnect: 'Disconnect analyzer',
	cardAnalyzerSectionScopeAndStrategyNoBalance: 'Scope & strategy data is used to present balances in Scope & strategy activities such as materiality. Click {0} to import Scope & strategy data.',
	cardAnalyzerSectionFinancialStatementsNoBalance: 'Financial statements can be imported to EY Canvas to provide drill-down from the financial statements to where the work has been performed in the EY Canvas engagement. Click {0} to import financial statements.',
	cardAnalyzerSectionAnotherAnalyzerType: 'This analyzer has been connected to facilitate integration between EY Canvas, EY Helix, and/or EY Smart Sampling. Click {0} to disconnect this analyzer.',
	cardAnalyzerSectionButtonLinkDisableTooltip: 'You are not an authorized team member of the linked analyzer. Contact the EY Helix project administrator to get access.',
	cardAnalyzerSectionButtonLinkDisableTooltipPermission: 'You do not have the necessary permissions to import this data. Ensure you have the "Import EY Helix data" permission within this Canvas engagement and try again.',
	cardAnalyzerTrialBalanceAnalisysPeriod: "Analysis date",
	cardAnalyzerTrialBalanceComparativePeriod: "Comparative date",
	cardAnalyzerTrialBalanceSecondComparativePeriod: "Second comparative date",
	cardAnalyzerTrialBalanceLastImportDate: "Last imported date",
	cardAnalyzerTrialBalanceCurrency: "Currency",
	cardAnalyzerTrialBalanceBusinessUnits: "Business unit(s)",
	cardAnalyzerTrialBalanceMapedGLAccounts: "Mapped GL accounts",
	cardAnalyzerTrialBalanceImportStatus: "Import status",
	cardAnalyzerTrialBalanceCurrencyTypeFunctional: "Functional",
	cardAnalyzerTrialBalanceCurrencyTypeReporting: "Reporting",
	cardAnalyzerTrialBalanceImportData: "Import data",
	cardAnalyzerTrialBalanceAdjustmentModule: "Adjustment module",
	cardAnalyzerTrialBalanceReImport: "Re-import",
	cardAnalyzerTrialBalanceRemove: "Remove",
	cardAnalyzerTrialBalanceImportStatusInProgress: "In-progress",
	cardAnalyzerTrialBalanceImportStatusImported: "Imported",
	cardAnalyzerTrialBalanceImportStatusError: "Error",
	cardAnalyzerTrialBalanceImportStatusDisconnected: "Disconnected",
	cardAnalyzerTrialBalanceImportModalTitle: "Import data",
	cardAnalyzerTrialBalanceImportModalDescription: "Select the attributes of the import and click 'import' to import",
	cardAnalyzerTrialBalanceImportModalButton: "Import",
	cardAnalyzerTrialBalanceReImportModalTitle: "Re-import data",
	cardAnalyzerTrialBalanceReImportModalDescription: "Select the attributes of the import and click 're-import' to re-import.",
	cardAnalyzerTrialBalanceReImportModalButton: "Re-import",
	cardAnalyzerTrialBalanceImportInProgressTooltip: "Import is in progress. This could take several minutes.",
	cardAnalyzerTrialBalanceImportEntityTooltip: "Entity cannot be changed during a re-import. Create a new import to select a different entity.",
	cardAnalyzerTrialBalanceImportMestEntity: "This selection was made in the previous step. To edit, you must return there.",
	cardAnalyzerTrialBalanceMestBusinessUnit: "This selection is based on the above entity. To edit the entity to business unit(s) relationship, access the 'Entity mapping' on the underlying summary page.",
	cardAnalyzerTrialBalanceFirstSelectCurrencyTypeTooltip: "First select a 'Currency type' to enable this field.",
	cardAnalyzerTrialBalanceFirstSelectCurrencyTooltip: "First select a 'Currency' to enable this field.",

	/*Helis Linked Projects Cards*/
	analysisDate: 'Analysis date: ',
	unlinkProject: 'Unlink project',
	editAnalyzer: 'Edit analyzer',
	deleteProject: 'Delete project',
	projectDeleted: 'Project has been deleted.',
	loadingProjectDataLinked: 'Loading data from EY Helix',
	projectMarkPrimaryConfirmationHeader: 'Change primary EY Helix project',
	projectMarkPrimaryConfirmationMsg: 'Are you sure that you want to change the Primary EY Helix project?',
	projectPrimaryEYHexliProject: 'Primary EY Helix project',
	helixProjectUnlink: 'Unlink',
	helixProjectDelete: 'Delete',
	analyzersLabel: 'Analyzers:',


	/*Helix Import List*/
	importHelixList: 'EY Helix Import List',
	importDocumentName: 'Document name',
	importDocumentID: 'Document ID',
	importFileSize: 'File size (in KB)',
	importDownload: 'Download',
	importNoRecords: 'No documents found',
	importInvalidDocumentID: 'Document ID requires a full match for search. Please ensure that you have included the full document ID',

	/*Helix Connect analyzer modal*/
	connectAnalyzerClientLabel: 'Client:',
	addConnectionNameLabel: 'Add connection name',
	connectionNamePlaceholder: 'Connection name',
	connectionNameRequired: 'Required',
	connectAnalyzerModalTitle: 'Connect analyzer',
	connectAnalyzerDescription: 'Select an analyzer below to create a link with this EY Canvas engagement. Search by client code to find EY Helix projects and the related analyzers.',
	analyzerLocationIncompatibleErrorMessage: 'Analyzer cannot be connected because its data is stored in a location incompatible with the location of the EY Canvas engagement.',
	analyzerMaxConnectionReachedErrorMessage: 'Maximum number of allowed connections have been reached for the selected analyzer. Please select another analyzer to proceed.',
	helixAnalyzerErrorMessage: 'There was an error connecting to the EY Helix analyzer. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	helixAnalyzerGLAConnectionErrorMessage: 'There are one or more error(s) connecting to the EY Helix analyzer to get mapped account count. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	helixReImportErrorMessage: 'An error occurred importing data from EY Helix. Refresh the page and try again. If the issue persists contact the Help Desk.',

	/*Helix Select Entity Modal*/
	selectEntityModalTitle: 'Select entity',
	noEntitiesMappedToBusiness: 'No entities have been mapped to business unit(s).',
	noEntitiesMappedToBusinessFirst: 'Click ',
	noEntitiesMappedToBusinessLink: 'here',
	noEntitiesMappedToBusinessLinkText: ' to get started.',
	searchEntityPlaceholder: 'Search entity',
	entityListHeader: 'Entity',
	selectEntityErrorMessage: 'Select an entity to continue.',
	entityAlreadyConnectedToScopeAndStrategy: "A 'Scope & strategy' import already exists for this entity. Only a single 'Scope & strategy' import is allowed per entity. Remove the existing import to enable this selection.",
	selectEntityNoEntitiesFound: 'No results found',
	selectEntityModalDescription: 'Select an entity for which you want to import data.',

	/*Manage Account Mapping*/
	manageAccountMapping: 'Manage account mapping',
	manageAccountMappingErrorMessage: 'Could not connect to EY Helix. Refresh the page and try again. If the issue persists, contact the Help desk.',
	helixViewerLoader: 'Loading Helix Viewer...',

	/*Helix Remove Import Modal*/
	removeImportModalTitle: 'Remove import',
	removeImportRemoveButtonLabel: 'Remove',
	removeImportDescription: 'Are you sure you want to remove the following import?',
	removeImportActionUndoneDescription1: 'Are you sure you want to remove the following import? ',
	removeImportActionUndoneDescription2: 'This action cannot be undone.',
	removeImportErrorMessage: 'The imported data has been changed since you opened this screen. To continue with the removal, refresh the page and try again.',

	/*Disconnect analyzer modal*/
	disconnectAnalyzerModalTitle: 'Disconnect analyzer',
	disconnectAnalyzerDisconnectButtonLabel: 'Disconnect',
	disconnectAnalyzerDescription: 'Are you sure you want to disconnect the selected analyzer?',
	disconnectAnalyzerImportsExistErrorMessage: 'An import was added to this connection since you opened this screen. A connection can only be disconnected if all associated imports are first removed. Refresh the page and try again.',

	/*Content Update */
	quote: '"',
	performContentUpdate: 'Perform content update',
	contentupdate: 'Content updates',
	btnContentUpdate: 'Update',
	btnContentUpdateSelected: 'Update',
	updateSuccessMessage: 'Content update submitted',
	msgContentUpdate: 'Select one or more categories below to update content. If substantial amounts of work have already been completed, discuss with engagement executives if a content update is appropriate. Content updates cannot be undone.',
	msgIndependance: 'Updating Independence may result in independence confirmations being required to be completed again.',
	msgProfile: 'Updating the profile may have a significant impact on engagement content. Users may lose access to the engagement until a new profile is submitted. This action cannot be undone.',
	msgHistoryContentUpdate: 'Content updates taken previously and the status of them.',
	msgWarningTitle: 'Warning',
	btnProceedContentUpdate: 'Proceed',
	btnCancelContentUpdate: 'Cancel',
	confirmationMessageP1: 'You are about to complete a content update for the selected content categories. Select',
	confirmationMessageP2: 'to continue or select',
	confirmationMessageP3: 'if you do not wish to complete the content update at this time.',
	warningMessage: 'One or more content types must be selected for update',
	groupReportingFormsSent: 'group reporting <b>forms sent</b>',
	groupReportingFromStatus: 'Group reporting form status',
	primaryTeamReviewStatus: 'Primary team review status',
	reportingStatus: 'Reporting status',
	taskStatusLabel: 'Task status',
	primaryTeam: 'Primary team',
	componentTeam: 'Component team',
	groupTasksReceived: 'group audit <b>tasks received</b>',
	group: 'Group',
	regionalTeam: 'Regional team',
	unlinkedLabel: 'Unlinked',
	linkedLabel: 'Linked',
	unlinkedTasks: '<b>unlinked tasks</b>',
	unlinkedTask: '<b>unlinked task</b>',
	primaryTeamGroupTaskPlaceholder: "Create components and send group instructions to monitor progress here.",
	componentTeamGroupTaskPlaceholder: "Accept component group tasks from the primary team to see a summary of progress here.",
	confirmUpdateMessage1: "Updating these forms may have a significant impact on the content. Once started, no additional content update can be performed until these complete. ",
	confirmUpdateMessage2: 'Select "Proceed" to continue or select "Cancel" if you do not wish to complete the content update at this time.',
	updateSelectedTitle: 'Update selected',
	statusCodeForbidden: 403,
	pspAccountHeader: "Account",
	pspAccountDateHeader: "Date of content",
	pspAccountStatus: "Status",
	pspAccountSelected: "selected",

	/*Preapre for Arc*/
	YearEndDate: "Year end date:",
	PeriodEndDate: "End date of period covered:",
	ReportDate: "Report date:",
	ArcDeadlineDate: "Archive deadline date:",
	ClientCode: "Client code:",
	PrimaryEngCode: "Primary engagement code:",
	SecondaryEngCode: "Secondary engagement code:",
	ReportType: "Is the report(s) qualified in any way and/or does it have emphasis of matter?:",
	ProtectedDocuments: "Note: Protected documents should not be retained in engagement files unless necessary",
	noObjectsAvailable: 'No objects available',
	CurrentlyUnavailable: 'Currently unavailable',
	showMoreToggle: 'Show more',
	showLessToggle: 'Show less',

	//#region Document upload status

	docListUploadTemporaryPlaceholder: '<center>No documents available<br />―<br />You can drag and drop one or more documents or click <button class="motif-button motif-text-alt-button motif-button-small">Add temporary files</button></center>',
	uploadEvidencePlaceholder: 'Drag and drop one or more documents or click <a>Add evidence</a>',
	uploadTemporaryPlaceholder: 'Drag and drop one or more documents or click <a>Add temporary files</a>',

	processing: 'Processing',
	uploading: 'Uploading',
	uploadComplete: 'Processing',
	downloading: 'Downloading',
	downloadComplete: 'Download Complete',
	loading: 'Loading',

	//#region Filter

	filter: 'Filter',
	noFiltersAvailable: 'No filters available',
	pickADate: 'Pick a Date',
	filterYes: 'Yes',
	filterNo: 'No',

	//#region Document list filters
	filterGroupDocumentsLabel: 'Documents',
	filterDocumentContentLabel: 'Document content',
	filterSharedEvidenceLabel: 'Shared evidence',
	filterFileExtensionLabel: 'File extension',
	filterDocumentConflictLabel: 'Conflicts',
	filterDuplicateFileNameLabel: 'Duplicate file name',
	filterCanvasFormsLabel: 'Canvas forms',

	filterGroupModificationsLabel: 'Modifications',
	filterLastModifyUserLabel: 'Last modified by',
	filterModifyAfterReviwerSignoffLabel: 'Modified since reviewer sign-off',
	filterModifiedAfterLabel: 'Modified after',

	filterGroupReviewNotesLabel: 'Review notes',
	filterReviewNoteStatusLabel: 'Status',
	filterReviewNoteAssignedToLabel: 'Assigned to',
	filterReviewNoteAuthoredByLabel: 'Authored by',
	filterReviewNoteOtherEngagementLabel: 'From other engagements',

	filterGroupSignOffsLabel: 'Sign-offs',
	filterSignOffMissingLabel: 'Missing sign offs',
	filterSignedOffByUserLabel: 'Signed off by',
	filterNotSignedOffByUserLabel: 'Not signed off by',
	filterSignOffRequirementsLabel: 'Sign-off requirements',

	filterGroupOtherLabel: 'Other',
	documentLink: 'Document link',
	filterByCopyLinkDocument: 'Filtered by copy link document',
	filterGroupAuditComponentLabel: 'Region/Component team',
	noGroupAuditComponents: 'No components have been created',
	filterFindingsLabel: 'Findings',
	filterGroupInstruction: 'Group instruction',
	noGroupInstruction: 'No instructions have been created',

	documentSearchPlaceholderLabel: 'Search documents',
	analyticSearchPlaceholderLabel: 'Search analytics',
	//#endregion

	//#endregion

	pendingResponseLabel: 'Pending response',
	receivedLabel: 'Received',
	dueToPrimaryTeam: 'Due to primary team',
	sentToPrimaryTeam: 'Sent to primary team',
	documentationPending: 'Documentation pending',
	documentationComplete: 'Documentation complete',
	viewBytimephaseTextLabel: 'View by time phase',
	showDetails: 'Show details',
	referenceDocAddDocHeaderText: 'Relate evidence or temporary files from this engagement in order to access them from the dashboard.',
	addDocsToTeam: 'Add documents to team documents',
	addDocsToMy: 'Add documents to my documents',
	addDocument: 'Add documents',
	externalUserRemove: 'Remove',

	// Internal user roles abbr
	adminRole: 'Admin',
	readOnlyRoleForThirdPartyUser: 'Read-only',
	legacy: 'Unrestricted',
	permissionLabel: 'Permission',
	displayPermissionErrorText: 'Cannot display permissions at the moment. Try again and if the issue persists, contact the Help Desk.',
	onlyShowRelatedTasks: 'Only show related tasks',

	softwareUpdate: 'Software updates',
	updateNow: "Update now",
	updateMsg: "Software updates are available for EY Canvas. Select Update Now to download and install the updates. The page will be refreshed.",

	processingError: 'Processing Error',

	//Create tag modal labels
	createtags: "Create tags",
	reportDate: 'Report Date:',
	managetags: 'Manage tags',
	savechanges: 'Save changes',
	manageTagGroupCreate: "Create",
	manageTagGroupDiscard: "Discard",
	manageTagGroupCreateTooltip: "Tag group",
	deletetag: 'Delete tag',
	deletetaggroup: 'Delete tag group',
	createTagGroup: "Create tag group",
	manageTagGroupName: 'Tag group',
	countOftasksAssigned: 'Count of tasks assigned',
	createTagGroupMessage: 'Create tag groups and tags to get started. Click {0} to create a tag group.',
	tagsContnetSearchPlaceholder: 'Search Tags',
	deleteTagHoverText: 'This tag will be removed from all tasks in your engagement.',
	deleteTagGroupHoverText: 'All tags in this group will be deleted and removed from all tasks in your engagement.',
	tagSaveChangesInfoText: 'Changes will be applied once saved.',
	tagConfirmModalTitleText: 'Confirm changes',
	tagConfirmModalPrimaryMessage: 'Are you sure that you want to save these changes?',
	tagConfirmModalSecondaryMessage: 'Once saved, any deleted tags or tag groups cannot be recovered.',
	tagDeleteModalSecondaryMessage: 'Once saved, any deleted tags cannot be recovered.',
	createNewTag: 'Create new tag',
	tagWillBeRemovedFromRequests: 'This tag will be removed from all requests in your engagement.',
	eyTags: 'EY tags',
	clientTags: 'Client tags',
	allTags: 'All tags',
	// Add canvas form
	addCanvasForm: 'Add Canvas form',
	addCanvasFormName: 'Document name',
	addCanvasFormNameBlankMessage: 'Document name is a required field',
	addCanvasFormNameInvalidCharacterMessage: 'Name cannot contain any of the following characters: */:<br>\\?|"',
	addCanvasFormDigital: 'Digital',
	addCanvasFormCore: 'Core',
	addCanvasFormNonComplex: 'Non-Complex',
	addCanvasFormComplex: 'Complex',
	addCanvasFormListed: 'Listed',
	addCanvasFormGroupAudit: 'Group audit',
	addCanvasFormPCAOBFS: 'PCAOB-FS',
	addCanvasFormPCAOBIA: 'PCAOB-IA',
	addCanvasFormStandards: 'Standards',
	addCanvasFormStandardsNotSelectedMessage: 'Standard is a required field',
	addCanvasFormLanguage: 'Language',
	addCanvasFormLanguageNotSelectedMessage: 'Language is a required field',
	addCanvasFormNoResultFound: 'No results found',
	addCanvasFormManageTasks: 'Manage tasks',
	addCanvasFormAvailableTasks: 'Task name',
	addCanvasFormAvailableTaskType: 'Type',
	addCanvasFormTypeOfForm: 'Type of form',
	addCanvasFormSubServiceLine: 'Sub service line',
	addCanvasFormTypeOfFormNotSelectedMessage: 'Type of form is a required field',
	addCanvasFormSelectedTasks: 'Selected tasks',
	addCanvasFormNoTaskDataAvailable: 'No tasks selected. Select at least one task to create a form.',
	addCanvasFormCreateForm: 'Create form',
	addCanvasFormCancel: 'Cancel',
	addCanvasFormSuccessMessage: '{0} has been successfully created. It may take up to ten minutes for the content to be delivered.',
	// Add Canvas form manage Objects
	addCanvasFormManageObjects: 'Manage {0}',
	addCanvasFormAvailableObjects: '{0} name', //
	addCanvasFormSelectedObjects: 'Selected {0}',
	addCanvasFormClickHereToOpenManageTab: 'Click here to open "Manage {0} tab',
	addCanvasFormNoObjectsDataAvailableRequired: 'No {0} selected. Select at least one to create a form.',
	addCanvasFormNoObjectsDataAvailableOptional: 'No {0} selected.',
	addCanvasFormObjectNotDefinedMessage: 'Objects are not available for this form',
	addCanvasFormOptional: '(optional)',
	addCanvasFormObjects: 'objects',
	addCanvasFormObject: 'Object',
	addCanvasFormSCOT: 'SCOT',
	addCanvasFormSCOTs: 'SCOTs',
	addCanvasFormITProcess: 'IT process',
	addCanvasFormITProcesses: 'IT processes',
	addCanvasFormControl: 'Control',
	addCanvasFormControls: 'controls',
	addCanvasFormITControl: 'IT control',
	addCanvasFormITControls: 'IT controls',
	addCanvasFormITApplication: 'IT application',
	addCanvasFormITApplications: 'IT applications',
	addCanvasFormSignoffRequirements: 'Required sign-offs:',
	addCanvasFormPICCheckBox: 'PIC',
	addCanvasFormEQRCheckBox: 'EQR',
	itProcessRelatedITGCITSP: 'IT process and related ITGCs/ITSPs',
	taskTitle: 'Understand and document the IT Process: {0}',
	taskDescription: 'Document our understanding of the IT process. Attach the relevant form as evidence to support our understanding of the IT process.<br>When ITGCs appear in the Task Attributes section, perform walkthrough procedures to confirm our understanding of the ITGCs and evaluate their design and implementation. Attach evidence of our procedures.',
	addCanvasFormAccounts: 'accounts',
	addCanvasFormAccount: 'account',
	addCanvasFormErrorMessage: 'This form can only be related to one account',
	addCanvasFormValidationMessage: 'A selection is required',
	addCanvasFormEstimates: 'estimates',
	addCanvasFormEstimate: 'estimate',
	addEstimateCanvasFormErrorMessage: 'This form can only be related to one estimate',
	addControlCanvasFormErrorMessage: 'This form can only be related to one control',
	addScotCanvasFormErrorMessage: 'This form can only be related to one SCOT',

	//Independence Confirmation
	sortOrderIndependence: 'Sort order',
	confirmationStatus: 'Confirmation status',
	confirmationDate: 'Confirmation date',
	independenceConfirmationSearch: 'Search team members',
	editTemplate: 'Edit template',
	viewTemplate: 'View Template',
	confirmedBy: 'confirmed by',
	overriddenBy: 'overridden by',
	grantedBy: 'granted access by',
	deniedBy: 'denied access by',
	list: 'List',
	paginationShow: 'Show',
	options: 'Options',
	removeTeamMemberModalText: 'Are you sure that you want to remove this team member from your engagement?',
	removeTeamMemberModalTitle: 'Remove team member',
	overrideRemovedBy: 'Override removed by',

	// Custom instructions
	addCustomInstruction: 'Add custom instructions',
	editCustomInstruction: 'Edit custom instructions',
	customInstructionInstructionalText: 'Add or edit custom instructions here.  These instructions will appear on each team member’s individual independence confirmation to provide guidance on how to respond to client-specific questions.',
	customInstructionPermissionTooltip: 'You must have the <b>Administer engagement</b> permission to take this action. Speak with an <b>Engagement Administer</b> to request permission.',
	customInstructionMaxLengthExceeded: 'Text exceeded maximum allowed length',

	//Independence Confirmation Details
	details: 'Details',
	question: 'Question',
	answer: 'Answer',
	countTeamMembers: 'Count of team members',
	executiveApproval: 'Executive approval',
	yes: 'Yes',
	no: 'No',
	independenceModalText: 'Here you can see the team members who selected this answer on their Individual Independence Confirmation.',
	notApplicable: 'Not applicable',
	readMore: 'Read more',
	readLess: 'Read less',
	teamMembsersTitle: 'Team member details',

	tasksSelected: 'tasks selected',
	taskSelected: 'task selected',
	unselectAll: 'Unselect all',
	addForm: 'Add form',
	addFormName: 'Name',
	addFormDigital: 'Digital',
	addFormCore: 'Core',
	addFormNonComplex: 'Non-Complex',
	addFormComplex: 'Complex',
	addFormListed: 'Listed',
	addFormGroupAudit: 'Group audit',
	addFormPCAOBFS: 'PCAOB-FS',
	addFormPCAOBIA: 'PCAOB-IA',
	addFormStandards: 'Standards',
	addFormLanguage: 'Language',
	addFormManageTasks: 'Manage Tasks',
	addFormManageObjects: 'Manage Objects',
	addFormAvailableTasks: 'Available tasks',
	addFormAvailableObjects: 'Available objects',
	addFormTypeOfForm: 'Type of form',
	addFormSelectedTasks: 'Selected tasks',
	addFormSelectedObjects: 'Selected objects',
	addFormCreateForm: 'Create form',
	addFormCancel: 'Cancel',
	createtag: "Create tag",
	tagsLabel: 'Tags',

	//Group instruction summary
	sInstruction: 'Scope',
	iInstruction: 'Individual',

	//CGT and CGT Unlinked related labels
	cgtSend: 'Send',
	cgtDueDate: 'Due date',
	cgtFrom: 'From',

	notesSelected: 'notes selected',
	noteSelected: 'note selected',
	cgtUnlinkedLabel: 'Unlinked',
	cgtUnlinkedInformationMessage: 'This task is no longer linked to another group engagement and can be deleted if it is no longer required.',
	sendtoPrimaryTeam: 'Send to primary team',
	sendtoPrimaryTeamdisableBtn: 'This task must contain evidence with at least one preparer and reviewer sign-off to send to the primary team',
	cgtSendModalHeader: 'Select one or more documents to send to the primary team. <span class="modal-instruction-text">Canvas forms will be sent in PDF format.  A record of PDF Canvas forms sent to the primary team is available in Temporary files.</span>',
	cgtNotifyCheck: 'Notify the primary team that no further documents are expected to be sent.',
	cgtCanvasFormValidation: 'There are unresolved validations in this Canvas form. Consider whether the validations should be resolved before sending it to the primary team.',
	finalVersionLabel: 'Final version',
	draftVersionLabel: 'Draft version',
	otherEvidence: 'Other evidence',
	selectAtLeastOneDocument: 'Select at least one document to continue.',
	cgtsendmodelinstructionheader: 'Select one or more documents to send to the primary team. <span class="modal-instruction-text">Marking a document as <b>Draft version</b> informs the primary team that you are still working on the document and may send additional versions. Marking a document as <b>Final version</b> informs the primary team that your work is complete and that you do not expect to send any additional versions of the document.</span>',
	//Independence confirmation
	undefined: 'Undefined',
	incomplete: 'Incomplete',
	nomattersidentified: 'No matters identified',
	matteridentifiedpendingaction: 'Matter identified - Pending action',
	matterresolveddeniedaccess: 'Matter resolved - Denied access',
	matterresolvedgrantedaccess: 'Matter resolved - Granted access',
	notapplicable: 'Not applicable',
	restored: 'Restored',
	overriden: 'Overriden',
	override: 'Override',
	priornomattersidentified: 'Prior - No Matters Identified',
	priormatteridentifiedpendingaction: 'Prior - Matter identified - Pending action',
	priormatterresolvedgrantedaccess: 'Prior - Matter Resolved - Granted Access',
	priormatterresolveddeniedaccess: 'Prior - Matter Resolved - Denied Access',
	addTagsLabelForTaskList: 'Add tags',
	addTagLabelForTaskDetails: '+ Add tag',
	manageTagsColorInputLabel: 'Color',
	manageTagsTagNameInputLabel: "Tag name",
	addTagRequiredMessage: 'Required',
	addNewTagLinkText: 'Add new tag',
	manageTagsLabel: "Manage tags",
	manageTagGroupHeader: "Create new tags and groups here. You can also edit and delete existing tags and groups. Tagging tasks can improve your engagement's organization and project management.",
	//add tag color dropdown
	addTagRedColorText: 'Red',
	addTagOrangeColorText: 'Orange',
	addTagTealColorText: 'Teal',
	addTagBlueColorText: 'Blue',
	addTagPurpleColorText: 'Purple',
	addTagGreenColorText: 'Green',
	deleteAssignmentConfirmationMessage: 'Are you sure that you want to delete this assignment?',

	// Return label for Returned document
	recieved: 'Received',

	selectServiceOffering: 'Select service offering',
	selectTasks: 'Select tasks',
	reviewSuggestedTasks: 'Review suggested tasks',
	reviewAvailableTasks: 'Review available tasks',
	setDueDate: 'Set due date',
	schedulerCreateRequestStep4TabText: 'Operating and communication protocols',
	createWorkRequestHeadingpart1: 'Name your service request and select a service offering to get started.',
	createWorkRequestHeadingpart2: "The service offerings listed below are based on your engagement's profile and the services available in your region. Costs vary by the rank of assigned resources and complexity.",
	createWorkRequestHeadingpart3: 'If your engagement has been rolled forward, any service offerings used by your engagement in the prior period are labeled with a ',
	createWorkRequestHeadingpart4: 'Prior period ',
	createWorkRequestHeadingpart5: 'badge.',
	createWorkRequestStep2Headingpart1: 'Review tasks that are available for the ',
	createWorkRequestStep2Headingpart2: ' service offering.',
	createWorkRequestStep2Headingpart3: '<u>For team’s participating in the Wave 2 centralization pilot</u>, select the relevant tasks based on the following criteria, which centralized team members may perform: (1) Objective audit procedures (i.e. those procedures that require little or no judgement), (2) Subjective procedures (i.e. those procedures that require judgment) only for either lower risk estimates or when inherent risk is lower for the relevant assertion(s).Tasks that are already included in another centralized service request are labeled as ',
	createWorkRequestStep2Headingpart4: '. If you used this service before, tasks that were included in your prior period request are labeled as ',
	createWorkRequestStep2Headingpart5: 'Prior period.',
	requestName: 'Request name',
	submittedBy: 'Submitted by',

	// Next wave labels
	totalTasks: 'Tasks',
	noServiceRequest: 'No service requests have been created yet. Create and submit service requests to get started.',
	eyContact: 'EY contact',
	requestStatusText: 'Request status',
	requestsByStatusText: 'Requests by status',
	serviceRequest: 'Service Requests',
	serviceGateway: 'Service Gateway',
	centralizedServices: 'Request services',
	serviceRequestDueDate: 'Due',
	NA: 'N/A',
	more: 'More',
	eycontacts: 'EY contacts',
	addEYContact: 'Add EY contact',
	editEYContacts: 'Edit EY contacts',
	addEYContactInstructions: 'Add or remove EY contacts for this request.  The updated EY contacts will be sent to the resource managers and assigned resources.',
	editEYContactDisabledInstructions: 'You must have the <b>Request services</b> permission to take this action. Speak with an engagement administrator to gain access.',
	emptyEYContactsPlaceholder: 'Add at least one EY contact to continue.',
	estimatedHours: 'Time to complete (hours)',
	resourceManagers: 'Resource managers',
	nextWaveServices: 'Centralized Services',
	centralizedservices: 'Centralized Services',
	onlyShowAccepetedRequests: 'Only show accepted requests',
	showSelectedOnly: 'Only show selected',
	emptyEngCodeMessage: 'There are no valid codes for your engagement.',
	primary: 'Primary',
	estimatedCosts: 'Estimated costs',
	assignedResources: 'Assigned resources',
	generalAuditTasks: 'General Audit tasks',
	generalInfo: 'General information',
	requestID: 'Request ID',
	createdDate: 'Created',
	startDate: 'Start',
	serviceRequestDue: 'Due',
	comingDueIn: 'Coming due in',
	comingDueTodayLabel: 'Coming due today',
	daysLabel: 'days',
	dayLabel: 'day',
	createByLabel: 'Created by',
	notProvidedLabel: 'Not provided',
	editLabel: 'Edit',
	serviceRequestNoHistoryLabel: 'There is no history for this request.',
	serviceRequestHistoryLabel: 'History log',
	serviceRequestTasks: 'Service Request Tasks',
	suggestedRequestTasks: 'Suggested Request Tasks',
	estimatedCost: 'Estimated cost',
	addinstructionsAndRelatedFiles: 'Add other operating and communication protocols for this request.',
	instructionText: 'Evidence related to this request will be archived and included with this request if you roll forward your engagement next year. Temporary files will not be archived and will not be included with this request if you roll forward your engagement.',
	instructionPlaceHolder: 'Other operating and communication protocols',
	warningText: 'Evidence will be archived with the request but temporary files will not.',
	availableDocuments: 'Available documents',
	noDocumentsAvailable: 'No documents available.',
	selectAll: 'Select all',
	deselectAll: 'Deselect all',
	documentsSelected: 'documents selected',
	selectedDocuments: 'Selected documents',
	noDocumentSelected: 'No documents have been selected yet. Select a document to get started (optional).',
	TaskName: 'Task name',
	AssignmentsLabel: 'Assignments',
	noTaskAssociatedToServiceRequest: 'There are no tasks associated to this request.',
	requestServices: 'Request services',

	serviceNotEditable1: 'To modify the tasks included in this request, select ',
	serviceNotEditable2: 'Edit ',
	serviceNotEditable3: 'on the ',
	serviceNotEditable4: 'Tasks ',
	serviceNotEditable5: 'tab. To make additional changes or cancel this service request, then ',
	serviceNotEditable6: 'contact one of the resource managers ',
	serviceNotEditable7: '(if assigned).',

	serviceReqMarkComplete: 'Marking a centralized service request as complete will inform the service provider that no additional work is required and that you have finished your review. Once the service request is marked complete, it cannot be undone.',
	serviceReqMarkCompleted: 'Completed',
	editServiceRequestTasks1: 'Review tasks that are selected for this service request.',
	editServiceRequestTasks2: 'All tasks that are suggested for the ',
	editServiceRequestTasks3: ' service offering are presented here. To add a task, select it from the list below. To remove a task, unselect it.',

	submitServiceRequestConfirmation1: 'Are you sure that you want to submit this service request?',
	submitServiceRequestConfirmation2: 'You selected a service offering that has already been submitted for your engagement.',
	alreadyScheduledHeader: 'Service offering already scheduled',

	createServiceRequestPermission1: 'You must have Create service request permissions to continue.',
	createServiceRequestPermission: 'You must have the <b>Manage service requests</b> permission to take this action. Speak with an Engagement Administrator to gain access.',
	schedulerRequestSubmissionError: 'An error occurred that prevented this request from being submitted to the scheduler. Select <b>Resubmit</b> to try again. Contact the Help Desk if the error persists.',
	resubmit: 'Resubmit',
	noServiceManager: 'A resource manager has not been assigned to this request yet.',
	noAssignedResource: 'No resources have been assigned to this request yet.',
	noMileStoneSetForService: 'Milestone start and due dates have not been set for this request yet.',
	isEngagementNominnatedForCentralizeService: 'Has your engagement been selected or confirmed by your Region to participate in the GDS Centralization pilot?',
	needApprovalForSericeRequestCreation: 'Please contact your Regional Assurance Managing Partner to obtain the appropriate approval to continue with this service request.',

	//TaskList Filters
	filterMissingRelatedTaskLabel: 'PIC/EQR document not related to task',
	filterRelatedToRisksLabel: 'Related to risks',
	filterGroupTasksLabel: 'Tasks',
	filterGroupAssignmentsLabel: 'Assignments',
	filterGroupDocumentsignoffsLabel: 'Document sign-offs',
	filterGroupProjectManagementLabel: 'Project management',
	filterAssignmentTypeLabel: 'Assignment type',
	filterTaskStatusLabel: 'Task status',
	filterTaskTypeLabel: 'Task type',
	filterAssignedToLabel: 'Assigned to',
	filterAssignmentStatusLabel: 'Assignment status',
	filterTaskReviewNoteStatusLabel: 'Note status',
	filterTaskCommentStatusLabel: 'Notes status',
	filterTaskReviewNoteAssignedToLabel: 'Assigned to',
	filterTaskReviewNoteAuthoredByLabel: 'Created by',
	filterPICDocumentsAssociated: 'PIC documents associated',
	filterEQRDocumentsAssociated: 'EQR documents associated',
	missingSignOffs: 'Missing sign-offs',
	signedOffBy: 'Signed off by',
	notSignedOffBy: 'Not signed off by',
	filterTimePhaseLabel: 'Time phase',
	filterMilestoneLabel: 'Milestone',
	filterAuditPhaseLabel: 'Audit phase',
	filterEngagementPhaseLabel: 'Engagement phase',
	filterDocumentConflictsLabel: 'Document conflicts',
	filterEntitiesLabel: 'Entity',
	missingEntityDocuments: 'Missing entity documents',
	filterDownloadedForOfflineLabel: 'Downloaded for offline',
	filterNextwaveServicesLabel: 'Centralized services',
	filterServiceGateway: 'Service gateway',
	filterScheduledServicesLabel: 'Related services',
	filterSuggestedServicesLabel: 'Suggested services',
	NoDocumentSignedOffLabel: 'No documents signed off by',
	SomeDocumentSignedOffLabel: 'Some documents signed off by',
	AllDocumentSignedOffLabel: 'All documents signed off by',
	usersLabel: 'Team members',
	serviceRequests: 'Centralized services',
	backToMainPage: 'Back to main page',
	suggestedNextwaveRequests: 'Suggested centralized requests',
	/* Component Send Status */
	deliveredDate: 'Delivered: {0}',
	sentDate: 'Sent: {0}',
	sentFailure: 'Delivery failure has occurred, try again and if the issue persists contact the Help Desk.',
	chooseTaskInstructionLabel: 'Choose tasks to include with this request.',
	createSRstep2InstructionalTextPart1: 'Tasks that are already included in another request are labeled as ',
	createSRstep2InstructionalTextPart2: '. If you used this service offering before, tasks that were included in your prior period request are labeled as ',
	createSRstep2InstructionalTextPart3: ' Use the toggle below to only show suggested tasks.',
	availableTasksLabel: 'Available tasks',
	guidance: 'Atlas Guidance',
	helixAnalyzers: 'Helix analyzers',
	eyHelix: 'EY Helix',
	smartAutomationLinks: 'Smart Automation',
	createAutomation: 'Create automation',
	noProjectTitle: 'Link a Helix project',
	multipleProjectsTitle: 'Select a linked Helix project',
	noProjectMessage: 'Link a Helix project to this engagement to get started on this Helix analyzer.',
	multipleProjectsMessage: 'This engagement is linked to multiple Helix projects. Select a Helix project from the list below to proceed.',

	automationGuidanceHeader: 'Suggested automations',
	helixAnalyzersHeader: 'Suggested analyzers',
	linkToHelixLabel: 'Link to Helix',
	noSelectedTasksText: 'No tasks have been selected yet. Select a task to get started.',
	selectedTasksLabel: 'Selected tasks',
	serviceOffering: 'Service offering',
	submitRequest: 'Submit request',
	scheduleYourRequest: 'Schedule your request.',
	serviceRequestStep3HeaderText: 'Select the start date that you would like the assigned resources to begin working on these tasks. Then select the date that these tasks should be completed by.',
	serviceRequestMilestoneDueDateHeaderText1: 'Select the ',
	startanddue: ' start and due date ',
	eachmilestone: 'for each milestone.',
	serviceRequestMilestoneDueDateHeaderText2: ' Your team is ultimately responsible for all work delivered. Therefore, the due date selected should allow sufficient time for your team to review the work delivered.',
	serviceRequestMilestoneDueDateHeaderText3: ' Estimated time to complete should only include time you expect the service provider to incur.',
	schedulerBudgetMainQuestion: 'Has your engagement team:',
	schedulerBudgetFirstQuestion: 'Included all work for this request in your financial, pricing, and planning processes?',
	schedulerBudgetSecondQuestion: 'Notified your onshore Experience Manager about this request?',
	schedulerBudgetThirdQuestion: 'Adjusted hours for onshore team members appropriately?',
	timetocompleteinfo1: 'Estimated time to complete should only include',
	timetocompleteinfo2: ' time you expect the service provider to incur.',
	serviceRequestStartDate: 'Start',
	saveDraft: 'Save draft',
	step3ValidationError: 'Due date must fall after start date',
	scheduledLabel: 'Scheduled',
	suggestedLabel: 'Suggested',
	searchTasksLabel: 'Search tasks',
	submit: 'Submit',
	selectTaskRequiredErrorMessage: 'You must select at least one task to continue.',
	moveToCompleted: 'Move to completed',
	requestResubmitMessagePart1: 'Re-submitting this request will reset the status to ',
	requestResubmitMessagePart2: 'Pending. ',
	requestResubmitMessagePart3: 'Any changes made will be reviewed by the Scheduler.',
	showSuggestedTaskToggle: 'Only show suggested tasks',

	// Assignments
	addAssignmentName: "Add assignment name",
	editAssignmentName: "Edit assignment name",
	deleteAssignmentName: "Delete assignment name",
	deleteAssignmentNameInstructionalTextHeader: "Are you sure that you want to delete this assignment name?",
	deleteAssignmentNameInstructionalText: "Once deleted, the assignment will be removed from all team members and roles in your engagement.",
	assignmentType: "Assignment type",
	assignmentTypeInstructionalText: "Select an assignment type and enter a name below. Click <b>Add</b> when you are done.",
	assignmentEditInstructionalText: "Edit the assignment type and name below. Click <b>Save changes</b> when you are done.",
	noSuggestedTaskLabel: 'No suggested tasks in this category.',
	manageAssignmentsLabel: 'Manage assignments',
	myAssignmentsLabel: 'My assignments',
	myAssignedTasks: 'My assigned tasks',
	currentlyAssignedTasks: 'Currently assigned',
	assignmentModalInstructionalText1: "To reassign or remove tasks assigned to a team member or role, select their name below. You may also use the <b>Delete</b> icon to delete all assignments for a team member or role. To edit or delete the name of an assignment, select the <b>More</b> menu.",
	unassignedTasks: "Unassigned tasks",
	assignedTasks: "Assigned tasks",
	type: 'Type',
	priorperiodservicerequests: 'Prior period service requests',
	unmarkcomplete: 'Unmark complete',
	taskAttributes: 'Task attributes',
	engagementTeam: 'Engagement team',
	assignTo: 'Assign to',
	reAssignTo: 'Reassign to',
	assign: 'Assign',
	reAssign: 'Reassign',
	reAssignWarningLabel: 'Select one or more tasks to reassign.',
	assignWarningLabel: 'Select one or more tasks to assign.',
	searchByTaskName: 'Search by task name',
	searchByTimePhaseName: 'Search by timephase name',
	assignment: 'Assignment',
	noMembersWithThisAssignment: 'There are no team members or roles with this assignment.',
	deleteTaskAssingmentByMemberAndAssignmentIntructionalText: 'The assignment will be removed from all tasks in your engagement.',
	noTaskAttributes: 'There are no attributes for this task. Select Create or Relate to get started.',
	assignmentWithoutAssignedUser: 'This assignment name is not currently in use.',

	// v2 profile navigation Zeus to Hercules to Kronos message
	v2ProfileDocumentIdAvailableMessage: 'Collecting profile information, please wait',
	v2ProfileDocumentIdDeletedMessage: 'No profile information found. Refresh the page and try again. if the error persists contact the Help Desk.',
	accountAndRelatedAssertions: 'Account and related assertions',
	risks: 'Risks',
	scotName: 'SCOT name',
	strategy: 'Strategy',
	transactionType: 'Transaction type',
	notSelectedText: 'Not selected',
	relatedBy: 'Related by',
	collaboration: 'Collaboration',
	controlsLabel: ' Controls',
	scotAndRelatedControls: 'SCOT and related controls',
	scotAndRelatedRisks: 'SCOT and related risks of material misstatement',
	frequencyLabel: 'Frequency',
	operatingEffectively: 'Operating effectively',
	designedEffectively: 'Designed effectively',
	timeToCompleteHours: 'Time to complete (hours)',
	completeRequiredFieldValidationError: 'Please complete all required fields in order to proceed.',
	itgcsAndItsps: 'ITGCs and ITSPs',
	itprocessItgcsAndItsps: 'IT process and ITGC/ITSPs',
	approachLabel: 'Approach',
	typeLabel: 'Type',
	itProcessName: 'IT process name',
	processEvaluation: 'Process evaluation',
	unrelatedControls: 'Unrelated controls',
	disableNextwavePlaceholder: 'Centralized services are not currently available for your country. Refresh the page and try again. Contact the Help Desk if the error persists.',
	disableNextwavePlaceholderDataCenter: 'Centralized services are not currently available for your local data center. Refresh the page and try again. Contact the Help Desk if the error persists.',
	dataPrivacyInviteMessage: 'Before inviting, have you adequately considered access restrictions to workpapers that may apply due to data privacy rules?',
	//Session Timeout
	sessionTimerMsg: 'Due to inactivity, your current work session is about to expire. For your security, EY Canvas sessions end automatically after 30 minutes of inactivity. Your current session will expire in {0} minutes. If you wish to remain logged in, please click Continue.',
	logout: 'Logout',
	sessionPopupTitle: 'Automatic logout for your protection',
	allSuggestedTasks: 'Tasks',
	viewByAccount: 'View by Account',
	viewBySCOT: 'View by SCOT',
	noServiceOfferingsAvailable: 'There are no service offerings available for your engagement at this time. Refresh the page and try again. Contact the Help Desk if the issue persists.',

	//Collaboration
	myRequests: 'My requests',
	allRequests: 'All requests',
	calendar: 'Calendar',
	calendarTodayButton: 'Today',
	requestsListButton: 'Request list',
	eventsButton: 'Events',
	analyticsButton: 'Analytics',
	showAssignedToMe: 'Show my requests',
	selectRequestsTitle: 'Select requests to view details',
	selectRequestsSub1: 'To enable bulk controls, use the check boxes or hold the',
	selectRequestsSub2: 'shift or control keys while selecting multiple requests.',
	noTagMessage: 'No tags created yet. Click <b>here<b> to get started.',
	tagAs: 'Tag as:',
	addTag: 'Add tag',
	searchTag: 'Search tags',
	documentsAttached: 'Documents attached',
	editDraftRequest: 'Edit draft request',
	deleteRequest: 'Delete request',
	deleteLabel: 'Delete',
	deleteLabelDisabled: 'Insufficient permissions to bulk delete.  Contact your engagement administrator and request permission to bulk delete.',
	DeleteRequestConfirmMsg1: 'Are you sure that you want to delete this request? ',
	DeleteRequestConfirmMsg2: 'This action cannot be undone.',
	deleteRequestSuccess: 'Request has been deleted',
	DeleteRequestsConfirmMsg1: 'Are you sure that you want to delete these {0} requests? ',
	dueDateCollabLabel: 'Due date',
	requestLabel: 'Request',
	statusLabel: 'Status',
	inValidRequestTitleLabel: 'The following requests cannot be deleted in the current status',
	bulkSendButton: 'Send',
	bulkDeleteButton: 'Delete',
	commentSyncFailedRetry: 'Comment could not be delivered to EY Canvas Client Portal. ',
	commentSyncFailedRetrySendAgain: 'Send again.',
	commentDeleted: 'This message has been deleted.',
	CommmentDeletionSyncFailed: 'Comment could not be deleted from EY Canvas Client Portal',
	clickLabel: 'Click',
	toRetry: 'to retry.',
	replySyncFailedRetry: 'Reply could not be delivered to EY Canvas Client Portal. ',
	quickFilterPriority: 'Priority',
	quickFilterErrorCounterTooltip: 'One or more requests has an error and requires attention.',

	eyContactNoResultsFound: 'User not found',
	eyContactClear: 'Clear',
	eyContactSearch: 'Search',
	eyContactCollaboration: 'EY contact',
	eyParticipantsCollaboration: 'EY participants',
	externalParticipantsCollaboration: 'External participants',
	syncInProgressEYContact: "Sync in progress",
	syncErrorEyContact: "Sync error. Please try again.",
	noAssignedContact: "No assigned contact",
	noAssignedParticipant: "No participants added",

	commentsTooltipLabel: "Comments",
	recordingVirusScanInProgress1: 'Virus scan in progress. Voice note will be available once complete.',
	screenrecordVirusScanInProgress1: 'Virus scan in progress. Screen record will be available once complete.',
	recordingVirusScanInProgress2: 'Refresh the page and try again.',
	confidentialDocumentsModalTitle: 'Confidential documents',
	confidentialDocumentsModalMsg1: 'The following confidential document(s) have been added to the request.',
	confidentialDocumentsModalMsg2: 'By clicking Continue, you are confirming that you have appropiate confidentiality level to send the document to EY Canvas Client Portal and that you have reviewed the assigment of the request.',
	confidentialDocumentsModalMsg3: 'You do not have the appropiate confidentiality level to send one or more of these documents to EY Canvas Client Portal. Please remove any confidential documents to which you do not have access in order to continue.',
	confidentialityLevel: 'Confidentiality level',
	voiceNoteUploadError: 'Error getting document details. Refresh the page and try again. If the issue persists, contact the Help desk.',
	requestEventTitle: 'Event ',
	noTaskDescription: 'No task description',

	newRequestLabel: "New request",
	newEventLabel: "New event",

	//Analytics Tab
	analyticsCreateDateLabel: 'Create date: ',
	createdByLabel: 'Created by: ',
	expirationDateLabel: 'Expiration date:',
	sharedWithLabel1: 'Shared with ',
	sharedWithLabel2: 'requests',
	sharedWithLabel3: 'request',
	analyticsTabTitle: 'Analytics',
	analyticsTabSubtitle: 'Share analytics with clients from connected EY Helix projects. To get started create a client inquiry from the bookmarks pane in ',
	analyticsTabSubtitle2: 'EY Helix',
	analyticsTabSubtitle3: '.',
	noActiveAnalyticsLabel: 'No analytics selected',
	noActiveAnalyticsSubtitleLabel1: "No analytics have been created. Click ",
	noActiveAnalyticsSubtitleLabel2: "here",
	noActiveAnalyticsSubtitleLabel3: " to get started.",
	noActiveAnalyticsSubtitleLabel4: 'After linking a project and saving bookmarks in EY Helix, come back to this page to preview analytics that can be shared to EY Canvas Client Portal.',
	selectAnalyticsLabel: 'Select analytics',
	analyticsNoPrimaryHelixProjectsMessage: 'This engagement is not linked to a Primary EY Helix project',
	selectAnalyticsModal: {
		closeTitleTip: 'Close',
		modalTitle: 'Select analytic',
		modalHeader: 'Select an analytic to share with external team members',
		selectAnalyticPlaceholder: 'Select analytic',
		selectAnalyticError: 'Analytic is required',
		analyticNamePlaceholder: 'Enter analytic name (required)',
		analyticNameError: 'Analytic name is required',
		cancel: 'Cancel',
		viewPreview: 'View analytic',
		noPreviewAvailable: 'No preview available',
		noPreviewDescription: 'Select an analyzer to enable preview',
		clickPreviewAnalytic: 'Click to preview the selected analytic',
		documentObservation: {
			label: 'Document any observation or query about the selected analytic',
			placeHolderLabel: 'Enter observation or query (optional)'
		}
	},
	viewAnalyticsModal: {
		closeTitleTip: 'Close',
		observationFieldPlaceholder: 'Observations or queries about the selected analytic',
		noObservationField: 'No observations or queries exist for this analytic.',
		appliedFiltersLabel: 'Applied filters',
		appliedFilters: [
			{
				id: '1',
				label: 'Analysis currency'
			},
			{
				id: '2',
				label: 'Currency code'
			},
			{
				id: '3',
				label: 'Display rounding'
			},
			{
				id: '4',
				label: 'Business unit group'
			},
			{
				id: '5',
				label: 'Business unit'
			},
			{
				id: '6',
				label: 'Primary account type'
			},
			{
				id: '7',
				label: 'Primary account sub-type'
			},
			{
				id: '8',
				label: 'Primary account class'
			},
			{
				id: '9',
				label: 'Primary account sub-class'
			},
			{
				id: '10',
				label: 'Primary account name'
			},
			{
				id: '11',
				label: 'Primary EY account designation'
			},
			{
				id: '12',
				label: 'Primary EY account'
			},
			{
				id: '13',
				label: 'Business unit'
			},
			{
				id: '14',
				label: 'Analysis date'
			},
			{
				id: '15',
				label: 'Comparative date'
			},
			{
				id: '16',
				label: 'Segment 01 group'
			},
			{
				id: '17',
				label: 'Segment 02 group'
			},
			{
				id: '18',
				label: 'Segment 03 group'
			},
			{
				id: '19',
				label: 'Segment 04 group'
			},
			{
				id: '20',
				label: 'Segment 05 group'
			}
		],
		save: 'Save',
		cancel: 'Cancel',
		disabledEdit: 'Observation cannot be edited because the request has already been sent to EY Canvas Client Portal. Please withdraw the request to enable this action.',
		errors: {
			unautorizedUser: 'You are not an authorized team member of the related EY Helix project. Contact the EY Helix project administrator to get access and try again.',
			bookmarkNotFound: 'The selected analytic has been deleted. Go to EY Helix to manage deleted analytics or to create a new analytic.',
			unautorizedAccessToBookmark: 'You do not have access to the requested EY Helix bookmark. Contact the EY Helix project administrator to get access and try again.',
			authenticationError: 'Authentication error. Refresh the page and try again. If the issue persists, contact the Help Desk.',
			genericError: 'Refresh the page and try again. Contact the Help Desk if the error persists.',
			defaultError: '{0} Refresh the page and try again. Contact the Help Desk if the error persists.'
		}
	},
	deleteAnalyticModal: {
		modalTitle: 'Delete analytic',
		modalHeader: 'Are you sure that you want to delete this analytic? The analytic will no longer be available within EY Canvas.'
	},
	// activity feed
	search: 'Search',
	searchTeams: 'Search teams',
	clear: 'Clear',
	groupActivityLabel: 'Group activity',
	documents: 'Documents',
	documentLabel: 'Document',
	linkRequests: 'Link requests',
	received: 'Received',
	returned: 'Returned',
	rejected: 'Rejected',
	accepted: 'Accepted',
	sent: 'Sent',
	unlinked: 'Unlinked',
	finalized: 'Finalized',
	groupActivityFeed: 'Group activity feed',
	component: 'Component',
	noExternalApprovalsMessage: 'There are no external approvals',
	noFileSelectedMessage: 'Select a document to view details',
	noInstructionSelectedMessage: 'Select an item to view details.',
	noLinkRequestSelectedMessage: 'Select an item to view details.',
	noItemSelectedMessage: 'Select an item to view details',
	viewGroupActivity: 'View group activity',
	pointOfContact: 'Point of contact',
	currentStatus: 'Current status',
	resolved: 'Resolved',
	viewVersion: 'View version',

	// activity feed right pane headings
	scope: 'Scope',
	groupRole: 'Group role',
	linkRequestStatus: 'Link request status',
	instructionStatus: 'Instruction status',
	linkStatus: 'Link status',
	today: 'Today',
	yesterday: 'Yesterday',
	thisWeek: 'This week',
	lastWeek: 'Last week',
	twoWeeksAgo: 'Two weeks ago',
	threeWeeksAgo: 'Three weeks ago',
	lastMonth: 'Last month',
	older: 'Older',
	actionsDateNote: 'All dates and times are reported in GMT time.',
	noActionsMessage: 'There is no data to display.',
	noManageRequestPermissionMessagePart1: 'You must have <b>Manage service request</b> permissions to take this action.',
	guidedWorkflow: 'EY Canvas FIT enablement',
	navExecution: 'Execution',
	navCanvasEconomics: 'EY Canvas Economics',
	navOversight: 'EY Canvas Oversight',
	navConclusion: 'Conclusion',
	navTeamMemberIndependence: 'Team member independence',
	navGroupAudit: 'Group management',
	navGroupActivityFeed: 'Group activity feed',
	navPrimaryStatus: 'Primary status',
	navComponentStatus: 'Component status',
	navGroupStatus: 'Group status',
	navEngagementManagement: 'Engagement management',
	navProfile: 'Profile',
	navGroupStructureSummary: 'Group structure',
	OpenGuidedWorkflowDocument: 'Open this document through the EY Canvas FIT enablement',
	navNotApplicable: 'Not applicable',
	canvasForms: 'Canvas forms',
	eYCanvasEconomics: 'EY Canvas Economics',
	overDueAssignments: 'Overdue assignments',
	comingDueAssignments: 'Coming due assignments',
	overDueReviewNotes: 'Overdue review notes',
	comingDueReviewNotes: 'Coming due review notes',

	//Group Audit/Status  for DashboardV2

	Reportingformsbystatus: 'Reporting forms by status',
	ReportingStatusSubTitle: 'View group tasks assigned to component teams below as well as a summary of group documents received by status. <br/> You can select to review detailed progress by team or by group task.',

	Total: 'Total',
	Returned: 'Returned',
	Overdue: 'Overdue ',
	PendingResponse: 'Pending response',
	Received: 'Received',
	ReadyForReview: 'Ready for review',
	messageNoDocument: 'No documents received yet.',
	byTeam: 'By team',
	byGroupTask: 'By group task',
	groupStructureLabel: 'Group structure',
	instructionPending: 'Instructions pending acceptance',
	linkRequestPending: 'Link request pending',
	notusingeycanvas: 'Not using EY Canvas',
	pendingLabel: 'Pending',
	teams: 'Teams',
	NoDocumentReceiced: 'No documents received yet.',
	selectTeamToSeeData: 'There is no data available. Select a team to see data here.',
	noDataAvailable: 'There is no data available.',
	prepared: 'Prepared',
	tasksAssigned: 'Tasks assigned',
	taskAssigned: 'Task assigned',
	instructionNotSent: 'Instructions not sent',
	assignedTeamNotProvidedDocForTasks: '\{0}\ teams have not sent documents for these tasks | \{1}\ documents expected',
	documentRecievedOutOfAssignedTasks: 'Documents received <br><b>\{0}\</b> out of \{1}\ Assigned tasks',
	documentRecievedOutOfAssignedTeams: 'Documents received <br><b>\{0}\</b> out of \{1}\ Assigned teams',

	groupStatusSubTitle: 'View group tasks assigned by the primary team below as well as a summary of group documents by status. <br/> You can select to filter the group tasks by task or document status.',
	notSent: 'Not sent',
	draftsent: 'Draft sent',
	finalsent: 'Final sent',
	noTaskForComponent: 'There is no data available.  <p> Group tasks sent from the primary team will be displayed here after they have been accepted.</p>',
	noTaskForComponentWithStatus: 'There is no data available. <p> Select one or more status options to see data here.</p>',

	//Dashboard V2 - activity feed
	activityFeedSubHeadingText: "Select an activity type to review the relevant engagement activity for the last 10 days. <br/> Click on a specific item's <b>Activity</b> icon to view all activity for that item. <br/> You can also use the toggle to refine your view.",
	activityFeedSubHeadingGroupAudit: "Select an activity type to review the relevant engagement activity for the last 10 days. <br/> Click on a specific item's <b>Activity</b> icon to view all activity for that item. <br/> You can also use the toggle to refine your view.",
	teamHistoryInstructionalText: 'Review the activity for this team for the past 10 days.',
	teamHistory: 'Team history',
	onlySeeMyActivity: 'See only my activity',

	taskAddedBy: 'Task added by ',
	taskMarkedCompleteBy: 'Task marked complete by',
	taskUnmarkedCompleteBy: 'Task unmarked complete by',
	taskHandedOffBy: 'Task handed off by',
	assignmentAddedBy: 'Assignment added by',
	assignmentEditedBy: 'Assignment edited by',
	assignmentClosedBy: 'Assignment closed by',
	assignmentReOpenedBy: 'Assignment reopened by',
	assignmentDeletedBy: 'Assignment deleted by',
	noteAddedBy: 'Note added by',
	noteClearedBy: 'Note cleared by',
	noteClosedBy: 'Note closed by',
	noteReopenedBy: 'Note reopened by',

	linkRequestSent: 'Link request sent by',
	instructionSentBy: 'Instructions sent by',
	linkRequestAcceptedBy: 'Link request accepted by',
	engagementUnlinkedBy: 'Engagement unlinked by',
	instructionAcceptedBy: 'Instructions accepted by',
	instructionReturnedBy: 'Instructions returned by',
	labelTo: 'to',
	instructionReceivedFrom: 'Instructions received from',
	filtersLabel: 'Filters',
	advanceOptions: 'Bulk operations',
	advanceOptionsLabel: 'Bulk operations',
	relatedScots: 'Related SCOTs',
	noRelatedScots: 'No related SCOTs',
	materialityLabel: 'Materiality',
	currentPeriod: 'Current date',
	previousPeriod: 'Prior date',
	showCurrentPeriod: 'Show current date',
	showPriorPeriod: 'Show prior date',
	planningMateriality: 'Planning materiality',
	tolerableError: 'Tolerable error',
	sadNominalAmount: 'SAD nominal amount',
	pmLabel: 'PM',
	teLabel: 'TE',
	sadLabel: 'SAD',
	accountBalance: 'Account balance',
	mapAccountBalances: 'Map account balances',
	connectToHelixProject: 'Connect to a Helix project',
	connectToImportBalances: ' to import balances',
	helixMultiple: 'Multiple',
	selectMESTentity: 'Select an entity to view details',
	relatedWCGWAndControls: 'Related WCGWs and controls',
	relateAtLeastOneWCGW: 'Each assertion with a control risk of Rely must have at least one related WCGW. ',
	notRelyRelateWCGW: 'Assertions with a control risk of Not Rely do not have a requirement to identify a WCGW.',
	relatedITProcesses: 'Related IT processes',
	noRelatedITProcesses: 'No related IT processes',
	relatedITRiskITGCs: "Related IT risks, ITGCs and ITSPs",
	relatedITRisks: 'Related IT risks',
	ALRAHigherRiskCode: 'H',
	materialityMestSelectEntity: 'Select an entity to view details',
	OARCurrentPeriod: 'Analysis date',
	OARComparative1Period: 'Comparative date 1',
	xTELabel: 'xTE',
	priorPeriodDesignation: 'Prior period designation:',
	priorPeriodEstimate: 'Prior period estimate:',
	notApplicableAbbreviation: 'N/A',
	accountDetails: 'Account details',
	launchGuidedWorkflow: 'Launch guided workflow',
	guidedWorkflowTitle: 'Guided workflow',
	viewAccountBalace: 'View account balances',
	viewAccountBalaceForEntity: 'Select an entity to view account balances',
	mainActivities: 'Main activities',
	oversightProjectTile:
	{
		typeOversight: 'oversight',
		createProject: 'Create project',
		oversightProjectengagementNotConnectedMessage1: 'The EY Canvas Oversight application summarizes milestone, project management, and group audit progress for connected engagements. Use it to ensure your group audit or portfolio of engagements is on track.',
		oversightProjectengagementNotConnectedMessage2: 'Your engagement is not connected to any EY Canvas Oversight projects.',
		click: 'Click',
		togetstarted: ' to get started',
		clickProjectmessage: 'Click <b> + Create project </b> to get started.',
		lblclient: 'Clients:',
		lblEngagementCount: 'Engagements:',
		lblTaskscompleted: "Tasks completed:",
		lblMore: "more",
		myProject: "My projects",
		OtherProject: "Other projects",
		oversightNoProjectConnectedMessage: "You are not a member of any of the EY Canvas Oversight projects that your engagement is connected to.",
		oversightOtherProjectNotConnectedMessage: "You are a member of all of the EY Canvas Oversight projects that your engagement is connected to.",
		draft: 'Draft',
		allTask: 'All Task',
		totalTask: 'Total Task',
	},

	economicsProjectTile:
	{
		typeEconomics: 'economics',
		economicsProjectengagementNotConnectedMessage1: 'The EY Canvas Economics application summarizes financial and EY Canvas progress.  Use it to manage the economics for your portfolio of engagements.',
		economicsProjectengagementNotConnectedMessage2: 'Your engagement is not connected to any EY Canvas Economics projects.',
		clickProjectmessage: 'Click <b> + Create project </b> to get started.',
		economicsNoProjectConnectedMessage: "You are not a member of any of the EY Canvas Economics projects that your engagement is connected to.",
		lblForecasted: "Forecasted:",
		lblActual: 'Actual:',
		lblETC: 'ETC:',
		lblVariance: 'Variance',
	},
	leftNavigation: {

		engagementOverview: 'Engagement overview',
		myProgress: 'My progress',
		executiveTasks: "Focus areas",
		integration: "Integration",
		groupAudit: "Group status",
		pinnedDocuments: "Pinned documents",
		Validations: "Validations",
		activityFeed: "Activity feed",
		primaryStatus: "Primary status",
		componentStatus: "Component status",
		picProgress: "PIC progress",
		picEQRProgress: "PIC/EQR progress",
		drillDown: "Drill down",
		maps: "Maps",
		financialStatement: "Financial statements",
	},
	nowRowOverlayClientRequest: {
		createNew: 'Click Add request to create a new request',
		all: 'No requests have been created',
		draft: 'No requests are in Draft status',
		pending: 'No requests are in Pending response status',
		received: 'No requests have been received',
		accepted: 'No requests have been accepted',
		customFilter: "No matches found. Please try again."
	},

	clientRequestPrefixes: {
		draft: 'Draft ',
		returned: 'Returned ',
		recalled: 'Recalled ',
		withdrawn: 'Withdrawn '
	},

	clientRequestsTabHeader: {
		all: 'All',
		draft: 'Draft',
		pending: 'Pending',
		received: 'Received',
		accepted: 'Accepted'
	},

	clientRequestsPriorityFilters: {
		all: 'All',
		normal: 'Normal',
		high: 'High',
		critical: 'Critical',
		highAndCritical: 'High + Critical'
	},

	requestTableHeader: {
		requestId: 'Request Id',
		title: 'Title',
		receivedDate: 'Received date',
		dueDate: 'Due date',
		sentDate: 'Sent date',
		acceptedDate: 'Accepted date',
		assignedTo: 'Assigned to',
		group: 'Group',
		status: 'Status',
		priorityType: 'Priority',
		tags: 'Tags'
	},

	dropdownColumnsFilter: {
		1: 'Assigned to',
		2: 'Group',
		3: 'Due date',
		4: 'Sent date',
		5: 'Received date',
		6: 'Accepted date',
		7: 'Status',
		8: 'Priority',
		9: 'Tags'
	},

	requestTableDropdownFilter: {
		customizeTable: 'Customize table',
		selectInfo: 'Select up to 4 options',
		selectInfoTooltip: 'Select up to four columns. Deselect one or more options to continue.'
	},

	ClientStatus: {
		1: "Draft",
		2: "Draft - No contact",
		3: "Sent",
		4: "System error",
		5: "Invalid client contact",
		6: "Pending response",
		7: "Received",
		8: "Accepted",
		9: "Returned",
		10: "Withdrawn",
		11: "Send in progress",
		12: "Accept in progress",
		13: "Withdraw in progress",
		14: "Delete in progress",
		15: "Return in progress",
		16: "Response in progress",
		17: "Deleted",
		18: "Invalid client contact",
		19: "Recall in transit",
		20: "Recalled",
		21: "Completion in progress",
		22: "Recall in progress"
	},

	analyticStatus: {
		1: 'Draft',
		2: 'Pending approval',
		3: 'Approved',
		4: 'Expired'
	},

	paginationControl: {
		firstPage: 'First Page',
		lastPage: 'Last Page',
		previousPage: 'Previous Page',
		nextPage: 'Next Page',
		show: 'Show'
	},

	auditPlanFilterLabels: {
		showMore: 'more',
		filterTypeOfScots: "SCOT",
		noScotsAvailable: 'No SCOTs available',
		filterTypeOfITProcess: "IT process",
		noITProcessAvailable: "No IT ​processes available",
	},

	controlListBuildStep4FilterLabels: {
		scots: {
			filterTypeOfScots: "SCOTs",
			noScotsAvailable: 'No SCOTs available',
		},
		testing: {
			filterTypeOfTesting: "Testing",
			noTestingAvailable: 'No Testing available',
		},
		designEffectiveness: {
			filterTypeOfDesignEffectiveness: "Design Effectiveness",
			noDesignEffectivenessAvailable: 'No Design Effectiveness available',
		},
	},

	clientRequestsFilterLabels: {
		filterAssignedTo: 'Assigned to',
		filterAttachmentsLabel: 'Attachment type',
		filterCreatedByLabel: 'Created by',
		filterStatusLabel: 'Status',
		filterDueAfterLabel: 'Due after',
		filterDueBeforeLabel: 'Due before',
		filterErrorsLabel: 'Errors',
		filterOverdueLabel: 'Overdue',
		filterTagLabel: 'Tag',
		filterTimePhaseLabel: 'Time Phase',
		filterTypeLabel: 'Type',
		filterPriorityLabel: 'Priority',
		searchMembers: 'Search members',
		noTags: 'No Tags have been created',
		noTimephase: 'No Time Phase',
		clearAll: 'Clear all',
		clearHoverText: 'Clear',
		noResultsFound: 'No results found',
		yes: 'Yes',
		no: 'No',
		showMore: 'Show more',
		// Check this
		filterNoMatchesFound: 'No matches found. Please try again.',
		filter: 'Filter',
		title: 'Filters',
		noRelatedTask: 'No related task',
	},
	//Dashboard - integration

	collaborationInstruction: 'View your Collaboration requests by status below. <br/> Click on a count to navigate to the request list with filters applied.',
	noValidationsAvailable: 'There are no validations for this audit phase.',
	individualView: 'Individual view',
	engagementView: 'Engagement view',
	centralizedServiceInstruction: 'View the percentage of tasks that are leveraging Centralized Services as well as requests by status below. <section >To create a new request, select <b>Request services.</b></section>',
	// Dashboard - todo list
	todoList: 'To-do list',
	todoListInProgress: 'Current',
	todoListOpen: 'Upcoming',
	todoListClosed: 'Completed',
	todoListInstruction: 'View assignments and review notes coming due by status. <br /> Select a time frame or category to refine your view. <br /> To open an item, click on the task or review note name.',
	noOpenAssignments: 'You do not have any open assignments.',
	noInProgressAssignments: 'You do not have any in progress assignments.',
	noClosedAssignments: 'You do not have any closed assignments.',
	allLabel: 'All',
	dueLabel: 'Due',
	noAssignments: 'You do not have any assignments.',
	executiveReview: 'Executive review',
	epTasksStatusSignOffWithoutDetails: 'View a summary of PIC status below.',
	epTasksStatusSignOff: 'View a summary of PIC status below. For a detailed look, select <b>View details</b>.',
	epeqrTasksStatusSignOffWithoutDetails: 'View a summary of PIC and EQR status below.',
	epeqrTasksStatusSignOff: 'View a summary of PIC and EQR status below. For a detailed look, select <b>View details</b>.',
	eqrDefaultMessage: "This engagement does not require an EQR.",
	selectPartners: 'Select a partner',
	noPartnersInEng: 'There are no partners in your engagement.',
	epTasks: 'PIC tasks',
	eqrTasks: 'EQR tasks',
	viewDetails: 'View details',
	picReview: 'PIC review',
	eqrReview: 'EQR review',
	eqrtasksWithSignOff: 'Tasks with EQR <br /> sign-offs incomplete',
	eqrdocumentsWithSignOff: 'Documents with EQR <br /> sign-offs incomplete',
	pictasksWithSignOff: 'Tasks with PIC <br /> sign-offs incomplete',
	picdocumentsWithSignOff: 'Documents with PIC <br /> sign-offs incomplete',
	partnerSignoffs: 'Partner sign-offs',
	epTaskswithpartnersignoffs: 'Click on a count to navigate to the task list with filters applied.',
	allDocssignedoff: 'All documents <br/>signed-off',
	someDocssignedoff: 'Some documents <br/>signed-off',
	noDocssignedoff: 'No documents <br/>signed-off',
	partnernotinvited: 'Partner not invited',
	noEQRsinyourengagement: 'There are no EQRs in your engagement.',
	selectEQRs: 'Select an EQR',
	eqrNotinvited: 'EQR not invited',
	eqrsignoffs: 'EQR sign-offs',
	eqrtaskswithpartnersignoffs: 'Click on a count to navigate to the task list with filters applied.',
	allpartners: 'All partners',
	allEQRs: 'All EQRs',
	reviewComments: 'Review notes',
	noOpenReviewComments: 'You do not have any open review notes.',
	noClearedReviewComments: 'You do not have any cleared review notes.',
	noClosedReviewComments: 'You do not have any closed review notes.',
	noReviewCommentsForSelectedTime: 'You do not have any review notes for the selected time frame. Select another time frame to continue.',
	picTasksSomeDocSignOff: "Tasks with some documents signed off by PIC",
	picTasksNoDocSignOff: "Tasks with no documents signed off by PIC",
	eqrTasksSomeDocSignOff: "Tasks with some documents signed off by EQR",
	eqrTasksNoDocSignOff: "Tasks with no documents signed off by EQR",
	picNotIdentified: "No PIC has been identified",
	eqrNotIndentified: "No EQR has been identified",
	todoReviewNote: "Review note",

	// Dashboard - Executive Tasks
	executiveTasks: 'Focus areas',
	executiveTasksInstruction: 'Select to view tasks by risk or by account below. <br/> Once you have made your selection, hover over a count to see more details or select a task to navigate to its specific details page.',
	byRisk: 'By risk',
	byAccount: 'By account',
	responsiveTasks: 'Related tasks',
	openNotes: ' Open notes',
	lowLabel: 'Low',
	mediumLabel: 'Medium',
	highLabel: 'High',
	criticalLabel: 'Critical',
	epRequired: 'PIC required',
	eqrRequired: 'EQR required',
	noDocumentsSignedOff: 'No documents signed off',
	someDocumentsSignedOff: 'Some documents signed off',
	allDocumentsSignedOff: 'All documents signed off',
	completedAssignments: 'Completed assignments',
	designation: 'Designation',
	significantAccount: 'Significant account',
	epSignOff: 'PIC sign-off ',
	eqrSignOff: 'EQR sign-off ',
	someLabel: 'Some',
	riskNoDataLabel: 'This risk has not been related to any tasks.',
	accountNoDataLabel: 'This account and its assertions have not been related to any tasks.',
	NoDataLabel: 'No data available for selected Accordion',
	// Manage tags
	manageTagsInstructionalText: `Create new tags here. You can also edit and delete existing tags. Tagging requests can improve your engagement's organization and project management.`,
	noTagsAdded: 'No tags added. Create a tag to get started.',

	// Client Request Comments
	noCommentsCreatedYet: 'No comments have been created yet.',
	addCommentTitleTip: 'Add comment',
	addReplyTitleTip: 'Add reply',
	addAComment: 'Leave a comment...',
	addAReply: 'Add a reply',
	deleteCommentConfirmationModalTitle: 'Delete comment',
	deleteCommentConfirmationModalMessage: 'Are you sure that you want to delete this comment? All replies to this comment will also be deleted.',

	// Client Request Voice Note Comment Labels
	voiceNoteCommentRecordLabel: 'Voice note',
	voiceNoteCommentStopLabel: 'Stop',
	voiceNoteCommentPlayLabel: 'Play',
	voiceNoteCommentDeleteLabel: 'Delete',

	//Client Request Status/Tooltip messages
	SendRequestSuccess: 'Request has been submitted successfully',
	BulkSendRequestSuccess: '{0} requests have been sent successfully',
	BulkSendOneRequestSuccess: '1 request has been sent successfully',
	SendInProgress: 'Send in progress',
	AcceptInProgress: 'Accept in progress',
	CompleteInProgress: 'Complete in progress',
	HasErrorState: 'Request could not be sent. Please try again.',
	WithdrawRequestSuccess: 'Request has been withdrawn',
	WithdrawInProgress: 'Withdraw in progress',
	WithdrawRequestError: 'Request could not be withdrawn, please try again.',
	DeleteRequestError: 'Request could not be deleted. Refresh the page and try again.',
	AcceptRequestError: 'Request could not be accepted, please try again.',
	CompleteRequestError: 'Request could not be completed, please try again.',
	InvalidClientContact: 'Invalid client contact.',
	BulkSendInvalid: 'One or more selected requests cannot be sent without taking further action. Please review and try again.',
	returnInProgress: 'Return in progress',
	returnRequestError: 'Request could not be returned, please try again',

	//Client Withdraw Request
	WithdrawRequest: 'Withdraw request',
	WithdrawReuestConfirmMsg: 'Are you sure that you want to withdraw this request? Once withdrawn, the client can no longer view it. The request will move to the Draft list once complete',
	WithdrawMenuOption: 'Withdraw',
	MoreOptions: 'More options',
	Complete: 'Complete',
	WithdrawLabel: 'Withdrawn',
	CompleteInstructionalText: 'Use Complete when information has already been provided by the client',

	//Client Complete Request
	CompleteRequestConfirmMsg: "Completing a request removes the request from the client's to-do list and updates the status to Sent for the client. The request will be moved to the Received list in EY Canvas. It can be used, for example, when requested information has already been received through alternative means.",
	CompleteRequest: 'Complete request',
	CompleteRequestSuccess: 'Request has been completed',

	//Client Accept Return Request
	AcceptLabel: 'Accept',
	ReturnLabel: 'Return',
	ReturnRequest: 'Return request',
	acceptRequest: 'Accept request',
	acceptRequestWithoutTask: 'Are you sure that you want to accept the selected request?',
	acceptRequestWithTask: '<b>Are you sure that you want to accept the selected request?</b> The attached documents will be available from the external documents tab of the {0} related task(s).',
	acceptRequestSuccess: 'Request has been accepted',
	returnedRequestSuccess: 'Request has been returned -',

	// Client Request Relate Files modal
	noRecordsFound: 'No records found',
	relateSelected: 'Relate selected',
	relateFilesModalHeader: 'To relate existing documents to this request, select the documents and click on Relate selected.',
	relateAnalyticModalHeader: 'To relate existing analytics to this request, check the box for the selected analytic. To preview other available analytics, click',
	relateAnalyticHereModalHeader: 'here',
	noAnalyticsRecordsFound: 'There are no analytics available to share. Click',
	noAnalyticsRecordsFoundGetStarted: 'to get started.',
	associateExistingDocumentsSelected: 'documents added',
	associateExistingDocumentSelected: 'document added',

	// Client Request Details Header
	timePhaseLabel: 'Time phase:',
	receivedDateLabel: 'Received:',
	dueDateLabel: 'Due:',
	sentDateLabel: 'Sent:',
	acceptedDateLabel: 'Accepted:',
	clientRequestSyncLabel: 'Updates are being sent to EY Canvas Client Portal',
	editDescriptionLabel: 'Edit Description',
	createdDateLabel: 'Created:',

	//Client Advance Search
	advancedSearch: 'Advanced search',
	advancedSearchRefereceNumberCheck: 'Reference #',
	advancedSearchTitleCheck: 'Title',
	advancedSearchDocumentsCheck: 'Documents',
	advancedSearchCommentsCheck: 'Comments',
	advancedSearchApplyButton: 'Apply',
	searchRequest: 'Search',
	clearSearch: 'Clear search',

	//Adjustment Topup module
	adjustmentModule: {
		currencyType: 'Currency type',
		currencyCode: 'Currency code',
		businessUnit: 'Business unit',
		all: 'All',
		moduleName: "Adjustment module",
		financialStatement: "Financial statements",
		viewByTrialBalanceType: "View by trial balance type",
		multiEntry: "Multi-entity",
		balanceSheet: "Balance sheet",
		incomeStatement: "Income statement",
		currentperiodUnadjusted: "Analysis date ",
		unadjusted: "(unadjusted)",
		currentperiodAdjusted: "Analysis date ",
		adjusted: "(adjusted)",
		adjustment: "Adjustment",
		newAdjustment: "New adjustment",
		noRecordsFound: "No records found",
		periodEnded: " date ended",
		periodsEnded: " dates ended",
		noResultsFound: "No results found",
		notApplicableAbbreviation: "N/A",
		noAdjustmentCreated: "No adjustment created.",
		createAdjustment: "Create a {0}.",
		next: "Next page",
		previous: "Previous page",
		reclassification: "Reclassification",
		manageAdjustment: "Manage adjustments",
		lastPage: "Last page",
		firstPage: "First page",
		filterYes: "Yes",
		filterNo: "No",
		showOnlyAdjustedAccountClasses: "Show only adjusted account classes",
		noneAvailable: 'None available',
		noImportedTrialbalanceAvailable: 'No imported trial balance.',
		trialBalanceRequired: 'Trial balance',
		comparativeperiodUnadjusted: "Comparative date",
		comparativeperiodAdjusted: "Comparative date ",
		multityEntityRequired: "Multi-entity",
		placeHolderMessageWhenHelixMappingIsTrue: "No imported trial balance. Click {0} to relate a new analyzer.",
		placeHolderMessageWhenHelixMappingIsFalse: "Integration with EY Helix is not available. Refresh the page and try again. If the issue persists, contact the Help Desk. is not displayed.",
		eyHelixIntegrationLinkText: 'EY Helix connections',
		noEntitiesAvailablePlaceholder: 'No entities created. Create entities to get started.',
		search: 'Search',
		viewAdjustmentWithValidations: 'View adjustments with validations ({0})',
	},

	misstatementLabels: {
		name: 'Name',
		notes: 'Notes',
		signOffs: 'Sign-offs',
		open: 'Open',
		openReadOnly: 'Open read-only',
		delete: 'Delete',
		rename: 'Rename',
		signOffRequirements: 'Sign-off requirements',
		confidentiality: 'Confidentiality',
		unlink: 'Unlink',
		removeFromAdjustment: 'Remove from adjustment'
	},



	allControls: 'All controls',
	//Client Request Document labels
	clientRequestDocuments: {
		externalDocuments: 'External',
		taskDocuments: 'Documents',
		deletedDocuments: 'Deleted',
		priorPeriodDocuments: 'Prior year',
		priorPeriodInfoMessage: 'These documents cannot be downloaded',
		uploadedBy: 'Uploaded by',
		deletedBy: 'Deleted by',
		lastModifiedBy: 'Last modified by',
		eyBadge: 'Deleted from Documents',
		externalBadge: 'Deleted from External',
		uploadInProgress: 'Upload in progress',
		refreshdocuments: 'Refresh documents',
		disabledDocument: 'Bulk operations are not allowed for this type of document.',
		menuOptions: {
			delete: 'Delete',
			open: 'Open',
			openr: 'Open read-only',
			restore: 'Restore',
			remove: 'Remove',
			rename: 'Rename',
			editInHelix: 'Edit in EY Helix'
		},
		externalPriorPeriod: 'Client',
		eyPriorPeriod: 'EY',
		uploadedByEY: 'EY',
	},

	//Client Request Assigned To Errors
	clientRequestAssignedToErrorLabel: 'Assigned user or group is not valid. Update the assignment to continue. Click ',
	clientRequestAssignedToErrorLabelEnd: 'to edit External team members.',
	clickHereLabel: 'here ',
	clientRequestAssignedToIconErrorLabel: 'Assigned group has no active members. Assign the request to an active user/group or add members to the group to continue.',
	clientRequestDueDateErrorLabel: 'Due date is required. Update the due date to continue.',

	clientRequestDocumentsNoDocsFound: [
		{
			id: 'externalDocuments',
			label: 'No external documents added'
		},
		{
			id: 'taskDocuments',
			label: 'Drag and drop one or more documents or click Add document'
		},
		{
			id: 'deletedDocuments',
			label: 'No documents have been deleted'
		},
		{
			id: 'searchRequestDocuments',
			label: 'No matches found, please try again'
		},
		{
			id: 'priorPeriodDocuments',
			label: 'No prior year documents available'
		}
	],

	liveNotifications: {
		"ey.at.hercules.annotation.created": "Annotation created",
		"ey.at.hercules.annotation.edited": "Annotation edited",
		"ey.at.hercules.annotation.replied": "Annotation replied",
		"ey.at.hercules.contentupdate.updated": "Content updated",
		"ey.at.hercules.contentupdate.failed": "Content update failed"
	},

	//Assign to
	usersOption: 'Users',
	externalUsersOption: 'External users',
	groupsOption: 'Groups',
	lblassignedto: 'Assigned to',
	searchGroup: 'Search group',
	requiredAssignedTo: 'Assigned to is required',
	rdSubmitRequest: 'Submit request',

	closeDrawer: 'Close and deselect all',
	requestSelected: 'request selected',
	requestsSelected: 'requests selected',
	//GA Scopes labels
	engagementScopesAndCustomSubScopes: 'Engagement scopes and custom sub-scopes',
	defineGroupScopes: 'Define group scopes',
	gaScopeIntro: 'Engagement scopes per EY GAM are included here by default. If you need to customize group tasks and instructions for teams who share the same scope, consider creating a sub-scope. When sending instructions, you’ll be able to send different versions to each sub-scope.',
	addSubScope: "Add sub-scope",
	customSubScope: "Custom sub-scope",
	noCustomSubscopes1: "There are no custom sub-scopes for this engagement scope.",
	noCustomSubscopes2: "Select <b>Add sub-scope<b> to get started.",
	subScopeName: 'Sub-scope name',
	addDescription: 'Add description',
	textExceedsLength500: 'Text cannot exceed 500 characters.',
	manageGroupPermission: 'You must have the <b>Manage group</b> permission to take this action. Speak with an Engagement Administrator to request permission.',
	deleteCustomSubScope: 'Delete custom sub-scope',
	areYouSureDeleteCustomSubScope: 'Are you sure that you want to delete this custom sub-scope?',

	//GA Component labels
	newTeam: 'New team',
	teamName: 'Team name',
	legalEntityName: 'Legal entity name',
	parentTeam: 'Parent team',
	isReferenceOnly: 'Reference only',
	isNotUsingCanvas: 'Team not using EY Canvas',

	referenceOnlyTooltip: 'Teams designated as <b>Reference only</b> will not receive link requests, instructions or tasks. They are used for organizational purposes only.',

	canvasFormNotOwnedByEng: 'Shared Canvas forms that are not owned by this engagement cannot be sent to EY Canvas Client Portal. Make a copy of the form in this engagement if you need to send it, or send it from the source engagement.',
	canvasFormNotAllowedInCtry: 'Sharing Canvas forms with clients is not available in your country.',
	on: 'on',
	sendRequest: 'Send request',
	selectUserOrGroup: 'Select user or group',
	canvasFormShowAttachments: 'Show {0} attachments',
	canvasFormShowOneAttachment: 'Show 1 attachment',
	canvasFormHideAttachments: 'Hide {0} attachments',
	canvasFormHideOneAttachment: 'Hide 1 attachment',

	//GA Components
	createGroupStructure: 'Create group structure',
	componentText: 'Create regions and components for each engagement team that will send deliverables through EY Canvas. You have the option to designate teams as <b>Not using EY Canvas</b> if they will not send deliverables through EY Canvas. You can also create teams for organizational purposes and designate them as <b>Reference only</b>. These teams will not receive link requests, instructions or tasks. When you are done, select <b>Send link requests</b>.',
	addTeam: 'Add team',
	sendLinkRequests: 'Send link requests',
	noComponents: 'No teams have been created yet.  Select <b> Add team <b> to get started.',
	editTeam: 'Edit team',
	deleteTeam: 'Delete team',
	deleteInstructional: 'Are you sure that you want to delete this team? <br/><br/> The link to this team will be broken and your engagements will no longer be able to exchange documentation. Additionally, all custom instructions and tasks assigned to this team will be deleted.',
	linkRequestHasBeenSent: 'You cannot edit the scope or designation for this team because a link request has already been sent or the designation is already set.',
	selectScopes: 'Select scope(s)',
	searchScopes: 'Search scopes',
	selectTeams: 'Select team(s)',
	sendLinkRequestsDescription: 'Select the scopes or teams to which you would like to link your engagement.<br> A link request will be sent to the point of contact for each team. After the point of contact accepts the link request, they will receive group instructions and tasks through EY Canvas.',
	sendVersionsDescription: 'Select the scopes or teams to which you would like to send the latest version of group instructions and tasks.<br>A team must be linked to your engagement to receive group instructions and tasks. After the team accepts the latest version, it will be available in their engagement.',
	notSentYet: "No version sent yet",
	notLinkedYet: "Link request not sent",
	cardView: 'Card view',
	noItemsPlaceholder: 'A version has not been published yet.  Publish a version of group instructions and tasks to see data here.',

	//GA Instructions
	customizeGroupInstructions: 'Customize group instructions',
	gaInstructionsIntro: 'Group instructions per EY GAM are included by default and are informational by nature. They are meant to inform region and component teams of key information, work scope and procedures performed centrally. Customize the instructions from EY GAM, add additional instructions if needed and designate whether each instruction should be assigned to a scope or a team. Once you are done, publish your instructions so they become available to send to the assigned scopes or teams.',
	addInstruction: 'Add instruction',
	instruction: 'Instruction',
	groupTaskSelected: 'Group task',
	assignScopes: 'Assign to scopes',
	assignTeams: 'Assign to teams',
	maxLengthMessage: 'Text cannot exceed <b>500<b> characters.',
	addScope: 'Add scope',
	editInstruction: 'Edit custom instruction',
	editKnowledgeInstruction: 'Edit Knowledge instruction',
	editKnowledgeTask: 'Edit Knowledge task',
	editCustomTask: 'Edit custom task',
	saveChangesInstruction: 'Save changes',
	updatedOnInstruction: 'Last updated:',
	knowledgeDescriptionInstruction: 'Knowledge description',
	editDisabledTitle: 'You must have the <b>Manage group</b> permission to take this action. Speak with an Engagement Administrator to request permission.',
	deleteCustomInstruction: 'Delete instruction',
	deleteGroupTask: 'Delete group task',
	areYouSureDeleteCustomInstruction: 'Are you sure that you want to delete this custom instruction?',
	areYouSureDeleteCustomTask: 'Are you sure that you want to delete this custom task?',
	publishAfterDelete: 'If you delete this instruction, you need to publish your changes and resend the newly-published set of instructions to the assigned scopes or teams.',
	publishAfterDeleteGroupTask: 'If you delete this group task, you need to publish your changes and resend the newly-published set of tasks to the assigned scopes or teams.',
	resendPublishInformation: 'You can publish your changes on this step. You can resend the newly-published set of instructions from the summary.',
	resendPublishInformationGroupTask: 'You can publish your changes on this step. You can resend the newly-published set of tasks from the summary.',
	compareVersionsNoVersionSelectedTitle: 'No version has been selected to compare!',
	compareVersionsNoVersionSelectedSubtitle: 'Please select the version from the dropdown to compare with latest version',

	//Add Section
	addSection: 'Add section',
	addSectionInstructionalText: 'Add a section to organize your custom instructions.',
	addSectionPlaceholder: 'Section name',

	//Edit Section
	editSection: 'Edit section name',
	editSectionInstructionalText: 'Make changes to the name of this custom section. <br> When you are done, publish your changes to send an updated version to selected scopes or teams.',
	editSectionSave: 'Save changes',

	//Delete Section
	deleteCustomSection: "Delete section",
	areYouSureDeleteCustomSection: "Are you sure that you want to delete this section?<br>All instructions in this section will be deleted. When you are done, publish your changes to send an updated version to selected scopes or teams.",
	customSection: "Section",

	//Publish Changes
	publishChanges: 'Publish changes',
	publishChangesInstructional: 'Are you sure that you want to publish changes to the current set of instructions and tasks? <br><br>The previous set of instructions and tasks will be overwritten. Once you publish your changes, you can send the updated set of instructions and tasks from the summary.',
	publishChangesNotAvailable: 'Not available yet',

	//GA Tasks
	costomizeGroupTasks: 'Customize group tasks',
	gaTasksIntro: 'Group tasks per EY GAM are included by default and sent to linked engagements. Customize the tasks from EY GAM, add additional tasks if needed and designate whether each task should be assigned to a scope or a team. Once you are done, publish your tasks so they become available to send to the assigned scopes or teams.',
	addCustomTask: 'Add custom task',
	groupTask: 'Group tasks',
	gaTasks: 'Tasks',
	attachments: 'Attachments',
	notAvailable: 'Not available',
	gaDocument: 'document',
	gaDocuments: 'documents',
	gaScope: 'scope',
	gaScopes: 'scopes',
	gaScopesCapitalized: 'Scopes',
	gaTeam: 'team',
	gaTeams: 'teams',
	gaUnassignedScopeTeam: 'Unassigned',
	hideDetails: 'Hide details',
	gaAssignedScopes: 'Assigned scopes',
	gaAssignedTeams: 'Assigned teams',
	addTask: 'New task',
	due: 'Due',
	noAttachments: 'No attachments have been added.',

	// Chip component
	chipMore: 'more',

	// GS Group Summary labels
	assignedTeam: 'Assigned team',
	lastPublished: 'Last published',
	versionStatus: 'Version status',
	lastSent: 'Last sent',
	lastSentTooltip: 'This is the date that a version of instructions and tasks was last sent to each team.  Click on the date to view the version sent to the team.',
	lastSentBeforeTooltip: 'There is a new version of instructions and tasks available for <b><<Scope name>><b>. Consider whether you should send the latest version to this team.',
	groupSummary: 'Group summary',
	summarySubTitle: 'Review the most recent version of the instructions and tasks assigned to each scope and team below. To send this version to the assigned scopes and teams, select <b>Send version</b>.<br/>You may also view the version sent to a specific team by selecting the relevant sent date.',
	compareVersions: 'Compare versions',
	sendVersion: 'Send version',
	compareVersionsInstructional: 'Compare the latest version of published instructions and tasks to the version sent to a team in order to identify differences. If there are differences between the versions, evaluate whether a new version needs to be sent to the team.',
	publishedVersion: 'Published version',
	sentVersion: 'Sent version',
	emptyPublishedVersion: 'There are no scopes available. <br/>Scopes that are assigned to component teams are listed here.',
	emptySentVersion: 'There are no teams available.',
	selectPublishedVersion: 'Select a published version to see data here.',
	selectSentVersion: 'Select a sent version to see data here.',
	dueDate: 'Due date',
	emptyPublishedSnapshot: 'There is no published version of instructions and tasks available for the selected scope. <br/>Publish a version to see data here.',
	emptySentSnapshot: 'Instructions and tasks have not been sent to the selected team. <br/>Publish and send instructions and tasks to this steam to see data here.',
	update: 'Update',
	updates: 'Updates',
	noTeamsPlaceholder: 'No Teams Placeholder',
	noTeamSelected: "Select at least one scope or team to continue.",
	latestVersionAlreadySent: 'No teams have been created yet.  Create one or more teams in order to publish a version of instructions and tasks.',
	latestHasBeenSended: 'The latest version of instructions and tasks has already been sent to this team',
	noNewVersionToSend: "The selected scopes or teams have already received the latest version of instructions and tasks. There are no updates available to send.",
	notSelectedTask: 'Not selected',
	assignedTeams: 'Assigned teams',
	noTeamsCreatedYet: 'No teams have been created yet.  Create one or more teams in order to publish a version of instructions and tasks.',
	newersTeamsSended: 'The latest version of instructions and tasks has been sent to the relevant scopes or teams.',
	LinkRequestNotSent: 'Link request not sent',
	lastVersionSentInstructionalText: 'The version of tasks and instructions sent to <b>{teamName}</b> on <b>{sentDate}</b> is displayed below.  This is the latest version sent to this team.',

	// ReceiveInstructions labels
	receiveInstructionsTitle: '{versionType} version of group instructions and tasks',
	receiveInstructionsInstructional: '{primaryEng} sent {versionType} version of group instructions and tasks on {sentDate}. Review this version and select whether to accept it or return it. You can use the <b>Compare versions</b> option to compare this version to previous versions.',
	fromLabel: 'From',
	assignedScope: 'Assigned scope',
	dateSent: 'Date sent',
	acceptVersion: 'Accept version',
	returnVersion: 'Return version',
	returnPrimaryButton: 'Return',
	returnVersionDescription: 'Are you sure that you want to return this version of instructions and tasks to the primary team?  <br>This version will not be imported into your engagement.  Leave a comment for the primary team explaining your rationale.',
	noContent: 'There are no instructions available at this moment, please try again later or contact desk help',
	editorPlaceHolder: 'Comment',
	receiveCompareVersionInstructional: 'Compare the selected version of instructions and tasks received from {primaryEng} to an earlier version received to identify differences.',
	latestReceiveCompareVersionInstructional: 'Compare the latest version of instructions and tasks received from {primaryEng} to an earlier version received to identify differences.',
	latestVersion: 'Latest version',
	earlierVersion: 'Earlier version',
	earlierVersionEmpty: 'There are no earlier versions available for comparison.',
	selectEarlierVersion: 'Select an earlier version to see data here.',
	pstName: 'Review group engagement instructions',
	pstDescription: "Review the group audit instructions. Complete group tasks in 'Execution - General'. These tasks have been added to the task list upon acceptance of the group audit instructions.",
	selectedVersion: 'Selected version',
	issuingEngagement: 'Issuing engagement',
	accountsAndDisclosureLink: "Account and disclosure",
	openRiskAssessmentDocuments: "Open risk assessment documents",
	openRiskAssessmentDocument: "Open risk assessment document",

	//Client engagement name labels
	successQueueMessage: 'The engagement display name has been successfully updated in EY Canvas Client Portal.',
	clientEngagementInstructionalText: 'Add or edit a custom engagement display name here. This name will be visible to external team members who access this engagement in EY Canvas Client Portal.',
	clientEngagementPlaceholder: 'Engagement display name',
	clientEngagementModalTitle: 'Engagement display name in EY Canvas Client Portal',
	clientDisplayName: 'Client display name',
	textExceedsLength: 'Text cannot exceed 100 characters.',

	// Manage client access locations
	location: 'Location',
	locationName: 'Location name',
	accessLocations: 'Access locations',
	inputType: 'Input type',
	ipAddress: 'IP address',
	ipAddresses: 'IP addresses',
	startOfIpRange: 'Start of IP range',
	endOfIpRange: 'End of IP range',
	cidrNotation: 'CIDR notation',
	manageClientAccessLocationsLink: 'Add location',
	manageClientAccessLocationsModalTitle: 'Manage client access locations',
	manageClientAccessLocationsInstructionalText: 'Add IP addresses to the list below to enable location-based access to EY Canvas Client Portal. <br>If client access locations are enabled, then only external team members with the IP addresses listed here will have access to this engagement. If no IP addresses are added, then external team members will be able to access this engagement from any location.<br> Click <b>here<b> to learn more.',
	manageClientAccessLocationsNoResultFound: 'There are no IP addressess added for this engagement. Internal and external team members can access this engagement from any location.',
	deleteAccessLocations: 'Delete access location(s)',
	deleteAccessLocationsInstructionalText: 'Are you sure that you want to delete the selected access location? <b>If an external team member attempts to access EY Canvas Client Portal from this location, they will no longer be able to access this engagement.',
	locationLengthError: 'The location cannot exceed 100 characters.',
	oneOrMoreIpAddressFormatError: 'One or more of the IP address provided are not valid.',
	ipAddressFormatError: 'The IP address provided is not valid.',
	ipSuffixError: 'The CIDR suffix for the IP address must be a decimal ≥ 1 and ≤ 32.',
	ipRangeStartSmallerThanEnd: 'Start IP should be less than end IP.',
	ipInputTypeInfo: 'Select IP address to enter an individual IP address or a list of IP addresses. Only IPv4 addresses are supported. <br>Select IP range to enter a range of IP addresses that share the same network prefix (i.e. the first three segments of the address). <br>Select CIDR block to enter a range of IP addresses with CIDR notation. Only CIDR addresses are supported.',
	ipAddressInfo: 'You can enter IP addresses individually, in a list separated by commas, or in a list with each address in a new row. <br>Valid IPv4 addresses contain four integers ranging from 0 to 255, separated by periods.',
	ipCidrInfo: 'Enter the CIDR notation that represents a range of IP addresses that should be able to access this engagement. <br>Valid CIDR notation contains a valid IPv4 address, a slash / character, and a decimal suffix ≥ 1 and ≤ 32.',
	ipAddressEg: 'e.g. 192.XXX.X.1, 192.XXX.X.2',
	ipRangeStartEg: 'e.g. 192.XXX.X.1',
	ipRangeEndEg: 'e.g. 192.XXX.X.2',
	ipCidrEg: 'e.g. 192.XXX.X.1/22',
	searchIpPlaceholder: 'Check IP address',
	ipNotAddedMessage: 'has not been added to the allowed list.',
	ipIsAllowedMessage: 'IP address is allowed.',
	importAccessLocationsLink: 'Import access locations',
	importAccessLocationsInstructionalText: 'Access locations can be imported from your previous engagement. <br>Are you sure that you want to import access locations?',
	importAccessLocationsCloseButton: 'Close',
	importAccessLocationsCancelButton: 'Cancel',

	// Export Requests
	exportRequests: 'Export requests',

	// Add custom request labels
	addCustomRequestModal: {
		titleTip: 'New request',
		titleTipAddButton: 'Add new',
		closeTitleTip: 'Close',
		modalTitle: 'New request',
		returnModalTitle: 'Return request',
		modalHeader: 'Add a new request to send to EY Canvas Client Portal',
		requiredAssignedTo: '(required)',
		assignToError: 'Assigned to is required',
		dueDate: 'Due date (required)',
		dueDateError: 'Due date is required',
		titlePlaceholder: 'Title (required)',
		titleError: 'Title is required',
		description: 'Description',
		descriptionplaceholder: 'Enter description',
		descriptionError: 'Request description exceeds the maximum length, (4,000 characters)',
		associateDocuments: 'Associate documents',
		emptyAssociatedDocumentsList: 'Drag and drop one or more documents or click Add document',
		addDocumentButton: 'Add document',
		signOffCheckbox: 'Documents uploaded in EY Canvas Client Portal will require sign-off',
		sendRequest: 'Send request',
		returnRequest: 'Return request',
		saveAsDraft: 'Save as draft',
		cancel: 'Cancel',
		copyTitleAndDescription: 'Copy title and description from task',
		copyAssociatedDocuments: 'Copy documents from task',
		priority: 'Request priority',
		addNewRequestButton: 'Add new request',
		addExistingRequestButton: 'Add existing request(s)'
	},
	addCustomEventModal: {
		titleTip: 'New event',
		closeTitleTip: 'Close',
		modalTitle: 'New event',
		eventDate: 'Event date',
		eventDateError: 'Date is required',
		titlePlaceholder: 'Title',
		titleError: 'Title is required',
		description: 'Description (optional)',
		descriptionplaceholder: 'Enter description',
		descriptionError: 'Event description exceeds the maximum length, (4,000 characters)',
		sendEvent: 'Send event',
		saveAsDraft: 'Save event as draft',
		cancel: 'Cancel',
		eyParticipantsCollaborationError: 'At least one EY participant is required',
		externalParticipantsCollaborationError: 'At least one external participant is required',
	},
	eyHelixInstructionText: 'Review linked EY Helix projects and suggested analyzers below. <br/> Click on any of the projects or analyzers to navigate to its specific EY Helix page.',
	smartAutomationInstrText: 'Review the Smart Automation solutions that you are currently using below. <br/> Click on a solution to navigate to the Smart Automation Hub.',
	smartAutomationSolutionsNotAvailable: 'Smart Automation solutions are not available for your engagement at this time.',
	noSmartAutomationAvailable: 'There are no Smart Automation solutions available for your engagement.',
	availableSolutions: 'Available solutions',
	useOfSuggestedSolutions: 'Use of suggested solutions',
	useOfOtherSolutions: 'Use of other solutions',
	suggestedSolutions: 'Suggested solutions',
	otherSolutions: 'Other solutions',
	currentlyusing: 'Currently in use',
	suggested: 'suggested',
	primaryProject: 'Primary Project',
	noLinkedProjects: 'There are no linked projects for your engagement.',
	noSuggestedAnalyzers: 'There are no suggested analyzers for your engagement.',
	eyHelixNotAvailable: 'EY Helix not available',
	helixNotAvailableMessage: 'EY Helix is not available for your engagement at this time.',

	noGroupTaskCreatedYet: 'No group tasks have been created yet.',
	noInstructionsCreatedYet: 'No instructions have been created yet.',
	documentsReceived: 'Documents received',
	documentsPending: 'Documents pending',

	teamLabel: 'Team',
	scopeLabel: 'Scope',

	documentSignOffby: 'Document signed-off by',
	documentAddedBy: 'Document added by',
	documentModifiedBy: 'Document modified by',
	documentDeletedBy: 'Document deleted by',
	commentAddedBy: 'Note added by',
	commentClearedBy: 'Note cleared by',
	commentClosedBy: 'Note closed by',
	commentReopenedBy: 'Note re-opened by',

	documentAssignedTo: 'Document assigned to',
	draftDocReceivedFrom: 'Draft document received from',
	finalDocReceivedFrom: 'Final document received from',
	documentReturnedBy: 'Document returned by',
	returnedDocumentClearedBy: 'Returned document cleared by',
	documentConflictResolvedBy: 'Document conflict resolved by',
	draftDocumentSentBy: 'Draft document sent by',
	documentReturnedFrom: 'Document returned from',
	finalDocumentSentBy: 'Final document sent by',
	noActivityAvailable: 'There is no activity available.',
	allEngagementFilterLabel: 'All other engagements',
	otherEngagementComments: 'Other engagement notes',
	engagements: 'Engagements',
	engagement: 'Engagement',
	view: 'View',
	notesModalInstructionalText: 'View and respond to notes for the selected {0} below.',

	//New collaboration Related Labels
	searchRelateFileNoMatchesFound: 'No matches found. Please try again.',

	//New collaboration Related tasks
	relatedTasksLabel: 'Related tasks',
	selectRelatedTasks: 'Select task',
	searchAndPressEnter: 'Search and press enter',
	noRelatedTasksSelected: 'No related tasks selected',
	relatedTasksCount: 'related tasks',
	notFoundTasks: 'Task not found',
	dueDateDetailLabel: 'Due date',
	requestType2MessageTitle: 'This request will open in a new tab',
	requestType2MessageSubtitle: 'Refresh the page to view any updates made.',
	requestType2InTrnasitMessageTitle: 'This request cannot be opened as it is in transit.',
	requestType2InTrnasitMessageSubtitle: 'Wait for sync to complete and refresh the page and try again.',

	//New collaboration Time Phase
	selectTimePhase: 'Select timephase',
	timePhaseNotFound: 'Timephase not found',

	understandITProcess: 'Understand IT processes',

	//New collaboration Access Location
	accessLocationLabel: 'Access location enabled',
	accessLocationTitle: 'Only users connecting from an authorized network location will have access to EY Canvas Client Portal for this engagement. Allowed locations can be managed from Access locations in the options menu.',

	// Reporting Labels
	summaryScreenLabel: 'Summary screen',
	dataExportLabel: 'Data export',
	projectManagementLabel: 'Project management',
	reportingHeaderName: 'Reporting',
	repAllTasks: 'All tasks',
	repDeletedTasks: 'Deleted tasks',
	repMultiEntityTasks: 'Multi entity tasks',
	repAllAuditPlan: 'Audit Plan',
	repITAppSOSummary: 'IT App/SO Summary',
	repITProcessScotControls: 'IT Process, SCOT, and Controls',
	repTaskAssignments: 'Task assignments',
	repTaskDetails: 'Task details',
	repTaskAnalysis: 'Task analysis',
	repTaskSummary: 'Task summary (Pilot)',
	repExportToExcel: 'Export data',
	repExportDate: 'Export date',
	repEngInfo: 'Engagement info',
	repNoRecordMessage: 'No records to display',
	dateInUTC: 'in UTC',
	repSCOTsControls: 'SCOTs & Controls',
	repITProcessSummary: 'IT Process Summary',
	repCanvasForms: 'Canvas Forms',
	repControlForms: 'Control Forms',
	projectInsight: 'Project Insight',
	archiveForm: 'Archive form',
	archive: 'Archive',
	repCanvasFormResponse: 'Canvas Form responses',
	repCanvasFormRelatedComments: 'Related comments',
	repControlFormResponse: 'Control Form responses',
	repNoRecordFound: 'No records found',
	repCanvasFormsIncomplete: 'Incomplete responses',
	repCanvasFormRelatedObjects: 'Related objects',
	voiceNoteLabel: 'Voice note',
	repComponentTeamGroup: 'Component team',
	componentTeamCanvasFormExport: 'Canvas form export',

	// Reporting Tasks
	repTaskTitle: 'Task title',
	repTaskDescription: 'Task description',
	repTaskSource: 'Task source',
	repTaskNature: 'Task nature',
	repTaskCloseEarly: 'Early',
	repTaskCloseLate: 'Late',

	// Reporting Documents
	repAllDocuments: "All documents",
	repSignOffs: "Sign-off",
	repDocumentsModified: "Documents modified after RRD",

	//Reporting Collaboration
	repRequestsAndTasks: "Requests and tasks",
	repRequestsTasksComments: "Requests/tasks comments",

	SCOTSummaryReportHeader: 'SCOT summary',
	GroupReportHeader: 'Group report',
	SCOTSummaryEffective: 'Effective',
	GroupInstructionSummary: 'Group instruction summary',
	GroupActivity: 'Component account mapping history',
	SEMReportHeader: 'SEM',
	GroupComponentAccountReportHeader: 'Group component account mapping',
	AccountDisclosuresReportHeader: 'Accounts and disclosures',

	//Reporting Collaboation Details
	collaborationDetails: 'Collaboration details',
	collaborationSummary: 'Summary',
	collaborationActivity: 'Activity details',
	ReviewNotesReportHeader: 'Review notes',

	GroupStructureSummary: 'Group Structure Summary',

	//Reporting CRT Summary
	wcgwSummary: 'WCGW summary',
	crtlabel: 'Controls review tool (CRT)',
	assertionSummary: 'Assertion summary',
	scotSummary: 'SCOT summary',
	noRecordsToExport: 'No records to export',
	statisticsSummary: 'Statistics',
	qualityChecks: 'Quality checks',
	controlSummary: 'Control summary',
	filterBySCOT: 'Filter by SCOT',

	//Reporting manage team
	independenceSummaryReportTabName: "Independence summary",

	//MEST dashboard
	viewAllRiskTypesAndAssertions: "View all risk types and assertions",
	riskRelatedToAssertion: "Risk related to assertion",
	higherRiskRelatedToAssertion: "Higher risk related to assertion",
	noRisksAvailable: 'No risks available',
	relatedEstimates: 'Related Estimates',
	viewAllAssertions: 'View all assertions',
	wcgwRelatedToAssertion: "WCGW related to assertion",
	noWcgwsAvailable: 'No WCGWs available',
	goTo: 'Go to',
	allItems: 'All items',

	// Create TimePhase Labels
	createTimePhaseLabels: {
		modalTitle: 'Add time phase',
		modalDescription: 'Add the attributes and click Save & close or Save & add.',
		timephaseNameLabel: 'Time phase name',
		milestoneSelectLabel: 'Milestone',
		timephaseLabel: 'Time phase',
		startDateLabel: 'Start date',
		endDateLabel: 'End date',
		startDateErrorMessage: 'Start date is required.',
		endDateErrorMessage: 'End date is required.',
		timephaseNameErrorMessage: 'Name is required.',
		milestoneErrorMessage: 'Milestone is required.',
		isKeyEvent: 'Key event',
		timephaseDescription: 'Description (optional) ',
		addSuccessMessage: 'Time phase added successfully.',
	},

	AccountListHeaderLabels: {
		pspAndosp: 'PSPs/OSPs',
		limitRiskAssertionLabel: 'Limited risk account',
		heading: 'Accounts and disclosures and related ',
		accountsOrDisclosure: 'Accounts and disclosures',
		psps: 'PSPs',
		rejected: 'Rejected',
		remove: 'Remove',
		risks: 'Risks',
		assertions: 'Assertions',
		noRecordsFound: 'No accounts or disclosures available',
		noResultsFound: 'No results found',
		responsiveHeading: 'Responsive ',
		rejectedPspsHeading: 'Rejected PSPs',
		importPsps: 'Import PSPs',
		importOsps: 'Import OSPs',
		addOsps: 'Add OSPs',
		pspEnded: 'to get started.',
		noPspsandOsps: "No {0} available.",
		allAreRejected: 'All PSPs have been rejected.',
		rejectButton: 'Reject',
		acceptButton: 'Accept',
		additionalInfo: ' Rationale:',
		noAssertionsAvailableLabel: 'No assertions available',
		noAssertionAvailableTooltip: 'No assertion available. Click <strong>Manage accounts and disclosures</strong> to add assertions.',
		importFromKnowledge: 'Import from knowledge',
		disabledAddOspTooltip: 'At least one assertion must be available to add a substantive task. Click <strong>Manage accounts and disclosures</strong> to add assertions.',
		noPsps: 'No PSPs available. {0} to get started.',
		noOspsPsps: 'No PSPs/OSPs available. {0}, {1}, or {2} to get started.',
		acceptErrorMsg: 'Unable to accept the rejected task. Refresh the page and try again. If the issue persists contact the Help Desk.',
		build7NoPspOrOspAttachedToAssertion: "Each assertion must have at least one responsive substantive procedure. The following assertion(s) do not have any responsive PSPs/OSPs: <b>{orphanAssertions}</b>. {0}, {1}, or add a {2} to address all assertions for the account or click on the edit icon for existing PSPs/OSPs responsive to this account to relate them to other assertions.",
		build7NoPspOrOsp: "Each assertion must have at least one responsive substantive procedure. None of the assertions have responsive PSPs/OSPs. {0}, {1}, or create a {2} to address all assertions for the account.",
		build7NoOspsAndAllPspAreRejected: "Each assertion must have at least one responsive substantive procedure. All PSPs have been rejected and none of the assertions have responsive PSPs/OSPs. {0} or create a {1} to address all assertions for the account.",
		build6And7NoAssertions: "Each significant account or significant disclosure must have at least one related assertion available to add a substantive procedure. Click {0} to add assertions.",
		build7LimitedAccountNoPspOsp: "Each limited risk account must have at least one responsive substantive procedure. {0} or create a {1} to respond to the risks of this account.",
		manageAccountAndDisclosures: "Manage accounts and disclosures"
	},

	AddTaskLabels: {
		accountLabel: 'Account:',
		taskSectionLabel: 'Task section:',
		ospModelTitle: 'New OSP',
		ostModelTitle: 'New OST',
		saveAndClose: 'Save',
		saveAndCreate: 'Save and create another',
		cancel: 'Cancel',
		prefix: 'Prefix',
		title: 'Title',
		suffix: 'Suffix',
		timePhase: 'Time phase',
		description: 'Customized description',
		descriptionPlaceholder: 'Customized task description (required)',
		assertions: 'Assertions',
		optional: '(optional)',
		required: 'Required',
		noResultFound: 'No results found',
		of: 'of',
		characters: 'characters',
		descriptionMaxLengthError: 'Description length exceeded maximum allowed length',
		noteDiscriptionErrorMessage: 'Response contains {0} characters which exceeds the maximum of {1} characters. Adjust the description by reducing text or formatting and try again. If the issue persists, contact the Help Desk.',
		customizeDescription: 'Customized task description (required)',
		errorMsg: 'Failed to add the OSP. Refresh the page and try again. If the issue persists contact the Help Desk.',
		customizeTaskDescription: 'Customize task description'
	},

	RemoveTaskLabels: {
		modelOspTitle: 'Delete OSP',
		modelOstTitle: 'Delete OST',
		deleteBtn: 'Delete',
		cancel: 'Cancel',
		confimationOspMsg: 'Are you sure that you want to delete the selected OSP?',
		confimationOstMsg: 'Are you sure that you want to delete the selected OST?',
		warning1Msg: 'Related evidence that is not related to any other tasks in this engagement will be moved to temporary files.',
		warning2Msg: 'Findings and response tasks that are not related to any other evidence will be deleted.'
	},

	TaskReportHeaderLabels: {
		Tasktype: 'Task type',
		Taskstatus: 'Task status',
		Taskassignedto: 'Task assigned to',
		Tasktitleprefix: 'Task title prefix',
		Tasktitle: 'Task title',
		Tasktitlesuffix: 'Task title suffix',
		Taskdescription: 'Task description',
		Knowledgetasktitle: 'Knowledge task title',
		Knowledgetaskdescription: 'Knowledge task description',
		Oldtaskname: 'Old task name',
		Oldtaskdetail: 'Old task detail',
		Rejected: 'Rejected',
		Rationalforrejection: 'Rational for rejection',
		Auditphase: 'Audit phase',
		Timephasetype: 'Milestone',
		Timephase: 'Time phase',
		Timephasestartdate: 'Time phase start date',
		Timephaseduedate: 'Time phase due date',
		Keyevent: 'Key event',
		Tasksource: 'Task source',
		Tasknature: 'Task nature',
		Lasttaskstatuschangedate: 'Last task status change date',
		Taggroup: 'Tag group',
		Tags: 'Tags',
		RelatedMESTentities: 'Related MEST entities',
		Schedulednextwaveservices: 'Scheduled nextwave services',
		Priority: 'Priority',
		Taskid: 'Task ID',
		Roleid: 'Role ID',
		Tasktypeid: 'Task type ID',
		Taskstatusid: 'Task status ID',
		Auditphaseid: 'Audit phase ID',
		Timephasetypeid: 'Milestone ID',
		Tasksourceid: 'Task source ID',
		Tasknatureid: 'Task nature ID',
	},

	glAccountDocumentLabels: {
		modelTitle: 'GL Account',
		modelName: 'Relate evidence',
		documentName: 'Document Name',
		documentCounter: '{0} Document',
		documentsCounter: '{0} Documents',
		btnCancel: 'Cancel',
		btnSave: 'Save',
		errorMessage: 'Select a document to continue',
		noResultsFound: 'No results found',
		newTickMark: 'New tickmark',
		bulkModePlaceholder: 'Select an evidence to relate and select <strong>\'Save\'</strong> to finish.'
	},

	// Edit TimePhase Labels
	editTimePhaseLabels: {
		modalTitle: 'Edit time phase',
		modalDescription: 'Edit the attributes and click <b>Save.</b>',
		editSuccessMessage: 'Time phase updated successfully.',
	},

	// Delete TimePhase Labels
	deleteTimePhaseLabels: {
		deleteTimePhaseModalTitle: 'Delete time phase',
		deleteDescription: ' Are you sure that you want to delete this time phase?',
		showTimePhaseName: 'Time phase',
		showMileStone: 'Milestone',
		showStartDate: 'Start date',
		showEndDate: 'End date',
		showDescription: 'Description:',
		showAssignedTasks: 'Count of tasks assigned',
		showAssignedAssignments: 'Count of assignments',
		deleteSuccessMessage: 'Time phase deleted successfully.',
	},

	// Create Tag Labels
	createTagGrouplabels: {
		modalTitle: 'Add tag group',
		modalDescription: 'Enter a name and click Save & close or Save & add to continue.',
		tagGroupNameLabel: 'Tag group',
		tagGroupNameErrorMessage: 'Tag group required',
		saveAndClose: 'Save & close',
		saveAndAdd: 'Save & add',
		addSuccessMessage: 'Tag group added successfully.',
	},

	// Bulk Tags
	tags: {
		noTagsAvailabel: 'No tags available',
		deleteTag: 'Delete tag',
		deleteDescription: 'Deleting tag cannot be undone, are you sure that you want to continue?',
		showDeleteTagName: 'Tag',
		showDeleteTagGroupName: 'Tag group',
		showAssignedTasks: 'Assigned tasks',
		deleteSuccessMessage: 'Tag deleted successfully.',
		task: 'Task',
		tasks: 'Tasks',
		addTagGrouplabels: 'Add tag group',
		addTag: 'Add tag',
		action: 'Action',
		addTagDesc: '<h3>Add tag</h3><p>Click on ‘Add tag group’ to create a new tag group that can be utilized to add tags.</p>',
		assignTagDesc: '<h3>Assign tags</h3><p>Drag and drop selected items onto the desired tag under a tag group.</p>',
		editTagDesc: '<h3>Edit tags</h3><p>Click on the overflow menu (three dots) and select ‘Edit’ to edit the tag properties.</p>',
		deleteTagDesc: '<h3>Delete tags</h3><p>Click on the overflow menu (three dots) and select ‘Delete’ to delete the tag.</p>',
		removeTagDesc: '<h3>Remove tag</h3><p>To remove a tag, drag one or more items with an existing tag to the associated tag name under a tag group.</p>',
		expand: 'Expand',
		collapse: 'Collapse',
		TagName: 'Tag name',
		TagGroupName: 'Tag group name',
		addTagSuccessMessage: 'Tag added successfully.',
		editTagSuccessMessage: 'Tag updated successfully.',
		addTagModalTitle: 'Add tag to ',
		editTagModalTitle: 'Edit tag',
		addTagModalDescription: 'Create new tag and click Save & close or Save & add to continue.',
		editTagModalDescription: 'Edit the attributes and click <b>Save.</b>',
		tagSetSuccessMessage: 'tag set successfully.',
		tagsSetSuccessMessage: 'tags set successfully.',
		tagRemoveSuccessMessage: 'tag removed successfully.',
		tagsRemoveSuccessMessage: 'tags removed successfully.',
		tagRemovedSuccessfully: 'Tag removed successfully.',
	},

	relateEvidenceHeader: 'Relate evidence that provides information about the adjustment.',
	relatedDocumentCounter: '{0} Document',
	relatedDocumentsCounter: '{0} Documents',
	documentsLocationLabel: 'Documents location',
	relateTemporaryFilesHeader: 'Relate a temporary document from this engagement.',

	// Create Assignment Labels
	addAssignmentlabels: {
		modalTitle: 'Add assignment',
		modalDescription: 'Enter a name and click Save when you are done.',
		assignmentNameLabel: 'Assignment name',
		assignmentNameErrorMessage: 'Assignment name cannot be empty',
		saveAndClose: 'Save & close',
		saveAndAdd: 'Save & add',
		addSuccessMessage: 'Assignment added successfully.',
	},
	addUserOrRoleLabelto: 'Add user or role to ',
	addUserOrRoleheader: 'Search the team member or role you want to add.',
	saveAndAdd: 'Save & add',

	// Bulk Assignment
	BulkActionsLabel: 'Bulk actions',
	BulkAssignmentAction: 'Action',
	BulkShow: 'Show',
	BulkActionsInstructionalText: 'Perform bulk operations for task groupings using drag and drop. To view individual tasks for a task grouping, mouse over the task group and click the arrow icon.',
	bulkOperationsModalDescription: 'Perform bulk operations for tasks. To view individual tasks for a task grouping, mouse over the task group and click the arrow icon.',
	selectRequest: 'Select a request to send.',
	replaceLabel: 'Replace',
	labelStaff: 'staff-',
	addModeLabel: 'Add',
	replaceModeLabel: 'Replace',
	dueDateModeLabel: 'Update due days',
	searchByAssignmentName: 'Search',
	addTeamMemberLabel: 'Add team member',
	noTeamMembersFound: 'No team members available',
	addMemberSuccessMessage: 'Team member added successfully.',
	addAssignmentLabel: 'Add assignment',
	addAssignmentNameLabel: 'Add assignment name',
	noAvailableAssignmentsMessage: 'No available assignments',
	showDuplicateError: 'The selected team member or role cannot have a duplicate assignment for the selected task(s). Choose a different assignment, team member, or role to continue.',
	infoBulkAssignments: 'Bulk assignments',
	infoBulkAssignmentDesc: 'Select one or more groupings of tasks to create new assignments or replace existing assignments. When assignments are created or edited, the current assigned to team member will be recalculated as the team member with the assignment due the earliest.',
	infoAssignmentsDueDate: 'Setting assignment(s) due date',
	infoAssignmentsDueDateDesc: 'Use “Select date/Calculate date” toggle to set assignment(s) due date. The toggle can be used to either give a specific due date for task(s) or to provide days prior to time-phase end date.',
	infoAddAssignmentExisting: 'Add assignment to existing team member',
	infoAddAssignmentExistingDesc: 'Adding assignments requires a number of days prior to due date to be set. Alternatively, exact due date may be set using the calendar control. Once that is done, drag and drop the selected items to create a new set of assignments.',
	infoAddAssignmentNew: 'Add assignment to new team member',
	infoAddAssignmentNewDesc: 'If the team member or role is not presented for the given assignment, click on add team member to see a list of available team members and roles.  Once selected that team member will be added to the bottom of the list and can be used for drag and drop assignment.',
	infoRemove: 'Remove assignment',
	infoRemoveDesc: 'To remove an assignment, drag one or more items to a team member under an assignment name.  Any incomplete assignments for that team member will be removed.  Completed assignments will not be removed.',
	infoReplace: 'Replace assignment',
	infoReplaceDesc: 'When replacing an assignment you will drag one or more items to a team member under an assignment name.  Any existing assignments with that same assignment name will be re-assigned to the selected team member.  If multiple team members had assignments for that assignment name, they will be consolidated to the selected user.  Setting due days prior is optional when using replace assignment.  If no due days prior is set, then the existing due days prior will be used.',
	infoUpdateDueDate: 'Update due days',
	infoUpdateDueDateDesc: 'Set the new "Days due", using “Select date” or “Calculate date” and then drag and drop onto the team member whose due days you want changed. Open and in progress assignments for that team member will have their due days updated. Completed assignments will not be changed.',
	infoDelete: 'Delete assignment',
	infoDeleteDesc: 'Click on assignment on the right hand side and an option to delete that set of assignments will appear.',
	infoExecutive: 'Executive assignment',
	infoExecutiveDesc: 'Use the filters and search functionality to filter the tasks for those applicable to executives to make assignments more quickly.',
	infoSpecificTask: 'Assignments to specific tasks',
	infoSpecificTaskDesc: 'If assignments need to be made at a task level, hover over the grouping on the left hand side and select the option to view individual tasks.  This will present the individual tasks for the group and enable fine grained assignments.',
	unassignedLabel: 'unassigned',
	replaceSignleSuccessMessage: 'task updated successfully.',
	replaceMultipleSuccessMessage: 'tasks updated successfully.',
	dueDateSingleSuccessMessage: 'assignment updated successfully.',
	dueDateMultipleSuccessMessage: 'assignments updated successfully.',
	invalidAssignmentUpdate: 'Assign the task to the same person to proceed with updating of due days.',
	removeSuccessMessage: 'assignment(s) updated successfully.',
	colorCode: 'Color code',
	removeSuccessSingleMessage: 'assignment updated successfully.',
	removeSuccessMultipleMessage: 'assignments updated successfully.',
	assignmentRemovedSuccessfully: 'Assignment removed successfully.',

	// Bulk Task
	itemsSelected: "tasks selected",
	itemSelected: "task selected",
	dragAndDrop: "Drag and drop",
	currentApplication: 'Current application',
	allAssignmentsClosed: 'All assignments closed',
	allAssignmentsCompleted: 'All assignments completed',

	onOrBeforeCurrentDate: 'On or before current date',
	withInCurrentWeek: 'This week',
	quickFilter: 'Quick filter',
	suggestedFilters: 'Suggested filters',
	showXMore: 'Show {0} more',

	// Task due date Events
	addEventlabels: {
		modalTitle: 'Add event',
		startDateLabel: 'Start date',
		modalDescription: 'Add the attributes and click Save & close or Save & add.',
		eventNameLabel: 'Event name',
		eventType: 'Event type',
		singleDay: 'Single day',
		dateRange: 'Date range',
		eventDate: 'Event date',
		eventDescription: 'Description (optional) ',
		isEvent: 'Share event with client',
		EventNameErrorMessage: 'Event name is required.',
		eventDateErrorMessage: 'Event date is required.',
		addSuccessMessage: 'Event added successfully.',
	},

	// Bulk Notes
	DeleteSomeNotesAreClosed: "<b>Only some of the notes that you selected have closed status and can be deleted.</b> <br /> If you choose to proceed, the notes listed below will be deleted.",
	DeleteSomeNotesAreNotClosed: "The notes listed below cannot be deleted because they have not been closed.",
	DeleteDontHaveClosedNotes: "The notes listed below cannot be deleted because they have not been closed.",
	someNotesAreOpen: '<b>Only some of the notes that you selected have open status.</b> <br /> If you choose to proceed, the notes listed below will be updated.',
	someNotesAreNotOpen: 'The notes listed below will not be updated because they have already been cleared or closed.',
	dontHaveOpenNotes: 'The notes listed below cannot be updated because they have already been cleared or closed.',
	ShowNumberMore: 'Show {0} more',

	// Drag and Drop
	assignmentLabel: 'assignment',
	assignmentsLabel: 'assignments',
	singleAssignmentCreatedMessage: 'assignment created successfully.',
	multipleAssignmentCreatedMessage: 'assignments created successfully.',
	daysPriorWarning: 'Set the days due prior before creating assignments.',



	// Related Tasks - Engagement selector
	selectEngagement: 'Select Engagement',
	thisEngagement: 'This engagement',
	noResultsFoundLabel: 'No results found',
	taskLocationLabel: 'Task location',

	// Delete Assginment
	deleteDescription: 'Deleting assignment cannot be undone, are you sure you want to continue?',
	deleteAssignmentModalTitle: 'Delete assignment',
	deleteSingleSuccessMessage: 'assignment deleted successfully.',
	deleteMultipleSuccessMessage: 'assignments deleted successfully.',
	teamMemberLabel: 'Team Member',
	assignedTasksCountLable: 'Assigned tasks',
	deleteAssignmentLabel: 'Assignment',
	selectengagement: 'Select engagement',

	//Due Days
	dueDateTitle: 'Enter due days',
	dueDatedescription: 'Enter the number of days before the time phase due date the assignment should be completed by.',
	dueDateAssign: 'Assign',
	dueDateSelect: 'Select',
	dueDateCalculate: 'Calculate',

	// Tasklist - bulk markcomplete
	markComplete: 'Mark complete',
	markCompleteMessgae1: 'Are you sure that you want to <b>complete the selected tasks</b>? <br /> If you have any incomplete assignments for the selected tasks, they will be closed.',
	markCompleteMessgae2: 'Only some of the tasks that you selected can be marked complete.<br /> If you choose to proceed, <b>the tasks listed below will be marked complete</b>. If you have any incomplete assignments, they will be closed.',
	markCompleteMessgae3: '<b>The tasks listed below will not be marked complete</b> because they do not have any evidence associated or the evidence associated is missing sign-offs.',
	markCompleteMessgae4: '<b>The tasks listed below cannot be marked complete</b> because they do not have any evidence associated or the evidence associated is missing sign-offs.',

	// Tasklist - bulk handoff
	handOffLabel: 'Hand off',
	confirmHandOff: 'Confirm hand off',
	handOffMessgae1: 'Are you sure that you want to <b>hand off the selected tasks</b> to the next assigned team member? <br /> If you have any incomplete assignments for the selected tasks, they will be closed.',
	handOffMessgae2: 'Only some of the tasks that you selected have another assigned team member. <br />If you choose to proceed, <b>the tasks listed below will be handed off</b>. If you have any incomplete assignments for the selected tasks, they will be closed.',
	handOffMessgae3: '<b>The tasks listed below will not be handed off</b> because they do not have any incomplete assignments.',
	handOffMessgae4: '<b>The tasks listed below cannot be handed off</b> because they do not have any incomplete assignments.',
	closeMyAssignments: 'Close my assignments',

	saveQuickFilter: 'Save quick filter',
	saveQuickFilterModalHeader: 'Save the filter chips that you applied as a quick filter.',
	saveQuickFilterModalText: 'Select saved and suggested quick filters to save time when you access this engagement again.  You can create up to five saved quick filters per engagement.',
	quickfiltername: 'Quick filter name',
	taskCategory: 'Task category',

	cannotsavefilter: 'Cannot save custom quick filter',
	cannotsavefiltermodalheadertext: '<b>You can only save five custom quick filters per engagement.</b> <br /> If you want to proceed, delete one of your existing custom quick filters and try again.',
	savedFilters: 'Saved filters',
	taskassignedto: 'Task assigned to',
	noteassignedto: 'Note assigned to',
	taskPrefix: 'Task prefix',
	taskSuffix: 'Task suffix',

	// Mark complete/HandOff Evidences category
	noSignOffs: 'No sign-offs',
	noSignOffsByMe: 'No sign-offs by me',
	myPreparerSignOffs: 'My preparer sign-off',
	myReviewerSignOffs: 'My reviewer sign-off',
	myPreparerAndReviewerSignOffs: 'My preparer and reviewer sign-offs',

	notificationDownErrorMessage: 'The Notifications feature is temporarily unavailable. Refresh the page and try again. If this message persists, contact the Help Desk.',
	notificationUpbutSomeLoadingErrorMessage: 'The Notification Center is temporarily unavailable. Refresh the page and try again - it will be available shortly.',

	timeTrackerErrorFallBackMessage: 'The Time Tracking feature is temporarily unavailable. Refresh the page and try again. If this message persists, contact the Help Desk.',
	timeTrackerLoadingFallbackMessage: 'The Time Tracking feature is temporarily unavailable. It will be available shortly.',

	signOffOnAllAs: 'Sign-off on all as',
	accountType: 'Account Type',

	openDocumentInstructionalText: 'This document will be automatically opened.  <b>You do not need to click to open it.</b> <br>After the document opens, you can close this tab.',
	closeTab: 'Close tab',

	// Build Step - Add Due Date
	milestones: 'Milestones',
	events: 'Events',
	noTimePhasesHaveBeenIdentified: 'No Time phases have been identified.',

	wcgws: 'WCGWs',
	relatedControls: 'Related controls',
	relatedControlsWCGWsRatio: 'Related controls / WCGWs',
	wcgwsToControlsRatio: 'WCGWs to Controls ratio',
	controlsToWCGWsRatio: 'Controls to WCGWs ratio',
	testedControls: 'Tested controls',

	// Collaboration request to Task relation
	CollaborationModalTitle: 'Relate requests to tasks',
	CollaborationModalDescription: 'To relate a request to a task, drag and drop one or more request(s) to the task below.',
	noDataFound: 'No data found',
	taskName: 'Task',
	showMessage: 'Select a category and task group to begin',
	showCategory: 'Category',
	showTaskGroup: 'Task group',
	optionITProcesses: 'IT processes',
	optionExecutionGeneral: 'Execution general',
	relatedRequestsLabel: 'Related requests',
	relatedRequestsFormatted: "{0} Related requests", //97 Related tasks
	relatedRequestFormatted: "{0} Related request", //1 Related task
	relatedRequests: 'Related requests',
	relatedTasks: 'Related tasks',
	relatedSuccessSingleMessage: '{0} request has been related to task successfully.',
	relatedSuccessMultipleMessage: '{0} requests have been related to task successfully.',
	showUnrelated: 'Show {0} unrelated',
	unrelate: 'Unrelate',
	noRequestsMessage: 'No requests available',
	requestNumber: 'Request number',
	sortAscending: 'Sort ascending',
	sortDescending: 'Sort descending',
	removeSorting: 'Remove sorting',

	// PIC Dashboard
	groupBy: 'Group by',
	allTasks: 'All tasks',
	iTSOs: 'IT/SOs',
	generalExecution: 'General execution',
	PICSignOff: 'PIC sign-off',
	EQRSignOff: 'EQR sign-off',
	completed: 'Completed',
	allAssigned: 'All assigned',
	picTaskAssignmentLabel: 'Your assignments',
	assignReadyForReview: 'Current',
	assignUpcomingForReview: 'Upcoming',
	assignReadyForReviewTasks: 'Current assignments',
	assignUpcomingForReviewTasks: 'Upcoming assignments',
	picTaskSignoffInComplete: 'Tasks with <b>PIC</b> sign-offs incomplete',
	picDocSignoffInComplete: 'Documents with <b>PIC</b> sign-offs incomplete',
	eqrTaskSignoffInComplete: 'Tasks with <b>EQR</b> sign-offs incomplete',
	eqrDocSignoffInComplete: 'Documents with <b>EQR</b> sign-offs incomplete',
	collapseCards: 'Collapse cards',
	expandCards: 'Expand cards',
	noUserSelectedPlaceholder1: 'The {0} has not been identified or invited to the engagement.',
	noUserSelectedPlaceholder2: 'Click here',
	noUserSelectedPlaceholder3: 'to identify or invite the {0}.',
	notInvitedLabel: 'Not invited',
	noTasksPlaceholder: 'There are no tasks associated to <br/>the milestones in this audit phase.',
	noTasksTilesPlaceholder: 'No tasks assigned to the selected user',
	noAssignmentPlaceholder: 'No assignments found',
	dueDateAssignmentPlaceholder: 'Assignments by due date',
	countAssignmentPlaceholder: 'Assignment count',
	OverduetPlaceholder: 'Overdue',
	TodayPlaceholder: 'Today',
	tasksView: 'Tasks view',
	documentsView: 'Documents view',
	picAndEqr: "PIC & EQR",
	ResponsiveToSR: "Related to ⚡SR",
	responsiveToFR: "Related to ⚡FR",
	relatedTasksFormatted: "{0} Related tasks", // 43 Related tasks
	relatedTaskFormatted: "{0} Related task", // 1 Related task
	autoAssignWarning2: "click here",
	toAssign: "to assign",
	taskAssignWarning: "task with {0} sign-off requirements not assigned,",
	tasksAssignWarning: "tasks with {0} sign-off requirements not assigned,",
	taskAdditionalFuncText1: '<b>This task has additional functionality. Please </b>',
	taskAdditionalFuncText2: '<b> to navigate to it.</b><p>Build Tasks do not require evidence to be associated to mark complete, unless the task requires PIC/EQR review.</p>',
	taskadditionalfunctionality: '<b>This task has additional functionality. Please</b> {0} <b>to navigate to it.</b><p>Build Tasks do not require evidence to be associated to mark complete, unless the task requires PIC/EQR review.</p>',
	taskclickhere: 'click here',
	taskAutoAssignModalTitle: 'Auto assign',
	taskAutoAssignModalDescription: 'There are {0} task with an EQR sign-off requirement that have not been assigned to {1}. Click "Assign" to create EQR assignment for {1}.',
	tasksAutoAssignModalDescription: 'There are {0} tasks with an EQR sign-off requirement that have not been assigned to {1}. Click "Assign" to create EQR assignments for {1}.',
	picTaskAutoAssignSuccessMessage: 'task with PIC sign-off requirement assigned to',
	picTasksAutoAssignSuccessMessage: 'tasks with PIC sign-off requirement assigned to',
	eqrTaskAutoAssignSuccessMessage: 'task with EQR sign-off requirement assigned to',
	eqrTasksAutoAssignSuccessMessage: 'tasks with EQR sign-off requirement assigned to',
	taskEntityDocumentValidationMsg: 'This task has entities that do not have any responsive evidence. Toggle to view by entities to see which entities need additional documentation.',
	// PIC/EQR Sign-Off validation message
	picSignOffValidationMsg: 'This task requires PIC sign-off, but no PIC documents are associated. Add at least one document with this requirement.',
	eqrSignOffValidationMsg: 'This task requires EQR sign-off, but no EQR documents are associated. Add at least one document with this requirement.',
	picAndEQRSignOffValidationMsg: 'This task requires PIC/EQR sign-off, but no PIC/EQR documents are associated. Add at least one document with this requirement.',
	updateDataOnPicEqrDashboardBannerMessage: 'Changes made have not been updated below. Please {0} to refresh the page.', //{0}= click here
	showMissingSignOffByLabel: 'Show documents missing {0} sign-off',

	FindingsReportName: 'Findings',
	FindingsDeficiencyReportTabName: 'Deficiency',
	FindingsMisstatementReportTabName: 'Misstatement',
	FindingsDeficiencyITReportTabName: 'Deficiency-IT',
	auditPlanRelatedEvidenceReporLabel: 'Audit plan with related evidence',
	groupStructureSummaryReportReportLabel: 'Group structure summary',
	auditPlanReportLabel: 'Audit plan report',
	itAppSOSummaryReportLabel: 'IT app & SO summary',
	craSummaryReportLabel: 'CRA summary',
	teamMembersLabel: 'Team members',
	ipeLabel: 'Information produced by the entity (IPE)',
	validationChecksReportLabel: 'Validation checks',
	trialBalanceReportLabel: 'Trial balance',
	trialBalanceReportTabLabel: 'Trial balance report',
	reportLabelYes: 'Yes',
	reportLabelNo: 'No',
	assignedBy: 'Assigned by',
	openInReviewNotesHub: 'Open in review notes hub',
	nextNote: 'Next',
	previousNote: 'Previous',

	//component team group tab names
	accountInfoCanvasFormExport: 'Account information',

	//project insight tab names
	projectInsightCanvasFormExport: 'Canvas Form Export',
	projectInsightSCOTToWCGWToControl: 'SCOT to WCGW to Control',
	projectInsightControlToITApplication: 'Control to IT Application',
	projectInsightControlToAssertion: 'Control to Assertion',
	projectInsightRiskToWCGW: 'Risks to WCGWs',

	//IPE Report
	ipeControlsReport: 'Controls',
	ipeSubstantiveReport: 'Substantive',
	ipeITGCReport: 'ITGC',

	// Milestone tab names
	milestonesReport: 'Milestones report',
	unmappedTasks: 'Unmapped tasks',

	// Effective
	isEffective: 'Effective',
	inEffective: 'Ineffective',
	nonEffective: 'Non Effective',

	clientRequests: 'Client Requests',
	externalTasks: 'External Tasks',
	requestPriority: 'Request Priority',
	scot: 'SCOT',
	assertionR: 'Assertion',
	wcgwToControlMappingTotal: "WCGW to Controls mapping totals",

	//CRA build step
	buildStep2EntityHeaderText: 'Significant accounts and disclosures, assertions, related WCGWs and controls',
	buildStep4EntityHeaderText: 'Significant accounts, disclosures and related assertions',
	accountNameHeader: 'Significant accounts and disclosures',
	noAssertionsLabel: 'No related assertions. Click <a>Manage accounts and disclosures</a> to get started.',
	noAssertionsBuildStep2text1: 'At least one assertion must be related to this account. Click ',
	accountWithoutAssertionsBuildStep2text1: 'Each significant account or disclosure must have at least one related assertion. Click ',
	noAssertionsBuildStep2text2: 'Manage accounts and disclosures',
	noAccountsLabel: 'No significant accounts or disclosures have been created. Click <span class="bold-text">Manage accounts and disclosures</span> to get started.',
	noAccountsLabelPlaceHolder: 'No significant accounts or disclosures have been created. <span class="bold-text">Manage accounts and disclosures</span> to get started.',
	noAccountsOrDiscloserPreText: 'No significant accounts or disclosures have been created. ',
	noAccountsOrDiscloserText: 'Manage accounts and disclosures',
	noAccountsOrDiscloserPostText: ' to get started.',
	noAssertionsBuildStep1text1: 'At least one assertion must be related to this risk. Click ',
	noAssertionsBuildStep1text1Msg: 'Each risk must have at least one related assertion. ',
	noAssertionsBuildStep1text2: 'Relate assertions',
	noAssertionsBuildStep1text3: ' to get started.',
	editRisk: 'Edit risk',
	deleteRisk: 'Delete risk',
	noControlsRelatedWWCGW: 'No related controls. ',
	noControlsRelatedWCGW: 'For each WCGW related to an assertion with a control risk of Rely, at least one control must be selected for testing. Create a ',
	noControlsRelatedWCGWNewCont: ' New control ',
	noControlsRelatedWCGWor: ' or ',
	noControlsRelatedWCGWRelateCont: ' Relate an existing control ',
	noControlsForWCGW: 'Assertions with a control risk of Not Rely do not have a requirement to identify controls.',
	noControlsRelatedWCGWFooter: ' to get started.',
	relateWCGWs: '<a>Relate WCGWs</a>',
	noWCGWs: 'No related WCGWs.',
	noWCGWsClick: ' Click ',
	noWCGWsFooter: ' to get started.',
	showOnlyRisksWithNoAssertion: 'Show only risks without any related assertions',
	showIncomplete: 'Show only assertions with incomplete CRA',
	showOnlyInvalidBuildStep2: 'Show only accounts missing required details',
	noTestedControlsWithRelyAssertion: 'For each WCGW related to an assertion with a control risk of Rely, at least one control must be selected for testing.',

	// Account build step
	accountOrDisclosure: 'Account / disclosures',
	relatedAssertions: 'Related assertions',
	relatedAccountsAndAssertions: 'Related accounts and assertions',
	pspIndexTitle: 'PSP index',
	statementTypeTitle: 'Statement type',
	significantAccountLabel: 'Significant',
	limitedRiskLabel: 'Limited risk',
	insignificant: 'InSignificant',
	significantDiscloure: 'Significant Discloure',
	accountAddedMessage: 'Account "##" is successfully created',
	accounHeaderText: "Accounts and disclosures",

	// Add accounts / disclosures Modal labels
	accountsListTitle: 'Accounts / disclosures and related assertions',
	addAccountsDisclosures: 'Add accounts / disclosures',
	editAccountsDisclosures: 'Edit accounts / disclosures',
	accountNameLabel: 'Account name (required)',
	accountDesignationLabel: 'Designation (required)',
	accountEstimateLabel: 'Account has an estimate',
	accountStatementTypeLabel: 'Statement type (required)',
	pspIndexDropdownLabel: 'PSP index (required)',
	removePSPIndexLabel: 'Remove PSP index',
	assertionsLabel: 'Assertions (required)',
	noAccounsMessage: 'No accounts found. Add accounts to get started.',

	//Delete account / disclosure modal labels
	deleteAccountDisclosure: 'Delete account / disclosure',
	deleteAcConfirmMessage: "Are you sure you want to delete the account/ disclosure {0}? All related assertions will be deleted. Any tasks that are only related to the selected account / disclosure will also be deleted.",

	true: 'True',
	false: 'False',
	taskSummaryReportEngagementInfo: 'Multiple engagements',
	viewPriority: "View Priority",
	priorityRequestsSent: "Priority requests sent",

	//reactive frame
	maxTabsLocked: 'Maximum allowed tabs reached. Unpin and close one of the tabs to open a new one.',
	openInNewTab: 'Open in new tab',
	copyLink: 'Copy link',
	copySuccess: 'Link copied to clipboard',
	copyFailure: 'Failed to copy link to clipboard',
	minimize: 'Minimize',

	//Risk status for account cards
	riskStatusLabels: {
		NoAssertionsAvailableLabel: 'No assertions available',
		SignificanceNotSelectedLabel: 'Significance not selected',
		InsignificantLabel: 'Insignificant',
	},

	lockTab: 'Pin tab',
	keyDocuments: 'Key documents',
	suggestedDocuments: 'Suggested documents',
	noSuggestedDocuments: 'No suggested documents',
	exitBulkMode: 'Exit bulk mode',
	bulkLabel: 'Bulk',

	me: 'Me',
	viewByUser: 'View by user',
	unsentDraftCapitalized: 'Unsent drafts',
	picSignoffInComplete: 'PIC sign-off incomplete',
	eqrSignOffIncomplete: 'EQR sign-off incomplete',

	tableView: 'Table view',
	noRelatedAssertions: 'No related assertions.',

	multiEntityTileMessage1: 'Click ',
	multiEntityTileMessage2: 'here',
	multiEntityTileMessage3: ' to see status by entity',
	allItemsMessage: ' to see all items',

	EntitySelector: 'Select an entity to get started',
	allEntities: 'All entities',
	multiEntity: 'Multi-entity',
	ungrouped: 'Ungrouped',
	numberSelected: '{0} selected',
	allTimePhases: "All",
	timePhases: 'Time Phase',
	noTimePhaseFound: 'No time phases found',
	unrelatedAssignments: 'Unrelated assignments',
	unrelatedRequests: 'Unrelated requests',
	relateRequests: 'Relate requests',
	taskWithoutAnyAssignments: 'Tasks without any assignments',
	privacyNotice: 'Privacy notice',
	lastPublishedAndSent: 'Last published and sent',
	drafts: 'Drafts',
	allEntitiesTask: 'This is an engagement-wide task related to all entities',
	noRelatedEntities: 'No related entities',
	clickNewRisk: "to get started.",
	relatedAccountsDisclosuresAndAssertions: 'Related significant accounts, disclosures and assertions',
	relateAssertion: 'Relate assertions',
	taskByEntity: 'Task by entity',
	engagementWideTask: 'Engagement-wide task',
	componentEngagementPill: 'CT',
	primaryAndComponentEngagementPill: 'PT/CT',
	// Scot build steps
	scotHeader: 'SCOTs',
	searchScot: 'Search',
	manageScots: 'Manage SCOTs',
	superModelStep1ScotMessage: 'Significant accounts and disclosures and related SCOTs',
	scotRelatedITApplicationServiceOrg: "SCOTs and related IT applications and service organizations",
	noScotsAvailable: 'No result found',
	searchScotPlaceholder: 'Search',
	searchScotClearHoverText: 'Clear',
	showOnlyUnrelatedScotToggleSwitch: 'Show only unrelated',
	newScot: 'New SCOT',
	importFromKnowledgeScot: 'Import SCOTs',
	importAccountsAndDisclosures: 'Import accounts and disclosures',
	showOnlyAccountRelatedScot: 'Show only SCOTs without any related significant account and disclosure ',
	warningMessageEstimateScotNotAssociatedWithEstimatedAccount: 'Each estimate SCOT must be related to at least one significant account or significant disclosure with an estimate.  Drag and drop this SCOT to a relevant significant account or significant disclosure.',
	warningMessageScotNotAssociatedWithAccount: 'Each SCOT must be related to at least one significant account or significant disclosure.  Drag and drop this SCOT to a relevant significant account or significant disclosure.',
	showvalidations: 'Show validations',

	scotRelatedWCGWandControls: 'SCOTs and related WCGWs and controls',
	newWcgw: 'New WCGW',
	manageWCGWs: 'Manage WCGWs',
	manageControl: 'Manage controls',
	importWCGWs: 'Import WCGWs',
	relateWCGWs: 'Relate WCGWs',
	newControl: 'New control',
	importControl: 'Import control',
	importControls: 'Import controls',
	relateControl: 'Relate controls',
	scotStrategyIsControlMessage: 'No controls identified for this WCGW. SCOT strategy is not defined.',
	scotStrategyIsWCGWMessage: 'No WCGWs identified for this SCOT. SCOT strategy is not defined.',
	controlsPlaceholderWithNoRelatedWCGWsMessage: ' Each SCOT must be related to at least one WCGW.  Create a ',
	controlsPlaceholderWithNoRelatedControlsMessage: 'Each WCGW must be related to at least one Control.  Create a ',
	noITApplicationSOMessage: 'No IT applications or service organizations identified for this SCOT. Click ',
	relatedItAppSOHeaderMessage: 'Related IT applications and service organizations',
	substantivePlaceholderWithNoRelatedControlsMessage: 'No Controls identified for this SCOT. For SCOTs with substantive strategy no controls need to be identified.',
	substantivePlaceholderWithNoRelatedWCGWsMessage: 'No WCGW identified for this SCOT. For SCOTs with substantive strategy, WCGWs need to be identified.',
	noITApplicationSOMessageText: 'to relate where required.',
	notSelected: 'Not selected',
	or: 'or',

	//WCGWControls
	showOnlyWCGWRelatedControls: 'Show only related',

	createorRelateControl: 'Create a new control or relate an existing control',

	//Accounts Scot build steps
	accountHeader: 'Accounts',
	searchAccount: 'Search account',
	searchAccountPlaceholder: 'Search',
	manageAccounts: ' Manage accounts and disclosures ',
	showOnlyUnrelatedAccountToggleSwitch: 'Show only unrelated',
	searchAccountClearHoverText: 'Clear',
	noAccountsAvailable: 'No results found',
	showOnlyScotRelatedAccount: 'Show only significant accounts and disclosures without any related SCOT ',
	warningMessageEstimateAccountNotAssociatedWithEstimatedScot: 'Each significant account or disclosure with an estimate must be related to at least one estimate SCOT. Drag and drop an existing relevant SCOT to this significant account or significant disclosure',
	warningMessageAccountNotAssociatedWithScot: 'Each significant account or disclosure must be related to at least one SCOT. Drag and drop an existing relevant SCOT to this significant account or significant disclosure',
	significantAccountsAndDisclosures: 'Significant accounts and disclosures',
	// Independence Only

	independenceOnlyStatus: 'Independence only',

	//Controls
	controlDesignEffectivenessWarningValidation: 'Controls must have a design effectiveness selected',
	controlHeader: 'SCOTs and related controls',
	manageControls: 'Manage controls',
	manageITApplications: 'Manage IT applications',
	searchControlClearHoverText: 'Clear',
	searchControlPlaceholder: 'Search',
	noControlsAvailable: 'No results found',
	controlName: 'Control name',
	frequency: 'Frequency',
	type: 'Type',
	newSO: 'New SO',
	designEffectiveness: 'Design effectiveness',
	testing: 'Testing',
	strategyTypeName: 'SCOT strategy',
	controlTestingYes: 'Yes',
	controlTestingNo: 'No',
	effective: 'Effective',
	ineffective: 'Ineffective',
	noControlsResult: 'No results found',
	noControlsLabel: 'No results found',
	relatedControl: 'Related control',
	relateControls: 'Relate controls',
	controlTypeValues: {
		itApplication: 'IT Application Controls',
		itDependentManual: 'IT Dependent Manual Control',
		manualPrevent: 'Manual Prevent',
		manualDetect: 'Manual Detect'
	},
	controlFrequencyTypes: {
		manyTimesPerDay: 'Many times per day',
		daily: 'Daily',
		weekly: 'Weekly',
		monthly: 'Monthly',
		quarterly: 'Quarterly',
		annually: 'Annually',
		iTApplicationControl: 'IT Application Control',
		other: 'Other'
	},
	filterTypeOfScots: "SCOTs",
	noScotsAvailable: 'No results found',


	onlyShowControlsWithNoDesignEffectiveness: 'Show only controls with no design effectiveness selected',

	// control Tasks
	controlCount: '{0} controls',

	//Create and Edit WCGW
	wcgwInputName: "WCGW name",
	editWCGW: "Edit WCGW",
	createNewWCGW: "Create new WCGW",
	editTheWCGW: "Edit the WCGW",
	createEditWCGWSave: "Save",
	createEditWCGWClose: "Cancel",
	createEditWCGWModelScot: "SCOT",
	newWCGWTitel: "New WCGW",
	wcgwNameIsRequired: "WCGW name is required",
	deleteWCGW: "Delete WCGW",


	//Audit Plan
	importPSPButtonText: 'Import PSPs',
	commonContentUpdateSuccessMessage: 'Content update in progress. This may take up to fifteen minutes to complete. Refresh the page to see newly imported PSPs.',
	responsivetoRisks: 'Responsive to risks',
	procedures: 'Procedures',
	toc: 'TOC',
	significantandFraudRisksHeading: 'Significant and fraud risks and their responsive procedures and controls',
	risksBeingRespondedToByComponentTeam: 'Risks are being responded to by component team(s).',
	responsivecontrolsandTOCs: 'Responsive controls and TOCs',
	ResponsivePSPOSP: 'Responsive PSP/OSP',
	responsivePSPsOSPs: 'Responsive PSPs/OSPs',
	responsiveTOC: 'Responsive TOC',
	responsiveControl: 'Responsive control',
	responsivePSPOPSMessage: 'At least one substantive procedure should be identified as being responsive for this assertion for this risk. Click {0} to identify responsive substantive procedures.',
	responsiveControlMessage: 'At least one control (with completed design effectiveness evaluation) should be identified as being responsive for this assertion for this risk. Click {0} to identify responsive controls. Click {1} to set the design effectiveness or testing strategy.',
	responsiveTOCMessage: 'Assertions with control risk of Rely must have at least one TOC that is responsive to the risk for a control is (1) not designated as lower risk and (2) has a completed design effectiveness. Click <b>Responsive TOC</b> to identify responsive TOCs.',
	notcompleted: 'Not completed',
	noResponsiveTOCAvailable: 'No responsive TOCs have been identified for this control.',
	refresh: 'Refresh data',
	tocHoverOverWhenControlTestingHasNoorNotCompleted: 'This control has not been selected for testing. Use <b>Manage controls</b> to change the testing selection.',
	noresponsiveTOCIdentified: 'No responsive TOC has been identified.',
	taskAssertionnotModified: 'The task assertions have not been modified. Edit the assertion relationship to proceed or click cancel to exit.',
	failedToEditRelatedAssertions: 'Failed to edit the assertions related to the task. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	assertionCannotEdited: 'Assertions with a disabled checkbox have been set by EY methodology and cannot be edited.',
	editAssertionInfoMessage: 'Add or remove assertions for the task. There must be at least one assertion selected.',
	editRelatedAssertions: 'Edit related assertions',
	loweRiskHeader: 'Lower risk',
	placeholderWhenControlTestingHasNotCompleted: 'This control has not been selected for testing. Use {0} to change the testing selection.',
	pspandOSP: 'PSPs/OSPs',
	tocs: 'TOCs',
	norelatedAssertionPlaceHolder: 'Each significant or fraud risk must have at least one assertion identified as being related to this risk. Click {0} to identify related assertions.',
	assertionMustHaveOneControlWithCompleteDesignEffectiveness: 'Each assertion must have at least one control with completed design effectiveness identified as being responsive to the risk. Click {0} to identify a responsive control.',
	controlRiskRelyNotLowerRisk: 'Each assertion with control risk of rely must have at least one control that is (1) not designated as lower risk, (2) designed effectively and (3) selected for testing. Click {0} to identify responsive control.',
	controlRiskRelyWithDesignEffectively: 'Each assertion with control risk of rely must have at least one control that is (1) designed effectively and (2) selected for testing. Click {0} to identify responsive control.',

	assertionWithControlRiskNotRely: 'Assertions with control risk of not rely do not have a requirement to identify a test of control.',
	thisControlNotSelectedForTesting: 'This control has not been selected for testing. Click {0} to change the testing selection.',
	testControlRelatedToControlAsLowerRisk: 'A test of control related to a control that is designated as a lower risk will not address the risk for this assertion.',
	testControlWithoutCompleteDE: 'A test of control related to a control without a completed design effectiveness evaluation will not address the risk for this assertion. Click {0} to set the design effectiveness.',
	testControlrelatedToineffective: 'A test of control related to a control with an ineffective design effectiveness evaluation will not address the risk for this assertion. Click {0} to change the design effectiveness.',
	anotherTestControlIdentified: 'Another test of control has been identified that responds to the risk of this assertion and no further tests of controls need to be identified. No responsive TOCs have been identified for this control.',
	eachControlMustHaveOneToc: 'Each assertion with control risk of rely must have at least one TOC that is responsive to the risk for a control that is (1) not designated as lower risk, (2) designed effectively and (3) selected for testing. No responsive TOCs have been identified for this control. Click {0} to identify responsive TOCs.',
	eachAssertionControlHaveAtleasetOneTOC: 'Each assertion with control risk of rely must have at least one TOC that is responsive to the risk for a control that is (1) designed effectively and (2) selected for testing. No responsive TOCs have been identified for this control. Click {0} to identify responsive TOCs.',
	norepsonsivePSPOSPplaceholder: 'Each assertion must have at least one substantive procedure identified as being responsive to this risk. Click {0} to identify a responsive substantive procedure.',

	//Reject Task
	rejectPspModalTitle: 'Reject PSP',
	rationaleRequired: 'Required',
	rationaleTextEditorLabel: 'Rationale for rejecting PSP',
	rejectTaskErrorMessage: 'Unable to reject the task. Refresh the page and try again.  If the issue persists, contact the Help Desk.',
	rejectTaskModalHeader: 'Are you sure that you want to reject the selected PSP?',
	rejectTaskModaWarningText: 'Related evidence that is not related to any other tasks in this engagement will be moved to temporary files.',
	rejectTaskRationaleLabel: "Rationale (required)",

	// Adobe Analytics
	aaCookieConsentTitle: 'Welcome to',
	aaCookieContentPrompt: 'Do you want to allow cookies?',
	aaCookieConsentExplanation:
		'<p>In addition to cookies that are strictly necessary to operate this website, we use the following types of cookies to improve your experience and our services: <strong>Functional cookies</strong> to enhance your experience (e.g. remember settings), <strong>Performance cookies</strong> to measure the website\'s performance and improve your experience, <strong>Advertising/Targeting cookies</strong>, which are set by third parties with whom we execute advertising campaigns and allow us to provide you with advertisements relevant to you.</p><p>Review our <a target="_blank" href="https://www.ey.com/en_us/cookie-policy">cookie policy</a> for more information.</p>',
	aaCookieConsentExplanationWithDoNotTrack:
		'<p>In addition to cookies that are strictly necessary to operate this website, we use the following types of cookies to improve your experience and our services: <strong>Functional cookies</strong> to enhance your experience (e.g. remember settings), <strong>Performance cookies</strong> to measure the website\'s performance and improve your experience, <strong>Advertising/Targeting cookies</strong>, which are set by third parties with whom we execute advertising campaigns and allow us to provide you with advertisements relevant to you.</p><p>We have detected that you have enabled the Do Not Track setting in your browser; as a result, Advertising/Targeting cookies are automatically disabled.</p><p>Review our <a target="_blank" href="https://www.ey.com/en_us/cookie-policy">cookie policy</a> for more information.</p>',
	aaCookieConsentDeclineOptionalAction: 'I decline optional cookies',
	aaCookieConsentAcceptAllAction: 'I accept all cookies',
	aaCookieConsentCustomizeAction: 'Customize cookies',
	aaCookieConsentCustomizeURL: 'https://www.ey.com/en_us/cookie-settings',

	//Task Sections
	taskSectionLabels: {
		taskSectionHeader: 'Task groups and related tasks',
		manageTaskSections: 'Manage task groups',
		taskSectionsAccordionHeader: 'Task groups',
		phaseAccordionHeader: 'Phase',
		tasksAccordionHeader: 'Tasks',
		rejectedAccordionHeader: 'Rejected',
		noRelatedTasksMessage: 'No PSTs/OSTs available. Create a {0} to get started.',
		taskSectionTaskHeader: 'Tasks',
		newOSTButtonText: 'New OST',
		cutomTaskSectionBadgeText: 'Custom',
		rejectedTasksLabel: "Rejected PSTs",
		additionalInfo: 'Rationale',
		rejectButton: 'Reject',
		acceptButton: 'Accept',
		removeButton: 'Remove',
		addButton: 'Add',
		allPSTsRejectedMessage: 'All PSTs have been rejected.',
		rejectModalTitle: 'Reject PST',
		rationaleTextEditorLabel: 'Rationale for rejecting PST',
		rejectTaskModalHeader: 'Are you sure that you want to reject the selected PST?',
		noResultsMessage: 'No results found',
		noTaskSetionsAvailableMessage: 'No task sections available',
		rejectTaskModaWarningText: 'Related evidence that is not related to any other tasks in this engagement will be moved to temporary files. PSTs with EY Canvas delivered documents cannot be rejected.',
		rejectTaskRationaleLabel: "Rationale (required)"
	},

	// Cookie Settings
	cookieSettings: {
		title: 'Cookie Settings',
		explanation:
			'Please provide your consent for cookie usage on ey.com and the My EY platform. Select one or more of the cookie types listed below, and then save your selection(s). Refer to the listing below for details on the types of cookies and their purpose.',
		emptyCookieListNotice:
			'Cookies from this category are not used in this app',
		nameTableHeader: 'Name of cookie',
		providerTableHeader: 'Cookie provider',
		purposeTableHeader: 'Purpose of cookie',
		typeTableHeader: 'Type of cookie',
		durationTableHeader: 'Duration of cookie',
		formSubmit: 'Save my selection',
		requiredCookieListTitle: 'Required Cookies',
		functionalCookieListTitle: 'Functional Cookies',
		functionalCookieAcceptance: 'I accept the functional cookies below',
		functionalCookieExplanation:
			'Functionality cookies, which allow us to enhance your experience (for example by remembering any settings you may have selected).',
		performanceCookieListTitle: 'Performance Cookies',
		performanceCookieAcceptance: 'I accept the performance cookies below',
		performanceCookieExplanation:
			'Performance cookies, which help us measure the website’s performance and improve your experience. In using performance cookies we do not store any personal data, and only use the information collected through these cookies in aggregated and anonymised form.',
		advertisingCookieListTitle: 'Targeting Cookies',
		advertisingCookieAcceptance:
			'I accept the advertising/targeting cookies below',
		advertisingCookieExplanation:
			'Advertising/targeting cookies, which we use to track user activity and sessions so that we can deliver a more personalized service, and (in the case of advertising cookies) which are set by the third parties with whom we execute advertising campaigns and allow us to provide advertisements relevant to you.',
		doNotTrackNotice:
			'We have detected that you have enabled the Do Not Track setting in your browser; as a result, advertising/targeting cookies are automatically disabled.'
	},

	//Task Sections and related Tasks
	taskSectionAndRelatedTask: 'Task sections and related tasks',
	manageTaskSections: 'Manage task sections',

	// Financial Statments
	financialStatementLabels: {
		financialStatements: "Financial statements",
		trialBalance: 'Trial Balance',
		okButton: 'OK',
		leadSheet: "Lead sheet",
		balanceSheet: 'Balance sheet',
		incomeStatement: 'Income statement',
		eyreferences: 'Reference',
		currenPeriod: 'Analysis date',
		comparativePeriod: 'Comparative date',
		changeFrom: 'Change from',
		percentageChangeFrom: '% Change from',
		notesColumn: 'Notes',
		viewTrialBalanceType: 'View by trial balance type',
		multiEntity: 'Multi-entity',
		placeHolderText: 'Search account classes',
		currencyType: 'Currency type',
		currencyCode: 'Currency code',
		businessUnit: 'Business unit',
		periodEnded: 'date ended',
		periodsEnded: 'dates ended',
		searchGLAccountPlaceholder: 'Search GL Accounts',
		eyReferenceDocuments: '{0} documents',
		relatedNotes: 'Related notes',
		notAvailable: 'Not available',
		significantDisclosures: 'Significant disclosures',
		noResultFound: 'No results found',
		openEYHelixProjects: 'Open EY Helix projects',
		openAdjustmentModule: 'Open adjustment module',
		goToSubstantiveProcedureLink: 'Go to substantive procedures',
		cancel: 'Cancel',
		remove: 'Remove'
	},

	financialStatementsClassView: {
		bulk: 'Bulk',
		eyAccount: 'EY account',
		placeHolderText: 'Search GL accounts',
		noAccountDesignation: 'Account designation has not been set.',
		insignificantLeadSheetMessage: 'Lead sheets are not presented for insignificant accounts',
		unmappedGLAccounts: 'Lead sheets are not presented for unmapped accounts',
		unmappedAccountText: 'Unmapped'
	},
	financialStatementTypeIds: [
		{
			id: 1,
			label: "Assets"
		},
		{
			id: 4,
			label: "Liabilities"
		},
		{
			id: 7,
			label: "Equity"
		},
		{
			id: 8,
			label: "Revenue"
		},
		{
			id: 9,
			label: "Expenses"
		},
		{
			id: 17,
			label: "Net income"
		}
	],
	copyrightMessage: 'Copyright © <year> all rights reserved',
	createNotes: {
		notesPlaceholderText: 'Add notes by clicking on {0} or {1}.',
		newNote: 'Add note',
		relateNote: 'Relate note',
		addNewNotesHeader: 'Enter note details below and select <b>\'Save and close\'</b> to finish. To create another note, select <b>\'Save and create another\'</b>.',
		noteIndex: 'Index',
		noteIndexRequired: 'Index (required)',
		noteDescription: 'Description',
		noteDescriptionRequired: 'Description (required)',
		saveAndClose: 'Save and close',
		newTickmarkDescription: 'Select the reason why there is no evidence referenced to this GL Account.',
		newTickmarkBulkModalDescription: ' Select the reason why there is no evidence referenced to the selected GL accounts.'
	},
	deleteNotes: {
		deleteNote: 'Delete note',
		deleteNoteTitle: 'Are you sure that you want to delete the selected note?',
		delete: 'Delete',
		cancel: 'Cancel'
	},
	editNotes: {
		editNote: 'Edit note',
		editNotesHeader: 'Edit note details below and select  <b>\'Save and close\'</b> to finish.',
		edit: 'Edit',
		cancel: 'Cancel'
	},
	notesListLabels: {
		actions: 'Actions',
		noteCount: '{0} note',
		notesCount: '{0} notes'
	},
	relateNotes: {
		relateNoteLabel: 'Relate note',
		searchPlaceholder: 'Search',
		accountLabel: 'Account',
		indexLabel: 'Index',
		descriptionLabel: 'Description',
		addedLabel: 'Added',
		showOnlyRelatedLabel: 'Show only related',
		noResultsFoundMessage: 'No results found',
		noteCount: '{0} Note',
		notesCount: '{0} Notes',
		closeBtnTitle: 'Close'
	},
	uploadEvidenceDocuments: {
		addnewEvidencesPlaceholderandLinks: 'Add evidence by clicking on {0}, {1} or designate no evidence required by clicking {2}.',
		newEvidence: 'New evidence',
		relateEvidence: 'Relate evidence',
		newTickMark: 'New tickmark',
		relateTasks: 'Relate task',
		noTasksSeleted: 'Select a task to continue.',
		relateTaskPlaceholder: 'New references must be related to at least one task. Select a task that this document should be added to as evidence.',
		confirmButtonTitle: 'Continue',
		closeButtonTitle: 'Cancel',
		noResultsFound: 'No results found',
		taskType: 'Type',
		taskName: 'Task name',
		taskCount: '{0} Task',
		tasksCount: '{0} Tasks',
		title: 'Reference',
		removeReference: 'Remove reference'
	},
	glAccountAssociatedNotes: {
		aggregatedNotesPlaceholder: 'No notes available. Select a GL Account to create a note.',
		notes: 'Notes',
		relatedGlAccountPlaceholder: 'Related GL Accounts'

	},
	finacialStatementsBulkOperations: {
		relateEvidenceLabel: 'Relate evidence',
		selectedCountGLAccount: '{0} GL account selected',
		selectedCountGLAccounts: '{0} GL accounts selected',
		selectAll: 'Select all',
		deselectAll: 'Deselect all',
		exitBulkMode: 'Exit bulk mode',
		noGLAccountsSelectedValidationMessageEvidence: 'Select at least one GL account to relate evidence or click Exit bulk mode.',
		noGLAccountsSelectedValidationMessageTickmark: 'Select at least one GL account to new tickmark or click Exit bulk mode.',
		noGLAccountsSelectedValidationMessageRemoveReference: 'Select at least one GL account to remove reference or click Exit bulk mode.',
		relateTickmarkLabel: 'New tickmark',
		removeReferenceLabel: 'Remove reference',
		removeReferenceConfirmationMsg: 'Confirm if you would like to remove references for all selected GL accounts.'

	},
	financialStatementsFilters: {
		referenceFilterKey: 'GL accounts missing references',
		accountFilterKey: 'GL accounts without mapping',
		noResultsPlaceholder: 'No results found',
		trialBalance: 'Trial balance',
		noneAvailable: 'None available',
		search: 'Search',
		multityEntity: "Multi-entity",
		placeHolderMessageWhenHelixMappingIsTrue: "No imported trial balance. Click {0} to relate a new analyzer.",
		placeHolderMessageWhenHelixMappingIsFalse: "Integration with EY Helix is not available. Refresh the page and try again. If the issue persists, contact the Help Desk.",
		eyHelixIntegrationLinkText: 'EY Helix integration',
		noEntitiesAvailablePlaceholder: 'No entities created. Create entities to get started.'
	},
	//Group instructions
	assertionTabButton: 'Assertions',
	inherentRiskFactorButton: 'Inherent risk factors',
	accountsAndDisclosure: 'Accounts/Disclosures',
	assertions: 'Assertions',
	assertionC: 'C',
	assertionEO: 'E/O',
	assertionMV: 'M/V',
	assertionRO: 'R&O',
	assertionPO: 'P&D',

	complexity: 'Complexity',
	subjUncertainty: 'Subject Uncertainty',
	fraudOrError: 'Fraud or error',
	change: 'Change',
	natureOfAccount: 'Nature of Account',
	relatedParties: 'Related Parties',
	higherInherentRiskLabel: 'Higher inherent risk',
	lowerInherentRiskLabel: 'Lower inherent risk',
	relevantLabel: 'Risk associated',
	relevantContributeLabel: 'Risk associated and contributes to the higher inherent risk',
	incompleteInherentRiskTooltip: 'Incomplete inherent risk',
	estimateLabel: 'Estimate',
	riskAssociatedLabel: 'Risk associated',
	greaterExtentLabel: 'Greater extent',
	lesserExtentLabel: 'Lesser extent',
	accordionNoRiskLabel: 'No risk related to this account assertion.',
	accordionNoRiskAccountLabel: 'No risk related to this account',
	accordionNoAssertionsLabel: 'No assertions related to this account.',
	accordionLimitedRiskLabel: 'The account has been identified as a limited risk.',

	maps: 'Maps',
	financialStatements: 'Financial Statements',
	serviceGatewayAutomation: 'Service Gateway & Automation',
	manageTaskGroups: 'Manage task groups',
	openAssignmentsLabel: "Open assignments",
	inProgressAssignmentsLabel: "In progress assignments",
	// My Progress collaboration view.
	calendarDays: [
		'Sunday',
		'Monday',
		'Tuesday',
		'Wednesday',
		'Thursday',
		'Friday',
		'Saturday'
	],
	calendarMonths: [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December'
	],
	myProgressToday: 'Today',
	noDueDateAssignedGroup: 'No due date assigned',
	myProgressStatusTile: {
		yourRequests: 'Your requests',
		totalCount: 'Total count',
		requestStatus: 'Request status',
		draft: 'Draft',
		pending: 'Pending',
		received: 'Received',
		accepted: 'Accepted',
		overdue: 'Overdue',
		noRelatedTasks: '{0} with no related tasks',
		oneNoRelatedTask: '1 with no related task',
		addRequest: 'New request',

		//Requests dues tile 2
		pendingRequestsByDueDate: 'Pending requests by due date',
		requestsYAxisLabel: 'Requests',
		requestsXAxisLabel: 'Days',
		tooltipDaysLabel: 'days',
		tooltipTotalLabel: 'Total: ',
		normalLabel: 'Normal',
		highLabel: 'High',
		criticalLabel: 'Critical',
		overdueLabel: 'Overdue',
		overDueCatFirst: 'Overdue > 90',
		overDueCatSecond: 'Overdue 31-90',
		overDueCatThird: 'Overdue 10-30',
		overDueCatFourth: 'Overdue 1-9',
		catFifth: '1-9',
		catSixth: '10-30',
		catSeventh: '31-90',
		catEighth: '> 90',
		noRequestsFound: 'No requests found',
		daysOverdue: 'Days overdue',
		daysComingDue: 'Days coming due',
	},
	documentAttributeReference: {
		name: 'Name',
		notes: 'Notes',
		signOffs: 'Sign-offs',
		tasks: 'Related tasks',
		open: 'Open',
		openReadOnly: 'Open read-only',
		delete: 'Delete',
		rename: 'Rename',
		signOffRequirements: 'Sign-off requirements',
		confidentiality: 'Confidentiality',
		unlink: 'Unlink',
		relateTasks: 'Relate tasks'
	},
	aiChatbot: 'EYQ Assurance Knowledge',
	selectDueDate: 'Select a due date',
	daysOverdue: 'Days overdue',
	daysComingdue: 'Days coming due',
	loadingDataMessage: 'Loading data... this may take a few seconds'
};

/*RBAC Errors*/
export const RbacErrors = {
	106: 'Insufficient roles to edit content. Work with an engagement administrator to get sufficient rights.'
};

/*Errors*/
export const Errors = {
	/*Doc Helper Custom Messages */
	0: 'Connection lost. Reconnect and try again. If the issue persists, contact the Help desk.',
	101: 'Invalid Engagement Status.',
	102: 'Valid engagement user not found.',
	103: 'Missing Engagement User Independence compliance.',
	104: 'Missing required Azure AD Scopes',
	105: 'An error occurred obtaining engagement permissions. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	106: "You don't have the required permissions to perform this action.",
	107: 'Valid engagement user not found. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	108: 'Engagement profile is incomplete. Please go to Landing page and Complete Profile.',
	303: 'A document with the same name is currently being uploaded.',
	401: 'Unable to complete the operation. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	403: 'is an unsupported file format and has not been uploaded. Re-save the document in a valid file format and try again. If the issue persists, contact the Help Desk.',
	410: 'This document has been deleted and therefore it cannot be opened.',
	411: 'Empty documents are not permitted.',
	412: 'A document with the same name already exists in this engagement.',
	413: 'Document exceeds the maximum allowable file size (250mb) and cannot be uploaded. Reduce the file size and try again.',
	500: 'Connection lost. Reconnect and try again. If the issue persists, contact the Help Desk.',
	414: 'Name exceeds the maximum length ({0} characters).',
	600: 'Operation cannot be complete at this time. Refresh the page and try again. If the issue persists contact the Help Desk.',
	601: 'Document with the same name exists.',
	602: 'Document is already in collaboration',
	603: 'Document not found.',
	'zip': 'The .zip file cannot be uploaded because it contains one or more unsupported file types, or it contains more than the maximum amount of embedded .zip files.',
	401000: 'Network change is detected and please reload the page to continue',

	/*Accounts*/
	1001: 'Create Account call failed.',
	1002: 'Missing Account name.',
	1003: 'The selected Account has been deleted. Close this modal to see the updated list.',
	1004: 'No results found. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	1005: 'Invalid Engagement Id.',
	1006: 'Invalid Account type.',
	1007: 'Invalid Statement type.',
	1008: 'The selected Account has been deleted. Close this modal to see the updated list.',
	1009: 'Get Account by Id call failed.',
	1010: 'Get Account by Engagement Id call failed.',
	1011: 'Get SEM Summary for an accountid call failed due to invalid request.',
	1012: 'Invalid Summary type.',
	1013: 'Create Account Review call failed.',
	1014: 'Delete Account Review call failed.',
	1015: 'Invalid Account Review create request.',
	1016: 'Invalid Account Review ID.',
	1017: 'Account is not part of this Engagement or it has been deleted.',
	1018: 'Account Review was created by another user.',
	1019: 'Account has been deleted by another user. Refresh the page and try again.',
	1020: 'Account need PSP to update',
	1024: 'Account name is more than 500 characters.',
	1025: 'Limited Risk or Insignificant account cannot be estimated',
	1026: 'Account cannot have duplicate assertions',
	1027: 'Invalid assertion id',
	1037: 'Cannot have duplicate PSP Indexes',
	1039: 'The selected Account has been deleted. Close this modal to see the updated list.',
	1048: 'Account has been invalid execution type.',
	1053: 'Account has Risk or Estimate associated, can not set to Limited Risk Account or Insignificant Account.',
	1054: 'Assertions to be deleted have associated with Risk or Estimate',
	1065: 'You cannot make changes to assertion(s) that have a Significant risk, or Fraud risk, or Risk of material misstatement or an estimate related.You need to remove these relations first.',

	1266: 'Engagement has reached maximum number of multi-edit mode documents.  Check some documents back in and try again.  If the issue persists contact the Help Desk.',
	1267: 'Document is conflicted. Resolve conflicts and try again.  If the issue persists, contact the Help Desk.',
	1268: 'Document is already in co-edit mode. end co-edit mode and try again.  If the issue persists, contact the Help Desk.',
	1269: 'Document is a shared evidence. Unlink and try again.  If the issue persists, contact the Help Desk.',

	/*Assertions*/
	2001: 'Invalid create request.',
	2002: 'Missing assertion name.',
	2003: 'Missing assertion.',
	2004: 'Get assertion call failed.',
	2005: 'Invalid Engagement Id.',
	2006: 'Get assertion by Id call failed.',
	2007: 'Get assertion WCGWs call failed.',
	2050: 'Assertion not found. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	/*Tags*/
	5120: 'Tag Id not found.',
	5121: 'Tag Id missing.',
	5123: 'Duplicate tag association.',
	5124: 'Tag Association not found.',


	/*Risks*/
	4001: 'Operation could not be completed at this time. Refresh the page and try again. If the issue persists, contact the Help desk.',
	4002: 'Missing risk name.',
	4003: 'Missing risk.',
	4004: 'Get risk call failed.',
	4005: 'Invalid Engagement Id.',
	4006: 'Get risk by Id call failed.',
	4007: 'Invalid query request.',
	4008: 'The selected Risk has been deleted. Close this modal to see the updated list.',
	4009: 'Invalid update request.',
	4010: 'Specific WCGW already assigned to this risk',
	4011: 'WCGW list cannot be null.',
	4012: 'Failed to get Risk Types.',
	4013: 'Invalid create request.',
	4014: 'The related assertion is not valid. Refresh the page and try again. If this error persists, contact the Help Desk.',
	4015: 'The WCGW is not valid. Refresh the page and try again. If this error persists, contact the Help Desk.',
	4016: 'The selected Risk has been deleted. Close this modal to see the updated list.',
	4017: 'The Assertion is not valid for the Risk.  Refresh the page and try again. If this error persists, contact the Help Desk.',
	4018: 'The risk type id passed is invalid.',
	4019: 'RiskName is not valid.',
	4020: 'Invalid Document ID.',
	4021: 'RiskName should not be more than 500 characters.',
	4023: 'AssertionIds list cannot be null.',
	4024: 'Limited risk documentation form could not be created due to an error. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	4025: 'Invalid account id.',
	4026: 'Invalid assertion id.',
	4027: 'AssertionRisk Model cannot be empty',
	4031: 'Invalid Risk or Form Body option.',

	4035: 'Cannot edit IsHigherRisk for Significant or Fraud Risks.',
	4036: 'KnowledgeAssertionId cannot be empty if no AssertionId is passed in. KnowledgeAssertionId must be in enums',
	4037: 'KnowledgeAssertionId already exists for this account.',
	4038: 'RiskTypeId does not match permissible options.',
	4040: 'This action cannot be taken. Refresh the page and try again. If the issue persists, contact the Help Desk.',

	/*TASK*/
	5001: 'Get all failed.',
	5002: 'This task is no longer available in this engagement.',
	5003: 'Get documents for task failed. Invalid request parameters.',
	5004: 'Get document related task failed. Invalid request parameters.',
	5005: 'Get Task By Id failed.',
	5006: 'Get Task Categories call failed.',
	5007: 'Get Task SubCategories call failed.',
	5008: 'Get Task Description call failed.',
	5009: 'Get Task ClientRequests call failed.',
	5010: 'Save Task ClientRequests call failed.',
	5011: 'The task that you are attempting to relate items to has been deleted or rejected.',
	5012: 'The item that you are attempting to relate has been deleted.',
	5013: 'The task that you are attempting to relate items to has been deleted or rejected.',
	5014: 'The document that you are attempting to relate has been deleted.',
	5015: 'Get Task Evidences call failed.',
	5016: 'Get WCGW Task call failed.',
	5017: 'Engagement Id should be greater that zero.',
	5018: 'This action cannot be taken. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5019: 'Task description is empty',
	5020: 'The selected task has been deleted or rejected. As such, this action cannot be completed at this time.',
	5021: 'Source engagement id is missing.',
	5022: 'Save Annotation Failed',
	5023: 'Engagement User not found.',
	5024: 'Delete Task call failed.',
	5025: 'Delete Tasks call failed.',
	5026: 'Task list is empty',
	5027: 'Review not not found.',
	5028: 'File name is required.',
	5029: 'File extension is required.',
	5030: 'File name cannot include: */:<>\\?|"',
	5031: 'Error updating the document name.',
	5032: 'Invalid document id.',
	5033: 'Operation type not found.',
	5034: 'Change Task Status Failed',
	5035: 'The action you are trying to perform cannot be completed at this time. Please try again later. Contact the Help Desk if this error persists.',
	5036: 'Body cannot be null or empty in the call.',
	5037: 'Request cannot be null in the call.',
	5038: 'Enter a unique file name to proceed.',
	5039: 'File name is required.',
	5040: 'File name is limited to 100 characters.',
	5041: 'File name cannot include: */:<>\\?|"',
	5042: 'The selected Task is rejected.',
	5043: 'The Task is a build step Task.',
	5044: 'The Task is a milestone Task.',
	5045: 'The Task is neither PSP or OSP type.',
	5046: 'Character limit is exceeded.',
	5047: 'Character limit is exceeded.',
	5048: 'Required field.',
	5049: 'The selected document cannot be removed from this task. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	5050: 'Task group id should not be zero or invalid',
	5051: 'Task section id should not be zero  or invalid',
	5052: 'Error while trying to add this document to the current task. Call failed.',
	5053: 'Error while trying to update this document in the current task. Call failed.',
	5054: 'Error while trying to add a copy of this document in the current task. Call failed.',
	5055: 'Error while trying to rename the document. Call failed.',
	5056: 'Cannot edit task title for knowledge or group task',
	5057: 'Task type should be Ost Type',
	5058: 'This document cannot be removed from the task because is system associated.',
	5059: 'Invalid time phase value.',
	5060: 'Add to Evidence error. Call Failed',
	5061: 'Another user has updated the information presented.  Refresh the page and try again.  If the error persists, contact the Help Desk.',
	5062: 'The requested document is not available for your engagement’s selected Channel in EY Atlas. Please, contact the Help Desk so information can be given to the content authors for future inclusion.',
	5063: 'Invalid Patch Operation.',
	5064: 'The selected task has been deleted or rejected. As such, this action cannot be completed at this time.',
	5065: 'Unable to update task source type. Request is invalid.',
	5066: 'Get guidance error. Call failed.',
	5067: 'Unable to update task nature type. Request is invalid.',
	5068: 'Unable to update task nature type. Request is invalid.',
	5069: 'Delete Task Assignment call failed.',
	5070: 'One or more selected tasks have been deleted. Please try again or contact the Help Desk if the error persists.',
	5071: 'Unable to update the assignment. Request is invalid.',
	5072: 'Preparer not found. Request is invalid.',
	5073: 'Assignment not found.',
	5074: 'Save task assignment failed',
	5075: 'The selected team member or role cannot have a duplicate assignment for the selected task(s). Choose a different assignment, team member, or role to continue. Contact the Help Desk if the error persists.',
	5076: 'The selected team member is not an active member of this engagement. Please try again or contact the Help Desk if the error persists.',
	5077: 'One or more selected tasks have been deleted. Please try again or contact the Help Desk if the error persists.',
	5078: 'The selected task assignment has been removed. Please try again or contact the Help Desk if the error persists.',
	5079: 'One or more selected tasks have been deleted. Please try again or contact the Help Desk if the error persists.',
	5080: 'Document version record does not exist.',
	5081: 'The user who is currently assigned to this task cannot be reassigned as the Preparer. Please try again or contact the Help Desk if the error persists.',
	5082: 'Update failed. Document name should be unique for an engagement. Refresh the page to remove this message.',
	5083: 'Task Detail characters limit is exceeded.',
	5084: 'Task Document create call failed.',
	5085: 'Task Document delete call failed.',
	5086: 'Task Handoffs create call failed.',
	5087: 'Task patch call failed.',
	5088: 'This task must contain evidence to hand-off. Try again or contact the Help Desk.',
	5089: 'All evidence associated to this task (with the exception of paper profiles) must have at least one preparer and reviewer to mark complete. Try again and contact the Help Desk if the error persists.',
	5091: 'Paper profile name already exists in the engagement.',
	5092: "Name cannot contain any of the following characters: */:<>\\?|\\",
	5093: "Paper profile name exceeds the maximum length (100 characters).",
	5101: "Create Task failed.",
	5102: "Task Description is missing.",
	5103: "Task title is missing.",
	5104: "Task timephase is missing.",
	5105: "Task relation cannot be edited. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5106: "Audit phase is invalid.",
	5107: "Audit phase should either be 'Scope and Strategy' or 'Execution'.",
	5108: "Task Description is too long.",
	5109: "Invalid Role Type parameter.",
	5110: "Assignment id must be greater than zero.",
	5111: "The item that you are attempting to relate tasks to has been deleted. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5112: "The item that you are attempting to relate tasks to has been deleted. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5113: "The item that you are attempting to relate tasks to has been deleted. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5116: "Document type is invalid.",
	5119: "The task status for one or more of the selected tasks was not updated. Refresh the page and try again. Contact the Help Desk if the error persists.",
	5127: "Cannot complete association. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5129: "Cannot complete association. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5133: "Cannot complete association. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5137: "Task relation cannot be edited. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5138: "Task relation cannot be edited. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5140: "Task relation cannot be edited. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5146: "To mark a task complete, all associated evidence (with the exception of paper profiles) must have at least one preparer and reviewer sign-off. Refresh the page and try again. Contact the Help Desk if the error persists.",
	5150: "One or more automations could not be related to the selected task at this time. Refresh the page and try again. Contact the Help Desk if the error persists.",
	5156: "Task relation cannot be edited. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5157: "Task relation cannot be edited. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5159: "Shared document type is not valid.",
	5160: "An error occurred while attempting to link the document. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5174: "Task must be related to one or more entities. To make the task engagement-wide, change the Tasks by entity toggle.",
	5184: "Task type is not a Primary Standard Task or Primary Substantive Procedure Task.",
	5185: "Task with EY Canvas delivered documents cannot be rejected.",
	5188: "Invalid Document or unlink in progress.",
	5189: "Task has documents which are Linked Evidence or Linked Response.",
	5190: "Task should have at least one assertion.",
	5191: "Cannot complete association. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5192: "The item that you are attempting to relate tasks to has been deleted. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	5193: "The selected item has been deleted. Refresh the page and try again. If the issue persists, contact the Help Desk.",


	/*WCGW*/
	6001: 'Create WCGW call failed.',
	6002: 'Missing WCGW name.',
	6003: 'Missing WCGW.',
	6004: 'Get WCGW call failed.',
	6005: 'Invalid Engagement Id.',
	6006: 'Could not complete the requested action, as the assertion ID is invalid or has been deleted. Refresh the page and try again.',
	6007: 'Get WCGW by Id call failed.',
	6008: 'Invalid request.',
	6009: 'Could not complete the requested action, as the WCGW ID is invalid or has been deleted. Refresh the page and try again.',
	6010: 'The task could not be associated to the WCGW.',
	6011: 'The selected WCGW is deleted.',
	6012: 'Task and WCGW are not related to the same assertion.',
	6013: 'The selected Task does not belong to the same Engagment.',
	6014: 'The task could not be disassociated from the WCGW.',
	6015: 'The task could not be associated to the WCGW.',
	6016: 'The task is rejected and cannot be associated to the WCGW.',
	6017: 'The task is not a milestone task and cannot be associated to the WCGW.',
	6018: 'The task is not a build step task and cannot be associated to the WCGW.',
	6019: 'The task is not a PSP or OSP and cannot be associated to the WCGW.',
	6020: 'The task and WCGW are associated to the same assertion and cannot be associated to the WCGW.',
	6027: 'Invalid WCGWId or ControlId.',
	6028: 'Cannot complete association. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	6029: 'Cannot complete removal. Refresh the page and try again. If the issue persists, contact the Help Desk.',

	/*Engagement*/
	7001: 'Get by ID not found.',
	7002: 'Get engagements by workspace ID call failed.',
	7003: 'GetAll engagement entities call failed.',
	7004: 'Get engagement by ID call failed.',
	7005: 'GetAll engagement users call failed.',
	7006: 'Last name should not exceed 250 characters.',
	7007: 'Invalid User Type Error.',
	7008: 'First name should not exceed 250 characters.',
	7009: 'User GUI cannot be null.',
	7010: 'Invalid User Status Error.',
	7011: 'Create engagement user call failed.',
	7012: '{0} {1} cannot be invited because he/she is already an active or pending team member.',
	7013: 'Initials should not exceed 3 characters.',
	7014: 'The EY Canvas Landing Page is not accessible at this time. Try again and if the issue persists, contact the Help Desk.',
	7015: '{0} {1} cannot be invited as the following access group(s): {2} have been deleted from the engagement. Refresh and try again.',
	7016: '{0} {1}  cannot be invited as the user is already an active team member in the following access group(s): {2}',
	7017: 'Domain is not allowed for selected group(s): {0}',
	7018: 'Email Address should not be null.',
	7019: 'First Name should not be null.',
	7020: 'Last Name should not be null',
	7021: 'User Initial should not be null.',
	7022: 'User PrimaryOffice should not be null.',
	7023: 'User LoginName should not be null.',
	7024: 'User EYRole should not be null.',
	7025: 'User Engagement Role should not be null.',
	7026: 'Unable to complete operation. Try again and if the issue persists, contact the Help Desk.',
	7027: 'Invalid email address',
	7028: 'Patch Engagement User call failed.',
	7029: 'EngagementUsers - Invalid EngagementUserStatusId.',
	7030: 'EngagementUsers - Invalid EngagementUserRoleId.',
	7031: 'One or more engagement userid not found.',
	7032: 'Email should not be greater than 250 characters.',
	7033: 'Requested User cannot be Null.',
	7034: 'Universal Message Processor Queue Failed.',
	7035: 'Initials should not exceed 3 characters.',
	7036: 'First name should not exceed 250 characters.',
	7037: 'Last name should not exceed 250 characters.',
	7038: 'Create external user call failed.',
	7039: 'One or more users cannot be invited because they are already an active or pending team member.  Refresh the page and try again, if issue persists contact the Help Desk',
	7040: 'First name should not exceed 250 characters.',
	7041: 'Last name should not exceed 250 characters.',
	7042: 'Initials should not exceed 3 characters.',
	7043: 'GPN should not be greater than 250 characters.',
	7044: 'GUI should not be greater than 250 characters.',
	7045: 'Get external user by ID failed.',
	7046: 'User should not be null.',
	7047: 'Cannot save changes at the moment. Try again and if the issue persists, contact the Help Desk.',
	7048: 'The EY Canvas Landing Page is not accessible at this time and is required to edit. Try again and if the issue persists, contact the Help Desk.',
	7049: 'Update Engagement User call failed.',
	7050: 'Members cannot be deactivated. Engagement must have at least one member who has permissions to administer engagement. Update your selection and try again. If the issue persists, contact the Help Desk.',
	7051: 'Get internal user by ID failed.',
	7052: 'User not found.',
	7053: 'Get by ID not found.',
	7054: 'Get quick links by engagement ID call failed.',
	7055: 'Insufficient rights to add prior members. Speak with an engagement team member with the appropriate rights to take this action.',
	7056: 'EY Canvas could not save changes at this time. Try again and if the issue persists, contact the Help Desk.',
	7057: 'Insufficient rights to add new members. Speak with an engagement team member with the appropriate rights to take this action.',
	7058: 'User status has changed.  Refresh the page and try again. If the issue persists, contact the Help Desk.',
	7062: 'EY Canvas Client Portal is not accessible at this time and is required to update existing member information. Try again and if the issue persists, contact the Help Desk.',
	7063: 'Cannot deactivate external members. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	7064: 'Invalid Patch Operation.',
	7065: '{0} {1} cannot be activated in one or more access groups. Domain is not allowed for selected group(s): {2}.',
	7066: '{0} is not a valid user.',
	7067: 'Put external user call failed.',
	7068: 'EY Canvas Client Portal is not accessible at this time and is required to update existing member information. Try again and if the issue persists, contact the Help Desk.',
	7069: 'Selected access groups are not active: {0}. Remove and try again.',
	7072: 'An error occurred during the unlink engagement process. Refresh the page and try again. Contact the Help Desk if the error persists.',
	7074: 'Changes cannot be saved. Engagement must have at least one active member who has permissions to administer engagement and has resolved independence. If the issue persists, contact the Help Desk.',
	7075: '{0} {1} cannot be invited because he/she is already an active team member.',
	7077: 'One or more users cannot be deactivated.  Refresh the page and try again, if issue persists contact the Help Desk.',
	7079: 'Domain is not allowed. Try again and if the issue persists, contact the Help Desk.',
	7080: 'You do not have permission to invite third-party members. Refresh the page and try again. If the issue persists, contact the Help Desk to get permission if appropriate.',
	7094: "The selected team member has signed off on documents in this engagement and cannot be removed.",
	7100: "Cannot process edits to restricted fields. Refresh and try again.",

	/*SCOT*/
	8001: 'Create Scot call failed.',
	8002: 'Missing Scot name.',
	8003: 'Missing Scot.',
	8004: 'Get Scot call failed.',
	8005: 'Invalid Engagement Id.',
	8006: 'Invalid Assertion id.',
	8007: 'Get Scot by Id call failed.',
	8008: 'Invalid request.',
	8009: 'The selected SCOT has been deleted. Close this modal to see the updated list.',
	8028: 'The selected SCOT has been deleted. Close this modal to see the updated list.',

	/*User*/
	10001: 'Logged in User preferences not found.',
	10002: 'User GetAll call failed.',
	10003: 'User Presence Get call failed.',

	/*Risk Type*/
	11001: 'Invalid create request.',
	11002: 'Missing RiskType name.',
	11003: 'Missing RiskType.',
	11004: 'Get RiskType call failed.',
	11005: 'Invalid Engagement Id.',

	/* Annotation Errors*/
	12001: 'Invalid request parameters.',
	12002: 'Create Annotation call failed.',
	12003: 'Get Annotation failed.',
	12004: 'Invalid Engagement ID.',
	12005: 'IDs in collection must be greater than zero.',
	12006: 'ID collection cannot be empty.',
	12007: 'Invalid Task ID.',
	12008: 'Invalid Document ID.',
	12009: 'Must have valid DocumentId or TaskId or FinancialStatementId.',
	12010: 'Replies require parent.',
	12011: 'Invalid Status ID.',
	12012: 'Document type should be 440GL.',
	12013: 'Invalid annontation type.',
	12014: 'Invalid Engagement User.',
	12015: 'This document has been deleted by another user.',
	12016: 'Update Annotation call failed.',
	12017: 'The note that you are replying to has been deleted by another team member. Refresh the page and try again.',
	12018: 'Annotation change action type should not be Null.',
	12019: 'Review note deleted.',
	12020: 'Invalid action to perform.',
	12021: 'User is not author of annotation.',
	12022: "Missing authoring user.",
	12023: "Authoring user doesn't exist or belong to the engagement.",
	12024: 'Assigned user required.',
	12025: 'Assigned user does not exist or belong to the engagement.',
	12026: 'Invalid notes.',
	12027: 'Notes must not be empty.',
	12028: 'Due date required.',
	12029: 'Valid priority required.',
	12030: 'The status of this note has changed. You can no longer edit or respond to the note. Please close and re-open the window to see updated data and continue editing.',
	12031: 'Annotation must be top level.',
	12032: 'Annotation must not be top level.',
	12033: 'At least one of the following values must not be empty: priority type, due date, status or assigned user.',
	12034: 'Notes exceeds maximum length (4,000 characters).',
	12035: 'Search string exceeds maximum length (500 characters).',
	12036: 'Only TaskId Or DocumentId should be accepted both are not allowed.',
	12037: 'Invalid Patch Operation.',
	12038: 'You are trying to edit a note that no longer exists. Refresh the page and try again.',
	12039: 'You are trying to edit the same note as another team member. Refresh the page and try again.',
	12040: 'Get Annotation users call failed.',
	12041: 'Get annotation users failed. Invalid query value.',
	12042: 'Document type is not valid to create an annotation.',
	12043: 'You are trying to add a note to a task or document that no longer exists. Refresh the page and try again.',
	12044: 'You are trying to edit a reply to a note that no longer exists. Refresh the page and try again.',
	12045: 'Review note not found.',
	12046: 'You are trying to delete a note that has already been deleted by another team member. Refresh the page and try again.',
	12047: 'You can only delete replies to notes that are in Open status. Refresh the page and try again.',
	12048: 'You are trying to change the status of a note that no longer exists. Refresh the page and try again.',
	12049: 'You are trying to delete a reply to a note that has already been deleted by another team member. Refresh the page and try again.',
	12050: 'You can only delete notes that are in Closed status.',
	12059: 'Review notes can only be deleted by the user who created the note.',
	12066: 'You can only reply to open notes.',
	12067: 'You are trying to delete a reply to a comment that has already been deleted by another team member. Refresh the page and try again.',
	12068: 'Comment could not be added. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	12070: 'You can only add one comment per financial statement. Please edit the existing.',
	12071: 'Failed to delete the information. Please try again. If the issue persists, contact the help desk.',

	/*Configuration*/
	13001: 'Configurations not found.',
	13002: 'Get Configurations API call failed.',

	/*Documents*/
	14001: 'Unable to perform call because the request is null.',
	14002: 'Document not found. Call failed.',
	14003: 'Engagement Id should be greater that zero.',
	14004: 'Document Id should not be null or empty.',
	14005: 'Error while trying to get associated tasks. Call failed.',
	14006: 'The selected document cannot be delete. Try again later. If the issue persists, contact the Help Desk.',
	14007: 'An unexpected error has occurred.',
	14008: 'An unexpected error has occurred during sign off.',
	14009: 'An error occurred while adding a sign off.',
	14010: 'The approval ID should be greater than zero.',
	14011: 'An error occurred while deleting a sign off.',
	14012: 'Body cannot be empty.',
	14013: 'The selected document cannot be unlinked. Try again later. If the issue persists, contact the Help Desk.',
	14014: 'Get Account By Document Id Call Failed.',
	14015: 'Invalid related entity.',
	14016: 'Get Document Approval call failed.',
	14017: 'GetAll Document Findings call failed.',
	14018: 'GetAll Documents call failed.',
	14019: 'Sign-off not found.',
	14020: 'Invalid action value.',
	14021: 'Invalid finding type.',
	14022: 'The document does not belong to the engagement.',
	14023: 'The document change type is not valid.',
	14024: 'GetAll Documents call failed. Parameter is not valid.',
	14025: 'An error has occurred while creating the document review. The API call has failed.',
	14026: 'An error has occurred while deleting the document review. The API call has failed.',
	14027: 'The Engagement ID should not be null or empty.',
	14028: 'The User ID is invalid.',
	14029: 'The User is not authorized to perform this action.',
	14030: 'No Document with the passed ID was found in this Engagement.',
	14031: 'The Document Review ID is not valid.',
	14032: 'The Document Review was not found.',
	14033: 'The Document was already approved.',
	14034: 'An Unlink process is in-progress for another engagement in the workspace or this document has already been unlinked. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	14035: 'The document is not shared with the given engagement.',
	14036: 'Version number should be greater that zero.',
	14037: 'Operation cannot be complete at this time. Refresh the page and try again. If the issue persists contact the Help Desk',
	14038: 'Failed to get document change reasons.',
	14039: 'Failed to get document change reason by ID.',
	14040: 'Failed to update change reason.',
	14041: 'Invalid change reason.',
	14042: 'Update change reason failed.',
	14043: 'Failed to create change reason.',
	14044: 'Failed to delete change reason.',
	14045: 'Invalid change reason Id.',
	14046: 'Document is not available.  Refresh the page and try again.  If the issue persists, contact the Help Desk.',
	14047: 'Document already has a change reason assigned.',
	14048: 'Document has a conflict, please resolve before proceeding.',
	14049: 'Invalid data to check whether document is added to team or user.',
	14050: 'Error while removing reference document.',
	14051: 'Unlink all shared evidence checklist not found.',
	14052: 'Search text exceeds the maximum permitted length (500 characters).',
	14053: 'Unable to perform call because the request is null.',
	14054: 'Invalid Patch Operation.',
	14055: 'Resolve Document history call failed.',
	14056: 'An error has occurred when trying to queue the message.',
	14057: 'A document with the same name already exists in the engagement.',
	14058: 'More than one document version with the same number has been found. Please contact Help Desk for further assistance.',
	14059: 'The selected document version couldnt be found. Please refresh the page and try again. If the issue persists, please contact Help Desk for further assistance.',
	14060: 'The operation couldnt be completed at the time. Please try again later. If the issue persists, please contact Help Desk for further assistance.',
	14061: 'Document is not shared, cant unlink the document. If the issue persists, please contact Help Desk for further assistance.',
	14062: 'The document confidentiality type id is not valid.',
	14063: 'Cannot change confidentiality type of this document type.',
	14064: 'User doesnt have permission.',
	14065: 'Invalid custom description.',
	14066: 'Failed to update extension.',
	14067: 'Invalid extension.',
	14068: 'Failed to get document extensions.',
	14069: 'This document has already been unlinked by another team member. Refresh the page and contact the Help Desk if the error persists.',
	14070: 'Invalid file type.',
	14071: 'The selected document version is no longer available. Please close and reopen this window to see the latest set of historical versions for the document.',
	14072: 'Source document Id should not be null or empty.',
	14073: 'Canvas form ids should not be null or empty.',
	14074: "Canvas form ID's should not be duplicates.",
	14075: 'Failed to associate document to canvas forms.',
	14076: 'Source document associated Canvas forms not found.',
	14077: 'Source document not found. Call failed.',
	14078: 'Current document is already associated with given canvas forms.',
	14079: 'This document has been deleted and therefore it cannot be opened.',
	14080: 'The source approval user id is invalid.',
	14081: 'The source approval user id should valid GUID and must not be empty GUID.',
	14082: 'The modify user id is invalid.',
	14083: 'The modify user id should be a valid GUID and must not be empty GUID.',
	14084: 'File name cannot include: */:<>\\?|""',
	14085: 'The document name exceeded maximum length allowed.',
	14086: 'DocService failed while updating document details.',
	14087: 'The input is not valid.',
	14088: 'A input has duplicate document names.',
	14089: 'The bookmark observation is not valid.',
	14090: 'Request status has changed. Please refresh the page and try again if required. If the issue persists, contact the help desk.',
	14091: 'This request has been deleted. Refresh the page to view updated data. If the issue persists, contact the Help Desk.',
	14092: 'Document not eligible for update. Refresh the page and try again.  If the issue persists, contact the Help Desk.',

	/*SEM*/
	15001: 'Get SEM Summary for an account id call failed due to invalid request.',
	15002: 'Invalid Account Id.',
	15003: 'Invalid Engagement Id.',
	15004: 'Invalid Summary type.',
	15005: 'Related account cannot be found. Refresh the page and try again. Contact the Help Desk if the issue persists.',

	/*Timephase*/
	16001: 'Get time phases failed.',
	16002: 'The engagement must be greater than zero.',
	16003: 'The time phase must be greater than zero.',
	16004: 'Invalid task ID value.',
	16005: 'Invalid time phase value.',

	/*Validations*/
	17001: 'Missing build step id or document type id.',

	/*TaskGroupSection*/
	18001: 'GetAll task group group call failed.',
	18005: 'This task group is no longer available in this engagement.',
	18006: 'This task group is no longer available. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	18016: 'Task groups can only be deleted when there are no related tasks. Delete or move the related tasks and try again.',
	18019: 'The task group that you are trying to update has been already deleted.',

	/*Assignments*/
	19001: 'Create assignment call failed.',
	19002: 'Get assignment call failed.',
	19003: 'Assignment name must be unique',
	19004: 'Invalid Assignment name',
	19005: 'Assignment name length exceeds more than 100 characters',
	19006: 'Invalid Assignment type',
	19007: 'Search Assignment length exceeds more than 500 characters.',
	19008: 'This assignment name was deleted by another team member. Refresh the page and try again.',

	19012: 'The TaskIds cannot be repeated.',
	19013: 'The RoleId and UserId fields cannot have values at the same time.',
	19014: 'The UserId cannot be the default value.',
	19016: 'Invalid PIC user or PIC user is not invited.',
	19017: 'Invalid EQR user or EQR user is not invited.',
	19018: 'Due days value must be greater than 0 and less than 1000.',
	19019: 'Create Task Auto Assignment call failed.',

	/*Client Request*/
	21001: 'Request could not be sent to EY Canvas Client Portal. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	21002: 'This request has been deleted. Refresh the page to view updated data. If the issue persists, contact the Help Desk',
	21009: 'Delete client request document call failed.',
	21010: 'The comment that you are replying to has been deleted by another team member. Refresh the page and try again.',
	21011: 'Client request document has been deleted.',
	21012: 'Client request document was not found.',
	21013: 'Document request is Empty.',
	21014: 'Document id is Empty.',
	21015: 'Client request id is Empty.',
	21016: 'Create client request document call failed.',
	21017: 'One or more of the associated documents has been deleted from the engagement. Please either remove the deleted document(s) from this request or refresh the page and try again.',
	21018: 'Document was not found.',
	21019: 'Client request status has changed.',
	21030: 'Client Group Id does not match.',
	21031: 'Request status has changed. Please refresh the page and try again if required. If the issue persists, contact the Help Desk.',
	21032: 'Client Group contact user is not active.',
	21033: 'Client Group is not active.',
	21034: 'Client Group contains no active user.',
	21045: 'The request status has changed. Please refresh the page to see latest changes.',
	21046: 'Request could not be sent to EY Canvas Client Portal. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	21050: 'Requests could not be deleted. Refresh the page and try again. If the issue persists, contact the Help Desk',
	21053: 'Task is no longer available in the engagement. Refresh the page to update the list.',
	21057: 'EY Contact could not be assigned. Refresh the page and try again.',
	21028: 'Due date is required.',
	21036: 'Timephase was not found',
	21064: 'Task cannot be associated to request. Requests can be associated to up to 25 tasks. Remove one or more associated tasks to associate a new one.',
	21065: 'One or more confidential document(s) have been added to the request. You do not have the appropriate confidentiality level to send one or more of these documents to EY Canvas Client Portal. Please remove any confidential documents to which you do not have access in order to continue.',
	21066: 'An error occurred retrieving the data. Refresh the page and try again. Contact the Help Desk if the error persists.',
	21067: 'Priority could not be updated. Refresh the page and try again. If the issue persists, contact the Help Desk',
	21035: 'Client request not found.',
	21074: 'Received request is not allowed changes to Title, Description, Priority.',
	21075: 'Accepted request is not allowed changes to Title, Description, Assigned to (group), Assigned to (user), Due date, Priority.',
	21077: 'Due date is required for Client Requests in Received and Pending status.',
	21039: 'Client Group ID not found.',
	21078: 'Group and User are both required, when updating the Assigned To Group or Assigned To User.',
	21079: 'Date format is invalid.',
	21027: 'Request title is required.',
	21041: 'Request title length exceeds maximum allowed characters.',
	21042: 'Request description length exceeds maximum allowed characters.',
	21060: 'Client User ID is Empty.',
	21076: 'Priority Type is not allowed.',

	/* Group Components*/
	22001: 'Get related components call failed.',
	22002: 'Get group components call failed.',
	22003: 'Create group components call failed.',
	22004: 'Invalid parent component id, the parent component you specified does not exist.',
	22005: 'The team name has excedeed maximum lengdes.',
	22006: 'The team legal name has excedeed maximum lengodes.',
	22008: 'The scope you specified does not exist.',
	22009: 'Invalid component short name.',
	22010: 'Invalid component legal name.',
	22011: 'Invalid component scope id.',
	22012: 'If the point of contact email was supplied then the point of contact guid cannot be null or empty.',
	22013: 'If the point of contact email was supplied then the point of contact text cannot be null or empty.',
	22016: 'This team has already been deleted by another team member. Refresh the page and try again.',
	22022: 'Team name already exists in this engagement.',
	22043: 'Send Instructions call failed.',

	/*User Presence*/
	23001: 'Logged in user presence not found.',
	23002: 'User presence get call failed.',
	23003: 'User presence document validation failed.',
	23004: 'User presence delete call failed.',
	23005: 'Document is no longer opened by any other users. Refresh the page and try again. Contact the Help Desk if the issue persists.',

	/* Forms */
	24001: 'Get form call failed.',
	24002: 'Invalid Engagement ID.',
	24003: 'Document Id should not be null or empty.',
	24004: 'Invalid Document ID.',
	24005: 'Invalid Form Header ID.',
	24006: 'Invalid Form Section ID.',
	24007: 'Invalid request parameters.',
	24008: 'Header Id should not be null or empty.',
	24009: 'Section Id should not be null or empty.',
	24010: 'Form body response update operation failed.',
	24011: 'Invalid request for Form body response update.',
	24012: 'Invalid Body ID.',
	24013: 'Invalid Form Body Option ID.',
	24014: 'Invalid Form Body Type ID.',
	24015: 'Invalid Request body for given body Type ID.',
	24016: 'Invalid Free Text for given body Type ID.',
	24017: 'Maximum characters, includes rich text formatting tags. Either reduce the length or remove unnecessary formatting and try again.',
	24018: 'For given Body Type ID response is not allowed.',
	24019: 'Body ID should not be null or empty.',
	24020: 'Invalid Request Body.',
	24021: 'Body is deleted.',
	24038: 'Document is not valid or does not exist.',
	24049: 'Selected object(s) have been deleted. Refresh the page and try again.  If the error persists contact the Help Desk.',
	24057: 'Document FormProfile validation failed.',
	24063: 'Country ID is invalid.',
	24064: 'Language ID is invalid.',

	/*Document Change Types*/
	25001: 'Get Document Change Types call failed.',
	25002: 'Invalid engagement ID.',
	25003: 'Invalid request.',

	/* Manage team */
	26001: 'ClientUserGroups GetAll call failed.',
	26002: 'Create new Client Group/ Email domain call failed.',
	26003: 'GroupName should not be null.',
	26004: 'Email domain should not be null.',
	26005: '{0} Email Domain label should not exceed 263 characters.',
	26006: '{0} Email Domain should not exceed 263 characters.',
	26007: '{0} First part of email domain can be * or alphanumeric, other special characters not allowed.',
	26008: '{0} If the first part is a wild card, then it must have two or more parts following.',
	26009: '{0} First part can be * or alphanumeric, other domain parts special characters not allowed.',
	26010: 'Email domain should be unique.',
	26011: 'Provided client access group ID is not valid.',
	26012: 'An error occurred while deleting the access group. Ensure that there are no requests/external tasks assigned to this group or to the members of this group and try again.',
	26013: 'Access group has already been deleted, please refresh the page to get the latest data.',
	26014: 'At least one email domain is required.',
	26015: 'EY Canvas Client Portal is not accessible at this time and is required to update existing member information. Try again and if the issue persists, contact the Help Desk.',
	26016: 'Error during delete operation.',
	26017: 'Get data operation failed.',
	26018: 'Concurrency issue, access group is no longer active. Refresh the page and try again.',
	26019: 'Save operation failed.',
	26020: 'Email domains cannot be removed when they have active users assigned. Changes have not been saved.',


	/* TimePhaseTypes - Milestones */
	27001: 'Get milestone details failed.',

	/*Client Request Counts*/
	28001: 'Get Client Requests Info call did not fetch any results.',

	/*Content updates Error messages*/
	29001: 'Get by ID not found.',
	29002: 'Acton type not found.',
	29003: 'Content ID(s) not found.',
	29004: 'Content update API call failed.',
	29005: 'Content update in-progress. Try again later and if the issue persists, contact the Help Desk.',
	29006: 'Invalid request parameters.',
	29010: 'The content is being refreshed. Try again later. If issue persists for extended time, contact IT Help Desk.',
	29012: 'Engagement is missing applicable standards profile question. Contact IT Help Desk.',
	29013: 'Primary standard tasks (PSTs) and Profile content updates are not allowed when there are EY Canvas FIT enablement activities that are shared. To update PSTs or Profile content, please unlink those activities.If multiple content update types have been selected, deselect Primary standard tasks (PSTs) and/or Profile and re-initialize Update.',
	/*IT Process*/
	30001: 'Get all ITProcess failed.',
	30002: 'Get all ITProcess - invalid engagement ID.',
	30003: 'ITProcess name cannot be empty.',
	30004: 'ITProcessName should not be more than 500 characters.',
	30005: 'ItProcessID is invalid.',
	30006: 'Get itprocess by id call failed.',
	30007: 'Invalid request.',
	30008: 'IT process is not valid.',
	30009: 'Document not found.',
	30010: 'ITProcess delete failed.',
	30012: 'Invalid ITRisk.',

	/*Checklist*/
	31001: 'GetAll CheckLists call failed.',
	31002: 'Put CheckLists call failed.',
	31003: 'Invalid CheckList parameter.',
	31004: 'Invalid Engagement Error.',
	31005: 'Invalid Request Parameters Error.',
	31006: 'Invalid IsChecked request parameter Error.',

	/*Archive*/
	32001: 'Engagement status is invalid, resolve the validation, and try again the archive process. Contact the Help Desk if the error persists.',
	32002: 'Archive failed while updating form bodies display status, please try again. Contact the Help Desk if the error persists.',
	32003: 'Archive failed while updating engagement status, please try again. Contact the Help Desk if the error persists.',
	32004: 'Archive failed while invalidating engagement cache, please try again. Contact the Help Desk if the error persists.',
	32005: 'Content Update is in progress. You cannot archive this engagement until the content update is complete. Try again later and Contact the Help Desk if the error persists.',
	32006: 'There are unresolved validations in this engagement. Refresh the page, resolve the validations, and try the archive process again. Contact the Help Desk if the error persists.',
	32007: 'Archive failed while building ARC Request Model, please try again. Contact the Help Desk if the error persists.',
	32008: 'Archive failed while Getting Arc API URL, please try again. Contact the Help Desk if the error persists.',
	32009: 'Archive failed while Making Arc API Call, please try again. Contact the Help Desk if the error persists.',
	32010: 'Archive failed due to missing data in the Arc API Response, please try again. Contact the Help Desk if the error persists.',
	32011: 'Archive failed while Saving Arc Form Details, please try again. Contact the Help Desk if the error persists.',
	32012: 'Archive failed while Updating the Engagement Status for Retry, please try again. Contact the Help Desk if the error persists.',
	32013: 'Archive failed while Queuing Archival Message, please try again. Contact the Help Desk if the error persists.',
	32014: 'Archive succeeded, but error occurred while queuing Universal status update message. Contact the Help Desk if the error persists.',
	32015: 'Archive succeeded, but error occurred while queuing CCP status update message. Contact the Help Desk if the error persists.',
	32016: 'Engagement status should be in Archive Error status to Retry the Archival Process.',
	32017: 'Engagement not found, please try again. Contact the Help Desk if the error persists.',
	32019: 'We are not able to process your request at this time. Please try again. If the issue persists, please contact EY Support.',
	32020: 'ARC URL is not configured, please try again. Contact the Help Desk if the error persists.',
	32200: 'There are unresolved validations in your engagement.  Run the Validations Checks report from Reporting or refer to the "Validations help" link in the "More" menu for more details.  If the error persists, contact the Help Desk.',
	32400: 'The following errors occurred when communicating with the ARC system.  Contact the Help Desk and show them this error message to continue.',

	/*RBAC*/
	33001: 'Engagement ID not found.',
	33002: 'User ID not found.',

	/*Helix Linked Projects*/
	34001: 'EY Helix Project has already been unlinked, refresh the page and try again. If the issue persists, contact the Help Desk.',
	34002: 'Engagement ID should not be null or empty.',
	34003: 'Body cannot be null or empty in the call.',
	34004: 'Project ID cannot be null or empty.',
	34005: 'Project Name cannot be null or empty.',
	34006: 'EY Helix Project has already been linked, refresh the page and try again. If the issue persists, contact the Help Desk.',
	34007: 'GetAll Helix Projects call failed.',
	34008: 'Engagement ID should be greater that zero.',
	34009: 'Operation could not be completed. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	34020: 'Could not link Helix Project. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	34024: 'Unable to send a notification to Helix. Region information is missing for the project.',
	34029: 'Project not linked because its location does not match the location of the EY Canvas Engagement.',
	34030: 'Analyzer cannot be linked. You are not an authorized team member of the selected analyzer. Contact the EY Helix project administrator to get access and try again.',
	34031: 'It looks like you have not accessed EY Helix application before.',
	34038: 'The selected analytic is no longer available. Refresh the page and try again. If the issue persists, contact the Help desk.',
	34043: `The selected EY Helix project is no longer available. Click 'Link project' to link a different project.`,
	34044: `The selected EY Helix project is marked for deletion. Click 'Link project' to link a different project.`,
	34045: `The selected EY Helix project is marked for storage. Click 'Link project' to link a different project.`,
	34046: `Invalid or missing analyzer in EY Helix. Refresh the page and try again. If the issue persists contact the Help Desk.`,
	34047: `The selected analyzer is not available in EY Helix. Refresh the page and try again. If the issue persists contact the Help Desk.`,
	34048: `Analytics are not available in the linked project. Go to EY Helix and complete the data & analytics processing steps to continue.`,
	34080: `Maximum number of Engagement Helix connections has been exceeded.`,

	/* PAANS */
	35001: 'The EY Policy Authoring, Approvals and Notification Service​ is unavailable at this time. We are unable to confirm if all relevant policies have been completed. If you have not reviewed the relevant policies, refresh the page and try again. If the issue persists, contact the Help Desk.',

	/*Engagement Comments*/
	38001: 'Create EngagementComments call failed',
	38002: 'GetAll EngagementComments call failed',
	38003: 'Cannot complete this action.  Refresh the page and try again. If the error persists contact the Help Desk',
	38004: 'Cannot complete this action.  Refresh the page and try again. If the error persists contact the Help Desk',
	38005: 'Cannot complete this action.  Refresh the page and try again. If the error persists contact the Help Desk',
	38006: 'Cannot complete this action.  Refresh the page and try again. If the error persists contact the Help Desk',
	38007: 'Cannot complete this action.  Refresh the page and try again. If the error persists contact the Help Desk',
	38008: 'Cannot complete this action.  Refresh the page and try again. If the error persists contact the Help Desk',
	38009: 'Cannot complete this action.  Refresh the page and try again. If the error persists contact the Help Desk',
	38010: 'Body should not be null',
	38011: 'CommentText should not be null or empty',
	38012: 'Entity does not exist in given engagement',
	38013: 'EngagementCommentStatusId should be greater than 0',
	38014: 'ParentEngagementCommentId should be greater than 0',
	38015: 'There was no canvas form body matching the specified criteria',
	38016: 'The note that you are replying to has been deleted by another team member. Refresh the page and try again',
	38017: 'The parent engagement comment supplied is cleared',
	38018: 'The parent engagement comment supplied is a reply itself',
	38019: 'The provided comment text should not be shorter than 1 and not longer than 4000 characters',
	38020: 'The provided entity uid is invalid',
	38021: 'The provided parent entity uid is invalid',
	38022: 'Delete EngagementComments call failed',
	38023: 'The comment id should not be empty',
	38024: 'The action should be a valid action',
	38025: 'The note status has changed. Refresh the page and try again.',
	38026: 'Review notes can only be deleted by the user who created the note.',
	38027: 'You are trying to edit a comment that no longer exists. Refresh the page and try again.',
	38028: 'Updates on cleared comments are not allowed',
	38029: 'Only the author can change the comment\'s text',
	38030: 'The engagement comment Id is invalid',
	38031: 'The comment status Id should not be empty',
	38032: 'There was no relationship record between the requested user and the engagement. Refresh the page and try again. If the error persists contact the Help Desk',
	38033: 'Update action is invalid',
	38034: 'The requested CommentId is already being used by another comment',
	38035: 'The supplied Comment Id is invalid',
	38036: 'Document Id should not be null or empty',
	38037: 'The Id of the user the comment will be assigned to should not be null',
	38038: 'The comment should not be reassigned while opening it or closing it',
	38039: 'The note that you are deleting a reply from has already been deleted. Refresh the page and try again',
	38040: 'Reply should not have due date',
	38041: 'Reply should not have priority',
	38042: 'Comment should have due date',
	38043: 'Comment should have priority',
	38044: 'You are trying to edit a reply to a comment that no longer exists. Refresh the page and try again',
	38045: 'Editing both the engagement status ID and its content, assigned to user, or priority is not allowed',
	38046: 'Update EngagementComments call failed',
	38047: 'You can only reply to open notes',

	/*Tags*/
	39004: 'The tag group that you are editing has been deleted by another team member. Refresh the page and try again.',
	40003: 'The selected tag group has been deleted by another team member. Select another tag group to continue.',
	40007: 'One or more selected notes have been deleted. Refresh the page and try again. Contact the Help desk if the error persists.',
	40011: 'Note index cannot exceed 5 characters.',
	40012: 'Tag color code is invalid. Refresh the page and try again.',
	40014: "The tag group that contains the tag that you are editing has been deleted by another team member. Refresh the page and try again.",
	40016: 'Tags could not be added to or removed from one or more of the tasks that you selected. Refresh the page and try again. Contact the Help Desk if the error persists.',
	40019: 'One or more tags that you are editing have been deleted by another team member. Refresh the page and try again.',
	40020: 'One or more tags could not be synced right now. Refresh the page and try again. Contact the Help Desk if the error persists.',
	40021: 'One or more of the tags that you selected have been deleted. Refresh the page and try again.',
	40022: 'Add one or more external team members to this engagement, then try this operation again. Contact the Help Desk if this error persists.',
	40027: 'Description is too long.',

	// Scheduler request
	70022: 'There are no tasks associated to this service request. Refresh the page and select one or more non-deleted tasks in order to continue. Contact the Help Desk if the error persists.',
	70024: 'Centralized services are not available for your engagement. Refresh the page and try again. Contact the Help Desk if the error persists.',
	70025: 'Centralized services are not currently available for your country. Refresh the page and try again. Contact the Help Desk if the error persists.',

	/* TaskDocumnet */
	80001: 'Create task document association failed.',
	80002: 'Request should have at least one task.',
	80003: 'Document ID should be present.',
	80004: 'Selected task(s) have been deleted. Refresh the page and try again.  If the error persists, contact the Help Desk.',
	80005: 'Document Id is invalid.',
	80006: 'User does not have sufficient permissions to perform the operation.',
	80007: 'Task document association failed.',
	80008: 'After task document association, task status change failed.',
	80011: 'Confidential documents are not eligible to be shared.',
	80012: 'Invalid or empty request payload.',
	80013: 'Task limit exceeded. Please select 300 or less tasks at a time.',
	80014: 'An error occurred while attempting to link the document. Refresh the page and try again. If the issue persists, contact the Help Desk.',

	/* ITApplication / SO */
	81001: 'Get all ITApplication failed.',
	81002: 'Get all ITApplication - invalid engagementid.',
	81003: 'The selected IT application has been deleted. Close this modal to see the updated list.',
	81004: '"Name" should not be empty.',
	81005: '"Name" should not be more than 500 characters.',
	81006: 'Invalid StrategyTypeId.',
	81007: 'Invalid Document Id.',
	81008: 'Get ITApplication by ID failed.',
	81009: 'Invalid classification.',
	81010: 'Invalid SCOT.',
	81011: 'Invalid Control.',
	81012: 'ITApplicationID should not be null or empty.',
	81013: 'ITApplication not found.',
	81014: 'Delete ITApplicationITProcess call failed.',
	81015: '"ITApplicationITProcessId" should not be empty.',
	81016: 'Invalid ITApplicationITProcessId.',
	81017: 'ITApplicationITProcess not found.',
	81018: 'Create ITApplicationITProcess call failed.',
	81019: 'Passed Service Organization instead of ITApplication.',

	/* Controls */
	83001: 'Failed to get controls.',
	83002: 'This action cannot be taken. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	83003: 'Control Id is null or empty.',
	83004: 'The selected Control has been deleted. Close this modal to see the updated list.',
	83005: 'Document Id is invalid.',
	83006: 'Missing control name.',
	83007: 'Invalid control name length.',
	83008: 'Invalid request.',
	83009: 'Invalid control FrequencyId.',
	83010: 'Invalid control TypeId.',
	83011: 'Invalid control ITApplications.',
	83012: 'Invalid Control DesignEffectivenessTypeId.',
	83013: 'Invalid ITApplications.',
	83014: 'Only SO type ITApplications are allowed, If the control type is manual prevent or manual detect type.',
	83015: 'Only ITDM may have manual IPE testing selected.',
	83016: 'Lower Risk controls are not allowed for engagements with this profile.',
	83017: 'Duplicate FilterSCOTs',
	83018: 'Control name is more than 500 characters.',
	83019: 'Invalid WCGW Ids.',
	83020: 'Duplicate WCGW Ids are not allowed.',
	83021: 'Duplicate ITApplication Ids are not allowed.',
	83023: 'Invalid current page.',
	83024: 'Invalid page size.',
	83025: 'Search String should not be more than 100 characters.',
	83026: 'IT APP without service organisation can only be associated to control of type ITDependentManualControl or ITApplicationControl.',
	83027: 'Duplicate FilterWCGWs.',
	83028: 'Invalid knowledge control Id.',

	/* ITControl */
	84001: 'Failed to get IT controls.',
	84002: 'Failed to get IT control by id.',
	84003: 'IT Control Id is null or empty.',
	84004: 'Invalid IT control Id.',
	84005: 'Document Id is invalid.',
	84006: 'Missing IT control name.',
	84007: 'Invalid IT control name length.',
	84008: 'Invalid IT Control FrequencyId.',
	84009: 'Invalid IT Control ApprochTypeId.',
	84010: 'Invalid IT Control DesignEffectivenessTypeId.',
	84011: 'Invalid IT Control Testing value.',
	84012: 'Invalid IT Control OperatingEffectivenessTypeId.',
	84013: 'Missing IT control frequency.',
	84014: 'Delete IT Control failed.',
	84015: 'Search String should not be more than 100 characters.',

	/*GroupTasks*/
	85001: 'The selected operation could not be completed at this time. Refresh the page and try again. Contact the Help Desk if the error persists.',
	85002: 'The selected operation could not be completed at this time. Refresh the page and try again. Contact the Help Desk if the error persists.',
	85003: 'The selected operation could not be completed at this time. Refresh the page and try again. Contact the Help Desk if the error persists.',
	85004: 'The selected operation could not be completed at this time. Refresh the page and try again. Contact the Help Desk if the error persists.',
	85005: 'The selected operation could not be completed at this time. Refresh the page and try again. Contact the Help Desk if the error persists.',
	85006: 'The selected operation could not be completed at this time. Refresh the page and try again. Contact the Help Desk if the error persists.',
	85007: 'The selected operation could not be completed at this time. Refresh the page and try again. Contact the Help Desk if the error persists.',
	85008: 'The selected operation could not be completed at this time. Refresh the page and try again. Contact the Help Desk if the error persists.',
	85009: 'The selected operation could not be completed at this time. Refresh the page and try again. Contact the Help Desk if the error persists.',
	85010: 'The selected operation could not be completed at this time. Refresh the page and try again. Contact the Help Desk if the error persists.',
	85011: 'The selected operation could not be completed at this time. Refresh the page and try again. Contact the Help Desk if the error persists.',
	85012: 'The selected document has already been assigned to another region or component. Therefore, it is not available for assignment. Refresh the page and try again.',
	85013: 'The selected operation could not be completed at this time. Refresh the page and try again. Contact the Help Desk if the error persists.',
	85014: 'The selected operation could not be completed at this time. Refresh the page and try again. Contact the Help Desk if the error persists.',
	85015: 'The selected operation could not be completed at this time. Refresh the page and try again. Contact the Help Desk if the error persists.',
	85016: 'Engagement Id should be greater that zero.',
	85017: 'This task is no longer available in this engagement.',
	85018: 'Invalid document id.',
	85019: 'You do not have the appropriate confidentiality level to send these documents. Refresh the page and try again. Contact the Help Desk if the error persists.',
	85020: 'One or more of the documents that you are trying to send are no longer available to be sent. Refresh the page and try again. Contact the Help Desk if the error persists.',
	85021: 'Forms not available for sending to Primary Team.',
	85022: 'One or more documents failed to send. Refresh the page and try again. Contact the Help Desk if the error persists.',

	/* ITRisk */
	86001: 'ITRisk name cannot be empty.',
	86002: 'ITRisk name should not be more than 500 characters.',
	86003: 'Invalid ITRisk Id.',
	86004: 'Get itrisk by id call failed.',
	86005: 'ITRisk not found.',
	86006: 'Create ITRiskITControl call failed.',
	86007: 'Invalid ITControl Id.',
	86008: 'Delete ITRiskITControl call failed.',
	86009: 'Invalid ITRiskITControl Id.',
	86010: 'Delete IT Risk failed.',


	/*Copyhub*/
	88017: 'Export process service is down - package creation partially succeeded',
	88018: 'Selected user for sending package is not valid (invalid email, Gui or fullname)',
	88033: 'Invalid copy package status to import.',
	88042: 'You do not have permission for bulk export.',
	88045: 'You do not have permission for create template engagement.',
	88048: 'Package is currently being imported by another User. Please try again later.',
	88049: 'Package no longer exist. Please refresh the tab.',
	88050: 'Another engagement copy is in progress right now.',
	88051: 'The engagement has too many copies in progress. Wait until copies have completed before initiating another.',
	88056: 'Action cannot be completed. Refresh the page and try again. If the issue persists contact the Help Desk.',
	88057: 'Some document(s) selected contain related evidence(s) in active multi-user edit mode. Please check-in the related evidences to proceed. If the error persists, please contact the help desk.',

	/* Group Scopes */
	92001: 'Get all group scopes call failed.',
	92002: 'Create group scope call failed.',
	92003: 'Invalid group scopes update request.',
	92004: 'Invalid scope name.',
	92005: 'Invalid parent scope id.',
	92006: 'Parent scope does not exist.',
	92007: 'Invalid scope description.',
	92008: 'Group scope name length exceeds more than 100 characters.',
	92009: 'Group scope description length exceeds more than 500 characters.',
	92010: 'Delete group scopes call failed.',
	92011: 'The custom sub-scope that you are editing has been deleted by another team member. Refresh the page and try again. Contact the Help Desk if the error persists.',
	92012: 'The specified scope id is not valid.',
	92013: 'This custom sub-scope has been assigned to one or more teams and cannot be deleted.',
	92014: 'The custom sub-scope that you are attempting to delete has already been deleted by another team member. Refresh the page and try again.',
	92015: 'The user does not have permissions to perform the operation.',
	92016: 'Scope name already exists in this engagement',
	92017: 'Get by id group scopes call failed.',

	/* Group Sections */
	101001: 'Create Group Sections call failed.',
	101002: 'The Group name cannot be empty or null.',
	101003: 'Group Section name length exceeds more than 100 characters.',
	101004: 'Section name already exists in this engagement.',
	101005: 'Edit Group Sections call failed.',
	101006: 'Invalid section id.',
	101007: 'The group section does not exist.',
	101008: 'Invalid engagement id.',
	101009: 'Invalid Group Knowledge Section.',

	/* Group Documents */
	110001: 'Invalid Engagement Id.',
	110002: 'Invalid instruction status.',
	110003: 'Get engagement by id call failed.',

	/* ClientEngagement */
	93001: 'Client engagement description not found.',
	93002: 'Client engagement description should not be longer than 100 characters.',
	93003: 'Client engagement request is Empty.',
	93004: 'Client engagement Get call failed.',
	93005: 'Client engagement Update call failed.',
	93006: 'The engagement display name could not be updated at this time.  Refresh the page and try again.  Contact the Help Desk if the error persists.',

	/*IP FIltering */
	96005: "{0} has not been added to the allowed list.",
	96015: "There are no access locations available to import from the source engagement.",
	96016: "There are no access locations available to import from the source engagement.",

	/*RBAC SchedulerRequests */
	'permissionIssueForScheduler': 'You do not have permission to request services. Contact an engagement administrator and request permission to take this action.',

	/* GroupInstructions */
	98001: 'Get group instructions call failed.',
	98002: 'One or more of the knowledge instruction section IDs is not valid.',
	98003: 'Create group instructions call failed.',
	98004: 'Instruction name cannot be empty.',
	98005: 'Instruction name cannot exceed 500 characters.',
	98006: 'Instruction description cannot be empty.',
	98007: 'Instruction description cannot exceed 4,000 characters.',
	98008: 'Instruction should be assigned to scopes or teams.',
	98009: 'Instruction name already exists in this engagement.',
	98011: 'This group instruction has already been deleted by another team member. Refresh the page and try again. Contact the help desk if the error persists.',
	98012: 'This group instruction has been deleted by another team member. Refresh the page and try again. Contact the help desk if the error persists.',
	98016: 'The group instruction that you are editing has been deleted by another team member. Refresh the page and try again. Contact the Help Desk if the error persists.',
	98017: 'This group task has already been deleted by another team member. Refresh the page and try again. Contact the help desk if the error persists.',
	98018: 'This group task has been deleted by another team member. Refresh the page and try again. Contact the help desk if the error persists.',
	98019: 'Entity not found',

	/* Group Snapshots */
	102001: 'Create group instruction snapshot call failed.',
	102002: 'Invalid Request Parameters Error.',
	102003: 'Invalid Engagement Error.',
	102004: 'Get all group snapshtos call failed.',
	102005: 'Get By Id group snapshot call failed.',
	102006: 'Snapshot not found.',
	102007: 'Invalid Snapshot Selected.',

	/* Group Links - Send link request */
	106001: 'Send group link call failed.',
	106002: 'The team list cannot be empty.',
	106003: 'One or more of the selected team is invalid.',
	106004: 'Queuing group link message failed.',
	106005: 'The teams cannot be repeated.',
	106006: 'The concurrency tokens cannot be repeated.',

	/* GroupInstructions - Send Version request */
	22019: 'The team was eliminated.',
	22023: 'Send Instructions call failed.',
	22024: 'The component that you are trying to send instructions to is not available or has already been deleted.',
	22025: 'The engagement id cannot be empty.',
	22026: 'The component id cannot be empty.',
	22027: 'Group Instruction found with no due date.',
	22028: 'Scope instruction is not yet published for the component.',
	22029: 'No new instruction published for the component to send.',
	22030: 'This version of instructions and tasks has already been accepted by another team member.  Refresh the page and try again.  Contact the Help Desk if the error persists.',

	22031: 'Group version call failed.',

	/* GroupVersion */
	22032: 'The instructions does not exist.',

	22034: 'Group version get by id call failed.',
	22035: 'Instruction set id cannot be empty.',

	/* Return instruction concurrency scenario*/
	22036: 'A new version of instructions and tasks is available. Refresh the page and try again. Contact the Help Desk if the error persists.',
	22037: 'This version of instructions and tasks has already been accepted by another team member. Refresh the page and try again. Contact the Help Desk if the error persists.',
	22038: 'This version of instructions and tasks has already been returned by another team member. Refresh the page and try again. Contact the Help Desk if the error persists.',

	37018: "This GL account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",
	37019: "Document relation cannot be edited. Refresh the page and try again. Contact the Help Desk if the error persists.",
	37030: "This GL account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",
	37032: 'Document relation cannot be edited. Refresh the page and try again. Contact the Help Desk if the error persists.',
	37033: 'Document relation cannot be edited. Refresh the page and try again. Contact the Help Desk if the error persists.',
	37034: 'Document relation cannot be edited. Refresh the page and try again. Contact the Help Desk if the error persists.',
	37037: 'This adjustment is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.',

	/* EngagementReports */
	111001: 'Get report by report type call failed.',
	113015: 'Trial balance unavailable. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	113025: 'Filter account class id or filter account id required, cannot proceed.',
	113050: 'TrialBalance or FinancialStatement does not belongs to this engagement or it might be deleted, cannot proceed.',

	/*Information Security */
	200001: 'The action taken was forbidden by EY Information Security. Refresh the page and try again. If the issue persists, contact the Help Desk.',

	/*GL account concurrency scenario*/
	113043: "This reconciling account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",
	113019: "This reconciling account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",
	113022: "Action cannot be completed. Refresh the page and try again. If the issue persists contact the Help Desk.",
	113039: "A reference is already associated with this GL account. Refresh the page and try again. Contact the Help Desk if the error persists.",
	113021: "This GL account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",
	113035: "A reference is already associated with this GL account. Refresh the page and try again. Contact the Help Desk if the error persists.",
	113020: "This evidence is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",
	113037: "This GL account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",
	40029: "This GL account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",

	/*Trial balance*/
	113060: "MultiEntity required for MEST engagement.",
	113061: "MultiEntity not required for none MEST engagement.",
	113057: "Engagement helix not found.",
	113094: "Trial Balance to update must be Planning and IstrialBalance true.",
	113095: "Trial Balance to update should not be Planning and IstrialBalance true when financial type is trial balance.",
	113069: "Scope and Strategy already exists for the engagement.",
	113009: "Invalid Trial balance id, cannot proceed.",
	113092: "Trial Balance is both Planning and Financial Statements. Can not proceed to soft delete.",
	114033: "All business units mapped to a given entity must share at least one currency type and currency code. Please re-map your data and try again."

};

export const controlRiskTypeStep2 = [{
	id: 1,
	name: 'Rely'
},
{
	id: 2,
	name: 'Not rely'
},
{
	id: 3,
	name: 'Test MP'
}
];


/*Label Collections */
//Canvas Forms Statuses
export const canvasFormStatus = [{
	id: 1,
	value: 'Update in progress'
},
{
	id: 3,
	value: 'Error'
},
{
	id: 5,
	value: 'Update in progress'
},
{
	id: 6,
	value: 'Error'
}
];

export const riskTypes = [{
	id: 1,
	name: 'Significant risks',
	abbrev: 'SR',
	title: 'Significant risk'
},
{
	id: 2,
	name: 'Fraud risks',
	abbrev: 'FR',
	title: 'Fraud risk'
},
{
	id: 3,
	name: 'Risks of material misstatement',
	abbrev: 'R',
	title: 'ROMM/Inherent risk'
}
];

export const riskTypesToolTip = [
	{ id: 1, name: 'Significant risks', abbrev: 'SR', label: 'Significant', title: 'Significant risk' },
	{ id: 2, name: 'Fraud risks', abbrev: 'FR', label: 'Fraud', title: 'Fraud risk' },
	{
		id: 3,
		name: 'Risk of material misstatement',
		abbrev: 'R',
		label: 'Risk of material misstatement',
		title: 'Risk of material misstatement'
	}
];

export const risksTypes = [{
	id: 1,
	name: 'Significant risks',
	abbrev: 'SR',
	title: 'Significant risks'
},
{
	id: 2,
	name: 'Fraud risks',
	abbrev: 'FR',
	title: 'Fraud risks'
},
{
	id: 3,
	name: 'Risks of material misstatement',
	abbrev: 'R',
	title: 'Risks of material misstatement'
}
];

export const emptyRiskTypes = [
	{
		id: 1,
		label: 'No significant risks have been identified'
	},
	{
		id: 2,
		label: 'No fraud risks have been identified'
	},
	{
		id: 3,
		label: 'No risks of material misstatement have been identified'
	}
];

export const controlRiskType = [{
	id: 1,
	name: 'Rely'
},
{
	id: 2,
	name: 'Not rely'
},
{
	id: 3,
	name: 'Test MP'
}
];
export const inherentRiskType = [{
	id: 1,
	name: 'Higher'
},
{
	id: 2,
	name: 'Lower'
}
];
export const CRAStrings = {
	Minimal: 'Minimal',
	Low: 'Low',
	'Low +SC': 'Low + SC',
	Moderate: 'Moderate',
	High: 'High',
	'High +SC': 'High + SC'
};
export const priorityType = [{
	id: 1,
	name: 'Low',
	className: 'Low',
	label: 'L'
},
{
	id: 2,
	name: 'Medium',
	className: 'Medium',
	label: 'M'
},
{
	id: 3,
	name: 'High',
	className: 'High',
	label: 'H'
},
{
	id: 4,
	name: 'Critical',
	className: 'Critical',
	label: 'C'
}
];
export const reviewNoteFilterTypes = [{
	value: 0,
	label: 'All'
},
{
	value: 1,
	label: 'Open'
},
{
	value: 2,
	label: 'Cleared'
},
{
	value: 3,
	label: 'Closed'
}
];
export const reviewStatus = [{
	id: 1,
	name: 'Open'
},
{
	id: 2,
	name: 'Cleared'
},
{
	id: 3,
	name: 'Closed'
}
];
export const reviewNoteOpenStatusOption = [{
	value: 2,
	label: 'Clear'
},
{
	value: 3,
	label: 'Close'
}
];
export const reviewNoteClearedStatusOption = [{
	value: 1,
	label: 'Reopen'
},
{
	value: 3,
	label: 'Close'
}
];
export const reviewNoteBulkClearedStatusOption = [{
	value: 1,
	label: 'Reopen'
},
{
	value: 2,
	label: 'Clear'
},
{
	value: 3,
	label: 'Close'
}
];
export const reviewNoteClosedStatusOption = [{
	value: 1,
	label: 'Reopen'
}
];
export const signOffTypes = [{
	value: 0,
	label: 'Preparer'
},
{
	value: 1,
	label: 'Reviewer'
},
{
	value: 2,
	label: 'None'
}
];
export const RNHNoteStatusOptions = [{
	value: 1,
	label: 'Open'
},
{
	value: 2,
	label: 'Closed'
},
{
	value: 3,
	label: 'Cleared'
}
];
export const assertions = [{
	id: 1,
	assertionname: 'Completeness',
	assertionabbreviation: 'C',
	statementtypeid: 2,
	displayorder: 1
},
{
	id: 2,
	assertionname: 'Existence',
	assertionabbreviation: 'E',
	statementtypeid: 2,
	displayorder: 2
},
{
	id: 3,
	assertionname: 'Valuation',
	assertionabbreviation: 'V',
	statementtypeid: 2,
	displayorder: 3
},
{
	id: 4,
	assertionname: 'Rights and Obligations',
	assertionabbreviation: 'R&O',
	statementtypeid: 2,
	displayorder: 4
},
{
	id: 5,
	assertionname: 'Presentation and Disclosure',
	assertionabbreviation: 'P&D',
	statementtypeid: 2,
	displayorder: 5
},
{
	id: 6,
	assertionname: 'Completeness',
	assertionabbreviation: 'C',
	statementtypeid: 1,
	displayorder: 6
},
{
	id: 7,
	assertionname: 'Occurrence',
	assertionabbreviation: 'O',
	statementtypeid: 1,
	displayorder: 7
},
{
	id: 8,
	assertionname: 'Measurement',
	assertionabbreviation: 'M',
	statementtypeid: 1,
	displayorder: 8
},
{
	id: 9,
	assertionname: 'Presentation and Disclosure',
	assertionabbreviation: 'P&D',
	statementtypeid: 1,
	displayorder: 9
},
{
	id: 10,
	assertionname: 'Completeness',
	assertionabbreviation: 'C',
	statementtypeid: 3,
	displayorder: 10
},
{
	id: 11,
	assertionname: 'Existence/Occurrence',
	assertionabbreviation: 'E/O',
	statementtypeid: 3,
	displayorder: 11
},
{
	id: 12,
	assertionname: 'Measurement/Valuation',
	assertionabbreviation: 'M/V',
	statementtypeid: 3,
	displayorder: 12
},
{
	id: 13,
	assertionname: 'Rights and Obligations',
	assertionabbreviation: 'R&O',
	statementtypeid: 3,
	displayorder: 13
},
{
	id: 14,
	assertionname: 'Presentation and Disclosure',
	assertionabbreviation: 'P&D',
	statementtypeid: 3,
	displayorder: 14
}
];
//Add Review Note
export const priorityTypes = [{
	value: 1,
	label: 'Low'
},
{
	value: 2,
	label: 'Medium'
},
{
	value: 3,
	label: 'High'
},
{
	value: 4,
	label: 'Critical'
}
];
/*Cog Menu*/
export const cogMenuOptions = {
	Open: 'Open',
	'Start Co-edit mode': 'Start multi-user editing',
	'End Co-edit mode': 'End multi-user editing',
	'Open read-only': 'Open read-only',
	'View history': 'View history',
	CopyLink: 'Copy link',
	Rename: 'Rename',
	Delete: 'Delete',
	'Remove from task': 'Remove from task',
	Remove: 'Remove',
	Unlink: 'Unlink',
	RelateTasks: 'Relate tasks',
	RelateEntities: 'Relate entities',
	Restore: 'Restore',
	PermanentlyDelete: 'Permanently delete',
	ChangeReason: 'Edit reason',
	Confidentiality: 'Confidentiality',
	SignoffRequirements: 'Sign-off requirements',
	AssignRegionComponent: 'Assign to region or component',
	UnassignRegionComponent: 'Unassign from region or component',
	ReturnToRegionComponent: 'Return to region or component',
	ClearReturnToRegionComponent: 'Clear return to region or component',
	OverwriteForm: 'Overwrite form',
	Finalize: 'Finalize document'
};
export const pagingSvgHoverText = {
	first: 'First Page',
	previous: 'Previous Page',
	next: 'Next Page',
	last: 'Last Page'
};
export const controlFrequencyType = {
	1: 'Many times per day',
	2: 'Daily',
	3: 'Weekly',
	4: 'Monthly',
	5: 'Quarterly',
	6: 'Annually',
	7: 'IT Application Control',
	8: 'Other'
};
export const itApproachType = {
	1: 'Controls',
	2: 'Substantive'
};
export const controlType = {
	1: 'IT Application',
	2: 'IT Dependent Manual',
	3: 'Manual Prevent',
	4: 'Manual Detect'
};
export const aggregateITEvaluationType = {
	1: 'Support',
	2: 'Not Support',
	3: 'FS & ICFR Support',
	4: 'FS Only Support'
};
export const entityType = {
	'ENTITY3': 'Account',
	'ENTITY4': 'SCOT',
	'ENTITY5': 'ITProcess',
	'ENTITY7': 'Risk',
	'ENTITY18': 'WCGW',
	'ENTITY19': 'Control',
	'ENTITY20': 'ITSOApplication',
	'ENTITY24': 'Assertion',
	'ENTITY34': 'ITControl',
	'ENTITY35': 'ITRisk',
};
export const trueFalseToYesNo = {
	'true': 'Yes',
	'false': 'No',
}
export const trueFalseToYesOnly = {
	'true': 'Yes',
}
export const yesNoLocalized = {
	'Yes': 'Yes',
	'No': 'No',
}
export const iTProcessEvaluationType = {
	1: 'Effective',
	2: 'Ineffective',
	3: 'Reliable',
	4: 'Not tested'
};

export const strategyType = {
	1: 'Controls',
	2: 'Substantive',
	3: 'Rely',
	4: 'Not Rely'
};
export const accountType = {
	1: 'Significant Accounts',
	2: 'Limited risk account'
};

export const scotTypes = {
	1: 'Routine',
	2: 'Non Routine',
	3: 'Estimation'
};
export const taskNavigation = {
	1: 'My tasks',
	2: 'All tasks',
	3: 'Scope & Strategy',
	4: 'SCOTs',
	5: 'IT/SOs',
	6: 'Accounts',
	7: 'General execution',
	8: 'Conclusion',
	9: 'Team summary',
	10: 'Risks'

};
export const subCategoty = {
	1: 'Show all',
	2: 'To prepare',
	3: 'To review',
};
export const subCategoryType = {
	AllTasks: {
		id: 1,
		title: 'Show all',
		label: 'Show all'
	},
	ToPrepare: {
		id: 2,
		title: 'To prepare',
		label: 'To prepare'
	},
	ToReview: {
		id: 3,
		title: 'To review',
		label: 'To review'
	},
	Preparers: {
		id: 2,
		title: 'Preparers',
		label: 'Preparers'
	},
	Reviewers: {
		id: 3,
		title: 'Reviewers',
		label: 'Reviewers'
	}
};
/*Task Types*/
export const taskType = {
	1: 'Standard task',
	2: 'Primary standard task',
	3: 'Walkthrough task',
	4: 'Control task',
	5: 'Substantive task',
	6: 'Primary substantive procedure task',
	7: 'Response task',
	8: 'Group task'
};

export const taskTypesForAddTask = {
	importfromknowledge: 'Import from Knowledge',
	custom: 'Custom',
	account: 'Account',
	itsubstantive: 'IT substantive procedure',
	scotwalkthroughtask: 'SCOT walkthrough',
	scotcontroltask: 'SCOT control',
	itwalkthroughtask: 'IT walkthrough',
	itcontroltask: 'IT control'
};

export const taskTypeBadge = {
	1: 'OST',
	2: 'PST',
	3: 'WT',
	4: 'TOC',
	5: 'OSP',
	6: 'PSP',
	7: 'RT',
	8: 'GT',
	9: 'PIC',
	10: 'EQR',
	11: 'PIC/EQR',
	22: 'ACT',
	23: 'UDP'
};
/*Task Types*/
export const taskTypeAbbreviation = {
	1: 'TOC',
	2: 'TOC',
	3: 'TOC',
	4: 'TOC',
	5: 'TOC',
	6: 'TOC',
	7: 'RT',
	8: 'RT',
	9: 'RT',
	10: 'RT',
	11: 'RT',
	13: 'OST',
	14: 'PST',
	16: 'OSP',
	17: 'PSP',
	18: 'WT',
	19: 'UDP',
	20: 'WT',
	22: 'ACT',
	23: 'GT',
	24: 'GT',
	25: 'GT',
	26: 'OSP',
	27: 'GT'
};
export const auditPhase = {
	1: 'Scope & strategy',
	2: 'Execution',
	3: 'Conclusion'
};
export const ProfileActionType = {
	1: 'Profile Submit - First Time',
	2: 'Profile Submit - RollForward',
	3: 'Profile Edit',
	4: 'Global Content Update',
	5: 'Import PSPs',
	6: 'Import PSTs',
	7: 'Canvas Form Content Update',
	8: 'Import GA Instructions',
	9: 'Add Manual Form',
	10: 'Profile Delivery',
	11: 'Mandatory Content Update',
	12: 'Canvas Form Profile Sync'
};

export const taskGroup = {
	1: 'Perform other planning procedures',
	2: 'Accounts flow',
	3: 'Significant class of transactions (SCOTs) flow',
	4: 'IT Applications & service organizations flow',
	5: 'Combined risk assessment (CRA) flow',
	6: 'Audit plan flow',
	7: 'Perform wrap up procedures',
	8: 'Summary of audit differences (SAD)',
	9: 'Evaluate audit results',
	10: 'Perform other audit procedures',
	11: 'Group audit structure',
	12: 'Group audit instructions',
	13: 'Primary group tasks',
	14: 'Component group tasks',
	15: 'Work plan',
	16: 'Accounts flow - MEST',
	17: 'Perform review procedures',
	18: 'Complete preliminary engagement activities',
	19: 'Establish the team',
	20: 'Enable the engagement with data',
	21: 'Perform RA analytical procedures and determine materiality',
	22: 'Identify significant accounts - MEST',
	23: 'Additional procedures to inform our risk assessments',
	24: 'Identify sources',
	25: 'Identify significant accounts',
	26: 'Identify and understand SCOTs',
	27: 'Identify and understand IT processes and service organizations',
	28: 'Confirm strategy and CRA',
	29: 'Perform additional required risk identification procedures',
	30: 'Consider the use of internal audit',
	31: 'Respond to risk assessments',
	32: 'Finalize strategy',
	33: 'EQR procedures',
	34: 'Design procedures',
	35: 'Evaluate and conclude on audit evidence',
	36: 'Issue communications and deliverables',
	37: 'EQR procedures',
	38: 'Prepare and issue the audit report',
	39: 'Finalize documentation and archive',
	40: 'Test entity-level controls',
	41: 'Assess data used in automated techniques',
	42: 'Execute required fraud procedures',
	43: 'Execute internal audit and specialist procedures',
	44: 'Evaluate IT processes',
	45: 'Minutes, contracts and litigation review',
	46: 'Perform procedures on financial statements',
	47: 'Execute RPTs, going concern and laws and regulations procedures',
	48: 'Discuss audit strategy revisions',
	49: 'Execution Conclusion',
	50: 'EQR procedures',
	51: 'Complete scope and strategy quality activities',
	52: 'Perform initial audit procedures',
	53: 'Perform risk assessment procedures',
	54: 'Identify service organizations',
	55: 'Digital - Task Group 5',
	56: 'Identify and understand IT processes',
	57: 'Perform planning procedures',
	58: 'Group Structure, Instructions and Involvement',
	59: 'Identify significant disclosures',
	60: 'Identify and understand significant reporting processes',
	61: 'Digital - Task Group 11',
	62: 'Digital - Task Group 12',
	63: 'Digital - Task Group 13',
	64: 'Digital - Task Group 14',
	65: 'Digital - Task Group 15',
	66: 'Digital - Task Group 16',
	67: 'Digital - Task Group 17',
	68: 'Complete post-interim project management activities',
	69: 'Execute substantive procedures - Governance',
	70: 'Execute substantive procedures - Strategy',
	71: 'Execute substantive procedures - Risk Management',
	72: 'Execute substantive procedures - Metrics and Targets',
	73: 'Execute substantive procedures - Other',
	74: 'Evaluate work of others',
	75: 'Digital - Task Group 25',
	76: 'Digital - Task Group 26',
	77: 'Digital - Task Group 27',
	78: 'Digital - Task Group 28',
	79: 'Digital - Task Group 29',
	80: 'Digital - Task Group 30',
	81: 'Digital - Task Group 31',
	82: 'Digital - Task Group 32',
	83: 'Digital - Task Group 33',
	84: 'Digital - Task Group 34',
	85: 'Evaluate and conclude on review evidence',
	86: 'Perform general assurance procedures',
	87: 'Evaluate and conclude on evidence',
	88: 'Digital - Task Group 38',
	89: 'Digital - Task Group 39',
	90: 'Digital - Task Group 40',
	91: 'Digital - Task Group 41',
	92: 'Digital - Task Group 42',
	93: 'Digital - Task Group 43',
	94: 'Digital - Task Group 44',
	95: 'Digital - Task Group 45',
	96: 'Digital - Task Group 46',
	97: 'Digital - Task Group 47',
	98: 'Digital - Task Group 48',
	99: 'Digital - Task Group 49',
	100: 'Digital - Task Group 50'
};
export const AutomationHubRequestStatus = {
	Draft: 'Draft',
	Submitted: 'Submitted',
	Sent: 'Send in Progress',
	InProgress: 'Processing',
	Failed: 'Processing Error',
	Completed: 'Completed',
	FailedToSendToBP: 'Processing Error',
	QueueingFailed: 'Submitting Failed',
	ActionRequired: 'Action Required'
};
export const milestonesLabels = {
	1: 'Scope',
	2: 'Strategy',
	3: 'Walkthroughs',
	4: 'Interim control testing',
	5: 'Interim substantive testing',
	6: 'Walkthroughs (year-end processes)',
	7: 'Year-end control testing',
	8: 'Year-end substantive testing',
	9: 'Conclusion',
	10: 'Not applicable',
	11: 'Execution',
	12: 'Scope and strategy quality activities',
	13: 'Other scope and strategy',
	14: 'CRA',
	15: 'Risk assessment and materiality',
	16: 'Finalize scope and strategy',
	17: 'Post-interim project management'
};

export const TasksFilterGroups = {
	Tasks: 'Tasks',
	Assignments: 'Assignments',
	ReviewNotes: 'Review notes',
	ProjectManagement: 'Project management',
	Other: 'Other'

};
export const TasksFilterTypes = {
	TaskStatus: 'Task status',
	TaskType: 'Task type',
	AssignedTo: 'Assigned to',
	OpenAssignments: 'Open assignments',
	ReviewNotesStatus: 'Review notes status',
	ReviewNotesAssignedTo: 'Review notes assigned to',
	ReviewNotesCreatedBy: 'Review notes created by',
	TimePhase: 'Time phase',
	Milestone: 'Milestone',
	AuditPhase: 'Audit phase',
	DocumentConflict: 'Document conflict',
	Findings: 'Findings',
	Entity: 'Entity',
	IsBookmarked: 'Downloaded for offline',
};

export const quickFilterTaskStatus = [{
	value: '1',
	label: 'Open'
},
{
	value: '2',
	label: 'In progress'
},
{
	value: '3',
	label: 'In review'
},
{
	value: '4',
	label: 'Complete'
}
];

export const quickFilterAssignmentStatus = [{
	value: '1',
	label: 'Open'
},
{
	value: '2',
	label: 'In progress'
},
{
	value: '3',
	label: 'Closed'
},
{
	value: '4',
	label: 'Unassigned'
}
];

export const dataExport = [
	// 'Archive Form',
	// 'Canvas Forms',
	'Collaboration',
	// 'Control Forms',
	'Documents',
	'Tasks',
	'Scott Summary',
	// 'Team Members',
	// 'Trial Balance'
];
export const dataExportReportNames = {
	'Archive Form': 'Archive Form',
	'Canvas Forms': 'Canvas Form Report',
	'Collaboration': 'Collaboration',
	'Control Forms': 'Control Report',
	'Documents': 'All Documents Report',
	'Tasks': 'All Tasks Report',
	'Team Members': 'Team Members',
	'Trial Balance': 'Numbers Report'
};
export const projectManagement = [
	'Collaboration Details',
	// 'Digital scorecard',
	// 'Milestones',
	// 'Review Notes',
	// 'Validation Checks'
];
export const projectManagementReportNames = {
	'Collaboration Details': 'Client Collaboration Dashboard',
	'Milestones': 'Milestone Report',
	'Review Notes': 'Review Notes Report',
	'Validation Checks': 'Validation Checks Report'
};

export const taskQuickFilterOptions = [
	{ id: 'taskToPreparer', label: 'Tasks to prepare', uiViewId: uiViews.taskSystemSuggestedFilter },
	{ id: 'tasksReadyForReview', label: 'Tasks ready for review', uiViewId: uiViews.taskSystemSuggestedFilter },
	{ id: 'allAssignedTasks', label: 'All assigned tasks', uiViewId: uiViews.taskSystemSuggestedFilter },
	{ id: 'allOverdueTasks', label: 'Overdue tasks', uiViewId: uiViews.taskSystemSuggestedFilter },
	{ id: 'allTasksDueThisWeek', label: 'Tasks coming due this week', uiViewId: uiViews.taskSystemSuggestedFilter }
];

export const noDefaultFilter =
{
	id: 'noDefaultFilter',
	label: 'No default filter'
};

export const taskTypes = [
	{
		id: '1',
		label: 'Control task'
	},
	{
		id: '2',
		label: 'Control Task - Control'
	},
	{
		id: '3',
		label: 'Control Task - ELC'
	},
	{
		id: '4',
		label: 'Control Task - IT/SO'
	},
	{
		id: '5',
		label: 'Control Task - MP'
	},
	{
		id: '6',
		label: 'Control Task - SO'
	},
	{
		id: '7',
		label: 'Response Task'
	},
	{
		id: '8',
		label: 'Cashflow Misstatement Response Task'
	},
	{
		id: '9',
		label: 'Deficiency Response Task'
	},
	{
		id: '10',
		label: 'Disclosure Misstatement Response Task'
	},
	{
		id: '11',
		label: 'Misstatement Response Task'
	},
	{
		id: '12',
		label: 'Standard Task'
	},
	{
		id: '13',
		label: 'Other Standard Task'
	},
	{
		id: '14',
		label: 'Primary Standard Task'
	},
	{
		id: '15',
		label: 'Substantive Task '
	},
	{
		id: '16',
		label: 'Other Substantive Procedure Task'
	},
	{
		id: '17',
		label: 'Primary Substantive Procedure Task'
	},
	{
		id: '18',
		label: 'Walkthrough Task'
	},
	{
		id: '19',
		label: 'Walkthrough Task - IT/SO'
	},
	{
		id: '20',
		label: 'Walkthrough Task - SCOT'
	},
	{
		id: '21',
		label: 'Todo'
	},
	{
		id: '22',
		label: 'Account Conclusion Task'
	},
	{
		id: '23',
		label: 'Group Task'
	},
	{
		id: '24',
		label: 'Primary Group Task'
	},
	{
		id: '25',
		label: 'Component Group Task'
	},
	{
		id: '26',
		label: 'IT/SO Other Substantive Procedure Task'
	},
	{
		id: '27',
		label: 'Component Group Task Unlinked'
	}
];

export const filterAssignmentType = [{
	value: '1',
	label: 'Preparer'
},
{
	value: '2',
	label: 'Detail reviewer'
},
{
	value: '3',
	label: 'General reviewer'
},
{
	value: '4',
	label: 'Partner'
},
{
	value: '5',
	label: 'EQR'
},
{
	value: '6',
	label: 'Other'
}
];

export const filterTaskStatus = [{
	value: '1',
	label: 'Open'
},
{
	value: '2',
	label: 'In progress'
},
{
	value: '3',
	label: 'In review'
},
{
	value: '4',
	label: 'Complete'
},
{
	value: '5',
	label: 'No evidence'
}
];

export const filterAssignmentStatus = [{
	value: '1',
	label: 'Open'
},
{
	value: '2',
	label: 'In progress'
},
{
	value: '3',
	label: 'Closed'
},
{
	value: '4',
	label: 'Unassigned'
}
];

export const filterTaskType = [{
	value: '1',
	label: 'Control task'
},
{
	value: '7',
	label: 'Response task'
},
{
	value: '13',
	label: 'Other standard task'
},
{
	value: '14',
	label: 'Primary standard task'
},
{
	value: '16',
	label: 'Other substantive procedure task'
},
{
	value: '17',
	label: 'Primary substantive procedure task'
},
{
	value: '18',
	label: 'Walkthrough/ UDP task'
},
{
	value: '22',
	label: 'Account conclusion task'
},
{
	value: '999',
	label: 'PIC sign-off required'
},
{
	value: '1000',
	label: 'EQR sign-off required '
}
];

export const filterTaskTypeGroupEngagement = [{
	value: '1',
	label: 'Control task'
},
{
	value: '7',
	label: 'Response task'
},
{
	value: '13',
	label: 'Other standard task'
},
{
	value: '14',
	label: 'Primary standard task'
},
{
	value: '16',
	label: 'Other substantive procedure task'
},
{
	value: '17',
	label: 'Primary substantive procedure task'
},
{
	value: '18',
	label: 'Walkthrough/ UDP task'
},
{
	value: '22',
	label: 'Account conclusion task'
},
{
	value: '23',
	label: 'Group task'
},
{
	value: '999',
	label: 'PIC sign-off required'
},
{
	value: '1000',
	label: 'EQR sign-off required '
}
];

export const filterTaskTypeInterimEngagement = [{
	value: '14',
	label: 'Primary standard task'
},
{
	value: '13',
	label: 'Other standard task'
},
{
	value: '23',
	label: 'Group task'
},
{
	value: '999',
	label: 'PIC sign-off required'
},
{
	value: '1000',
	label: 'EQR sign-off required '
}
];

export const filterMilestones = [{
	value: '1',
	label: 'Scope',
	hideFromMenu: true
},
{
	value: '2',
	label: 'Strategy',
	hideFromMenu: true
},
{
	value: '12',
	label: 'Scope and strategy quality activities'
},
{
	value: '13',
	label: 'Other scope and strategy'
},
{
	value: '14',
	label: 'CRA'
},
{
	value: '15',
	label: 'Risk assessment and materiality'
},
{
	value: '16',
	label: 'Finalize scope and strategy'
},
{
	value: '17',
	label: 'Post-interim project management'
},
{
	value: '3',
	label: 'Walkthroughs'
},
{
	value: '4',
	label: 'Interim control testing'
},
{
	value: '5',
	label: 'Interim substantive testing'
},
{
	value: '6',
	label: 'Walkthroughs (year-end processes)'
},
{
	value: '7',
	label: 'Year-end control testing'
},
{
	value: '8',
	label: 'Year-end substantive testing'
},
{
	value: '11',
	label: 'Execution'
},
{
	value: '9',
	label: 'Conclusion'
},
{
	value: '10',
	label: 'N/A'
},
{
	value: '0',
	label: 'No milestone'
}
];

export const documentListMilestones = [{
	value: '1',
	label: 'Scope'
},
{
	value: '12',
	label: 'Scope and strategy project management'
},
{
	value: '13',
	label: 'Other scope and strategy'
},
{
	value: '2',
	label: 'Strategy'
},
{
	value: '14',
	label: 'CRA'
},
{
	value: '15',
	label: 'Risk assessment and materiality'
},
{
	value: '16',
	label: 'Finalize scope and strategy'
},
{
	value: '17',
	label: 'Post-interim project management'
},
{
	value: '3',
	label: 'Walkthroughs'
},
{
	value: '4',
	label: 'Interim control testing'
},
{
	value: '5',
	label: 'Interim substantive testing'
},
{
	value: '6',
	label: 'Walkthroughs (year-end processes)'
},
{
	value: '7',
	label: 'Year-end control testing'
},
{
	value: '8',
	label: 'Year-end substantive testing'
},
{
	value: '11',
	label: 'Execution'
},
{
	value: '9',
	label: 'Conclusion'
},
{
	value: '10',
	label: 'N/A'
}
];

export const filterAuditPhases = [{
	value: '1',
	label: 'Scope & Strategy'
},
{
	value: '2',
	label: 'Execution'
},
{
	value: '3',
	label: 'Conclusion'
}
];
export const filterDocListReviewNoteStatus = [{
	value: 1,
	label: 'Open'
},
{
	value: 5,
	label: 'Cleared'
},
{
	value: 2,
	label: 'Closed'
}
];

export const filterDocumentConflicts = [{
	value: '1',
	label: 'Yes'
}, {
	value: '0',
	label: 'No'
}];
export const filterDownloadedForOffline = [{
	value: '1',
	label: 'Yes'
}, {
	value: '2',
	label: 'No'
}];

export const missingEntityDocuments = [{
	value: 10034,
	label: 'Yes'
}]

export const filterTaskFindings = [{
	value: '1',
	label: 'Deficiency'
},
{
	value: '2',
	label: 'Misstatement'
}
];

export const ConfidentialityTypes = [{
	id: 1,
	Name: 'Default'
},
{
	id: 2,
	Name: 'Low'
},
{
	id: 3,
	Name: 'Moderate'
},
{
	id: 4,
	Name: 'High'
},
{
	id: 5,
	Name: 'Confidential'
},
];

export const RoleForMember = [{
	id: 1,
	role: 'Partner in Charge',
	roleAbbreviation: 'PIC',
	displayOrder: 9
},
{
	id: 2,
	role: 'Engagement Partner',
	roleAbbreviation: 'EP',
	displayOrder: 8
},
{
	id: 3,
	role: 'Executive Director',
	roleAbbreviation: 'ED',
	displayOrder: 5
},
{
	id: 4,
	role: 'Principal',
	roleAbbreviation: 'Principal',
	displayOrder: 6
},
{
	id: 5,
	role: 'Senior Manager',
	roleAbbreviation: 'Sr.Manager',
	displayOrder: 4
},
{
	id: 6,
	role: 'Manager',
	roleAbbreviation: 'Manager',
	displayOrder: 3
},
{
	id: 7,
	role: 'Senior',
	roleAbbreviation: 'Senior',
	displayOrder: 2
},
{
	id: 8,
	role: 'Staff',
	roleAbbreviation: 'Staff',
	displayOrder: 1
},
{
	id: 9,
	role: 'Intern',
	roleAbbreviation: 'Intrn'
},
{
	id: 10,
	role: 'Engagement Quality Reviewer',
	roleAbbreviation: 'EQR',
	displayOrder: 10
},
{
	id: 11,
	role: 'Other Partner',
	roleAbbreviation: 'Other Partner',
	displayOrder: 7
},
{
	id: 12,
	role: 'GDS - Staff',
	roleAbbreviation: 'GDS Staff',
	displayOrder: 13
},
{
	id: 13,
	role: 'Advisory (ITRA,TAS,Human Capital or Other)',
	roleAbbreviation: 'ADV'
},
{
	id: 14,
	role: 'Tax',
	roleAbbreviation: 'Tax'
},
{
	id: 15,
	role: 'Executive Support Services',
	roleAbbreviation: 'ESS'
},
{
	id: 16,
	role: 'General Counsel',
	roleAbbreviation: 'GCO',
	displayOrder: 12
},
{
	id: 17,
	role: 'Audit Quality Reviewer',
	roleAbbreviation: 'AQR',
	displayOrder: 11
},
{
	id: 18,
	role: 'ML Component Team',
	roleAbbreviation: 'MCT'
},
{
	id: 19,
	role: 'Client Supervisor',
	roleAbbreviation: 'C. Supervisor'
},
{
	id: 20,
	role: 'Client Staff',
	roleAbbreviation: 'C. Staff'
},
{
	id: 21,
	role: 'Internal Audit Supervisor',
	roleAbbreviation: 'IA Supervisor'
},
{
	id: 22,
	role: 'Internal Audit Staff',
	roleAbbreviation: 'IA Staff'
},
{
	id: 23,
	role: 'Regulator',
	roleAbbreviation: 'Regulator'
},
{
	id: 24,
	role: 'Other (e.g. due diligence review)',
	roleAbbreviation: 'Other'
},
{
	id: 25,
	role: 'Office',
	roleAbbreviation: 'Office'
},
{
	id: 26,
	role: 'Area',
	roleAbbreviation: 'Area'
},
{
	id: 27,
	role: 'Industry',
	roleAbbreviation: 'IND'
},
{
	id: 28,
	role: 'National',
	roleAbbreviation: 'NAT'
},
{
	id: 29,
	role: 'Global',
	roleAbbreviation: 'GBL'
},
{
	id: 30,
	role: 'GDS - Senior',
	roleAbbreviation: 'GDS Senior',
	displayOrder: 14
},
{
	id: 31,
	role: 'GDS - Manager',
	roleAbbreviation: 'GDS Manager',
	displayOrder: 15
}
];

export const SubServiceLines = [{
	subServiceLineId: 1,
	subServiceLineName: 'Audit',
	displayOrder: 1
},
{
	subServiceLineId: 2,
	subServiceLineName: 'FIDS',
	displayOrder: 2
},
{
	subServiceLineId: 9,
	subServiceLineName: 'FAAS',
	displayOrder: 3
},
{
	subServiceLineId: 11,
	subServiceLineName: 'CCaSS',
	displayOrder: 4
},
{
	subServiceLineId: 12,
	subServiceLineName: 'BTS',
	displayOrder: 5
},
{
	subServiceLineId: 13,
	subServiceLineName: 'Human Capital',
	displayOrder: 6
},
{
	subServiceLineId: 14,
	subServiceLineName: 'Law',
	displayOrder: 7
},
{
	subServiceLineId: 15,
	subServiceLineName: 'Indirect Tax',
	displayOrder: 8
},
{
	subServiceLineId: 16,
	subServiceLineName: 'GCR',
	displayOrder: 9
},
{
	subServiceLineId: 17,
	subServiceLineName: 'Transaction Tax',
	displayOrder: 10
},
{
	subServiceLineId: 18,
	subServiceLineName: 'ITS',
	displayOrder: 11
},
{
	subServiceLineId: 19,
	subServiceLineName: 'GCO',
	displayOrder: 12
},
{
	subServiceLineId: 20,
	subServiceLineName: 'Business Consulting',
	displayOrder: 13
},
{
	subServiceLineId: 21,
	subServiceLineName: 'Technology Consulting',
	displayOrder: 14
},
{
	subServiceLineId: 22,
	subServiceLineName: 'Transactions and Corporate Finance',
	displayOrder: 15
},
{
	subServiceLineId: 23,
	subServiceLineName: 'EY Parthenon',
	displayOrder: 16
},
{
	subServiceLineId: 24,
	subServiceLineName: 'Other',
	displayOrder: 17
},
{
	subServiceLineId: 25,
	subServiceLineName: 'Technology Risk',
	displayOrder: 18
}
];

export const SchedulerRequestRole = [{
	id: 31,
	userTypeId: 4,
	label: 'GDS Manager'
},
{
	id: 31,
	userTypeId: 3,
	label: 'Request Manager'
}
];

/* Task Status */
export const TaskStatus = [{
	id: 1,
	label: 'Open'
},
{
	id: 2,
	label: 'In progress'
},
{
	id: 3,
	label: 'In review'
},
{
	id: 4,
	label: 'Complete'
},
{
	id: 5,
	label: 'Removed'
},
{
	id: 6,
	label: 'PIC/EQR Sign-off Complete'
}
];
/* GATaskSendStatus*/
export const GATaskSendStatus = [{
	id: 1,
	label: 'Not sent'
},
{
	id: 2,
	label: 'In progress'
},
{
	id: 3,
	label: 'Sent'
},
{
	id: 4,
	label: 'Returned'
}
];
// 9 - Return error (UI value, doesn't exist in database)
export const GAComponentDocumentStatusLabels = [{
	id: GAComponentDocumentStatus.Open,
	label: 'Open'
},
{
	id: GAComponentDocumentStatus.InProgress,
	label: 'Received'
},
{
	id: GAComponentDocumentStatus.Submitted,
	label: 'Submitted'
},
{
	id: GAComponentDocumentStatus.Returned,
	label: 'Returned'
},
{
	id: GAComponentDocumentStatus.InReview,
	label: 'Prepared'
},
{
	id: GAComponentDocumentStatus.Complete,
	label: 'Reviewed'
},
{
	id: GAComponentDocumentStatus.Dismissed,
	label: 'Dismissed'
},
{
	id: GAComponentDocumentStatus.RejectInTransit,
	label: 'Return in progress'
},
{
	id: GAComponentDocumentStatus.ReturnError,
	label: 'Return error'
}
];
export const TeamSummaryPreparerTaskStatus = [{
	id: 1,
	label: 'Open'
},
{
	id: 2,
	label: 'In progress'
},
{
	id: 3,
	label: 'Closed'
}
];
export const TeamSummaryReviewerTaskStatus = [{
	id: 1,
	label: 'Open'
},
{
	id: 2,
	label: 'In progress'
},
{
	id: 3,
	label: 'Closed'
}
];
export const DocumentHelper = {
	401: 'Unable to complete the operation. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	413: 'Document exceeds the maximum allowable file size (250mb) and cannot be uploaded. Reduce the file size and try again.',
	412: 'A Document with name already exists in this engagement',
	414: 'Name exceeds the maximum length ({0} characters).',
	410: 'This document has been deleted and therefore it cannot be opened.',
	411: 'Empty documents are not permitted.'
};
export const reviewNoteCategories = [{
	value: reviewNoteRoutes.path.all.id,
	path: reviewNoteRoutes.path.all.path,
	label: 'All notes'
},
{
	value: reviewNoteRoutes.path.document.id,
	path: reviewNoteRoutes.path.document.path,
	label: 'Document notes'
},
{
	value: reviewNoteRoutes.path.task.id,
	path: reviewNoteRoutes.path.task.path,
	label: 'Task notes'
},
{
	value: reviewNoteRoutes.path.form.id,
	path: reviewNoteRoutes.path.form.path,
	label: 'Canvas form comments'
}
];

export const reviewNoteStatus = [{
	value: '1',
	label: 'Open'
},
{
	value: '2',
	label: 'Cleared'
},
{
	value: '3',
	label: 'Closed'
}
];

/* RNH Review note hub */
export const reviewNoteTypes = [{
	id: 1,
	type: 'document',
	label: 'Document note'
},
{
	id: 2,
	type: 'task',
	label: 'Task note'
}
];

export const accountConclusionTabs = {
	details: 'Details',
	conclusions: 'Conclusions'
};


export const rnhFilterType = [{
	id: 0,
	filterType: rnhFilterTypeQuery.annotationStatusIds,
	name: 'Note status Id',
	inDropDown: false
},
{
	id: 1,
	filterType: rnhFilterTypeQuery.authoredBy,
	name: 'Authored by',
	inDropDown: true
},
{
	id: 2,
	filterType: rnhFilterTypeQuery.assignedTo,
	name: 'Assigned to',
	inDropDown: true
},
{
	id: 3,
	filterType: rnhFilterTypeQuery.priority,
	name: 'Priority',
	inDropDown: true,
	filterOptions: [{
		id: "1",
		label: "Low"
	}, {
		id: "2",
		label: "Medium"
	}, {
		id: "3",
		label: "High"
	}, {
		id: "4",
		label: "Critical"
	}]
},
{
	id: 4,
	filterType: rnhFilterTypeQuery.dueBefore,
	name: 'Due on or before',
	inDropDown: true,
	isDateTime: true
},
{
	id: 5,
	filterType: rnhFilterTypeQuery.dueAfter,
	name: 'Due on or after',
	inDropDown: true,
	isDateTime: true
}
];

export const rnhSortingOptions = [{
	id: 'Number',
	label: '#'
},
{
	id: 'DueDate',
	label: 'Due'
},
{
	id: 'Priority',
	label: 'Priority'
},
{
	id: 'Status',
	label: 'Status'
}
];


export const userConfidentiality = [{
	id: 1,
	value: "General"
},
{
	id: 2,
	value: "Low"
},
{
	id: 3,
	value: "Medium"
},
{
	id: 4,
	value: "High"
},
{
	id: 5,
	value: "Restricted"
},
{
	id: 6,
	value: "Confidential"
}
];

export const externalUserStatus = {
	active: "Active",
	inactive: "Inactive"
};

export const engagementStatus = {
	1: "Active",
	2: "Pending",
	3: "Rejected",
	4: "Inactive",
	13: "Scheduled - Inactive"
};

export const copyRequestStatus = {
	0: "Expired",
	1: "Ready",
	2: "Sent",
	3: "Received",
	4: "Export in progress",
	5: "Export success",
	6: "Export error",
	7: "Import in progress",
	8: "Import success",
	9: "Import error",
	10: "Declined",
	11: "Copy in progress",
	13: "Draft",
	14: "Send in progress",
	15: "Delivery in progress",
	16: "Delivery error"
}

export const copyObjectGrouptype = {
	21: "Engagement",
	22: "Accounts",
	23: "SCOTs",
	20: "Evidence",
	24: "Roll forward from existing",
	25: "Template",
	26: "Bulk Export",
	27: "External document",
	28: "Guided Workflows",
	29: "Engagement by Entity"
}

export const independenceStatus = {
	0: labels.undefined,
	1: labels.incomplete,
	2: labels.nomattersidentified,
	3: labels.matteridentifiedpendingaction,
	4: labels.matterresolveddeniedaccess,
	5: labels.matterresolvedgrantedaccess,
	6: labels.notapplicable,
	7: labels.restored,
	8: labels.overriden,
	9: labels.priornomattersidentified,
	10: labels.priormatteridentifiedpendingaction,
	11: labels.priormatterresolvedgrantedaccess,
	12: labels.priormatterresolveddeniedaccess
};

export const independenceStatusFilterOptions = [{
	value: 3,
	label: labels.matteridentifiedpendingaction
},
{
	value: 4,
	label: labels.matterresolveddeniedaccess
},
{
	value: 5,
	label: labels.matterresolvedgrantedaccess
},
{
	value: 8,
	label: labels.override
},
{
	value: 1,
	label: labels.incomplete
},
{
	value: 2,
	label: labels.nomattersidentified
},
{
	value: 7,
	label: labels.restored
},
{
	value: 6,
	label: labels.notapplicable
}
];

export const independenceConfirmationStatus = {
	0: labels.undefined,
	1: labels.incomplete,
	2: labels.nomattersidentified,
	3: labels.matteridentifiedpendingaction,
	4: labels.matterresolveddeniedaccess,
	5: labels.matterresolvedgrantedaccess,
	6: labels.notapplicable,
	7: labels.restored,
	8: labels.override,
	9: labels.priornomattersidentified,
	10: labels.priormatteridentifiedpendingaction,
	11: labels.priormatterresolvedgrantedaccess,
	12: labels.priormatterresolveddeniedaccess
};

export const timePhaseTypes = {
	1: 'Scope',
	2: 'Strategy',
	3: 'Walkthroughs',
	4: 'Interim Control Testing',
	5: 'Interim Substantive Testing',
	6: 'Walkthroughs (year-end processes)',
	7: 'Year-end Control Testing',
	8: 'Year-end Substantive Testing',
	9: 'Conclusion',
	10: 'N/A',
	11: 'Execution',
	12: 'Scope and strategy quality activities',
	13: 'Other scope and strategy',
	14: 'CRA',
	15: 'Risk Assessment and Materiality',
	16: 'Finalize scope and strategy',
	17: 'Post-interim project management'
};

export const engagementMetricsComingDueOptions = [{
	value: 1,
	label: 'Tomorrow'
},
{
	value: 3,
	label: 'Next 3 days'
},
{
	value: 5,
	label: 'Next 5 days',
	isDefault: true
},
{
	value: 10,
	label: 'Next 10 days'
},
{
	value: 30,
	label: 'Next 30 days',
	isMax: true
}
];

export const engagementMetricsWhatsNewOptions = [{
	value: 1,
	label: 'Yesterday'
},
{
	value: 3,
	label: 'Last 3 days'
},
{
	value: 5,
	label: 'Last 5 days',
	isDefault: true
},
{
	value: 10,
	label: 'Last 10 days',
	isMax: true
}
];

export const engagementMetricsDisplayedAttributes = {
	preparer: 'To prepare',
	forMyReview: 'To review',
	upcomingReview: 'Upcoming review',
	reviewNotesAssigned: 'Notes for me',
	reviewNotesAuthored: 'Notes by me',
	partnerTasks: 'Partner tasks',
	eqrTasks: 'EQR tasks',
	timephases: 'Time phases',
	groupTasks: 'Group tasks',
	groupDeliverables: 'Group deliverables ',
	automation: 'Automation',
	requests: 'Requests'
};

export const quickLinks = {
	linkAccountSummary: 'Accounts summary',
	linkScotSummary: 'SCOTs summary',
	linkITSummary: 'IT summary',
	linkCRASummary: 'CRA summary',
	linkGAStructureSummary: 'Group structure summary',
	linkGAInstrcutionSummary: 'Group instructions summary',
	linkSEM: 'Substantive evaluation matrix',
	linkAuditPlan: 'Audit plan',
	linkWorkPlan: 'Work plan',
	linkITProcessEvaluation: 'IT evaluations',

	linkGeneral: 'General',
	linkScots: 'SCOTs',
	linkITSO: 'IT/SO',
	linkAccounts: 'Accounts',
	linkResponseTask: 'Response tasks',
	linkWrapupEngagement: 'Wrap up engagement',
	linkArchive: 'Archive checklist'
};

export const customKeyEvents = {
	reportDate: 'Report date',
	endDatePeriodCovered: 'End date of period covered',
	archiveDeadlineDate: 'Archive deadline date'
};

export const filterReviewNoteStatus = [{
	value: filters.reviewNoteStatus.open,
	label: 'Open'
},
{
	value: filters.reviewNoteStatus.cleared,
	label: 'Cleared'
},
{
	value: filters.reviewNoteStatus.closed,
	label: 'Closed'
}
];

export const filterFileExtension = [{
	value: filters.fileExtension.canvasForm,
	label: 'Canvas form'
},
{
	value: filters.fileExtension.email,
	label: 'Email'
},
{
	value: filters.fileExtension.excel,
	label: 'Excel'
},
{
	value: filters.fileExtension.paperProfile,
	label: 'Paper profile'
},
{
	value: filters.fileExtension.pdf,
	label: 'PDF'
},
{
	value: filters.fileExtension.powerPoint,
	label: 'PowerPoint'
},
{
	value: filters.fileExtension.smartAutomation,
	label: 'Smart Automation'
},
{
	value: filters.fileExtension.visio,
	label: 'Visio'
},
{
	value: filters.fileExtension.word,
	label: 'Word'
},
{
	value: filters.fileExtension.zip,
	label: 'Zip'
},
{
	value: filters.fileExtension.other,
	label: 'Other'
}
];

export const filterDocumentContent = [{
	value: filters.documentContent.trackedChanges,
	label: 'Tracked changes'
},
{
	value: filters.documentContent.comments,
	label: 'Comments'
},
{
	value: filters.documentContent.formulaError,
	label: 'Formula errors (Excel files only)'
},
{
	value: filters.documentContent.highlightsWordFilesOnly,
	label: 'Highlights (Word files only)'
},
{
	value: filters.documentContent.hiddenSheets,
	label: 'Hidden sheets'
},
{
	value: filters.documentContent.embeddedFiles,
	label: 'Embedded files'
},
{
	value: filters.documentContent.ProtectedFiles,
	label: 'Protected'
},
{
	value: filters.documentContent.DocumentContentNotAvailable,
	label: 'Document content not available'
},
{
	value: filters.documentContent.DocumentsInCollaborationMode,
	label: 'Documents in multi-user edit mode'
},
];

export const filterSharedEvidence = [{
	value: filters.sharedEvidence.source,
	label: 'Source'
},
{
	value: filters.sharedEvidence.target,
	label: 'Target'
}
];

export const filterFindings = [{
	value: filters.findings.misstatement,
	label: 'Misstatement'
},
{
	value: filters.findings.deficiency,
	label: 'Deficiency'
}
];

export const filterSignoffRequirements = [
	{
		value: filters.signoffRequirements.picMandatory,
		label: 'PIC mandatory'
	},
	{
		value: filters.signoffRequirements.picTeamAssigned,
		label: 'PIC team assigned'
	},
	{
		value: filters.signoffRequirements.eqrMandatory,
		label: 'EQR mandatory'
	},
	{
		value: filters.signoffRequirements.eqrTeamAssigned,
		label: 'EQR team assigned'
	}
];

export const filterResponsiveToRisks = [
	{
		value: filters.responsiveToRisk.responsiveToSignificantRisk,
		label: 'Significant risks'
	},
	{
		value: filters.responsiveToRisk.responsiveToFraudRisk,
		label: 'Fraud risks'
	},
	{
		value: filters.responsiveToRisk.responsiveToHigherInherentRisk,
		label: 'Higher inherent risks'
	}
];

export const filterMissingRelatedTask = [
	{
		value: filters.missingRelatedTask.picSignoffRequired,
		label: 'PIC sign-off required'
	},
	{
		value: filters.missingRelatedTask.eqrSignoffRequired,
		label: 'EQR sign-off required'
	}
];

export const filterCanvasForms = [{
	value: filters.canvasForms.incompleteResponses,
	label: 'Incomplete responses'
},
{
	value: filters.canvasForms.unresolvedComments,
	label: 'Unresolved comments'
}
];

export const documentChangeTypes = {
	0: 'No reason for change selected',
	1: 'Non-administrative change',
	2: 'Accepting revisions when the track changes functionality was used',
	3: 'Adding additional cross referencing to evidence that already exists',
	4: 'Adding an original confirmation response previously received via fax or email',
	5: 'Cosmetic change',
	6: 'Completing Form AP and substantial role evaluation',
	7: 'Deleting or discarding superseded documentation',
	8: 'Preparing the management letter',
	9: 'Signing off on completion checklists relating to the archive process',
	10: 'Sorting, collating and cross-referencing final documents',
	11: 'When adjusted to the local time zone, the modification is on or before the report date (Americas only)'
};

export const documentChangeTypesOptions = [
	{
		value: 1,
		label: 'Non-administrative change'
	},
	{
		value: 2,
		label: 'Accepting revisions/comments when such functionalities were used'
	},
	{
		value: 3,
		label: 'Adding additional cross referencing to evidence that already exists'
	},
	{
		value: 4,
		label: 'Adding an original confirmation response previously received via fax or email'
	},
	{
		value: 5,
		label: 'Cosmetic change'
	},
	{
		value: 6,
		label: 'Completing Form AP and substantial role evaluation'
	},
	{
		value: 7,
		label: 'Deleting or discarding documentation that does not constitute audit evidence'
	},
	{
		value: 8,
		label: 'Preparing or adding documents that do not support our opinion'
	},
	{
		value: 9,
		label: 'Signing off on completion checklists relating to the archive process'
	},
	{
		value: 10,
		label: 'Sorting, collating and cross-referencing final documents'
	},
	{
		value: 12,
		label: 'MEST only: Modification to evidence related to entities with a report date later than the report date in EY Canvas'
	},
	{
		value: 11,
		label: 'When adjusted to the local time zone, the modification is on or before the report date (Americas only)'
	}
];

export const FourFortyFilterTypes = [{
	id: 0,
	filterType: 'QuickFilter',
	name: 'Quick filters',
	hasChild: false
},
{
	id: 1,
	filterType: 'TaskStatus',
	name: 'Task status',
	hasChild: false
},
{
	id: 2,
	filterType: 'TaskType',
	name: 'Task type',
	hasChild: false
},
{
	id: 3,
	filterType: 'AssignedTo',
	name: 'Assigned to',
	hasChild: false,
	loadOptionsFromServer: true
},
{
	id: 4,
	filterType: 'OpenAssignment',
	name: 'Open assignments',
	hasChild: false,
	loadOptionsFromServer: true
},
{
	id: 5,
	filterType: 'AssignmentsUsersEngagementRoles',
	name: 'Open assignments',
	hideDisplay: true,
	loadOptionsFromServer: true
},
{
	id: 6,
	filterType: 'ReviewNotesStatus',
	name: 'Review notes status',
	hasChild: false
},
{
	id: 7,
	filterType: 'ReviewNotesAssignedTo',
	name: 'Review notes assigned to',
	hasChild: false,
	loadOptionsFromServer: true
},
{
	id: 8,
	filterType: 'ReviewNotesCreatedBy',
	name: 'Review notes created by',
	hasChild: false,
	loadOptionsFromServer: true
},
{
	id: 9,
	filterType: 'TimePhase',
	name: 'Time phase',
	hasChild: false,
	loadOptionsFromServer: true
},
{
	id: 10,
	filterType: 'Milestone',
	name: 'Milestone',
	hasChild: false
},
{
	id: 11,
	filterType: 'AuditPhase',
	name: 'Audit phase',
	altName: 'Engagement phase',
	hasChild: false
},
{
	id: 12,
	filterType: 'DocumentConflict',
	name: 'Document conflict',
	hasChild: false
},
{
	id: 13,
	filterType: 'Findings',
	name: 'Findings',
	hasChild: false,
	hideForNonAudit: true
},
{
	id: 14,
	filterType: 'Entity',
	name: 'Entity',
	hasChild: false,
	loadOptionsFromServer: true,
	hideForNonMest: true
},
{
	id: 15,
	filterType: 'IsBookmarked',
	name: 'Downloaded for offline',
	hasChild: false
}
];

/* Arc Timeline */
export const arcValidationGroups = [{
	id: 1,
	label: 'Build Step 29 ???'
},
{
	id: 2,
	label: 'Build Step 30 ???'
},
{
	id: 3,
	label: 'SEM (Evaluation Matrix) ???'
},
{
	id: ArcTimelineGroups.FinalizeEvidence,
	label: 'Finalize evidence'
},
{
	id: ArcTimelineGroups.CompleteRemainingTasks,
	label: 'Complete remaining tasks'
},
{
	id: ArcTimelineGroups.ResolveValidations,
	label: 'Resolve remaining validations'
},
{
	id: 7,
	label: 'Prepare for archive'
},
{
	id: 8,
	label: 'Engagement Dashboard'
},
{
	id: 9,
	label: 'Canvas Form (Individual)'
},
{
	id: 10,
	label: 'Canvas Form (All)'
}
];

export const checkListTypes = [{
	id: 7,
	label: 'Finalize hard copy files and folders'
},
{
	id: 13,
	label: 'Confirm the accuracy of key engagement dates'
},
{
	id: 14,
	label: 'Confirm the accuracy of engagement codes'
},
{
	id: 15,
	label: 'Confirm the accuracy of the client code'
},
{
	id: 10,
	label: 'Unlink this engagement from the group'
},
{
	id: 16,
	label: 'Validate the report type'
},
{
	id: 17,
	label: 'Review temporary files for those modified after the report release date'
},
{
	id: 18,
	label: 'Review deleted files for those modified after the report release date'
},
{
	id: 19,
	label: 'Ensure changes to the engagement profile are submitted'
},
{
	id: 20,
	label: 'Review protected documents'
},
{
	id: 95,
	label: 'Designate overall person in charge'
}
];

export const arcValidationTypes = [{
	id: ArcTimeLineValidationTypes.DocumentConflict,
	label: 'Resolve remaining document conflicts'
},
{
	id: ArcTimeLineValidationTypes.DocumentsInMultiUserEditMode,
	label: 'Documents in multi-user editing'
},
{
	id: ArcTimeLineValidationTypes.DocumentsWithIsProtected,
	label: 'Review protected documents'
},
{
	id: ArcTimeLineValidationTypes.DocumentIsNotFinalized,
	label: 'Document content not available'
},
{
	id: ArcTimeLineValidationTypes.AddressAllOpenReviewNotes,
	label: 'Close all unresolved review notes'
},
{
	id: ArcTimeLineValidationTypes.RemoveTrackedChangesFromEvidence,
	label: 'Remove tracked changes from evidence'
},
{
	id: ArcTimeLineValidationTypes.FinalizeSmartAutomationEvidenceFiles,
	label: 'Finalize Smart Automation evidence files'
},
{
	id: ArcTimeLineValidationTypes.FinalizeCompleteAllPICSignoffRequirements,
	label: 'Complete all PIC signoff requirements'
},
{
	id: ArcTimeLineValidationTypes.FinalizeCompleteAllEQRSignoffRequirements,
	label: 'Complete all EQR signoff requirements'
},
{
	id: ArcTimeLineValidationTypes.PICEvidenceWithoutAtLeastOneRelatedPICTask,
	label: 'Relate PIC documents to PIC tasks'
},
{
	id: ArcTimeLineValidationTypes.EQREvidenceWithoutAtLeastOneRelatedEQRTask,
	label: 'Relate EQR documents to EQR tasks'
},
{
	id: ArcTimeLineValidationTypes.EvidencemissingSignoffs,
	label: 'Signoff on all evidence'
},
{
	id: ArcTimeLineValidationTypes.CanvasFormComment,
	label: 'Resolve Canvas form comments'
},
{
	id: ArcTimeLineValidationTypes.UnlinkedSharedEvidence,
	label: 'Unlinked shared evidence'
},
{
	id: ArcTimeLineValidationTypes.TaskswithoutEvidence,
	label: 'Add evidence to open tasks'
},
{
	id: ArcTimeLineValidationTypes.PICTaskWithoutAtLeastOneRelatedPICEvidence,
	label: 'Verify all PIC tasks contain PIC documents'
},
{
	id: ArcTimeLineValidationTypes.EQRTaskWithoutAtLeastOneRelatedEQREvidence,
	label: 'Verify all EQR tasks contain EQR documents'
},
{
	id: ArcTimeLineValidationTypes.RelateEvidenceToEntityTask,
	label: 'Relate evidence to entity task'
},
{
	id: ArcTimeLineValidationTypes.MarkTasksComplete,
	label: 'Mark tasks complete'
},
{
	id: ArcTimeLineValidationTypes.AccountsSummary,
	label: 'Accounts summary'
},
{
	id: ArcTimeLineValidationTypes.ScotSummary,
	label: 'SCOTs summary'
},
{
	id: ArcTimeLineValidationTypes.CraSummary,
	label: 'CRA summary'
},
{
	id: ArcTimeLineValidationTypes.ITSummary,
	label: 'IT summary'
},
{
	id: ArcTimeLineValidationTypes.ConfirmAccuracyOfAuditorReport,
	label: 'Confirm accuracy of auditors report data'
},
{
	id: ArcTimeLineValidationTypes.CompleteArchiveForm,
	label: 'Complete archive form'
},
{
	id: ArcTimeLineValidationTypes.CompleteArchiveTask,
	label: 'Complete archive task'
},
{
	id: ArcTimeLineValidationTypes.UnlinkGroupSharedEvidence,
	label: 'Unlink group shared evidence'
},
{
	id: ArcTimeLineValidationTypes.AuditPlan,
	label: 'Audit plan'
},
{
	id: ArcTimeLineValidationTypes.UnassociateFinding,
	label: 'Unassociated findings'
},
{
	id: ArcTimeLineValidationTypes.IndependenceCompliance,
	label: 'Independence compliance'
},
{
	id: ArcTimeLineValidationTypes.IncompleteCanvasFormResponses,
	label: 'Finalize incomplete Canvas form responses'
},
{
	id: ArcTimeLineValidationTypes.WCGWwithNoRelatedsubstantivetask,
	label: 'Substantive evaluation matrix'
},
{
	id: ArcTimeLineValidationTypes.ITEvaluation,
	label: 'IT evaluations'
},
{
	id: ArcTimeLineValidationTypes.DocumentModifiedAfterReportReleaseDate,
	label: 'Documents modified after the report release date'
},
{
	id: ArcTimeLineValidationTypes.DuplicateFileNames,
	label: 'Rename evidence files with duplicate file names'
},
{
	id: ArcTimeLineValidationTypes.ITFlowCanvasForm,
	label: 'IT Flow'
},
{
	id: ArcTimeLineValidationTypes.AdjustmentsModule,
	label: 'Adjustments'
},
{
	id: ArcTimeLineValidationTypes.CanvasFormsWithNoContent,
	label: 'Review Canvas forms with no content'
},
{
	id: ArcTimeLineValidationTypes.PersonInCharge,
	label: 'Person in charge'
},
{
	id: ArcTimeLineValidationTypes.EstimateAccountWithoutEstimatePSPindex,
	label: ''
},
{
	id: ArcTimeLineValidationTypes.TempFilesWithPreparerAndReviewerSignoffsError,
	label: 'Review temporary files that have preparer and reviewer sign-offs for files that should be included in evidence or deleted'
},
{
	id: ArcTimeLineValidationTypes.TemporaryFilesWithPICRequirementUserOrKnowledge,
	label: "Review temporary files that have PIC tags for files that should be included in evidence or tags deleted"
},
{
	id: ArcTimeLineValidationTypes.TemporaryFileWithEQRRequirementUserOrKnowledge,
	label: "Review temporary files that have EQR tags for files that should be included in evidence or tags deleted"
},
{
	id: ArcTimeLineValidationTypes.DeletedFilesWithPICRequirementUserOnly,
	label: "Review deleted files that have PIC tags for files that should be included in evidence or tags deleted"
},
{
	id: ArcTimeLineValidationTypes.DeletedFilesWithEQRRequirementUserOnly,
	label: "Review deleted files that have EQR tags for files that should be included in evidence or tags deleted"
},
{
	id: ArcTimeLineValidationTypes.DocumentAssociatedToInvalidObject,
	label: "Documents related to objects that are no longer available in the engagement"
}
];

export const ArchiveErrors = {
	32204: "Engagement has Task without Evidences.",
	32209: "Engagement has CanvasForm with Incomplete Responses.",
	32210: "Engagement has Open Review Notes.",
	32212: "Engagement has Incomplete Task.",

	32402: "Archive ID is null Or empty.",
	32403: "File GUID is null Or empty.",
	32404: "ARC FileStoreHost is null Or empty.",
	32424: "Primary engagement code is missing or invalid.",
	32425: "Report release date cannot be a future date.",
	32426: "Report release date must be after engagement end date.",
	32427: "A partner must be invited to the engagement.",
	32428: "The ARC is missing data on workpaper type.",
	32429: "A selection is required on the archive form for report type.",
	32430: "A selection is required on the archive form for qualified reports.",
	32431: "An error has occurred during the archive process due to integration with the ARC.Contact the Help Desk to report this error."
};

export const validationTypes = [
	{
		id: 1,
		label: 'Independence compliance outstanding',
		altLabel: 'Incomplete form',
		errorLabel: 'Independence compliance outstanding'
	},
	{
		id: 2,
		label: 'Independence form version not current',
		altLabel: 'Out of date form',
		errorLabel: 'Independence form version not current'
	},
	{
		id: 3,
		label: 'Access granted by ineligible role',
		altLabel: 'Not approved by PPEDD',
		errorLabel: 'Access granted by ineligible role'
	},
	{
		id: 4,
		label: 'Override by ineligible role',
		altLabel: 'Not overridden by PPEDD',
		errorLabel: 'Override by ineligible role'
	},
	{
		id: 5,
		label: 'Unrelated SCOTs (without Account)',
		errorLabel: 'Unrelated SCOTs'
	},
	{
		id: 6,
		label: 'Unrelated Controls (without WCGW)',
		errorLabel: 'Unrelated Controls'
	},
	{
		id: 7,
		label: 'Controls strategy selected with no related WCGWs',
		errorLabel: 'Controls strategy selected with no related WCGWs'
	},
	{
		id: 8,
		label: 'Controls strategy selected with no related Controls',
		errorLabel: 'Controls strategy selected with no related Controls'
	},
	{
		id: 9,
		label: 'Controls strategy selected with no related Controls selected for testing',
		errorLabel: 'Controls strategy selected with no related Controls selected for testing'
	},
	{
		id: 10,
		label: 'Controls strategy selected and there is a WCGW with no related Controls selected for testing',
		errorLabel: 'Controls strategy selected and there is a WCGW with no related Controls selected for testing'
	},
	{
		id: 11,
		label: 'Unrelated Risks',
		errorLabel: 'Unrelated Risks'
	},
	{
		id: 12,
		label: 'Complete CRA for this Assertion',
		errorLabel: 'Complete CRA for this Assertion'
	},
	{
		id: 13,
		label: 'Unrelated WCGWs',
		errorLabel: 'Unrelated WCGWs'
	},
	{
		id: 14,
		label: 'Significant Account has no related SCOTs',
		errorLabel: 'Significant Account has no related SCOTs'
	},
	{
		id: 15,
		label: 'Rely strategy selected with no related WCGWs',
		errorLabel: 'Rely strategy selected with no related WCGWs'
	},
	{
		id: 16,
		label: 'Rely strategy selected with no related Controls',
		errorLabel: 'Rely strategy selected with no related Controls'
	},
	{
		id: 17,
		label: 'Rely strategy selected with no related Controls selected for testing',
		errorLabel: 'Rely strategy selected with no related Controls selected for testing'
	},
	{
		id: 18,
		label: 'Rely strategy selected and there is a WCGW with no related Controls selected for testing',
		errorLabel: 'Rely strategy selected and there is a WCGW with no related Controls selected for testing'
	},
	{
		id: 19,
		label: 'Unrelated IT App/SO',
		errorLabel: 'Unrelated IT app/So'
	},
	{
		id: 20,
		label: 'Unrelated Control / IT Substantive Procedure',
		errorLabel: 'Unrelated Control/IT Substantive Procedures'
	},
	{
		id: 21,
		label: 'No related IT App/SO',
		errorLabel: 'No related IT App/SO'
	},
	{
		id: 22,
		label: 'No related risks',
		errorLabel: 'No related risks'
	},
	{
		id: 23,
		label: 'No related Controls / IT Substantive Procedures',
		errorLabel: 'No related Controls / IT Substantive Procedures'
	},
	{
		id: 24,
		label: 'No related Controls / IT Substantive Procedures selected for testing',
		errorLabel: 'No related Controls / IT Substantive Procedures selected for testing'
	},
	{
		id: 25,
		label: 'There is a Risk with no related Controls / IT Substantive Procedures selected for testing',
		errorLabel: 'There is a Risk with no related Controls / IT Substantive Procedures selected for testing'
	},
	{
		id: 26,
		label: 'The Limited Risk Account does not have any related Substantive Tasks',
		errorLabel: 'The limited risk account does not have any related substantive tasks'
	},
	{
		id: 27,
		label: 'No Substantive tasks are related to the Assertion',
		errorLabel: 'No Substantive tasks are related to the Assertion'
	},
	{
		id: 28,
		label: 'Unrelated TOC',
		errorLabel: 'Unrelated TOC'
	},
	{
		id: 29,
		label: 'Unrelated Walkthrough',
		errorLabel: 'Unrelated Walkthrough'
	},
	{
		id: 30,
		label: 'No Walkthrough tasks are related to the SCOT',
		errorLabel: 'No Walkthrough Tasks are related to the SCOT'
	},
	{
		id: 31,
		label: 'No Control tasks are related to a Control selected for testing',
		errorLabel: 'No Control tasks are related to a Control selected for testing'
	},
	{
		id: 32,
		label: 'Unrelated IT/SO Walkthrough',
		errorLabel: 'Unrelated IT/SO Walkthrough'
	},
	{
		id: 33,
		label: 'Unrelated IT/SO TOC',
		errorLabel: 'Unrelated IT/SO TOC'
	},
	{
		id: 34,
		label: 'Unrelated IT/SO OSP',
		errorLabel: 'Unrelated IT/SO OSP'
	},
	{
		id: 35,
		label: 'The IT/SO Process does not have a related walkthrough task',
		errorLabel: 'The IT/SO Process does not have a related walkthrough task'
	},
	{
		id: 36,
		label: 'A Control does not have a related TOC',
		errorLabel: 'A Control does not have a related TOC'
	},
	{
		id: 37,
		label: 'A IT Substantive Procedure does not have a related OSP',
		errorLabel: 'A IT Substantive Procedure does not have a related OSP'
	},
	{
		id: 38,
		label: 'Document Conflict',
		errorLabel: 'Unresolved conflicts'
	},
	{
		id: 39,
		label: 'Sync Conflict - Shared Evidence - Not displayed in Canvas validation count',
		errorLabel: 'Shared evidence - Sync conflict'
	},
	{
		id: 40,
		label: 'Evidence missing Sign-offs',
		errorLabel: 'Signoff on all evidence'
	},
	{
		id: 41,
		label: 'Tasks without Evidence',
		errorLabel: 'Add evidence to open tasks'
	},
	{
		id: 42,
		label: 'Invalid Engagement Code',
		errorLabel: 'Invalid engagement code'
	},
	{
		id: 43,
		label: 'Invalid Client Code',
		errorLabel: 'Invalid client code'
	},
	{
		id: 44,
		label: 'Duplicate File Names',
		errorLabel: 'Duplicate File Names'
	},
	{
		id: 45,
		label: 'Inconsistent IT Evaluation',
		errorLabel: 'Incomplete IT Process Evaluation'
	},
	{
		id: 46,
		label: 'Incomplete IT Process Evaluation',
		errorLabel: 'Incomplete IT Process Evaluation'
	},
	{
		id: 47,
		label: 'Incomplete Aggregate IT Evaluation',
		errorLabel: 'Incomplete Aggregate IT Evaluation'
	},
	{
		id: 48,
		label: 'Response Incomplete',
		errorLabel: 'Supporting rationale incomplete'
	},
	{
		id: 49,
		label: 'Unrelated Misstatement',
		errorLabel: 'Unrelated misstatements'
	},
	{
		id: 50,
		label: 'Unassociated Deficiency',
		errorLabel: 'Unassociated Deficiencies'
	},
	{
		id: 51,
		label: 'WCGW with no related substantive task',
		errorLabel: 'WCGW with no related substantive task'
	},
	{
		id: 52,
		label: 'Risk with no related WCGW',
		errorLabel: 'Risk without WCGW'
	},
	{
		id: 53,
		label: 'Estimate Account without estimate PSP index',
		errorLabel: 'Estimate Account without estimate PSP index'
	},
	{
		id: 54,
		label: 'Estimate Account without estimate SCOT',
		errorLabel: 'Estimate Account without estimate SCOT'
	},
	{
		id: 55,
		label: 'Estimate SCOT without estimate Account',
		errorLabel: 'Estimate SCOT without estimate Account'
	},
	{
		id: 56,
		label: 'Assertion with control risk of rely without a responsive TOC',
		errorLabel: 'Assertion with control risk of rely without a responsive TOC'
	},
	{
		id: 57,
		label: 'Assertion with control risk of rely without at least one responsive TOC associated to an effectively designed control that is not lower risk that is responsive to the risk',
		errorLabel: 'Assertion with control risk of rely without at least one responsive TOC associated to an effectively designed control that is not lower risk that is responsive to the risk'
	},
	{
		id: 58,
		label: 'Assertion without a responsive substantive task',
		errorLabel: 'Assertion without a responsive substantive task'
	},
	{
		id: 59,
		label: 'Assertion without a responsive control',
		errorLabel: 'Assertion without a responsive control'
	},
	{
		id: 60,
		label: 'Canvas Form Comment',
		errorLabel: 'Canvas Form Comment'
	},
	{
		id: 61,
		label: 'Canvas Form incomplete responses',
		errorLabel: 'Canvas Form incomplete responses'
	},
	{
		id: 62,
		label: 'Open or cleared review notes that should be closed or deleted',
		errorLabel: 'Open or cleared review notes that should be closed or deleted'
	},
	{
		id: 63,
		label: 'Evidence with track changes',
		errorLabel: 'Evidence with track changes'
	},
	{
		id: 64,
		label: 'Tasks not marked complete',
		errorLabel: 'Mark tasks complete'
	},
	{
		id: 65,
		label: 'Shared evidence not unlinked',
		errorLabel: 'Unlinked shared evidence'
	},
	{
		id: 66,
		label: 'Documents without a modification type selected',
		errorLabel: 'Documents without a modification type selected'
	},
	{
		id: 67,
		label: 'Non-administrative changes without change reason (rationale)',
		errorLabel: 'Non-administrative changes without change reason (rationale)'
	},
	{
		id: 68,
		label: 'Unapproved modifications for non-administrative changes by appropriate role',
		errorLabel: 'Unapproved modifications for non-administrative changes by appropriate role'
	},
	{
		id: 69,
		label: '440 GL missing executive reviewer sign-off',
		errorLabel: '440 GL Missing executive reviewer sign-off'
	},
	{
		id: 70,
		label: "Group engagement that has not been unlinked",
		errorLabel: 'Unlink this engagement from the group'
	},
	{
		id: 71,
		label: "Canvas Form without any Headers",
		altLabel: "Canvas Form without any Headers",
		errorLabel: 'Canvas Form without any Headers'
	},
	{
		id: 72,
		label: "Group Component Summary Document missing content",
		errorLabel: 'Group Component Summary Document missing content'
	},
	{
		id: 73,
		label: "Incomplete Canvas Form Responses Regardless of Approval",
		errorLabel: 'Incomplete Canvas Form'
	},
	{
		id: 74,
		label: "Profile V2 Change Not Submitted",
		errorLabel: 'Profile Change Not Submitted'
	},
	{
		id: 75,
		label: "0 byte electronic files",
		errorLabel: '0 byte electronic files'
	},
	{
		id: 76,
		label: 'Independence form edited after submission',
		altLabel: 'Form not submitted',
		errorLabel: 'Independence form edited after submission'
	},
	{
		id: 77,
		label: 'Independence template different from individual',
		altLabel: 'Independence template different from individual',
		errorLabel: 'Independence template different from individual'
	},
	{
		id: 78,
		label: 'IT Application (not SO) without at least one related IT Process',
		errorLabel: 'Unrelated IT application'
	},
	{
		id: 79,
		label: 'ITGC has no related ITRisk or is related to an ITRisk where HasNoITGC = 1',
		errorLabel: 'Unrelated ITGC'
	},
	{
		id: 80,
		label: 'ITSP has no related ITRisk',
		errorLabel: 'Unrelated ITSP'
	},
	{
		id: 81,
		label: 'ITProcess has no related IT Application',
		errorLabel: 'Unrelated IT process'
	},
	{
		id: 82,
		label: 'ITProcess with no ITRisk where there is a ITAC or ITDM (without exception) related via ITApplication',
		errorLabel: 'Missing IT risk'
	},
	{
		id: 83,
		label: 'ITRisk (HasNoITGC = 0) has no related ITGC',
		errorLabel: 'Missing ITGC or mark none exists'
	},
	{
		id: 84,
		label: 'ITDM/ITAC with no related IT Application',
		errorLabel: 'App/ITDM control with no IT app'
	},
	{
		id: 85,
		label: 'ITSP not deleted when corresponding body is not displayed',
		errorLabel: 'ITSP to be deleted'
	},
	{
		id: 86,
		label: 'ITGC not deleted when corresponding body is not displayed',
		errorLabel: 'ITGC to be deleted'
	},
	{
		id: 87,
		label: 'ITRisk not deleted when corresponding body is not displayed',
		errorLabel: 'IT risk to be deleted'
	},
	{
		id: 88,
		label: 'ITGC with HasITControlTesting = 1 exists when corresponding body is not displayed',
		errorLabel: 'ITGC with invalid testing strategy'
	},
	{
		id: 89,
		label: 'ITGC without a selected Design Effectiveness',
		errorLabel: 'Missing ITGC design evaluation'
	},
	{
		id: 90,
		label: 'Control without a selected Design Effectiveness',
		errorLabel: 'Control without a selected Design Effectiveness'
	},
	{
		id: 91,
		label: 'SCOT without IT Applications where HasNoITApplication = 0',
		errorLabel: 'Unrelated SCOT'
	},
	{
		id: 92,
		label: "Substantive procedures and tests of controls that are responsive to a significant risk but not to the risk's related WCGW",
		errorLabel: "Inconsistent RiskTaskRelation vs Risk > WCGW > Task relationship"
	},
	{
		id: 93,
		label: 'Inconsistent response for testing controls',
		errorLabel: 'Inconsistent response for testing controls'
	},
	{
		id: 94,
		label: 'SCOT with HasNoITApplication = 0 has ITDM or App controls',
		errorLabel: 'IT application in SCOT missing'
	},
	{
		id: 95,
		label: "No team member has been assigned with overall responsibility",
		altLabel: 'No team member has been assigned with overall responsibility',
		errorLabel: 'No team member has been assigned with overall responsibility'
	},
	{
		id: 96,
		label: "Risk factors unrelated to a Risk or not marked as not a ROMM",
		errorLabel: "Risk factors unrelated to a Risk or not marked as not a ROMM"
	},
	{
		id: 97,
		label: "Risks unrelated to an Assertion",
		errorLabel: "Risks unrelated to an Assertion"
	},
	{
		id: 98,
		label: "Incomplete measurement basis forecast amount",
		errorLabel: "Incomplete measurement basis forecast amount"
	},
	{
		id: 99,
		label: "Incomplete measurement basis forecast amount rationale",
		errorLabel: "Incomplete measurement basis forecast amount rationale"
	},
	{
		id: 100,
		label: "Incomplete measurement basis adjusted amount",
		errorLabel: "Incomplete measurement basis adjusted amount"
	},
	{
		id: 101,
		label: "Incomplete planning materiality",
		errorLabel: "Incomplete planning materiality"
	},
	{
		id: 102,
		label: "Planning materiality greater than maximum amount",
		errorLabel: "Planning materiality greater than maximum amount"
	},
	{
		id: 103,
		label: "Incomplete planning materiality rationale",
		errorLabel: "Incomplete planning materiality rationale"
	},
	{
		id: 104,
		label: "Incomplete tolerable error",
		errorLabel: "Incomplete tolerable error"
	},
	{
		id: 105,
		label: "TE not within range of allowed values",
		errorLabel: "TE not within range of allowed values"
	},
	{
		id: 106,
		label: "Incomplete tolerable error rationale",
		errorLabel: "Incomplete tolerable error rationale"
	},
	{
		id: 107,
		label: "Incomplete SAD",
		errorLabel: "Incomplete SAD"
	},
	{
		id: 108,
		label: "SAD greater than maximum",
		errorLabel: "SAD greater than maximum"
	},
	{
		id: 109,
		label: "Incomplete SAD rationale",
		errorLabel: "Incomplete SAD rationale"
	},
	{
		id: 110,
		label: "Incomplete PACE selection",
		errorLabel: "Incomplete PACE selection"
	},
	{
		id: 111,
		label: "No related documents",
		errorLabel: "No related documents"
	},
	{
		id: 112,
		label: "PIC task without at least one related PIC evidence",
		errorLabel: "PIC task without at least one related PIC evidence"
	},
	{
		id: 113,
		label: "EQR task without at least one related EQR evidence",
		errorLabel: "EQR task without at least one related EQR evidence"
	},
	{
		id: 114,
		label: "PIC evidence without at least one related PIC task",
		errorLabel: "PIC evidence without at least one related PIC task"
	},
	{
		id: 115,
		label: "EQR evidence without at least one related EQR task",
		errorLabel: "EQR evidence without at least one related EQR task"
	},
	{
		id: 116,
		label: "PIC evidence without at least one PIC sign-off",
		errorLabel: "PIC evidence without at least one PIC sign-off"
	},
	{
		id: 117,
		label: "EQR evidence without at least one EQR sign-off",
		errorLabel: "EQR evidence without at least one EQR sign-off"
	},
	{
		id: 118,
		label: "Evidence not to be archived is still present",
		errorLabel: "Evidence not to be archived is still present"
	},
	{
		id: 119,
		label: "Temporary files with preparer and reviewer sign-offs",
		errorLabel: "Temporary files with preparer and reviewer sign-offs"
	},
	{
		id: 120,
		label: "All Open or Cleared Canvas Form Comments",
		errorLabel: "All Open or Cleared Canvas Form Comments"
	},
	{
		id: 121,
		label: "Temporary files that have a PIC requirement",
		errorLabel: "Temporary files that have a PIC requirement"
	},
	{
		id: 122,
		label: "Temporary file that has a EQR requirement",
		errorLabel: "Temporary file that has a EQR requirement"
	},
	{
		id: 123,
		label: "Deleted files that have a PIC requirement",
		errorLabel: "Deleted files that have a PIC requirement"
	},
	{
		id: 124,
		label: "Deleted files that have a EQR requirement",
		errorLabel: "Deleted files that have a EQR requirement"
	},
	{
		id: 125,
		label: "Review protected documents",
		errorLabel: "Review protected documents"
	},
	{
		id: 126,
		label: "Document content not available",
		errorLabel: "Document content not available"
	},
	{
		id: 127,
		label: "Income Statement Body without data",
		errorLabel: "Income Statement Body without data"
	},
	{
		id: 128,
		label: "Balance Sheet Body without data",
		errorLabel: "Balance Sheet Body without data"
	},
	{
		id: 129,
		label: "MultiEntity - MultiEntity not related to all the PSP/ACT for related Account(s)",
		errorLabel: "MultiEntity - MultiEntity not related to all the PSP/ACT for related Account(s)"
	},
	{
		id: 130,
		label: "Account without Individual Risk Assessment Form Form",
		errorLabel: "Account without Individual Risk Assessment Form Form"
	},
	{
		id: 131,
		label: "Estimate without Estimate documentation",
		errorLabel: "Estimate without Estimate documentation"
	},
	{
		id: 132,
		label: "Account without Individual Analytic Form",
		errorLabel: "Account without Individual Analytic Form"
	},
	{
		id: 133,
		label: "MultiEntity without Individual Profile Form",
		errorLabel: "MultiEntity without Individual Profile Form"
	},
	{
		id: 134,
		label: "Account - AccountTypeID does not match Action",
		errorLabel: "Account - AccountTypeID does not match Action"
	},
	{
		id: 135,
		label: "Account - HasEstimate does not match Action",
		errorLabel: "Account - HasEstimate does not match Action"
	},
	{
		id: 136,
		label: "Account - Account FormOption Has Related Risks Not Associated To Account",
		errorLabel: "Account - Account FormOption Has Related Risks Not Associated To Account"
	},
	{
		id: 137,
		label: "Account - Higher Inherent Risk Assertion without related IsHigherRisk Risk",
		errorLabel: "Account - Higher Inherent Risk Assertion without related IsHigherRisk Risk"
	},
	{
		id: 138,
		label: "MultiEntity - MultiEntity without any related substantive procedures for related Account(s)",
		errorLabel: "MultiEntity - MultiEntity without any related substantive procedures for related Account(s)"
	},
	{
		id: 139,
		label: "Component without a Group Involvement Form (Excluding Reference Only Components)",
		errorLabel: "Component without a Group Involvement Form (Excluding Reference Only Components)"
	},
	{
		id: 140,
		label: "Component (Full/Specific) without a related Group Risk Assessment Instruction (Excluding Reference Only Components)",
		errorLabel: "Component (Full/Specific) without a related Group Risk Assessment Instruction (Excluding Reference Only Components)"
	},
	{
		id: 141,
		label: "MultiEntity - Account without any related MultiEntity",
		errorLabel: "MultiEntity - Account without any related MultiEntity"
	},
	{
		id: 142,
		label: "Document.SmartEvidenceSourceID associated to an invalid object",
		errorLabel: "Document.SmartEvidenceSourceID associated to an invalid object"
	},
	{
		id: 143,
		label: "Account - Higher Inherent Risk Assertion without related IsHigherRisk Risk",
		errorLabel: "Account - Higher Inherent Risk Assertion without related IsHigherRisk Risk"
	},
	{
		id: 144,
		label: "Group - Accounts (Executed in other engagements) without a related Component",
		errorLabel: "Group - Accounts (Executed in other engagements) without a related Component"
	},
	{
		id: 145,
		label: "Account - Estimate Account without estimate PSP index",
		errorLabel: "Account - Estimate Account without estimate PSP index"
	},
	{
		id: 146,
		label: "MultiEntity - MultiEntity Individual Profile Change Not Submited (Body)",
		errorLabel: "MultiEntity - MultiEntity Individual Profile Change Not Submited (Body)"
	},
	{
		id: 147,
		label: "MultiEntity - MultiEntity Individual Profile Change Not Submited (Individual Document)",
		errorLabel: "MultiEntity - MultiEntity Individual Profile Change Not Submited (Individual Document)"
	},
	{
		id: 148,
		label: "Account - Incomplete or invalid account properties",
		errorLabel: "Account - Incomplete or invalid account properties"
	},
	{
		id: 149,
		label: "Document Upload - Missing required PIC/EQR Sign-offs",
		errorLabel: "Document Upload - Missing required PIC/EQR Sign-offs"
	},
	{
		id: 150,
		label: "Document Upload - Missing required PIC/EQR Sign-off Requirements",
		errorLabel: "Document Upload - Missing required PIC/EQR Sign-off Requirements"
	},
	{
		id: 151,
		label: "Account - Significant Account / Disclosure without any related assertions",
		errorLabel: "Account - Significant Account / Disclosure without any related assertions"
	},
	{
		id: 152,
		label: "Document upload - Missing Preparer or Reviewer Sign-offs",
		errorLabel: "Document upload - Missing Preparer or Reviewer Sign-offs"
	},
	{
		id: 153,
		label: "Adjustment without any evidence",
		errorLabel: "Adjustment without any evidence"
	},
	{
		id: 154,
		label: "Estimate without account related",
		errorLabel: "Estimate without account related"
	},
	{
		id: 155,
		label: "Higher/Lower risk estimate related to non-estimate account",
		errorLabel: "Higher/Lower risk estimate related to non-estimate account"
	},
	{
		id: 156,
		label: "Estimate category response not aligned to designation in 'Edit estimate'",
		errorLabel: "Estimate category response not aligned to designation in 'Edit estimate'"
	},
	{
		id: 157,
		label: "Estimate without valid SCOT",
		errorLabel: "Estimate without valid SCOT"
	},
	{
		id: 158,
		label: "Account without valid estimate",
		errorLabel: "Account without valid estimate"
	},
	{
		id: 159,
		label: "Estimate account without Higher or Lower risk Estimate",
		errorLabel: "Estimate account without Higher or Lower risk Estimate"
	},
	{
		id: 160,
		label: "Estimate SCOT without Higher or Lower risk Estimate",
		errorLabel: "Estimate SCOT without Higher or Lower risk Estimate"
	},
	{
		id: 161,
		label: "Adjustments that do not net",
		errorLabel: "Adjustments that do not net"
	},
	{
		id: 162,
		label: "Higher risk estimate without valid risk related",
		errorLabel: "Higher risk estimate without valid risk related"
	},
	{
		id: 163,
		label: "Document - Document checked out or in the process of being checked out for collaboration",
		errorLabel: "Document - Document checked out or in the process of being checked out for collaboration"
	},
	{
		id: 164,
		label: "Non-Engagement wide tasks missing evidence",
		errorLabel: "Non-Engagement wide tasks missing evidence"
	},
	{
		id: 165,
		label: "EP or EQR Signoff requirement does not match response",
		errorLabel: "EP or EQR Signoff requirement does not match response"
	},
	{
		id: 166,
		label: "Significant/Fraud risk related to an estimate that is not a Higher risk",
		errorLabel: "Significant/Fraud risk related to an estimate that is not a Higher risk"
	}
];

export const contentType = {
	1: 'Primary standard tasks (PSTs)',
	2: 'Primary substantive procedures Index (PSP index)',
	3: 'Primary substantive procedures (PSPs)',
	4: 'Group audit instructions',
	5: 'Canvas forms required by methodology',
	6: 'Canvas forms created by users (example: SCOT form)',
	7: 'Independence',
	9: 'Profile',
	10: 'Canvas maps'
};

export const contentTypeByName = {
	'PST': 'Primary standard tasks (PSTs)',
	'PSPIndex': 'Primary substantive procedures Index (PSP index)',
	'PSP': 'Primary substantive procedures (PSPs)',
	'GAInstructions': 'Group audit instructions',
	'CanvasFormKnowledge': 'Canvas forms from Knowledge',
	'CanvasFormUserAdded': 'Canvas forms created by users (example: SCOT form)',
	'IndependenceForm': 'Independence',
	'Profile': 'Profile',
	'Maps': 'Canvas maps'

};

export const reportTypes = {
	1: 'Unqualified - with Emphasis Of Matter',
	2: 'Unqualified - without Emphasis Of Matter',
	3: 'Qualified - with Emphasis Of Matter',
	4: 'Qualified - without Emphasis Of Matter',
	5: 'Adverse opinion - with Emphasis Of Matter',
	6: 'Adverse opinion - without Emphasis Of Matter',
	7: 'Disclaimer Of opinion - with Emphasis Of Matter',
	8: 'Disclaimer Of opinion - without Emphasis Of Matter',
	100: 'No',
	101: 'N/A',
	102: 'Not yet selected'
};

export const internalUserRoles = [{
	roleKey: 3,
	sectionId: 2,
	groupDisplayOrder: 150,
	groupName: "Permissions",
	roleNameUI: "Archive engagement",
	displayName: "Archive engagement",
	roleDisplayOrder: 2,
	tooltipText: "Ability to archive the engagement"
},
{
	roleKey: 4,
	sectionId: 2,
	groupDisplayOrder: 150,
	groupName: "Permissions",
	roleNameUI: "Administer engagement",
	displayName: "Administer engagement",
	roleDisplayOrder: 1,
	tooltipText: "Ability to invite internal and external members and assign permissions to internal members"
},
{
	roleKey: 5,
	sectionId: 2,
	groupDisplayOrder: 150,
	groupName: "Permissions",
	roleNameUI: "Update content",
	displayName: "Update content",
	roleDisplayOrder: 6,
	tooltipText: "Ability to edit the profile and accept a content update"
},
{
	roleKey: 7,
	sectionId: 2,
	groupDisplayOrder: 150,
	groupName: "Permissions",
	roleNameUI: "Create service request",
	displayName: "Manage service requests",
	roleDisplayOrder: 4,
	tooltipText: 'Ability to create service requests and mark service requests complete'
},
{
	roleKey: 8,
	sectionId: 2,
	groupDisplayOrder: 150,
	groupName: "Permissions",
	roleNameUI: "Manage group",
	displayName: "Manage group",
	roleDisplayOrder: 5,
	tooltipText: 'Accept or reject groups instructions received from the Primary or Regional team'
},
{
	roleKey: 9,
	sectionId: 2,
	groupDisplayOrder: 150,
	groupName: "Permissions",
	roleNameUI: "Copy, Roll-forward, Restore engagements",
	displayName: "Copy, Roll-forward, Restore engagements",
	roleDisplayOrder: 3,
	tooltipText: "Ability to copy the engagement, and to roll-forward and restore it's archive"
},
{
	roleKey: 0,
	sectionId: 1,
	groupDisplayOrder: 200,
	groupName: "Confidentiality",
	roleNameUI: "Default",
	displayName: "None (Default)",
	roleDisplayOrder: 1,
	tooltipText: 'Default Confidential Documents Role'
},
{
	roleKey: 10,
	sectionId: 1,
	groupDisplayOrder: 200,
	groupName: "Confidentiality",
	roleNameUI: "Low",
	displayName: "Low",
	roleDisplayOrder: 8,
	tooltipText: 'Low Confidential Documents Role'
},
{
	roleKey: 11,
	sectionId: 1,
	groupDisplayOrder: 200,
	groupName: "Confidentiality",
	roleNameUI: "High",
	displayName: "High",
	roleDisplayOrder: 10,
	tooltipText: 'High Confidential Documents Role'
},
{
	roleKey: 12,
	sectionId: 1,
	groupDisplayOrder: 200,
	groupName: "Confidentiality",
	roleNameUI: "Moderate",
	displayName: "Moderate",
	roleDisplayOrder: 9,
	tooltipText: 'Moderate Confidential Documents Role'
},
// {
// roleKey: 13,
// sectionId:1,
// groupDisplayOrder: 200,
// groupName:"Confidentiality",
// roleNameUI: "Confidential",
// displayName: "Confidential",
// roleDisplayOrder: 11,
// tooltipText: 'Strictly Confidential Documents Role'
// },
{
	roleKey: 14,
	sectionId: 3,
	groupDisplayOrder: 100,
	groupName: "Restrictions",
	roleNameUI: "Read-only",
	displayName: "Read-only",
	roleDisplayOrder: 12,
	tooltipText: 'This functionality should only be used to grant third-party reviewers to this EY Canvas engagement. Appropriate approvals and authorization should be acquired from Professional Practice.'
},
{
	roleKey: 16,
	sectionId: 3,
	groupDisplayOrder: 100,
	groupName: "Restrictions",
	roleNameUI: "Review only",
	displayName: "Review only",
	roleDisplayOrder: 13,
	tooltipText: 'Review only gives this user the ability to view information in the EY Canvas engagement, sign-off, and use the review note functionality. This should be used when other EY users need to review this engagement but not be able to make edits.'
},
{
	roleKey: 37,
	sectionId: 3,
	groupDisplayOrder: 100,
	groupName: "Restrictions",
	roleNameUI: "Independence only",
	displayName: "Independence only",
	roleDisplayOrder: 14,
	tooltipText: 'Independence only gives this user the ability to complete their independence form for the engagement, but will not allow user to fully access the EY Canvas engagement. This should be used when a user has performed work for the engagement, but does not need to have access to EY Canvas.'
},
{
	roleKey: 6,
	sectionId: 2,
	groupDisplayOrder: 150,
	groupName: "Permissions",
	roleNameUI: "Undo edits",
	displayName: "Rollback / bulk delete document",
	roleDisplayOrder: 7,
	tooltipText: "Ability to rollback documents if changes were accidentally made after the report release date and remove them from the 440 EY Canvas Form"
},
{
	roleKey: 35,
	sectionId: 2,
	groupDisplayOrder: 150,
	groupName: "Permissions",
	roleNameUI: "Manage sharing of EY Canvas FIT enablement",
	displayName: "Administer Guided Workflows",
	roleDisplayOrder: 14,
	tooltipText: "Ability to share Guided Workflows between EY Canvas engagements"
},
{
	roleKey: 36,
	sectionId: 2,
	groupDisplayOrder: 150,
	groupName: "Permissions",
	roleNameUI: "Import EY Helix data",
	displayName: "Import EY Helix data",
	roleDisplayOrder: 15,
	tooltipText: "Ability to import data from EY Helix"
}
];

export const ValidationSubGroups = [{
	id: 9008,
	label: 'Independence compliance'
},
{
	id: 9001,
	label: 'Account summary'
},
{
	id: 9002,
	label: 'SCOT summary'
},
{
	id: 9004,
	label: 'IT summary'
},
{
	id: 9003,
	label: 'CRA summary'
},
{
	id: 9005,
	label: 'Audit plan'
},
{
	id: 9011,
	label: 'Substantive evaluation matrix'
},
{
	id: 9012,
	label: 'Validations by Canvas form'
},
{
	id: 9009,
	label: 'IT evaluation'
},
{
	id: 49,
	label: 'Unrelated misstatements'
},
{
	id: 50,
	label: 'Unrelated deficiencies'
},
{
	id: 44,
	label: 'Duplicate file names'
},
{
	id: 38,
	label: 'Unresolved conflicts'
},
{
	id: 9013,
	label: 'Modifications after the report release date'
},
{
	id: 9014,
	label: 'IT flow'
},
{
	id: 9015,
	label: 'EY Canvas FIT enablement'
},
{
	id: 71,
	label: 'Forms with no content'
},
{
	id: 9016,
	label: 'Incomplete canvas form response'
},
{
	id: 9017,
	label: 'Adjustment module'
},
];

export const engagementIndustry = {
	116: "Not Sector Specific",
	61: "Aerospace and Defense – Aerospace Manufacturing",
	112: "Aerospace and Defense – Defense Contracts Manufacturing",
	59: "Airlines – Air Transportation",
	92: "Asset Management – Commodity Funds",
	57: "Asset Management – Other Funds",
	43: "Asset Management – Private Equity / Venture Capital",
	85: "Asset Management – Registered / Listed Funds",
	53: "Asset Management – Structured Products",
	60: "Asset Management – Unregulated Hedge Funds",
	10: "Asset Management – Unregulated Segregated Accounts",
	90: "Audit of Compliance Management Systems",
	51: "Automotive – Automotive Dealers and Repairs",
	101: "Automotive – Automotive Manufacturing",
	5: "Automotive – Automotive Suppliers",
	71: "Banking and Capital Markets – Banks",
	89: "Banking and Capital Markets – Broker Dealers",
	27: "Banking and Capital Markets – Credit Unions",
	54: "Banking and Capital Markets – Diversified and Other Financial Institutions",
	32: "Banking and Capital Markets – Investment Banking",
	4: "Biotechnology – Biotech – Emerging Growth Markets",
	109: "Biotechnology – Health Research and Testing",
	66: "Chemicals – Chemicals Manufacturing",
	41: "Cleantech",
	37: "Consolidations",
	130: "Construction – Engineering and Architectural Services",
	68: "Construction – Highway and Heavy Construction",
	65: "Construction – Specialty Contractors",
	82: "Consumer Products – Consumer Non– Durable Goods Manufacturing",
	17: "Consumer Products – Food and Beverages Manufacturing",
	35: "Consumer Products – Food Crops, Livestock, Fishing",
	33: "Consumer Products – Household Appliances and Electronics Manufacturing",
	75: "Consumer Products – Other Consumer Durable Goods Manufacturing",
	39: "Consumer Products – Textiles and Apparel Manufacturing",
	21: "Diversified Industrial Products – Fabricated Metals",
	31: "Diversified Industrial Products – Forestry, Pulp, and Paper",
	29: "Diversified Industrial Products – Industrial Instruments Manufacturing",
	40: "Diversified Industrial Products – Industrial Machines Manufacturing",
	26: "Diversified Industrial Products – Industrial Packaging",
	42: "Diversified Industrial Products – Lumber and Wood Manufacturing",
	105: "Diversified Industrial Products – Other Industrial Products",
	100: "Diversified Industrial Products – Primary Metals",
	45: "Diversified Industrial Products – Printing",
	1: "Diversified Industrial Products – Rubber and Plastics Manufacturing",
	118: "Diversified Industrial Products – Stone, Clay, and Glass Manufacturing",
	76: "General",
	79: "Government and Public Sector – Education",
	78: "Government and Public Sector – Federal, National, and International Governments",
	131: "Government and Public Sector – Health Commissioner",
	132: "Government and Public Sector – Health Provider",
	97: "Government and Public Sector – Local government, including State or other levels below National",
	2: "Health – Academic Medical Centers",
	72: "Health – Government Hospitals",
	74: "Health – Managed Health Care",
	8: "Health – Multi Hospital Systems",
	128: "Health – Non System Hospitals",
	94: "Health – Other Health Care Entities",
	73: "Health – Physician Groups",
	121: "Health – Post Acute Care",
	58: "Health – Specialty Hospitals",
	16: "Hospitality and Leisure – Gaming and Gambling",
	7: "Hospitality and Leisure – Hotels, Motels, and Lodging",
	126: "Hospitality – Restaurants / Eating and Drinking Establishments",
	84: "IFRS",
	55: "Insurance – Health Insurance",
	111: "Insurance – Insurance Agents and Brokers",
	69: "Insurance – Life Insurers",
	96: "Insurance – Other Insurance",
	11: "Insurance – Property and Casualty Insurers",
	117: "Insurance – Reinsurers",
	23: "Life Sciences – Medical Technology",
	48: "Media and Entertainment – Advertising",
	14: "Media and Entertainment – Broadcast, Cable Network, Online Video",
	18: "Media and Entertainment – Cable Provider, Satellite, MVPD",
	86: "Media and Entertainment – Film",
	46: "Media and Entertainment – Integrated Media and Entertainment",
	15: "Media and Entertainment – Music Industry",
	25: "Media and Entertainment – Other Media and Entertainment",
	20: "Media and Entertainment – Publishing",
	30: "Media and Entertainment – Sports",
	28: "Mining – Mining Operations",
	3: "Non-complex SMEs",
	120: "Not for Profit – Foundations and Charitable Trusts",
	107: "Not for Profit – Other Not For Profit Organizations",
	70: "Oil and Gas – Energy Trading",
	22: "Oil and Gas – Exploration and Production",
	67: "Oil and Gas – Refining",
	113: "Other Transportation – Local and Urban Transportation",
	38: "Other Transportation – Other Transportation",
	83: "Other Transportation – Rail Transportation",
	88: "Other Transportation – Road Transport and Warehousing",
	6: "Other Transportation – Water Transportation",
	87: "Pension Funds / Benefit Plans",
	95: "Pharmaceutical – Medical Devices Manufacturing",
	123: "Pharmaceutical – Pharmaceuticals Manufacturing and Wholesale",
	115: "Power and Utilities – Electricity",
	119: "Power and Utilities – Natural Gas",
	110: "Power and Utilities – Other Utilities",
	102: "Power and Utilities – Waste and Water",
	125: "Professional Firms and Services – Business Services",
	34: "Professional Firms and Services – Other Services",
	47: "Professional Firms and Services – Personal Services",
	124: "Professional Firms and Services – Professional Service Firms",
	127: "Professional Firms and Services – Rental and Leasing Services",
	108: "Professional Firms and Services – Travel Services",
	49: "Real Estate – Commercial Real Estate Owners/ Developers",
	56: "Real Estate – Other Real Estate Owners/ Developers",
	62: "Real Estate – Real Estate Investment Trusts",
	122: "Real Estate – Real Estate Investors",
	12: "Real Estate – Real Estate Service Companies",
	91: "Real Estate – Residential Real Estate Owners/ Developers",
	24: "Retail and Wholesale – Department Stores",
	93: "Retail and Wholesale – Internet Retail and Mail Order",
	80: "Retail and Wholesale – Mass Merchandisers / Discount Stores",
	9: "Retail and Wholesale – Other Specialty Retailers",
	77: "Retail and Wholesale – Retail Apparel and Accessory Stores",
	114: "Retail and Wholesale – Supermarkets, Grocery, and Convenience Stores",
	36: "Retail and Wholesale – Wholesale Durable Goods",
	64: "Retail and Wholesale – Wholesale Non– Durable Goods",
	104: "Sustainability",
	63: "Technology – Communication and Networking Equipment",
	52: "Technology – Computers and Electronics",
	138: "Technology – Internet and Social Commerce",
	103: "Technology – IT Services",
	19: "Technology – Other Technology",
	98: "Technology – Semiconductors",
	13: "Technology – Software / SaaS / Apps",
	81: "Telecommunications – Cable Communications Services",
	106: "Telecommunications – Integrated Communications Providers",
	129: "Telecommunications – Internet Service Providers",
	99: "Telecommunications – Mobile Wireless Communications Services",
	50: "Telecommunications – Other Communications",
	44: "Telecommunications – Satellite Communications Services"
};

export const rnhQuickFilterLabel = [
	{
		id: rnhQuickFilter.all,
		label: 'Show all'
	},
	{
		id: rnhQuickFilter.assigned,
		filterType: rnhFilterTypeQuery.assignedTo,
		label: 'Assigned to me'
	},
	{
		id: rnhQuickFilter.authored,
		filterType: rnhFilterTypeQuery.authoredBy,
		label: 'Authored by me'
	}
];

export const relatedItemStatus = [{
	id: 1,
	label: 'Draft'
},
{
	id: 2,
	label: 'No Client Contact'
},
{
	id: 3,
	label: 'Sent'
},
{
	id: 4,
	label: 'System Error'
},
{
	id: 5,
	label: 'Invalid Client Contact'
},
{
	id: 6,
	label: 'Pending Response'
},
{
	id: 7,
	label: 'Received'
},
{
	id: 8,
	label: 'Accepted'
},
{
	id: 9,
	label: 'Returned'
},
{
	id: 10,
	label: 'Withdrawn'
},
{
	id: 11,
	label: 'Send In Progress'
},
{
	id: 12,
	label: 'Accept In Progress'
},
{
	id: 13,
	label: 'Withdraw In Progress'
},
{
	id: 14,
	label: 'Delete In Progress'
},
{
	id: 15,
	label: 'Return In Progress'
},
{
	id: 16,
	label: 'Response In Progress'
},
{
	id: 17,
	label: 'Deleted'
},
{
	id: 18,
	label: 'Invalid Client Contact Returned'
},
{
	id: 19,
	label: 'Recall In Progress'
},
{
	id: 20,
	label: 'Recalled'
},
{
	id: 21,
	label: 'Completion In Progress'
},
{
	id: 22,
	label: 'Recall In Progress'
}
];

export const GroupDocuments = [{
	id: 33,
	label: 'Group instructions sent by the primary team'
},
{
	id: 37,
	label: 'Documents returned from the primary team'
}
];

export const engagementUserStatus = {
	1: 'Active',
	2: 'Pending',
	3: 'Rejected',
	4: 'De-Activated',
	5: 'Request for Archive Access',
	6: 'Reject Archive Access',
	7: 'Copy Engagement - Inactive',
	8: 'Unlinked-Inactive',
	9: 'Template - Inactive',
	10: 'Roll Forward - Inactive',
	11: 'Localized to Isolated Universal',
	12: 'Invitation in Progress',
	13: 'Scheduled - Inactive'
};
export const CGTTaskSendStatus = [{
	id: 1,
	label: 'Not sent'
},
{
	id: 2,
	label: 'Document in transit'
},
{
	id: 3,
	label: 'Draft version sent'
},
{
	id: 4,
	label: 'Returned'
},
{
	id: 5,
	label: 'In review'
},
{
	id: 6,
	label: 'Complete'
},
{
	id: 7,
	label: 'Dismissed'
},
{
	id: 8,
	label: 'Reject in transit'
},
{
	id: 9,
	label: 'Final version sent'
},
{
	id: 999,
	label: 'Send failed'
}
];

export const ServiceRequestStatus = [{
	id: 11,
	cssClass: 'accepted-text',
	statusLabel: 'Accepted'
},
{
	id: 12,
	cssClass: 'pending-text',
	statusLabel: 'Sent'
},
{
	id: 13,
	cssClass: 'rejected-text',
	statusLabel: 'Canceled'
},
{
	id: 14,
	statusLabel: 'Draft'
},
{
	id: 15,
	cssClass: 'completed-text',
	statusLabel: 'Completed'
},
{
	id: 16,
	statusLabel: 'Prior period complete'
},
{
	id: 17,
	statusLabel: 'Submission error'
},
{
	id: 22,
	statusLabel: 'N/A'
},
{
	id: 24,
	statusLabel: 'Action required'
}
];

export const assignmentsSectionLabels = [{
	id: bulkAssignment.assign,
	label: "Assignments"
},
{
	id: bulkAssignment.timephase,
	label: "Time phases"
},
{
	id: bulkAssignment.tag,
	label: "Tags"
}
];

export const assignmentsSectionLabelsNew = [{
	id: bulkAssignment.assign,
	label: "Assignments"
},
{
	id: bulkAssignment.timephase,
	label: "Time phases"
},
];

export const assignmentTypeLabels = [{
	id: assignmentTypes.preparer,
	label: "Preparer"
},
{
	id: assignmentTypes.detailReviewer,
	label: "Detail reviewer"
},
{
	id: assignmentTypes.generalReviewer,
	label: "General reviewer"
},
{
	id: assignmentTypes.partner,
	label: "Partner"
},
{
	id: assignmentTypes.eqr,
	label: "EQR"
},
{
	id: assignmentTypes.other,
	label: "Other"
}
];

export const assignmentActionsLabels = [{
	id: bulkAssignmentConstants.actionIds.add,
	label: "Add"
},
{
	id: bulkAssignmentConstants.actionIds.remove,
	label: "Remove"
},
{
	id: bulkAssignmentConstants.actionIds.replace,
	label: "Replace"
},
{
	id: bulkAssignmentConstants.actionIds.updateDueDays,
	label: "Update days due"
}];

export const tagActionsLabels = [{
	id: bulkAssignmentConstants.actionIds.add,
	label: "Add"
},
{
	id: bulkAssignmentConstants.actionIds.remove,
	label: "Remove"
}];

export const manageAssigmentsActionTypeLabel = [{
	id: actionTypes.edit,
	label: "Edit"
},
{
	id: actionTypes.delete,
	label: "Delete"
}
];

export const confidentialityLevels = {
	[confidentialityTypes.DEFAULT]: 'Default',
	[confidentialityTypes.LOW]: 'Low',
	[confidentialityTypes.MODERATE]: 'Moderate',
	[confidentialityTypes.HIGH]: 'High'
};

export const milestoneTaskLabels = [{
	id: milestoneBuildTaskIds.accounts,
	label: 'Accounts flow tasks'
},
{
	id: milestoneBuildTaskIds.scots,
	label: 'SCOTs flow tasks'
},
{
	id: milestoneBuildTaskIds.itso,
	label: 'IT/SO flow tasks'
},
{
	id: milestoneBuildTaskIds.cra,
	label: 'CRA flow tasks'
},
{
	id: milestoneBuildTaskIds.auditPlan,
	label: 'Audit plan flow tasks'
},
{
	id: milestoneBuildTaskIds.groupStructure,
	label: 'Group structure flow tasks'
},
{
	id: milestoneBuildTaskIds.groupInstructions,
	label: 'Group instructions flow tasks'
},
{
	id: milestoneBuildTaskIds.review,
	label: 'Review flow tasks'
}
];

//Filters for RegionComponentEvidence
export const gaDocFilters = {
	scope: 'Scope',
	teamName: 'Team name',
	groupStructure: 'Group structure',
	region: 'Region',
	component: 'Component'
};

export const filterSourceOfForm = [{
	value: '1',
	label: 'Custom'
},
{
	value: '2',
	label: 'Knowledge'
},
{
	value: '3',
	label: 'Independence'
}
];

export const independenceActions = [{
	id: independenceActionIds.createIndependenceForm,
	label: 'Create independence form'
},
{
	id: independenceActionIds.removeTeamMember,
	label: 'Remove team member'
},
{
	id: independenceActionIds.removeOverride,
	label: 'Remove override'
}
];


export const reviewNoteModalLabels = {
	/*Review Notes*/
	commentThread: 'Note thread',
	singleNoteInstructionalText: 'View and respond to the selected note below.',
	emptyNoteDetailsMessage:
		'Select a note to view details. To enable bulk controls, use the control or shift key and select multiple review notes. If you would like to work on an individual note, then select that note from the list.',
	documentReviewNotesLabel: 'Document notes',
	addNewReviewNoteButtonText: 'New note',
	noNotesAssociatedWithDocumentLabel: 'Leave a note by using the inputs below. Assign the note to a user and specify the priority and due date.',
	noNotesFound: 'No notes found',
	noNotesAssociatedWithTaskLabel: 'There are no {0} notes associated to the task.',
	allNotesLabel: 'All notes',
	charactersLabel: 'characters',
	myNotesLabel: 'My notes',
	showClearedLabel: 'Show cleared',
	showClosedLabel: 'Show closed',
	assignedToLabel: 'Assigned to',

	ofLabel: 'of',
	enterNoteText: 'Enter note',
	addNewNoteModalClose: 'Close',
	addNewNoteModalTitleLabel: 'Add new note',
	editNoteModalTitleLabel: 'Edit note',
	deleteIconHoverText: 'Delete',
	deleteIconModalAcceptText: 'Delete',
	deleteIconModalConfirmMessage: 'Are you sure that you want to delete your reply to this note?',
	deleteIconModalConfirmMessageParent: 'Are you sure that you want to delete the selected note?',
	deleteIconModalTitleLabel: 'Delete note',
	deleteReplyIconModalTitle: 'Delete reply',
	emptyRepliesMessage: 'No replies yet',
	replyInputPlaceholder: 'Reply to this note',
	replyInputPlaceholderEdit: 'Edit reply to review note',
	noteInputPlaceholderEdit: 'Edit review note',
	replyText: 'Reply text',
	editReplyModelTitle: 'Edit reply',
	editReplyPlaceholder: 'Enter reply',
	noteDueDateLabel: 'Due',

	priorityLabel: 'Priority',
	dueDateLabel: 'Due date',
	dueLabel: 'Due',
	status: 'Status',
	noteModifiedDateLabel: 'Modified',
	cancelLabel: 'Cancel',
	saveLabel: 'Save',
	clearedBy: 'Cleared by',
	closedBy: 'Closed by',
	reopenedBy: 'Reopened by',
	reply: 'Reply',
	editIconHoverTextLabel: 'Edit',
	required: 'Required',
	closeTitle: 'Close',
	otherEngagementNotes: 'Other engagement notes',
	closeLabel: 'Close',
	showMore: 'Show more',
	showLess: 'Show less',
	showMoreEllipsis: 'Show more...',
	showLessEllipsis: 'Show less...',
	noResultFound: 'No results found',
	engagementNameLabel: 'Engagement name:',
	taskReviewNotesLabel: 'Task notes',
	fromUserLabel: labels.fromUserLabel,
	toUserLabel: labels.toUserLabel,
};

//Copyhub create package
export const createPackageLabels = {
	packageType: 'Package type',
	categories: 'Categories',
	itemsToCopy: 'Items to copy',
	createPackage: 'Create package',
	selectPackageType: 'Select package type',
	selectPackageTypeTitle: 'Select package type',
	selectCategoriesTitle: 'Select categories',
	selectEntitiesTitle: 'Select entities',
	relateCanvasFormsTitle: 'Relate documents',
	relateAnObjectTitle: 'Relate an object',
	step1InstructionalText: 'Select package type, name it and select recipient. Ensure compliance with all applicable laws, regulations and EY policies regarding data privacy, transfer of data between jurisdictions and protection of confidential information before creating or sending a Copy Package.',
	packageTypes: [{
		value: 21,
		text: 'Engagement'
	}, {
		value: 20,
		text: 'Evidence'
	}, {
		value: 24,
		text: 'Roll forward from existing'
	}, {
		value: 22,
		text: 'Accounts'
	}, {
		value: 23,
		text: 'SCOTs'
	}, {
		value: 26,
		text: 'Bulk export'
	}, {
		value: 25,
		text: 'Template'
	}, {
		value: 27,
		text: 'External documents'
	}, {
		value: 28,
		text: 'Guided workflows'
	}, {
		value: 29,
		text: 'Engagement by entity'
	}],

	packageName: 'Package name',
	packageDetailsText: 'Package details',
	required: 'Required',
	sendTo: 'Send to',
	nameOrEmail: "Name or email",
	sendToName: 'Name',
	sendToEmail: 'Email',
	clearAllValues: 'Clear all values',
	engagementIdErrorMessage: 'The engagement id is not specified.',
	emptyCategoriesStep2Text: '...',
	insufficientPermissionsMessage: 'Insufficient permissions to create copy package. Contact your engagement administrator and request permission to create copy package.',
	CopyHubCanvasFormTooltip: 'For EY Canvas forms only',
	CopyEngagementInProgress: 'Only one Engagement copy can be processed at a time.',

	//Step 3 labels
	step3Header: 'Select {0} to copy',
	selectAllText: 'Select all',
	delectAllText: 'Deselect all',
	documentsSelectedText: 'documents selected',
	scotsSelectedText: 'SCOTs selected',
	accountsSelectedText: 'Accounts selected',
	entitiesSelectedText: 'entities selected',
	step3InstructionText: 'Ensure compliance with all applicable laws, regulations and EY policies regarding data privacy, transfer of data between jurisdictions and protection of confidential information before creating or sending a Data Package.',
	step3InstructionTextEvidence: 'Ensure compliance with all applicable laws, regulations and EY policies regarding data privacy, transfer of data between jurisdictions and protection of confidential information before sending engagement data.',
	step3InstructionTextWarning: 'EY Canvas Forms will not include related objects (e.g. SCOTs, Controls).',
	step3InstructionTextWarningFIT: 'The copy of Guided workflows can include Relevant Events and Conditions identified and their related descriptions. They will not include other related objects (e.g. Accounts, Risks).',
	availableCanvasFormsColumnName: 'Available documents',
	availableFITDocuments: 'Available guided workflows',
	availableAccountsColumnName: 'Available accounts',
	availableSCOTsColumnName: 'Available SCOTs',
	availableExternalDocumentsColumnName: 'Available external documents',
	step3NoItemeSelectedError: 'Select at least one item to proceed',
	searchPackagePlaceholder: 'Search',
	searchPackageClearHoverText: 'Clear',

	//step2:
	step2Header: 'Select categories for {0} package',
	step2AccountsHdr: 'Select categories to include in copy package. The core package includes all related assertions, PSPs and OSPs.',
	step2scotshdr: 'Select categories to include in copy package. The core package includes all related WCGWs, Controls and tasks',
	step2canformhdr: 'Select categories to include in copy package',
	step2InstructionTextEngagementByEntity: 'Select entities to include in copy package',
	availableEntitiesColumnName: 'Available entities',
	step2HeaderEntities: 'Select {0} for engagement package',
	entitiesLabel: 'entities',

	scots: 'SCOTs',
	itso: 'IT application/ SO structure',
	evidence: 'Evidence',
	realtedevidence: 'Related Evidence',
	signoffs: 'Sign-Offs',
	tempfiles: 'Temporary Files',
	priorperiodevidence: 'Prior Period Evidence',
	recentlydeletedfiles: 'Recently Deleted Files',
	historyfiles: 'History Files',
	extgrp: 'External Groups and External Team members',
	eydocument: 'EY Documents',
	extdoc: 'External Documents',
	totalfilesize: 'The total file size of all selections is ',
	requestandexernaltasks: 'Requests and External Tasks',
	rollForwardFromExisting: 'Roll forward from existing',
	template: 'Template',
	bulkExport: 'Bulk export',

	fileSizeWaring: 'The selected categories include files that {0}. EY Canvas does not support copy packages exceeding this limit.',
	fileSizeWarningline2: 'Consider removing document categories to reduce overall file size of the copy package.',
	coloredExceedLable: 'exceed {0} GB',
	step2EngHdr: "Select categories to include in copy package. The base package includes engagement profile, all knowledge documents, Primary Standard tasks, Other standard tasks, time phases; accounts/ disclosures, assertions and their related tasks; SCOTs, WCGWs, Controls and their related tasks; IT applications/ Service Organizations, Risks, ITGCs/ ITSPs and related tasks; Maps. If Group Audit engagement, package will include also group audit data.",
	step2EngByEntityHdr: "Select categories to include in copy package. The base package includes engagement and selected entity profile, knowledge documents, Primary Standard tasks, Other standard tasks, time phases; accounts/ disclosures, assertions and their related tasks; SCOTs, WCGWs, Controls and their related tasks; IT applications/ Service Organizations, Risks, ITGCs/ ITSPs and related tasks; Maps. If Group Audit engagement, package will include also group audit data.",
	step2BulkExpHdr: 'Select document categories to be exported.',
	gb: "GB",
	step2And: "and",
	step2Files: "document(s)",
	lessThanMinGB: "less than 0.01 GB",
	CategoryFileSizeCount: ': {0} GB and {0} document(s)',

	cancelLabel: "Cancel",
	showSelected: "Show selected",
	showSelectedDocuments: "Show {0} selected document(s)",
	showSelectedEntities: "Show {0} selected entity/entities",
	showSelectedGuidedWorflows: "Show {0} selected guided workflow(s)",
	showSelectedAccounts: "Show {0} selected account(s)",
	showSelectedSCOTs: "Show {0} selected SCOT(s)",
	noDataFoundLabel: "No data found",
	copyPackageSuccessMessage: '{0} data export has been initiated.',
	copyPackageWarningLabel: 'Warning : The package could not be sent to below members due to invalid information :- {0}',
	noResultFound: "No results found",
	canvasForms: "EY Canvas Forms",
	canvasFormsInformationText: "EY Canvas Forms can be exported only as Evidence and/or Temporary Files.<br/>Please select one of these options to enable EY Canvas Forms download.",
	coEditSelectAllWarningMessage: 'Some documents are currently in active multi-user edit mode and cannot be included in the copy package',
	coEditDocumentTooltip: 'Document is in active multi-user edit mode and cannot be copied. Please check-in the document to copy it as a part of this package',
	coEditCopyWarningMessage: '{0} documents are in active multi-user edit mode within the {1} category/categories. Please check-in all documents within each category in order to include them as a part of this package'
};

export const documentTypes = [
	{ id: 1, label: "Evidence" },
	{ id: 2, label: "Temporary" },
	{ id: 3, label: "Prior Year Evidence" },
	{ id: 4, label: "Client Files" },
	{ id: 5, label: "Snapshot" },
	{ id: 6, label: "Smartform" },
	{ id: 29, label: "Paper Profile" },
	{ id: 47, label: "Bulk Document Export" },
	{ id: 48, label: "Canvas Form" },
	{ id: 51, label: "Automation Hub" },
	{ id: 59, label: "Packages" },
	{ id: 72, label: "Smart Working Paper" }
];

export const activityTypes = [{
	id: activityType.primaryLinkAccept,
	label: 'Link request accepted by {0}'
},
{
	id: activityType.primaryLinkReject,
	label: 'Link request rejected by {0}'
},
{
	id: activityType.primaryUnlink,
	label: 'Engagement unlinked from the group by {0}'
},
{
	id: activityType.primaryComponentUnlink,
	label: 'Engagement unlinked from the group by {0}'
},
{
	id: activityType.componentPrimaryUnlink,
	label: 'Engagement unlinked from the group by {0}'
},
{
	id: activityType.primarySendLink,
	label: 'Link request sent by {0} to {1}'
},
{
	id: activityType.documentsReceived,
	label: 'Documents received by {0}'
},
{
	id: activityType.primarySendInstruction,
	label: 'Instructions sent from {0} to {1}'
},
{
	id: activityType.primaryRejectInstruction,
	label: 'Instructions returned by {0}'
},
{
	id: activityType.primaryAcceptInstruction,
	label: 'Instructions accepted by {0}'
},
{
	id: activityType.componentReceivedInstruction,
	label: 'Instructions received'
},
{
	id: activityType.componentAcceptInstruction,
	label: 'Instructions accepted by {0}'
},
{
	id: activityType.componentRejectInstruction,
	label: 'Instructions returned by {0}'
},
{
	id: activityType.componentAcceptUpdatetInstruction,
	label: 'Instructions accepted by {0}'
},
{
	id: activityType.componentRejectUpdateInstruction,
	label: 'Instructions returned by {0}'
},
{
	id: activityType.primaryEvidenceReceived,
	label: 'Version received by {0}'
},
{
	id: activityType.documentVersionConflictResolved,
	label: 'Conflict resolved by {0}'
},
{
	id: activityType.documentOverwrite,
	label: 'Document contents overwritten by {0}'
},

{
	id: activityType.primaryAssignComponent,
	label: 'Document assigned to {0}'
},
{
	id: activityType.componentUnassigned,
	label: 'Document unassigned from {0}'
},
{
	id: activityType.clearDocumentReturnedtoComponent,
	label: 'Version finalized by {0}'
},
{
	id: activityType.componentClearReturnedDocument,
	label: 'Version resolved by {0}'
},
{
	id: activityType.primaryReturnEvidence,
	label: 'Version returned by {0}'
},
{
	id: activityType.componentEvidenceSent,
	label: 'Version sent by {0}'
},
{
	id: activityType.componentReturnEvidence,
	label: 'Version returned by {0}'
},
{
	id: activityType.createReviewNote,
	label: 'Note opened by {0}'
},
{
	id: activityType.openReviewNote,
	label: 'Note opened by {0}'
},
{
	id: activityType.clearReviewNote,
	label: 'Note cleared by {0}'
},
{
	id: activityType.closeReviewNote,
	label: 'Note closed by {0}'
},
{
	id: activityType.reviewerSignOff,
	label: 'Signed off by {0}'
},
{
	id: activityType.preparerSignOff,
	label: 'Signed off by {0}'
},
{
	id: activityType.canvasSendClientRequest,
	label: labels.sent
},
{
	id: activityType.clientRespondToClientRequest,
	label: 'Responded'
},
{
	id: activityType.canvasRejectClientRequest,
	label: labels.rejected
},
{
	id: activityType.canvasWithdrawClientRequest,
	label: labels.WithdrawLabel
},
{
	id: activityType.canvasDeleteClientRequest,
	label: 'Deleted'
},
{
	id: activityType.canvasAcceptClientRequest,
	label: labels.accepted
},
{
	id: activityType.CEARecallClientRequest,
	label: 'Recalled'
},
{
	id: activityType.canvasCompleteClientRequest,
	label: labels.completed
}
];


export const gaLinkStatus = [{
	id: GALinkStatus.Undefined,
	label: 'Undefined'
},
{
	id: GALinkStatus.NoPointOfContact,
	label: 'No point of contact'
},
{
	id: GALinkStatus.Pending,
	label: 'Pending'
},
{
	id: GALinkStatus.Accepted,
	label: 'Accepted'
},
{
	id: GALinkStatus.Rejected,
	label: 'Rejected'
},
{
	id: GALinkStatus.Expired,
	label: 'Expired'
},
{
	id: GALinkStatus.Unlinked,
	label: 'Unlinked'
},
{
	id: GALinkStatus.Delegated,
	label: 'Delegated'
},
{
	id: GALinkStatus.SystemError,
	label: 'System error'
},
{
	id: GALinkStatus.Sent,
	label: 'Sent'
},
{
	id: GALinkStatus.InvalidPointOfContact,
	label: 'Invalid point of contact'
},
{
	id: GALinkStatus.ComponentNotUsingCanvas,
	label: 'Component not using Canvas'
}
];

export const gaInstructionStatus = [{
	id: 0,
	label: labels.notApplicable
},
{
	id: instructionStatus.notSent,
	label: 'Not sent'
},
{
	id: instructionStatus.pending,
	label: 'Pending'
},
{
	id: instructionStatus.accepted,
	label: 'Accepted'
},
{
	id: instructionStatus.rejected,
	label: 'Returned'
},
{
	id: instructionStatus.systemError,
	label: 'System error'
},
{
	id: instructionStatus.expired,
	label: 'Expired'
},
{
	id: instructionStatus.sent,
	label: 'Sent'
},
{
	id: instructionStatus.unlinked,
	label: 'Unlinked'
},
{
	id: instructionStatus.queued,
	label: 'Queued'
}
];

export const gsSnapshotComparisonStatus = [
	{ id: snapshotComparisonIds.noChange, value: null },
	{ id: snapshotComparisonIds.new, value: 'New' },
	{ id: snapshotComparisonIds.added, value: 'Added' },
	{ id: snapshotComparisonIds.modified, value: 'Modified' },
	{ id: snapshotComparisonIds.updated, value: 'Updated' },
	{ id: snapshotComparisonIds.removed, value: 'Removed' },
	{ id: snapshotComparisonIds.itemsRemoved, value: 'Items removed' },
]

export const gaRoleType = [{
	id: GARoleTypeId.Primary,
	label: 'Primary'
},
{
	id: GARoleTypeId.Region,
	label: 'Region'
},
{
	id: GARoleTypeId.Component,
	label: 'Component'
}
];

export const linkRequestTypes = [{
	id: linkType.sent,
	label: 'Sent'
},
{
	id: linkType.unlinked,
	label: 'Unlinked'
},
{
	id: linkType.accepted,
	label: 'Accepted'
}
];

export const instructionTypes = [{
	id: instructionType.sent,
	label: 'Sent'
},
{
	id: instructionType.rejected,
	label: 'Returned'
},
{
	id: instructionType.received,
	label: 'Received'
},
{
	id: instructionType.accepted,
	label: 'Accepted'
}
];

export const syncStatusLabels = [
	{
		id: syncStatus.notSynchronized,
		label: 'Not Synchronized'
	},
	{
		id: syncStatus.syncInTransit,
		label: 'Sync in transit'
	},
	{
		id: syncStatus.syncInProcess,
		label: 'Sync in process'
	},
	{
		id: syncStatus.synchronized,
		label: 'Synced'
	},
	{
		id: syncStatus.deleteInTransit,
		label: 'Delete in transit'
	},
	{
		id: syncStatus.deleteInProcess,
		label: 'Delete in process'
	},
	{
		id: syncStatus.deleted,
		label: 'Deleted'
	},
	{
		id: syncStatus.noHostEngagement,
		label: 'No host engagement'
	},
	{
		id: syncStatus.syncError,
		label: 'Sync error'
	}
];

export const colorOptionsLabels = {
	Red: 'Red',
	Orange: 'Orange',
	Teal: 'Teal',
	Blue: 'Blue',
	Purple: 'Purple',
	Green: 'Green',
	Yellow: 'Yellow',
	Gray: 'Gray'
};

export const todoListTimeFrameLabels = [
	{ id: todoListTimeframeOptions.byDay, label: "By day" },
	{ id: todoListTimeframeOptions.byWeek, label: "By week" },
	{ id: todoListTimeframeOptions.byMonth, label: "By month" },
	{ id: todoListTimeframeOptions.all, label: "All" },
	{ id: todoListTimeframeOptions.overdue, label: "Overdue" }
];

export const clientRequestsStatusFilter = [
	{
		value: 'Draft',
		label: 'Draft'
	},
	{
		value: 'Pending',
		label: 'Pending response'
	},
	{
		value: 'Received',
		label: 'Received'
	},
	{
		value: 'Accepted',
		label: 'Accepted'
	}
];

export const clientRequestsTypeFilter = [
	{
		value: 'Required',
		label: 'Sign-off required'
	},
	{
		value: 'NotRequired',
		label: 'Sign-off not required'
	}
];

export const clientRequestsPriorityFilter = [
	{
		value: 'Normal',
		label: 'Normal'
	},
	{
		value: 'High',
		label: 'High'
	},
	{
		value: 'Critical',
		label: 'Critical'
	}
];

export const clientRequestsAttachmentsFilter = [
	{
		value: 'Analytics',
		label: 'Analytics'
	},
	{
		value: 'ExternalAttachments',
		label: 'External attachments'
	},
	{
		value: 'EyAttachments',
		label: 'EY attachments'
	},
	{
		value: 'None',
		label: 'None'
	}
];

export const clientRequestsCreatedByFilter = [
	{
		value: 'Client',
		label: 'Client'
	},
	{
		value: 'EY',
		label: 'EY'
	}
];

export const filterTimePhase = [
	{
		value: -1,
		label: 'No Time Phase'
	}
];

export const clientRequestsBooleanFilters = [
	{
		value: 1,
		label: 'Yes'
	},
	{
		value: 0,
		label: 'No'
	}
]

export const bulkClientRequestsNoRelatedTaskFilter = [
	{
		value: false,
		label: 'Yes'
	},
	{
		value: true,
		label: 'No'
	}
]

export const controlsTestingFilters = [
	{ value: 'true', label: 'Yes' },
	{ value: 'false', label: 'No' },
	{ value: 'null', label: 'Not selected' }
];

export const controlsDesignEffectivenessFilters = [
	{ value: '1', label: 'Effective' },
	{ value: '2', label: 'Ineffective' },
	{ value: '0', label: 'Not selected' }
];

export const clientRequestAnnotationTabs = [
	{ id: clientRequestNoteTab.comments, label: 'Comments' },
	{ id: clientRequestNoteTab.history, label: 'History' }
];

export const riskTypeOptions = [
	{ id: 1, name: 'Significant risks' },
	{ id: 2, name: 'Fraud risks' },
	{ id: 3, name: 'Risks of material misstatement' }
];

export const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export const longDays = ['Sundays', 'Mondays', 'Tuesdays', 'Wednesdays', 'Thursdays', 'Fridays', 'Saturdays'];
export const shortDays = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

// GA Scopes
export const gaScopesResource = [
	{ id: gaScopes.full, label: 'Full' },
	{ id: gaScopes.specific, label: 'Specific' },
	{ id: gaScopes.specificAuditProcedures, label: 'Specified audit procedures' },
	{ id: gaScopes.review, label: 'Review' },
]

// GA Instructions
export const gaRecommendationTypeResource = [
	{ id: gaRecommendationType.required, label: 'Required' },
	{ id: gaRecommendationType.optional, label: 'Optional' },
	{ id: gaRecommendationType.notApplicable, label: 'Not applicable' },
]

// GS Group Summary
export const gsTabsResource = [
	{ id: groupSummaryTabs.assignedTeams, label: 'Assigned teams' },
	{ id: groupSummaryTabs.instructions, label: 'Instructions' },
	{ id: groupSummaryTabs.tasks, label: 'Tasks' },
]

export const receiveInstructionsTypeResource = {
	true: {
		title: 'New',
		instructional: 'a new'
	},
	false: {
		title: 'Updated',
		instructional: 'an updated'
	}
}

export const clientRequestSystemGeneratedMessages = {
	sent: "Request sent to ",
	accepted: "Request accepted",
	received: "Request received",
	returned: "Request returned",
	withdrawn: "Request withdrawn",
	complete: "Request was completed by EY",
	recalled: "Request recalled",
	notification_submit: "Request submitted to automation",
	notification_success: "Request submitted successfully to automation",
	notification_error: "An error occurred submitting to automation.  Click 'Submit to automation' to try again.",
	restore_document: "Document restored - ",
	delete_document: "Document deleted - ",
	assignedto: "Item reassigned to",
	editrequest: "Request edited",
	prioritychange: "Request priority updated to"
};

export const externalTaskSystemGeneratedMessages = {
	sent: "External Task sent to ",
	accepted: "External Task accepted",
	received: "Response received",
	returned: "External Task returned",
	withdrawn: "External Task withdrawn",
	complete: "External Task was completed from EY Canvas",
	recalled: "External Task recalled",
	restore_document: "Document restored - ",
	delete_document: "Document deleted - ",
	assignedto: "Item reassigned to",
	editrequest: "External Task edited",
	prioritychange: "Extrernal Task priority updated to"
};

export const ipInputLabels = [
	{ id: ipInputType.ipAddress, label: 'IP address' },
	{ id: ipInputType.ipRange, label: 'IP range' },
	{ id: ipInputType.cidrBlock, label: 'CIDR block' }
];

export const ipFilterTypeLabels = {
	[ipFilterType.ipAddress]: "IP Address",
	[ipFilterType.ipRange]: "IP Range",
	[ipFilterType.cidrBlock]: "CIDR Block"
};

export const gaLinkStatusObj = {
	[GALinkStatus.Undefined]: 'Undefined',
	[GALinkStatus.NoPointOfContact]: 'No point of contact',
	[GALinkStatus.NotSent]: 'Not sent',
	[GALinkStatus.Pending]: 'Link request pending',
	[GALinkStatus.Accepted]: 'Link request accepted',
	[GALinkStatus.Rejected]: 'Rejected',
	[GALinkStatus.Expired]: 'Expired',
	[GALinkStatus.Unlinked]: 'Unlinked',
	[GALinkStatus.Delegated]: 'Delegated',
	[GALinkStatus.SystemError]: 'System error',
	[GALinkStatus.Sent]: 'Sent',
	[GALinkStatus.InvalidPointOfContact]: 'Invalid point of contact',
	[GALinkStatus.ComponentNotUsingCanvas]: 'Not using EY Canvas',
	[GALinkStatus.ComponentReferenceOnly]: 'Reference only'
};

export const epTasksObj = [{
	value: '3',
	label: 'No documents signed-off'
},
{
	value: '2',
	label: 'Some documents signed-off'
},
{
	value: '1',
	label: 'All documents signed-off'
}
];



export const eqrTasksObj = [{
	value: '6',
	label: 'No documents signed-off'
},
{
	value: '5',
	label: 'Some documents signed-off'
},
{
	value: '4',
	label: 'All documents signed-off'
}
];

export const groupsFilterEntity = [
	{ id: 1, label: 'Tasks' },
	{ id: 2, label: 'Documents' }
];

export const scopesFilterEntity = [
	{ id: 1, label: 'Full' },
	{ id: 2, label: 'Specific' },
	{ id: 3, label: 'Specified audit procedures' },
	{ id: 4, label: 'Review' },
];

export const notesFilterLabels = [
	{ id: notesFilter.allNotes, label: 'All notes' },
	{ id: notesFilter.myNotes, label: 'My notes' },
	{ id: notesFilter.authoredByMeNotes, label: 'Assigned to me' }
];

//Client Request Advanvce Search
export const advancedSearchValues = [
	{
		id: 1,
		value: labels.advancedSearchTitleCheck
	},
	{
		id: 2,
		value: labels.advancedSearchRefereceNumberCheck
	},
	{
		id: 3,
		value: labels.advancedSearchDocumentsCheck
	},
	{
		id: 4,
		value: labels.advancedSearchCommentsCheck
	}
];


export const TaskTypeLabels = [{
	id: TaskListTypes.ScopeAndStrategy,
	label: taskNavigation[TaskListTypes.ScopeAndStrategy]
},
{
	id: TaskListTypes.SCOTs,
	label: taskNavigation[TaskListTypes.SCOTs]
},
{
	id: TaskListTypes.ITSOs,
	label: taskNavigation[TaskListTypes.ITSOs]
},
{
	id: TaskListTypes.Accounts,
	label: taskNavigation[TaskListTypes.Accounts]
},
{
	id: TaskListTypes.GeneralExecution,
	label: taskNavigation[TaskListTypes.GeneralExecution]
},
{
	id: TaskListTypes.Conclusion,
	label: taskNavigation[TaskListTypes.Conclusion]
}
];

export const TaskCategoryLabels = [
	{
		id: TaskListTypes.ScopeAndStrategy,
		label: taskNavigation[TaskListTypes.ScopeAndStrategy],
		displayOrder: 1
	},
	{
		id: TaskListTypes.Risks,
		label: taskNavigation[TaskListTypes.Risks],
		displayOrder: 2
	},
	{
		id: TaskListTypes.SCOTs,
		label: taskNavigation[TaskListTypes.SCOTs],
		displayOrder: 3
	},
	{
		id: TaskListTypes.ITSOs,
		label: taskNavigation[TaskListTypes.ITSOs],
		displayOrder: 4
	},
	{
		id: TaskListTypes.Accounts,
		label: taskNavigation[TaskListTypes.Accounts],
		displayOrder: 5
	},
	{
		id: TaskListTypes.GeneralExecution,
		label: taskNavigation[TaskListTypes.GeneralExecution],
		displayOrder: 6
	},
	{
		id: TaskListTypes.Conclusion,
		label: taskNavigation[TaskListTypes.Conclusion],
		displayOrder: 7
	},
];

export const kendoLabels = {
	alignLeft: 'Justify left',
	alignRight: 'Justify right',
	alignCenter: 'Justify center',
	alignFull: 'Justify full',
	addComment: 'Add comment',
	addColumnBefore: 'Add column left',
	addColumnAfter: 'Add column right',
	addRowAbove: 'Add row above',
	addRowBelow: 'Add row below',
	bulletList: 'Insert unordered list',
	bold: 'Bold',
	backColor: 'Highlight',
	createLink: 'Insert Hyperlink',
	createTable: 'Create table',
	cleanFormatting: 'Clean formatting',
	deleteRow: 'Delete row',
	deleteColumn: 'Delete column',
	deleteTable: 'Delete table',
	fontSizeInherit: "Font size",
	foreColor: 'Color',
	format: 'Format',
	fontSize: 'Font size',
	hyperlink: 'Insert web link',
	italic: 'Italic',
	indent: 'Indent',
	insertTableHint: "Create a {0} by {1} table",
	'hyperlink-dialog-content-address': "Web Address",
	"hyperlink-dialog-title": "Insert hyperlink",
	"hyperlink-dialog-content-title": "Title",
	"hyperlink-dialog-content-newwindow": "Open link in new window",
	"hyperlink-dialog-cancel": "Cancel",
	"hyperlink-dialog-insert": "Insert",
	outdent: 'Outdent',
	orderedList: 'Insert ordered list',
	print: 'Print',
	pdf: 'export to pdf',
	redo: 'redo',
	strikethrough: 'Strikethrough',
	subscript: 'Subscript',
	superscript: 'Superscript',
	underline: 'Underline',
	undo: 'Undo'
};

export const kendoFormatOptions = [
	{ text: 'Paragraph', value: "p" },
	{ text: 'Heading 1', value: "h1" },
	{ text: 'Heading 2', value: "h2" },
	{ text: 'Heading 3', value: "h3" },
	{ text: 'Heading 4', value: "h4" },
	{ text: 'Heading 5', value: "h5" },
	{ text: 'Heading 6', value: "h6" }
];

export const kendoFontSize = [
	{ text: '8', value: '8px' },
	{ text: '9', value: '9px' },
	{ text: '10', value: '10px' },
	{ text: '11', value: '11px' },
	{ text: '12', value: '12px' },
	{ text: '14', value: '14px' },
	{ text: '16', value: '16px' },
	{ text: '18', value: '18px' },
	{ text: '20', value: '20px' },
	{ text: '22', value: '22px' },
	{ text: '24', value: '24px' },
	{ text: '26', value: '26px' },
	{ text: '28', value: '28px' },
	{ text: '36', value: '36px' },
	{ text: '48', value: '48px' },
	{ text: '72', value: '72px' }
];

export const monthsList = [
	"January",
	"February",
	"March",
	"April",
	"May",
	"June",
	"July",
	"August",
	"September",
	"October",
	"November",
	"December"
];
export const pspContentStatus = {
	1: "Update required",
	2: "Update in progress",
	3: "Update complete",
	4: "Update error"
}

export const handOffLabels = {
	handoff: "Hand-off",
	handOffTitleTip: 'Hand-off for review',
	markCompleteTitleTip: 'Mark complete',
	handoffModalTitle: 'Hand-off to the next team member',
	handoffConfirmButtonText: 'Hand-off',
	return: 'Return',
	handModalDescription: 'To sign-off on an evidence file, select from the options below.',
	markCompleteTextLine1: 'Hand-off this task to the next team member.',
	markCompleteTextLine2: 'To sign-off on an evidence file, select from the options below. If you have an assignment for this task and have completed it, select <b>Yes</b> to close it. If this task requires PIC or EQR sign-off, select from the options below.',
	closeLabel: 'Close',
	handoffto: 'Hand-off to',
	missingToUserError: 'Required',
	markCompleteConfirm: 'Mark complete',
	markCompleteModalHeaderTextPart1: 'This task will be marked complete.',
	markCompleteModalHeaderTextPart2: 'To sign-off on an evidence file, select from the options below. If you have an assignment for this task and have completed it, select <b>Yes</b> to close it. If this task requires PIC or EQR sign-off, select from the options below.',
	signOffOnAllAs: 'Sign-off on all as',
	preparer: 'Preparer',
	reviewer: 'Reviewer',
	none: 'None',
	noSignOffsByMe: 'No sign-offs by me',
	myPreparerSignOffs: 'My preparer sign-offs',
	myReviewerSignOffs: 'My reviewer sign-offs',
	myPreparerAndReviewerSignOffs: 'My preparer and reviewer sign-offs',
	preparerTitle: 'Preparer sign-offs',
	reviewerTitle: 'Reviewer sign-offs',
	autoAssignmentMessage: 'This team member does not have an assignment. {0} ​assignment with a due date of {1} will be created. To edit this assignment {2}.', // {0}=>assignment name , {1}=>Date, {2}=>"click here",
	clickHere: 'click here',
	noTaskEvidencesHandoffModal: 'There are no evidence files associated to this task.',
	// Create Assignment
	createAssignment: 'Create assignment',
	create: 'Create',
	cancelLabel: 'Cancel',
	createassignmentheader1: 'The selected team member does not have an assignment for this task.',
	createassignmentheader2: 'Create an assignment here.',
	dueDate: 'Due date',
	teamMemberAssigmentLabel: 'Team member',
	daysPriorToEndDate: 'Days prior to end date',
	// Add Assignment
	addAssignmentTitle: "Add assignment name",
	confirmButtonLabel: 'Add',
	cancelButtonLabel: 'Cancel',
	assignmentTypeInstructionalText: "Select an assignment type and enter a name below. Click <b>Add</b> when you are done.",
	assignmentType: "Assignment type",
	required: 'Required',
	clearHoverText: 'Clear',
	unmarkcomplete: 'Unmark complete',
	markCompleteErrorMessage: 'Task cannot be marked complete. Refresh the page and try again. If the issue persists contact the Help Desk.',
	// Assignment Dropdown
	noResultFound: 'No results found',
	addTaskGroupLabel: 'Add task group',
	addAssignmentName: "Add assignment name",
	assignmentName: 'Assignment name',
	additionalSignOff: 'Additional required sign-offs',
	signoffRequirementsModalPICLabel: 'PIC',
	signoffRequirementsModalEQRLabel: 'EQR',
	closeMyAssignment: 'Close my assignment',
	filterYes: 'Yes',
	filterNo: 'No',
	assignmentTypeLabels: [{
		id: assignmentTypes.preparer,
		label: "Preparer"
	},
	{
		id: assignmentTypes.detailReviewer,
		label: "Detail reviewer"
	},
	{
		id: assignmentTypes.generalReviewer,
		label: "General reviewer"
	},
	{
		id: assignmentTypes.partner,
		label: "Partner"
	},
	{
		id: assignmentTypes.eqr,
		label: "EQR"
	},
	{
		id: assignmentTypes.other,
		label: "Other"
	}
	]
};

export const displayedOn = {
	"Account": "Account",
	"SCOT": "Scot",
	"IT/SO": "IT/SO",
	"Scope & Strategy": "Scope & Strategy",
	"Execution": "Execution",
	"Conclusion": "Conclusion"
}

export const auditPlanReportLabels = {
	adc: 'Related object',
	secondaryObject: 'Secondary related object',
	taskTypeColumn: 'Task type',
	taskNamePrefix: "Task prefix",
	taskName: 'Task title',
	taskNameSuffix: "Task suffix",
	taskDescription: 'Task description',
	auditTaskStatus: 'Task status',
	rationaleForRejection: 'Rationale for rejection',
	knowledgeTaskTitle: 'Knowledge task title',
	knowledgeTaskDescription: 'Knowledge task description',
	assignedTo: 'Assigned to',
	engagementTagGroupName: 'Tag group',
	engagementTagName: 'Tags',
	prioritized: 'Prioritized',
	viewDisplayedOn: 'View displayed on',
	engagementPhase: 'Engagement phase',
	milestone: 'Milestone',
	periodName: 'Time phase',
	riskTypeAbbr: 'Related risk type',
	riskName: 'Related risk name',
	relatedMESTEntityName: 'Related MEST entities',
	scheduledNextWaveservices: 'Centralized services',
	taskID: 'Task ID',
	timephaseID: 'Timephase ID',
	taskTypeID: 'Task type ID',
	timephaseTypeID: 'Timephase type ID'
}

export const reportingTaskAll = {
	taskType: labels.taskType,
	taskStatus: labels.taskStatusLabel,
	taskAssignedTo: labels.taskassignedto,
	taskNamePrefix: labels.taskPrefix,
	task_Name: labels.repTaskTitle,
	taskNameSuffix: labels.taskSuffix,
	taskDescription: labels.repTaskDescription,
	knowledge_Task_Title: 'Knowledge task title',
	knowledge_Task_Description: 'Knowledge task description',
	rejected: labels.rejected,
	rationale_for_Rejection: 'Rationale for rejection',
	audit_Phase: labels.auditPhasesLabel,
	milestonename: labels.filterMilestoneLabel,
	periodName: labels.timephase,
	timephasestartdateinutc: 'Time phase start date (in UTC)',
	timephaseduedateinutc: 'Time phase due date (in UTC)',
	taskSourceType: labels.repTaskSource,
	taskNatureType: labels.repTaskNature,
	lastTaskChangeDateInUTC: 'Last task status change date (in UTC)',
	engagementTagGroupName: labels.manageTagGroupName,
	engagementTagName: labels.tagsLabel,
	mesT_Entity_Name: 'Related MEST entities',
	multiEntityType: 'Multi entity type',
	taskID: 'Task ID',
	taskTypeID: 'Task type ID',
	taskStatusID: 'Task status ID',
	auditPhaseID: 'Audit phase ID',
	timephaseTypeID: 'Milestone ID',
	taskSourceTypeID: 'Task source ID',
	taskNatureTypeID: 'Task nature ID',
	cgTaskID: 'KnowledgeTaskID',
	knowledgeContentID: 'KnowledgeContentID',
}

export const reportTaskAssignments = {
	taskNamePrefix: labels.taskPrefix,
	taskName: labels.repTaskTitle,
	taskNameSuffix: labels.taskSuffix,
	taskDescription: labels.repTaskDescription,
	taskTypeName: labels.taskType,
	taskSourceType: labels.repTaskSource,
	taskNatureType: labels.repTaskNature,
	auditPhaseName: labels.engagementPhase,
	milestones: labels.filterMilestoneLabel,
	periodName: labels.timephase,
	PICSignoffRequired: 'PIC signoff required',
	EQRSignoffRequired: 'EQR signoff required',
	taskStatusName: labels.taskStatusLabel,
	taskDueDateInUTC: 'Task due date (in UTC)',
	engagementTagGroupName: labels.manageTagGroupName,
	engagementTagName: labels.tagsLabel,
	completedAssignment: labels.completedAssignments,
	totalAssignment: 'Total assignments',
	closedTaskAssignmentPercent: 'Closed task assignment %',
	assignmentOrder: 'Assignment order',
	firstNameVal: 'Task assignment team member first name',
	lastNameVal: 'Task assignment team member last name',
	assignmentName: labels.assignmentName,
	assignmentTypeName: labels.filterAssignmentTypeLabel,
	roleName: 'Engagement user role',
	assignmentStatusVal: 'Task assignment status',
	dueDays: 'Due days',
	completedDateInUTC: 'Completed date (in UTC)',
	assignmentDueDateInUTC: `Assignment due date (in UTC)`,
	daysCompleteBeforeDueDate: 'Days remaining before task assignment due date',
	daysCompleteAfterDueDate: 'Days overdue after task assignment due date',
	closedEarlyOrLate: 'Closed early / late',
	closedDaysEarly: 'Closed days early',
	closedDaysLate: 'Closed days late',
	oldTaskName: 'Legacy task title',
	oldTaskDetail: 'Legacy task description',
	taskID: 'Task ID',
	assignmentID: 'Assignment ID',
	roleID: 'Role ID',
	userID: 'User ID'
}

export const reportingMultiEntityTask = {
	engagementID: 'EngagementId',
	taskID: 'TaskId',
	taskNamePrefix: labels.taskPrefix,
	task_Name: labels.repTaskTitle,
	taskNameSuffix: labels.taskSuffix,
	taskDescription: labels.repTaskDescription,
	mesT_Entity_Name: 'Related entity',
	multiEntityType: 'MultiEntityType',
	taskTypeID: 'TaskTypeID',
	taskStatusID: 'TaskStatusID'
}

export const
	reportingManageteamInternal = {
		firstName: labels.firstnameLabel,
		lastName: labels.lastnameLabel,
		userInitials: labels.initialsLabel,
		emailAddress: labels.editExternalEmailLabel,
		gui: 'GUI',
		engagementRole: labels.engagementrole,
		hasOverallResponsability: 'Has overall responsibility',
		userStatus: 'Status',
		independenceStatus: 'Independence status',
		grantedAccess: 'Granted access after archive',
		primaryOffice: 'Primary office',
		preferredContactPhone: 'Phone number',
		engagementUserStatusID: 'Engagement user status ID',
		engagementRoleID: 'Engagement role ID',
		independenceStatusID: 'Independence status ID'
	}

export const reportingManageteamExternal = {
	clientGroupName: 'Group name',
	firstName: labels.firstnameLabel,
	lastName: labels.lastnameLabel,
	userInitials: labels.initialsLabel,
	emailAddress: labels.editExternalEmailLabel,
	domain: 'User domain',
	validDomainWithinGroup: 'Valid domain within group',
	userStatus: 'User status',
	preferredContactPhone: 'Preferred phone number',
};

export const controlDesignEffectivenessType = {
	1: 'Effective',
	2: 'Ineffective',
};

export const itAppSOSummaryReportLabels = {
	itApplicationName: 'IT application/service organization',
	strategyTypeName: 'IT strategy',
	typeName: 'Type',
	itProcessName: 'IT process',
	itRiskName: 'IT risk',
	itControlName: 'ITGCs/ITSPs',
	natureOfTest: 'Nature of test',
	controlFrequencyTypeNameColumn: 'Frequency',
	testing: 'Testing',
	designEffectiveness: 'Design effectiveness',
	evaluation: 'IT process evaluation'
};

export const ArchiveReportLabels = {
	engagementDescription: 'Engagement description',
	archiveReportQualifiedNameSection: 'Report qualified',
	archiveReportQualifiedTypeNameSection: 'Report qualified type',
	archiveFolderDescription: 'Archive folder description',
	archiveFolderTypeNameSection: 'Folder type',
	location: 'Location',
	archiveComments: 'Archive comments',
	engagementID: 'Engagement ID',
	archiveCountryOfficeRegionID: 'Archive country office region ID',
	archiveReportQualifiedID: 'Archive report qualified ID',
	archiveReportQualifiedTypeID: 'Archive report qualified type ID'
};

export const canvasFormRelatedCommentsLabels = {
	canvasFormName: 'Canvas Form name',
	order1: 'HeaderOrder',
	formHeaderName: 'Header',
	order2: 'SectionOrder',
	order3: 'BodyOrder',
	formBodyResponseValue: 'Response',
	commentNumber: 'Comment number',
	author: 'Author',
	assignedTo: 'Assigned to',
	createDateSection: 'Create date',
	commentStatusSection: 'Status',
	commentText: 'Comment',
	commentVoiceNote: 'Has voice note',
	reply: 'Reply',
	replyVoiceNote: 'Has voice note'
};

export const canvasFormRelatedObjectsLabels = {
	canvasFormName: 'Canvas Form name',
	order1: 'HeaderOrder',
	formHeaderName: 'Header',
	formHeaderID: 'FormHeaderID',
	order2: 'SectionOrder',
	formSectionID: 'FormSectionID',
	formSectionName: 'Section',
	firstLevelEntityColumn: 'First level entity',
	firstLevelRelatedObject: 'First level related object',
	secondLevelEntityColumn: 'Second level entity',
	secondLevelRelatedObject: 'Second level related object'
};

export const canvasFormResponseLabels = {
	canvasFormName: 'Canvas Form name',
	order1: 'HeaderOrder',
	formHeaderName: 'Header',
	knowledgeFormHeaderID: 'Header KnowledgeID',
	headerKnowledgeContentID: 'Header KnowledgeContentID',
	order2: 'SectionOrder',
	formSectionName: 'Section',
	knowledgeFormSectionID: 'Section KnowledgeID',
	sectionKnowledgeContentID: 'Section KnowledgeContentID',
	order3: 'BodyOrder',
	formBody: 'Body',
	knowledgeFormBodyID: 'Body KnowledgeID',
	bodyKnowledgeContentID: 'Body KnowledgeContentID',
	formBodyResponse_Value: 'Response',
};

export const CanvasFormsIncompleteLabels = {
	canvasFormName: 'Canvas Form name',
	header: 'Header',
	headerOrder: 'HeaderOrder',
	sectionOrder: 'SectionOrder',
	bodyOrder: 'BodyOrder',
	body: 'Body',
	formHeaderID: 'FormHeaderID',
	formSectionID: 'FormSectionID',
	formBodyID: 'FormBodyID',
};
export const controlFormResponseLabels = {
	controlName: 'Control',
	documentName: 'Document',
	engagementDescription: 'Engagement description',
	formHeader: 'Header',
	headerKnowledgeDisplayOrder: 'HeaderKnowledgeDisplayOrder',
	formSection: 'Section',
	sectionKnowledgeDisplayOrder: 'SectionKnowledgeDisplayOrder',
	formBodyVal: 'Body',
	bodyKnowledgeDisplayOrder: 'BodyKnowledgeDisplayOrder',
	ControlTesting: 'Has control testing',
	controlFrequencyType: 'Control frequency',
	Effective: 'Is effective',
	formBodyOptionVal: 'Form option body value',
	controlType: 'Control type',
	controlDesignEffectivenessType: 'Control design effectiveness type',
};

export const itProcessSummaryLabels = {
	itProcessName: 'IT process',
	itProcessEvaluation: 'IT process evaluation',
	itProcesSupportingRationale: 'Supporting rationale',
	itRiskName: 'IT risk',
	itControlName: 'ITGCs/ITSPs',
	natureOfTest: 'Nature of test',
	controlFrequencyTypeId: 'Frequency',
	testing: 'Testing',
	designEffectiveness: 'Design effectiveness',
	operatingEffectiveness: 'Operating effectiveness'
}

export const itProcessScotControlsLabels = {
	itProcessName: 'IT process',
	scotName: 'SCOT',
	controlName: 'Control',
	controlDesignEffectivenessTypeName: 'Design effectiveness',
	testing: 'Testing',
	operatingEffectiveness: 'Operating effectiveness',
	controlTypeName: 'Control type',
	isIPEManuallyTestedName: 'IS IPE manually tested',
	itApplicationName: 'IT application',
	aggregateITEvaluationTypeName: 'Aggregate IT evaluation'
};

export const scotsControlsReportLabels = {
	scotName: 'SCOT',
	controlName: 'Control',
	operatingEffectiveness: 'Operating effectiveness',
	itApplicationName: 'IT application',
	aggregateITEvaluation: 'Aggregate IT evaluation',
	supportingRationaleControlLabel: 'Supporting rationale',
}

export const sCOTSummaryReportHeaderLabels = {
	scotName: 'SCOT',
	scotTypeName: 'Transaction type',
	strategyTypeName: 'SCOT strategy',
	itApplicationName: 'SCOT IT App / SO',
	wcgwName: labels.wcgw,
	controlName: labels.control,
	controlFrequencyTypeName: labels.frequencyLabel,
	controlTypeName: 'Control type',
	testing: 'Testing',
	operatingEffectiveness: 'Operating effectiveness',
	controlITApplication: 'Control IT App / SO',
	aggregateITEvaluationTypeName: 'Aggregate IT evaluation',
	supportingRationale: 'Supporting rationale',
	scotId: 'SCOT ID',
	strategyTypeID: 'Strategy type ID',
	scotTypeID: 'SCOT type ID',
	wcgwid: 'WCGW ID',
	controlID: 'Control ID',
	controlFrequencyTypeID: 'Control frequency type ID',
	controlTypeID: 'Control type ID',
	aggregateITEvaluationTypeID: 'Aggregate IT evaluation type ID',
};

export const findingsDeficiencyHeaderLabels = {
	description: "Deficiency description",
	controls: 'Controls',
	controlsIsEffective: 'Operating effectiveness of controls',
	type: 'Deficiency type',
	magnitude: 'Magnitude',
	responseText: 'Response text',
	remediatedAtYearEnd: 'Remediated at year end',
	mitigatingControls: 'Compensating control',
	mitigatingControlsIsEffective: 'Operating effectiveness of compensating control',
	mitigatingTasks: 'Mitigating tasks',
	foundIn: 'Found in document',
	accountsAndAssertions: 'Accounts and sssertions',
	scoTs: 'SCOTs',
	deficiencyID: 'Deficiency ID',
	controlID: 'Control ID',
	mitigatedControlID: 'Mitigated control ID',
	mitigatedTaskID: 'Mitigated task ID',
	documentID: 'Document ID',
	accountID: 'Account ID',
	scotID: 'SCOT ID'
};

export const findingsMisstatementHeaderLabels = {
	description: "Misstatement description",
	type: "Misstatement type",
	trialBalance: "Trial balance",
	period: "Period",
	accountNumber: "Account number",
	accountName: "Account name",
	accountType: "Account type",
	debit: "Debit",
	credit: "Credit",
	responseText: "Response text",
	correctedUncorrected: "Correct/uncorrected",
	mitigatingTasks: "Mitigating tasks",
	foundInDocument: "Found in document",
	accountsAndAssertions: "Accounts and assertions",
	misstatementID: "Misstatement ID",
	trialBalanceID: "Trial balance ID",
	misstatementAdjustmentID: "Misstatement adjustment ID"
};

export const findingsDeficiencyITHeaderLabels = {
	itApplicationName: "IT application name",
	itProcessName: "IT process name",
	itControlName: "IT control name",
	itApproachTypeName: "IT approach type",
	isEffective: "Control effectiveness",
	referenceNumber: "Reference number",
	description: "Deficiency description",
	deficiencyMagnitudeName: "Deficiency magnitude",
	deficiencyTypeName: "Deficiency type",
};

export const auditPlanRelatedEvidenceReportHeaderLabels = {
	adc: "Related object",
	secondaryObject: "Related control / substantive procedure",
	taskName: "Task title",
	taskDescription: "Task description",
	taskTypeColumn: "Task type",
	taskStatusValue: "Task status",
	rationaleForRejection: "Rationale for rejection",
	engagementPhase: "Engagement phase",
	milestone: "Milestone",
	periodName: "Time phase",
	assignedTo: "Assigned to",
	engagementTagGroupName: "Tag group",
	engagementTagName: "Tags",
	displayedOn: "View displayed on",
	documentName: "Document name",
	preparersValue: "Preparers (date in UTC)",
	reviewersValue: "Reviewers (date in UTC)",
	openReviewNotes: "Open review notes",
	closedReviewNotes: "Cleared review notes",
	trackChangesValue: "Track changes",
	lastModifiedBy: "Last modified by",
	lastModifiedDateValue: "Last modified dates (in UTC)",
	taskID: "Task ID",
	timephaseID: "Timephase ID",
	taskTypeID: "Task type ID",
	documentTypeID: "Document type ID",
	parentDocumentTypeID: "Parent document type ID",
	timePhaseTypeID: "Time phase type ID",
};

// group instruction summary
export const groupInstructionSummaryReportHeaderLabels = {
	sectionName: "Section",
	gaInstructionName: 'Instruction title',
	gaInstructionDescription: 'Instruction description',
	documents: 'Document name',
	knowledgeInstructionName: 'Knowledge instruction title',
	knowledgeInstructionDescription: 'Knowledge instruction description',
	gaScopeName: 'Related scopes / sub-scopes',
	componentOnly: 'Scope / individual instruction',
	shortName: 'Region / component name',
	cSection: 'Custom section',
	customInstruction: 'Custom instruction',
	gAinstructionID: 'GA instruction ID',
};

// GIS last publish and send
export const gIsLastPublishAndSendReportHeaderLabels = {
	primaryEngagementID: 'Engagement ID',
	gaScopeID: 'GA scope ID',
	gaScopeName: 'Scope',
	gaComponentID: 'GA component ID',
	shortName: 'Component name',
	lastPublishedDateInUTC: 'Last published date',
	lastSentDateInUTC: 'Last sent date',
	gaLinkStatusId: 'Link status',
	gaInstructionStatusId: 'Instruction status'
};

// Group Activity
export const groupActivityReportHeaderLabels = {
	engagementID: 'Engagement ID',
	gaScopeID: 'GA scope ID',
	gaScopeName: 'Scope',
	gaComponentID: 'GA component ID',
	shortName: 'Component name',
	gaLinkStatusId: 'Link status',
	accountID: 'Account ID',
	accountName: 'Account name',
	accountType: 'Account designation',
	activityTypeID: 'Activity type ID',
	activityTypeText: 'Activity type',
	modifyDateInUTC: 'Modify date',
	modifyUser: 'Modify user',
};

export const AccountDisclosuresReportHeadeLabels = {
	engagementID: 'Engagement ID',
	accountID: 'Account ID',
	accountName: 'Account name',
	accountTypeID: 'Account type ID',
	accountTypeId: 'Account designation',
	knowledgeAssertionId: 'Assertion Abbreviation',
	inherentRiskTypeId: 'Inherent risk assessment',
	controlRiskTypeId: 'Control risk assessment',
	craValue: 'CRA',
	riskID: 'Risk ID',
	riskTypeID: 'Risk type ID',
	riskType: 'Risk type',
	riskName: 'Risk name',
	isHigherRiskValue: 'Is higher risk',
};

// CRA summary
export const craSummaryReportHeaderLabels = {
	accountName: 'Account',
	accountTypeName: 'Account type',
	rationale: 'Rationale',
	pspIndex: 'PSP index',
	conclusionStatement: 'Account conclusion statement',
	scotName: 'SCOTs',
	transactionType: 'Transaction type',
	strategyTypeName: 'SCOT strategy',
	wcgwName: 'WCGW',
	controlName: 'Control',
	controlFrequencyTypeName: 'Frequency',
	controlTypeName: 'Control type',
	testing: 'Testing',
	operatingEffectiveness: 'Operating effectiveness',
	itApplicationName: 'SCOT IT App/SO',
	controlITApplication: 'Control IT App/SO'
};

export const craSummaryAssertionReportHeaderLabels = {
	accountName: 'Account',
	accountTypeName: 'Account type',
	rationale: 'Rationale',
	pspIndex: 'PSP index',
	assertionAbbreviation: 'Assertion',
	riskName: 'Risk',
	inherentRiskTypeName: 'Inherent risk assessment',
	controlRiskTypeName: 'Control risk assessment',
	craValue: 'CRA',
	wcgwName: 'WCGW',
	controlName: 'Control',
	controLFrequencyTypeName: 'Frequency',
	controlTypeName: 'Control type',
	testing: 'Testing',
	isLowerR: 'Islowerrisk',
	operatingEffectiveness: 'Operating effectiveness',
	itApplicationName: 'IT App/ SO'
};

export const craSummaryDataReportHeaderLabels = {
	wcgwName: 'WCGW',
	controlName: 'Control',
	controLFrequencyTypeName: 'Control frequency',
	controlTypeName: 'Control type',
	itApplicationName: 'IT application',
	assertionName: 'Assertion',
	statementTypeName: 'Statement type',
	accountTypeName: 'Account type',
	assertionAbbreviation: 'Assertion abbreviation',
	inherentRiskTypeName: 'Inherent risk',
	controlRiskTypeName: 'Control risk',
	craValue: 'CRA',
	riskTypeAbbreviation: 'Risk abbreviation',
	frequency: 'Frequency',
	accountName: 'Account',
	riskName: 'Risk',
	pspIndex: 'PSP index',
	testing: 'Testing',
	operatingEffectiveness: 'Operating effectiveness',
	isLowerRiskColumn: 'Is lower risk',
	scotName: 'SCOT',
	controlitApplicationName: 'Control IT application',
	rationale: 'Rationale',
	accountID: 'Account ID',
	riskID: 'Risk ID',
	scotid: 'SCOT ID',
	wcgwid: 'WCGW ID',
	controlID: 'Control ID',
	itApplicationID: 'IT application ID',
	knowledgeAssertionID: 'Knowledge assertion ID',
	controlTypeID: 'Control type ID',
	controlFrequencyTypeID: 'Control frequency type ID',
	accountTypeID: 'Account type ID',
	riskTypeID: 'Risk type ID',
	inherentRiskTypeID: 'Inherent risk type ID',
	controlRiskTypeID: 'Control risk type ID',
	statementTypeID: 'Statement type ID',
	conclusionStatement: 'Account conclusion statement',
};

export const reportingRequestsAndTasks = {
	requestTitle: 'Request/Task title',
	request_Description: 'Request/Task description',
	type: 'Type',
	tasks: 'Task title',
	engagementTagName: 'Tags',
	eyAssigned: 'EY assigned user',
	clientGroupName: 'External group',
	externalAssignedUser: 'External assigned user',
	periodName: 'Time phase',
	dueDateInUTC: 'Due date (in UTC)',
	requestStatus: 'Request/Task status',
	documentType: 'Document type',
	documentName: 'Current year document name',
	priorYearDocumentName: 'Prior year document name',
	externalDocumentSignOffInUTC: 'External document signoffs (in UTC)',
	clientRequestReferenceNumber: 'Client request reference number',
};

export const reportingRequestComment = {
	requestTitle: 'Request/Task title',
	request_Description: 'Request/Task description',
	type: 'Type',
	tasks: 'Task title',
	engagementTagName: 'Tags',
	eyAssigned: 'EY assigned user',
	clientGroupName: 'External group',
	externalAssignedUser: 'External assigned user',
	periodName: 'Time phase',
	dueDateInUTC: 'Due date (in UTC)',
	requestStatus: 'Request/Task status',
	externalDocumentSignOffInUTC: 'External document signoffs (in UTC)',
	annotationTextData: 'Comments',
	createDateInUTC: 'Comments date (in UTC)',
	annotationUserInitials: 'Commented by'
};

export const reportingAllDocuments = {
	documentName: 'Document name',
	fileExt: 'File extension',
	canvasFormType: 'Canvas Form type',
	docType: 'Document type',
	confidentiality: 'Confidentiality',
	docFileSize: 'File size (KB)',
	preparers: 'Preparers (in UTC)',
	reviewers: 'Reviewers (in UTC)',
	relatedTask: 'Related tasks',
	openReviewNote: 'Open review notes',
	clearedReviewNote: 'Cleared review notes',
	trackChanges: 'Track changes',
	hiddenSheets: 'Hidden sheets',
	comments: 'Comments',
	highlighted: 'Highlights',
	conflicted: 'Conflicts',
	docModifyUser: 'Last modified by',
	docModifyDateInUTC: 'Last modified date (in UTC)',
	documentID: 'Document ID',
};

export const signOffDocuments = {
	documentName: 'Document name',
	fileExt: 'File extension',
	canvasFormType: 'Canvas Form type',
	docType: 'Document type',
	confidentiality: 'Confidentiality',
	docFileSize: 'File size (KB)',
	docModifyUser: 'Last modified by',
	docModifyDateInUTC: 'Last modified date (in UTC)',
	signOffDate: 'Signed off date (in UTC)',
	signedOffBy: 'Signed off by',
	role: 'Role',
	preparerReviewer: 'Preparer/Reviewer',
};

export const reportingDocumentsModified = {
	documentName: "Document Name",
	lastModifiedDateInUTC: "Last modified date (in UTC)",
	lastModifiedUser: "Last modified user",
	reason: "Reason",
	documentChangeComment: "Rationale",
	preparersInUTC: "Preparers (in UTC)",
	reviewersInUTC: "Reviewers (in UTC)",
	approver: "Approvals (in UTC)"
};
export const reportingDeletedTaskReport = {
	taskNamePrefix: labels.taskPrefix,
	taskName: "Task title",
	taskNameSuffix: labels.taskSuffix,
	taskDescription: "Task description",
	taskTypeAbbreviation: "Task type",
	taskSourceType: "Task source",
	taskNatureType: "Task nature",
	last_Modified_By: "Last modified by",
	modifyDateInUTC: "Last modified date (in UTC)",
	oldTaskName: "Legacy task title",
	oldTaskDetail: "Legacy task description",
};

export const SEMReportHeaderLabel = {
	accountAssertion: 'Account/Assertion',
	craValue: 'CRA',
	riskOfMaterialMisstatements: labels.riskOfMaterialMisstatement,
	relatedRisks: 'Related risks',
	taskType: 'Task type',
	taskTitle: 'Task title',
	taskSource: labels.source,
	taskNature: labels.nature,
	taskTypeID: 'Task type ID',
	taskSourceTypeID: 'Task source type ID',
	taskNatureTypeID: 'Task nature type ID',
}

export const MilestonesReportHeaderLabels = {
	taskName: labels.repTaskTitle,
	taskType: labels.taskType,
	taskStatus: labels.taskStatusLabel,
	auditPhase: labels.auditPhasesLabel,
	periodName: labels.timephase,
	timephase: "Current milestone",
	correctTimephase: "Correct milestone"
}

export const MilestonesReportHeader = {
	milestone: 'Milestone',
	status: 'Milestone status',
	taskStatus: 'Task status',
	taskTitle: 'Task title',
	taskTypeAbbreviationColumn: 'Task type abbreviation',
	taskType: 'Task type',
	timePhase: 'Time phase',
	assignedTo: 'Assigned to',
	taskName: 'Task name',
	task_Detail: 'Task detail',
	due_Date: 'Due date',
	documentName: 'Document name',
	preparers: 'Preparers',
	reviewers: 'Reviewers',
	tagGroup: 'Tag group',
	tags: 'Tags',
	engagementID: 'Engagement ID',
	taskID: 'Task ID',
	taskTypeID: 'Task type ID',
	taskStatusID: 'Task status ID',
	timephaseID: 'Time phase ID',
	timephaseTypeID: 'Time phase type ID',
	documentID: 'Document ID'
}

export const groupStructureSummaryReportHeaderLabels = {
	gaScopeName: "Scope / sub-scope name",
	gaScopeDescription: "Scope description",
	shortName: 'Region / component name',
	legalName: 'Legal name',
	gaRoleTypeName: 'Group role',
	relatedRegion: 'Related region',
	pocText: 'Point of contact',
	gaLinkStatusName: 'Link status',
	gaInstructionStatusName: 'Instruction status',
	engagementID: 'EngagementID',
	gaRoleTypeID: 'GARoleTypeID',
	gaLinkStatusID: 'GALinkStatusID',
	gaInstructionStatusID: 'GAInstructionStatusID',
}

export const collaborationSummary = {
	clientRequestID: "Request number",
	requestTitle: "Title",
	requestType: "Type",
	engagementTagName: "Tags",
	clientUser: "Assigned to",
	clientEmail: "Client email",
	clientStatusName: "Status",
	isOverDue: "Overdue",
	dueDateInUTC: "Due date (in UTC)",
	eySentDateInUTC: "EY sent date (in UTC)",
	eyReceivedDateInUTC: "Received date (in UTC)",
	deliveredLate: "Delivered late",
	daysLate: "Days late",
	timesReturned: "Times returned",
}

export const collaborationActivity = {
	clientRequestID: "Request number",
	requestTitle: "Title",
	requestType: "Type",
	engagementTagName: "Tags",
	clientUser: "Assigned to",
	clientEmail: "Client email",
	clientStatusName: "Status",
	isOverDue: "Overdue",
	dueDateInUTC: "Due date (in UTC)",
	eySentDateInUTC: "EY sent date (in UTC)",
	eyReceivedDateInUTC: "Received date (in UTC)",
	deliveredLate: "Delivered late",
	daysLate: "Days late",
	timesReturned: "Times returned",
	activity: "Activity",
	activityDateInUTC: "Activity date (in UTC)",
	historicalDueDateInUTC: "Historical due date (in UTC)",
}

export const groupReportHeaderLabels = {
	gaInstructionName: 'Instruction name',
	gascopeTypeIDName: labels.scope,
	componentName: 'Component name',
	pointOfContact: labels.pointOfContact,
	dueDateValue: 'Due date (in UTC)',
	overdueValue: labels.overdueLabel,
	gaStatusIdName: labels.status,
	documentName: labels.documents,
	createDateValue: 'Signed off date (in UTC)',
	signoffBy: labels.signedOffBy,
	engagementRoleIDName: labels.role,
	isPreparerText: 'Preparer/Reviewer',
	documentID: 'Document ID',
	gaStatusID: 'GA status ID',
	engagementRoleID: 'Engagement role ID',
}

export const wcgwSummaryHeaders = {
	wcgwName: 'WCGW',
	scotName: 'SCOT',
	controlName: 'Related controls',
	itApplications: 'Related IT App/SO',
	testing: 'Testing selection',
	isLowerR: 'IsLowerRisk',
	controlFrequencyTypeName: 'Control frequency',
	controlTypeName: 'Control type',
	wcgwCount: 'Count of other related WCGWs',
}

export const allControlsHeaders = {
	engagementID: 'EngagementID',
	scotid: 'SCOTID',
	controlID: 'ControlID',
	scotName: 'SCOT name',
	controlName: 'Control description',
	hasControlTesting: 'Testing selection',
	isLowerRisk: 'IsLowerRisk',
	controlTypeID: 'Control type',
	relatedITApplicationNames: 'Related IT App/SO',
	responsiveToSR: 'Responsive to a Significant Risk',
	IPE: 'IPE'
}

export const qualityChecksHeaders = {
	itemID: 'Item ID',
	itemName: 'Item name',
	qualityChecks: 'Quality check',
	validationDescription: 'Validation description',
	buildGroup: 'Build group',
	impactedItem: 'Impacted item',
	type: 'Type',
}

export const statisticsHeaders = {
	scotname: 'SCOT',
	strategyTypeId: 'SCOT strategy',
	wcgwName: 'WCGW',
	controlName: 'Control',
	operatingEvaluation: 'Operating evaluation',
	itApplicationName: 'Related IT App / SO',
	assertions: 'Assertions',
	controlTypeId: 'Control type',
	testingSelection: 'Testing selection',
	controlFrequencyTypeId: 'Frequency',
	itApplications: 'IT applications',
	scotTypeId: 'SCOT type',
	itType: 'IT App type',
	isLowerR: 'Is lower risk',
	engagementID: 'Engagement ID',
	workspaceID: 'Workspace ID',
	scotID: 'SCOT ID',
	scotTypeID: 'SCOT type ID',
	wcgwid: 'WCGW ID',
	controlID: 'Control ID',
}

export const CRTAssertionCountSummaryHeaders = {
	accountName: "Account",
	assertion: "Assertion",
	controlName: "Control",
	ControlTypeName: "Control type",
	ControlFrequencyTypeName: "Frequency",
	Testing: "Testing",
	OperatingEvaluation: "Operating evaluation",
	assertionControlCount: "Assertion control count",
	assertionAbbreviation: "Assertion abbreviation",
	wcgwName: "WCGW",
	engagementID: "Engagement ID",
	workspaceID: "Workspace ID",
	assertionID: "Assertion ID",
	wcgwid: "WCGW ID",
	controlID: "Control ID"
}
export const crtlistcontrolTypeName = {
	'IT Application Control': 'IT Application Control',
	'IT Dependent Manual Control': 'IT Dependent Manual Control',
	'Manual Prevent': 'Manual Prevent',
	'Manual Detect': 'Manual Detect'
}
export const controlFrequencyNameTypes = {
	'Many times per day': 'Many times per day',
	'Daily': 'Daily',
	'Weekly': 'Weekly',
	'Monthly': 'Monthly',
	'Quarterly': 'Quarterly',
	'Annually': 'Annually',
	'IT Application Control': 'IT Application Control',
	'Other': 'Other'
};

// Folder types
export const archiveFolderTypeNameTypes = {
	'Working Papers': 'Working Papers',
	'Perm File Active': 'Perm File Active',
	'Perm File Superseded': 'Perm File Superseded',
	'Working Papers - CD/DVD': 'Working Papers - CD/DVD',
	'Perm File Active - CD/DVD': 'Perm File Active - CD/DVD',
	'Perm File Superseded - CD/DVD': 'Perm File Superseded - CD/DVD',
	'Data Storage Devices': 'Data Storage Devices'
};

export const operatingEvaluationType = {
	'Effective': 'Effective',
	'Ineffective': 'Ineffective',
	'Not Selected': 'Not Selected'
};
export const CRTSCOTCountSummaryHeaders = {
	scotname: "SCOT",
	strategyTypeName: "SCOT strategy",
	wcgwName: "Related WCGWs",
	controlName: "Related controls",
	operatingEvaluation: "Operating evaluation",
	itApplicationName: "Related IT app / SO",
	assertions: "Assertions",
	controlTypeName: "Control type",
	testing: "Testing selection",
	controlFrequencyTypeName: "Frequency",
	itApplications: "IT applications",
	itAppType: "IT application type",
	scotTypeName: "SCOT type",
	soctisLowerRisk: "Lower risk control",
	engagementID: "Engagement ID",
	workspaceID: "Workspace ID",
	scotID: "SCOT ID",
	scottypeid: "SCOT type ID",
	wcgwid: "WCGW ID",
	controlID: "Control ID"
};

export const projectInsightCanvasFormExportHeaders = {
	EngagementID: "EngagementID",
	DocumentID: "DocumentID",
	ControlID: "ControlID"
};

export const projectInsightSCOTToWCGWToControlHeaders = {
	engagementID: "EngagementID",
	scotName: "SCOTName",
	strategyTypeName: "StrategyTypeName",
	wcgwName: "WCGWName",
	controlID: "ControlID",
	controlName: "ControlName",
	controlFrequencyTypeName: "ControlFrequencyTypeName",
	controlTypeName: "ControlTypeName",
	isLowerRiskHeader: "IsLowerRisk",
	hasControlTestingHeader: "HasControlTesting",
	operativeEffectiveness: "Operative Effectiveness"
};

export const ComponentTeamGroupAccountInfoControlHeaders = {
	engagementId: "Engagement ID",
	accountId: "Account ID",
	accountName: "Account name",
	accountTypeId: "Account type ID ",
	accountDesignation: "Account designation",
	pspIndexTitle: "PSP index",
	knowledgeAssertion: "Assertion abbreviation",
	inherentRiskType: "Inherent risk assessment",
	controlRiskType: "Control risk assessment",
	craValue: "CRA",
	riskId: "Risk ID",
	riskTypeId: "Risk type ID",
	riskTypeEnum: "Risk type",
	riskName: "Risk name",
	isHigherRiskText: "Is higher risk",
	rejectedTaskId: "Task ID",
	rejectedTaskName: "Rejected PSP",
	rejectedTaskRationale: "Rejected PSP Rationale"
};

export const projectInsightControlToITApplicationHeaders = {
	engagementID: "EngagementID",
	controlID: "ControlID",
	itApplicationID: "ITApplicationID",
	controlITApplication: "ControlITApplication"
};

export const projectInsightControlToAssertionHeaders = {
	engagementID: "EngagementID",
	controlID: "ControlID",
	Accountname: "AccountName",
	AssertionAbbreviation: "AssertionAbbreviation"
};

export const projectInsightRisksToWCGWsHeaders = {
	engagementId: "EngagementID", //show only in excel
	accountName: "AccountName",
	accountId: "AccountID", //show only in excel
	knowledgeAssertion: 'Assertion',
	CRA: "CRA",
	RelatedRisk: "RelatedRisk",
	riskId: "RiskID", //show only in excel
	riskType: "RiskType",
	WCGW: "WCGW",
	wcgwId: "WCGWID", //show only in excel
	RelatedSCOT: "RelatedSCOT",
	scotId: "SCOTID" //show only in excel
};

export const ipeControlsHeaders = {
	EngagementID: "EngagementID",
	DocumentID: "DocumentID"
};

export const ipeSubstantiveHeaders = {
	EngagementID: "EngagementID",
	DocumentID: "DocumentID"
};

export const ipeITGCHeaders = {
	EngagementID: "EngagementID",
	DocumentID: "DocumentID"
};

export const iTAppSOReport = {
	relatedITSO: "Related IT app/SO",
	iTAppType: "IT App type",
	iTAppControl: "IT App control",
	testingSelection: "Testing selection",
	relatedSCOTs: "Related SCOTs",
	relatedSCOTStrategy: "Related SCOT strategy",
	itdm: "ITDM",
	manualPrevent: "Manual prevent",
	manualDetect: "Manual detect",
	noRelatedControls: "No related controls",
	controlsStatistics: "Controls by type",
	relatedSCOTType: "Related SCOT type",
	controlType: "Control type",
	grandTotal: "Total",
	yes: "Yes",
	no: "No",
	notSelected: "Not selected",
	controls: "Controls",
	substantive: "Substantive",
	routine: "Routine",
	nonRoutine: "Non routine",
	estimation: "Estimation",
};

export const IndependenceSummaryReport = {
	id: "ID",
	userName: "User name",
	order: "Order",
	questionFormatted: "Question",
	answer: "Answer",
	actionTypeID: "Action type ID",
	independenceStatusID: "Independence status ID",
	EngagementUserStatusName: "Engagement user status",
	engagementUserStatusID: "Engagement user status ID",
	IndependenceStatusName: "Independence status",
	requiresExecutiveClearance: "Requires executive clearance",
};

export const additionalInfoBasedOnValidationTypeId = {
	1: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	2: 'The team is not using the most up to date version of the 109 - Team member independence form',
	3: 'A team member changed their role from a PPEDD role after granting access to another team member with an independence matter',
	4: 'A team member changed their role from a PPEDD role after overriding another team member with an independence matter',
	5: 'Click on the validation link, identify the SCOT that has no number badge next to it. Relate the SCOT to an Account',
	6: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	7: 'Identify the SCOT where the related WCGWs count is blank. Navigate to the respective build task. Expand the SCOT and add WCGWs as appropriate',
	8: 'Identify the SCOT where the related Controls count is blank. Navigate to the respective build task. Expand the SCOT and add a Control to the WCGWs',
	9: 'Identify the SCOT with the validation, expand the SCOT details and verify that at least one control per WCGW has Yes selected for testing',
	10: 'Identify the SCOT with the validation, expand the SCOT details. Verify that at least one control per WCGW has Yes selected for testing',
	11: 'Click on the validation link, identify the Risk that has no number badge next to it. Relate the appropriate assertion to the risk',
	12: 'Identify the assertion missing an inherent and/or control risk. Complete the missing field',
	13: 'Click on the validation link and open the Add WCGW drawer. Select one SCOT at a time and identify the WCGWs that has no number badge next to it. Relate the WCGW to the appropriate assertion',
	14: 'Identify the Account that has no number badge next to it. Navigate to the SCOTs build flow and relate the SCOT to an Account',
	15: 'Identify the account / assertion with the validation, click on the Add WCGWs button and relate the WCGW to the assertion',
	16: 'This validation check verifies that all WCGWs related to an assertion with a Controls strategy are covered by a control that will be tested. Identify the assertion with the validation, click on the Add WCGWs button and relate the WCGW to the assertion',
	17: 'Review each WCGW associated to an assertion and verify that it is covered by at least one control that has a testing strategy of Yes',
	18: 'All WCGWs for an assertion with a Rely strategy must be covered by a control with a testing value set to Yes',
	19: 'An IT/SO has a Strategy of Rely that is not deleted nor related to an IT/SO Process',
	20: 'An IT/SO Control/IT Substantive procedure is not related to an IT/SO risk',
	21: 'A change in strategy from Rely to Not Rely after creating IT/SO process',
	22: 'A risk is not related to an assertion',
	23: 'An IT/SO Control/IT Substantive Procedure is not related to an IT/SO risk',
	24: 'An IT/SO Controls/Substantive procedure related to an IT/SO risk is not selected for testing ',
	25: 'An IT/SO Control/IT Substantive Procedure is not related to an IT/SO risk',
	26: 'Identify the limited risk account that does not have any Tasks. Add one or more OSPs',
	27: 'Verify you have imported PSPs. If PSPs have not been imported, click on import PSPs. If there are no PSPs for the assertion, create an OSP',
	28: 'Navigate to the SCOTs build flow, open the Add Test of Control drawer, identify the TOC task that has no number badge next to it. Relate the TOC task to the control',
	29: 'Engagement contains at least one walkthrough task that has not yet been associated to a SCOT',
	30: 'A SCOT does not have at least one walkthrough task associated to it',
	31: 'Navigate to the SCOTs build flow, open the Add Test of Control drawer, identify the TOC task that has no number badge next to it. Relate the TOC task to the control',
	32: 'An IT/SO walkthrough is not related to at least one IT/SO process',
	33: 'An IT/SO test of control is not related to at least one IT/SO control/substantive procedure with a  testing value set to Yes',
	34: 'An IT/SO other substantive procedure is not related to at least one IT/SO control/substantive procedure with a testing value set to Yes',
	35: 'An IT/SO process does not have at least one walkthrough task associated to it ',
	36: 'A control with a testing value set to Yes has no test of control task associated to it',
	37: 'An IT/SO other substantive procedure is not related to at least one IT/SO control/substantive procedure with a testing value set to Yes',
	38: 'Click on the validation link, from the Evidence list click on the conflict icon to resolve the conflict',
	39: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	40: 'Click on the validation link, from the Evidence list sign-off on the documents missing a preparer or reviewer sign-off. Only sign-off on those files you have prepared or reviewed',
	41: 'Click on the validation link, from the filtered task list review each task and associate the appropriate evidence files',
	42: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	43: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	44: 'Click on the validation link, from the Evidence list rename the documents with duplicate names',
	45: 'The IT process evaluation has not been selected or is inconsistent with the ITCG/ITSP operating effectiveness evaluations',
	46: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	47: 'The aggregate IT evaluation has not been selected for one or more of the application/ITDM controls',
	48: 'Canvas form has at least one field that has not been completed ',
	49: 'Click on the validation link then click on Add Assertion to relate the assertion or limited risk account',
	50: 'Task that has no assertion or limited risk account associated. Click on Add Assertion to associate an assertion or limited risk account',
	51: 'A WCGW has not been related to a substantive task',
	52: 'Engagement has at least one inherent, significant or fraud risk that is not associated to at least one WCGW',
	53: 'Estimate account that is missing the EST Accounting estimates index. Add it from the PSP index list.',
	54: 'Identify the Account(s) that has an estimate and open the Account to see if it has an estimate SCOT related to it. Once you identify the account(s) missing the estimate SCOT you will need to relate the estimate SCOT.',
	55: 'Identify the estimate SCOT that is not related to an estimate Account. Once you identify the estimate SCOT missing the estimate Account you will need to relate the estimate SCOT to the estimate Account.',
	56: 'A significant or fraud risk must have at least one substantive procedure, one control and one test of control task (if applicable)',
	57: 'A significant or fraud risk must have at least one substantive procedure, one control and one test of control task (if applicable)',
	58: 'Click on the risk with the validation and expand the assertion. Verify at least one task has Yes selected',
	59: 'Click on the risk with the validation and expand the assertion. Verify at least one Control has Yes selected. The design effectiveness also needs to be completed for the control',
	60: 'Click on the validation link Resolve Canvas Form comments. Open each Canvas form and select show unresolved comments. All comments must be cleared or closed',
	61: 'Click on the validation link Finalize incomplete Canvas form responses. Open each Canvas form and select show incomplete responses. All Canvas Form questions need to be completed',
	62: 'Click on the validation link, review open Comments and clear or close all open Comments.',
	63: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	64: 'Click on the validation link, from the filtered task list review each task and mark open tasks complete',
	65: 'Click on the unlink all button to unlink all shared evidence',
	66: 'Form 440 has at least one document without a reason for change selected ',
	67: 'Form 440 has at least one document with a “non administrative” reason for change selected that does not have the rationale completed',
	68: 'Form 440 has at least one document with a “non administrative” reason for change selected that has not been approved by a manager or above',
	69: 'Form 440 has not been signed off by either the engagement partner or partner in charge',
	70: 'Click on the unlink from group button on the archive checklist',
	71: 'A Canvas form has no headers or standard content',
	72: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	73: 'Click the validation check icon in the Canvas form to see the number of incomplete responses ',
	74: 'Click on the link and submit the updated version of the Engagement Profile.smt',
	75: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	76: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	77: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	78: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	79: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	80: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	81: 'Identify IT processes and relate them to IT applications',
	82: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	83: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	84: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	85: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	86: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	87: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	88: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	89: 'The IT process evaluation has not been selected or is inconsistent with the ITCG/ITSP operating effectiveness evaluations',
	90: 'Control is missing a design effectiveness selection',
	91: 'View SCOTs and related IT applications relevant to the audit',
	92: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	93: 'Use the step by step guidance in the "How to document the IT flow in EY Canvas" enabler to resolve this validation',
	94: 'Use the step by step guidance in the "How to document the IT flow in EY Canvas" enabler to resolve this validation',
	95: 'An engagement has no specific team member identified as the person in charge in Manage Team',
	96: 'A risk factor is not related to a risk or not marked as “Not a ROMM”',
	97: 'A risk is not related to an assertion',
	98: 'An amount needs to be entered into the Forecast basis',
	99: 'A rationale needs to be entered for the Forecast basis',
	100: 'An amount needs to be entered into the Adjusted basis',
	101: 'Planning materiality percentage has not been selected',
	102: 'Planning materiality percentage is outside the allowable range',
	103: 'A rationale needs to be entered for the Planning Materiality percentage selected',
	104: 'Tolerable error has not been entered',
	105: 'Tolerable error percentage is outside the allowable range',
	106: 'A rationale needs to be entered for the Tolerable error percentage selected',
	107: 'SAD percentage has not been selected',
	108: 'SAD percentage is outside the allowable range',
	109: 'A rationale needs to be entered for the SAD percentage selected',
	110: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	111: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	112: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	113: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	114: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	115: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	116: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	117: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	118: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	119: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	120: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	121: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	122: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	123: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	124: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	125: 'Protected documents should not be retained in engagement files unless necessary',
	126: 'Delete document and re-upload',
	127: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	128: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	129: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	130: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	131: "Navigate to the Estimate listing form and use 'Create document' option there",
	132: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	133: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	134: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	135: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	136: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	137: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	138: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	139: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	140: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	141: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	142: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	143: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	144: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	145: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	146: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	147: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	148: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	149: 'Click on the validation link Finalize incomplete Canvas form responses. Open each Canvas form and verify all required documents associated to the requirements have the related PIC/EQR sign-off. Only sign-off on those files you have prepared or reviewed.',
	150: 'Click on the validation link Finalize incomplete Canvas form responses. Open each Canvas form and verify all required documents associated to the requirements have the related PIC/EQR sign-off requirement on the documents.',
	151: 'Please check that all significant accounts and disclosures have at least one assertion.',
	152: 'Open each Canvas form and verify all required documents associated to the requirements have Preparer and Reviewer sign-offs. Only sign-off on those files you have prepared or reviewed.',
	153: 'Navigate to the adjustment and use "Add evidence" option to associate appropriate evidence',
	154: 'Navigate to the estimate document and check there that Higher/Lower risk estimates have an Estimate account related. Very low risk estimates should have at least one account related.',
	155: 'Navigate to the estimate document and check there  accounts related. Based on the audit documentation either unrelate non-estimate account or modify it to an estimate account.',
	156: 'Navigate to the estimate document and check responses there.',
	157: 'Navigate to the estimate document and check there that Higher/Lower risk estimates have an Estimate SCOT related. Very low risk estimates should have at least one SCOT related.',
	158: 'Navigate to the account document and check there are at least one estimate related.',
	159: 'Navigate to the account document and check there are at least one  Higher or Lower risk estimate related.',
	160: 'Navigate to the estimate lead sheet to identify Estimate SCOTs that do not have any estimate related. Based on the audit documentation either modify those SCOTs to non-estimate or relate estimates to those SCOTs',
	161: 'Navigate to the adjustment and check sum of the debit entries equals to the sum of credit entries.',
	162: 'Navigate to the estimate document and c and check there are at least one significant or fraud risk related.',
	163: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	164: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	165: 'Use the step by step guidance in the "How to clear validation checks in EY Canvas" enabler to resolve this validation',
	166: 'Navigate to the estimate document and check there  risks related. Based on the audit documentation either unrelate Significant/Fraud risk or update estimate category to Higher risk.'
};

export const validationChecksReportHeaderLabels = {
	validationType: "Validation type",
	validationDescription: "Validation description",
	itemName: "Item name",
	auditPhase: "Audit phase",
	additionalInformation: "Additional information",
	localization: "Localization",
	itemType: "Item type",
	location: labels.location,
	count: "Count",
	validationCount: "Count of validations",
	itemID: "Item ID",
	validationTypeID: "Validation type ID",
	category: "Category",
	auditPhaseID: "Audit phase ID",
	entity: labels.filterEntitiesLabel
};


export const ReviewNotesReportHeaderLabel = {
	annotationID: 'Annotation ID',
	assignToUserID: 'Assigned to user ID',
	assignedtoUser: labels.assignedTo,
	createUserID: 'Author ID',
	createdBy: 'Author',
	createdDate: 'Created on',
	dueDateLabel: 'Due date',
	relatedEvidence: 'Related evidence',
	reviewNote: labels.reviewNotesLabel,
	lastModifiedBy: 'Last modified by',
	modifyUserID: 'Modified by user ID',
	lastModifiedOnLabel: 'Last modified on',
	priorityType: labels.priorityLabel,
	annotationParentID: 'Parent annotation ID',
	referenceNumber: 'Reference',
	relatedTasks: 'Related task',
	replies: labels.reply,
	reviewNoteStatus: labels.status,
	statusChangedByUserID: 'Status changed by user ID',
	statusChangedBy: 'Status Changed By',
	statusChangedDateLabel: 'Status changed date',
	startDateLabel: 'First created (in UTC)',
	clearedDateLabel: 'Last cleared (in UTC)',
	closedDateLabel: 'Last closed (in UTC)',
	documentTypeID: 'Document type ID',
	childAnnotationID: 'Child annotation ID'
};

export const taskDueDateCategoryIdLabels = {
	0: "Past weeks",
	1: "Current week",
	2: "Next week",
	3: "Future weeks"
};

export const taskSummaryReportHeaderLabels = {
	engagementID: "Engagement ID",
	taskID: "Task ID",
	displayedTaskName: labels.TaskName,
	taskNamePrefix: "Task prefix",
	taskNameSuffix: "Task suffix",
	dueDateColumn: labels.taskDueDateHeader,
	dueDateWeek: labels.dueLabel,
	assignmentType: labels.assignmentType,
	assignmentTypeID: "Assignment type ID",
	assignmentName: labels.assignmentName,
	assignmentStatus: labels.taskAssigmentStatusHeader,
	reviewNoteAssignedOpen: "Assigned open review notes",
	reviewNoteAssignedCleared: "Assigned cleared review notes",
	reviewNoteAuthoredOpen: "Authored open review notes",
	reviewNoteAuthoredCleared: "Authored cleared review notes",
	taskStatus: labels.taskStatusLabel,
	taskStatusID: "Task status ID",
	taskType: labels.taskType,
	taskTypeID: "Task type ID",
	milestone: labels.filterMilestoneLabel,
	milestoneID: "Milestone ID",
	isOverdueColumn: labels.Overdue,
	timephaseName: labels.timephase,
	relatedObjectName: "Related object",
	relatedEntityID: "Related object ID",
	openAssignmentsOverdue: "Open assignments-overdue",
	openAssignmentsThisWeek: "Open assignments-this week",
	openAssignmentsNextWeek: "Open assignments-next week",
	openAssignmentsTotal: "Open assignments-total",
	inProgressAssignmentsOverdue: "In progress assignments-overdue",
	inProgressAssignmentsThisWeek: "In progress assignments-this week",
	inProgressAssignmentsNextWeek: "In progress assignments-next week",
	inProgressAssignmentsTotal: "In progress assignments-total"
};

export const crtControlSummaryReportHeaderLabels = {
	scotID: "SCOT ID",
	scotName: "SCOT",
	strategyTypeName: "Strategy type",
	wcgwID: "WCGW ID",
	wcgwName: "WCGW",
	controlID: "Control ID",
	controlName: "Control",
	operatingEvaluation: "Operating evaluation",
	assertions: "Assertions",
	controlTypeName: "Control type",
	testingFormatted: "Testing selection",
	scotStrategy: "SCOT strategy",
	itApplicationName: "Related IT App / SO",
	controlFrequencyTypeName: "Frequency",
	scotTypeID: "SCOT type ID",
	scotTypeName: "SCOT type",
	itAppType: "IT/SO application",
	lowerRiskControl: "Lower risk control"
};

export const trialBalanceReportHeaderLabels = {
	engagementID: "Engagement ID", //show only in excel
	trialBalanceID: "Trial balance ID", //show only in excel
	trialBalanceTypeID: "Trial balance type ID", //show only in excel
	trialBalanceTypeName: "Trial balance type name",
	financialStatementID: "Financial statement ID", //show only in excel
	financialStatementName: "Financial statement name",
	financialStatementTypeID: "Financial statement type ID", //show only in excel
	financialStatementTypeName: "Financial statement type name",
	financialStatementSubTypeID: "Financial statement sub type ID", //show only in excel
	financialStatementSubTypeName: "Financial statement sub type name",
	analysisPeriodBalance: "Analysis date balance",
	comparativePeriodBalance: "Comparative date balance",
	analysisComparativeBalanceChange: "Analysis comparative balance change",
	analysisComparativeBalanceChangePercent: "Analysis comparative balance change percent",
	secondComparativePeriodBalance: "Second comparative date balance",
	analysisSecondComparativeBalanceChange: "Analysis second comparative balance change",
	analysisSecondComparativeBalanceChangePercent: "Analysis second comparative balance change percent",
	parentFinancialStatementID: "Parent financial statement ID", //show only in excel
	displayOrder: "Display order", //show only in excel
	eyCanvasAccountName: "EY Canvas account name",
	relatedEntities: "Related entities"
};

export const taskSourceTypes = {
	1: labels.internal,
	2: labels.external,
};

export const taskNatureTypes = {
	1: labels.testOfDetail,
	2: labels.substantiveAnalyticalProcedure,
	3: labels.testOfControl,
};

export const priorityTypesCollaboration = [{
	value: 1,
	label: 'Normal'
},
{
	value: 3,
	label: 'High'
},
{
	value: 4,
	label: 'Critical'
}
];

export const StatementType = [{
	id: 1,
	value: 'Income Statement'
}, {
	id: 2,
	value: 'Balance Sheet'
}, {
	id: 3,
	value: 'Both'
}];

export const AccountTypes = [
	{ id: 1, accountTypeName: 'Significant' },
	{ id: 2, accountTypeName: 'Limited risk' },
	{ id: 3, accountTypeName: 'Insignificant' },
	{ id: 4, accountTypeName: 'Other' },
	{ id: 5, accountTypeName: 'Significant disclosures' }
];

export const ITAppSOAttributes = [{
	id: 1,
	value: 'Testing selection'
}, {
	id: 2,
	value: 'Related IT app/SO'
}, {
	id: 3,
	value: 'Related SCOTs'
}, {
	id: 4,
	value: 'Related SCOT strategy'
}, {
	id: 5,
	value: 'Related SCOT type'
}];

export const notesEditorLabels = {
	addNoteButtonLabel: reviewNoteModalLabels?.addNewReviewNoteButtonText,
	saveNoteButtonLabel: labels.saveLabel,
	messagePlaceholder: labels.addNewNoteModalTitle,
	messagePlaceholderReply: reviewNoteModalLabels?.replyInputPlaceholder,
	messagePlaceholderEdit: reviewNoteModalLabels?.noteInputPlaceholderEdit,
	messagePlaceholderReplyEdit: reviewNoteModalLabels?.replyInputPlaceholderEdit,
	addReplyButtonLabel: reviewNoteModalLabels?.reply,
	characters: labels.characters,
	of: labels.of,
	formRequired: labels.required,
	formMaxLength: labels.formMaxLength,
	toFieldLabel: labels.assignedTo,
	priorityFieldLabel: labels.rnhPriority,
	dueDateFieldLabel: labels.dueDate,
	voiceNoteButtonLabel: labels.voiceNoteButtonLabel,
	stopRecordingButtonLabel: labels.stopRecordingButtonLabel,
	cancelButtonLabel: labels.cancelButtonLabel,
	noResultsFound: labels.noResultsFound,
	microphoneBlockedMessage: labels.microphoneBlockedMessage,
	microphoneBlockedOnVideoMessage: labels.microphoneBlockedOnVideoMessage,
	notInMainWindowVoice: labels.notInMainWindowVoice,
	notInMainWindowScreen: labels.notInMainWindowScreen,
	voiceNoteNotAvailable: 'Voice note and screen recording is not available in drawer view. Switch to full screen view to use these features.',
	deleteButtonTitle: labels.voiceNoteCommentDeleteLabel,
	playButtonTitle: labels.voiceNoteCommentPlayLabel,
	pauseButtonTitle: labels.voiceNoteCommentStopLabel,
	screenRecord: labels.screenRecord,
	playbackReview: labels.playbackReview,
	close: labels.reviewNotesModalClose
};

export const noteModalLabels = {
	...notesEditorLabels,
	closeButton: labels.reviewNotesModalClose,
	closed: labels.closed,
	open: labels.open,
	cleared: labels.cleared,
	allNotes: labels.allNotes,
	myNotes: labels.myNotes,
	assignedToMe: labels.assignedToMe,
	noNotesFound: reviewNoteModalLabels?.noNotesFound,
	noNotesFoundInstructional: reviewNoteModalLabels?.noNotesAssociatedWithDocumentLabel,
	assignedTo: labels.assignedTo,
	dueDate: labels.dueDate,
	edit: labels.edit,
	delete: labels.delete,
	clear: labels.clear,
	reopen: labels.reopen,
	close: labels.closeTitle,
	reply: labels.reply,
	confirm: labels.confirm,
	cancel: labels.cancelButtonLabel,
	deleteModalHeaderNote: reviewNoteModalLabels?.deleteIconModalTitleLabel,
	deleteModalHeaderReply: reviewNoteModalLabels?.deleteReplyIconModalTitle,
	deleteModalTextNote: reviewNoteModalLabels?.deleteIconModalConfirmMessageParent,
	deleteModalTextReply: reviewNoteModalLabels?.deleteIconModalConfirmMessage,
	showMore: reviewNoteModalLabels?.showMore,
	showLess: reviewNoteModalLabels?.showLess,
	view: labels.view,
	notSelected: labels.notSelectedText,
	deleteButtonTitle: labels.voiceNoteCommentDeleteLabel,
	playButtonTitle: labels.voiceNoteCommentPlayLabel,
	pauseButtonTitle: labels.voiceNoteCommentStopLabel
};

export const EntitiesLabels = {
	close: 'Close',
	cancel: 'Cancel',
	repNoRecordMessage: 'No results found',
	edit: 'Edit',
	delete: 'Delete',
	actions: 'Actions',
	show: 'Show',
	first: 'First Page',
	last: 'Last Page',
	prev: 'Previous Page',
	next: 'Next Page',

	[Entity.Account]: {
		manageEntity: 'Manage accounts and disclosures',
		searchEntity: 'Search accounts',
		createEntity: 'New account',
		entityName: 'account',
		entityNameCaps: 'Account',
		entityNamePlural: 'Accounts',
		placeholderText: "Create new accounts and disclosures or edit and delete existing accounts and disclosures below.",
		deleteConfirmLabel: 'Are you sure you want to delete this account? All existing relationships will be removed. This action cannot be undone.'
	},
	[Entity.Estimate]: {
		manageEntity: 'Manage estimate',
		searchEntity: 'Search estimate',
		createEntity: 'New estimate',
		entityName: 'estimate',
		entityNameCaps: 'Estimate',
		entityNamePlural: 'Estimates',
		placeholderText: 'Create new estimates or edit and delete existing estimates below.',
		deleteConfirmLabel: 'Are you sure you want to delete this estimate? All existing relationships will be removed. This action cannot be undone.'
	},
	[Entity.Risk]: {
		manageEntity: 'Manage risks',
		searchEntity: 'Search risks',
		createEntity: 'New risk',
		entityName: 'risk',
		entityNameCaps: 'Risk',
		entityNamePlural: 'Risks',
		placeholderText: 'Create new risks or edit and delete existing risks below.',
		deleteConfirmLabel: 'Are you sure you want to delete this risk? All existing relationships will be removed. This action cannot be undone.'
	},
	[Entity.STEntity]: {
		manageEntity: 'Manage entities',
		searchEntity: 'Search entities',
		createEntity: 'New entity',
		entityName: 'entity',
		entityNameCaps: 'Entity',
		entityNamePlural: 'Entities',
		placeholderText: 'Create new entities or edit and delete existing entities below.',
		deleteEntity: 'Delete entity',
		deleteConfirmLabel:
			'Are you sure you want to delete this entity? All existing relationships will be removed. This action cannot be undone.'
	},
	[Entity.Control]: {
		manageEntity: 'Manage controls',
		searchEntity: 'Search controls',
		createEntity: 'New control',
		entityName: 'control',
		entityNameCaps: 'Control',
		entityNamePlural: 'Controls',
		placeholderText: 'Create new controls or edit and delete existing controls below.',
		deleteEntity: 'Delete control',
		deleteConfirmLabel: 'Are you sure you want to delete this control? All existing relationships will be removed. This action cannot be undone.'
	},
	[Entity.SCOT]: {
		manageEntity: 'Manage SCOTs',
		searchEntity: 'Search SCOTs',
		createEntity: 'New SCOT',
		entityName: 'SCOT',
		entityNameCaps: 'SCOT',
		entityNamePlural: 'SCOTs',
		placeholderText: 'Create new SCOTs or edit and delete existing SCOTs below.',
		deleteEntity: 'Delete SCOT',
		deleteConfirmLabel: `Are you sure you want to delete this SCOT? All existing relationships will be removed. This action cannot be undone.`
	},
	[Entity.ITApplication]: {
		manageEntity: 'Manage IT applications',
		searchEntity: 'Search',
		createEntity: 'New IT application',
		entityName: 'IT application',
		entityNameCaps: 'IT application',
		entityNamePlural: 'IT applications',
		placeholderText: 'Create new IT applications or edit and delete existing IT applications below.',
		deleteEntity: 'Delete IT application',
		deleteConfirmLabel: 'Are you sure you want to delete this IT application? All existing relationships will be removed. This action cannot be undone.'
	},
	[Entity.TaskSection]: {
		manageEntity: 'Manage task groups',
		searchEntity: 'Search task group',
		createEntity: 'New task group',
		entityName: 'task group',
		entityNameCaps: 'Task group',
		entityNamePlural: 'Task groups',
		placeholderText: 'Create a new task group or edit and delete existing task group below.',
		deleteEntity: 'Delete task group',
		deleteConfirmLabel: 'Are you sure that you want to delete the selected task group? Only task groups that do not have any related tasks can be deleted.'
	},
	[Entity.WCGW]: {
		manageEntity: 'Manage WCGWs',
		searchEntity: 'Search WCGWs',
		createEntity: 'New WCGWs',
		entityName: 'WCGW',
		entityNameCaps: 'WCGW',
		entityNamePlural: 'WCGWs',
		placeholderText: 'Create new WCGW or edit and delete existing WCGW below.',
		deleteEntity: 'Delete WCGW',
		deleteConfirmLabel: 'Are you sure you want to delete this WCGW? All existing relationships will be removed. This action cannot be undone.'
	},
	[Entity.Misstatement]: {
		manageEntity: 'Manage adjustments',
		searchEntity: 'Search adjustments',
		createEntity: 'New adjustment',
		entityName: 'adjustment',
		entityNameCaps: 'Adjustment',
		entityNamePlural: 'Adjustments',
		placeholderText: 'Create new adjustments or edit and delete existing adjustments below.',
		deleteConfirmLabel: 'Are you sure that you want to delete the selected adjustment? This action cannot be undone.'
	},
	[Entity.AdjustmentValidation]: {
		manageEntity: 'Manage adjustments with validations checks',
		searchEntity: 'Search',
		entityName: 'adjustments',
		entityNameCaps: 'Adjustments',
		entityNamePlural: 'Adjustments',
		placeholderText: 'Each adjustment must have related at least one evidence and for each adjustment the sum of the debit entries should equal the sum of the credit entries. The following adjustment(s) have one or more validation issues. Click on <b>"Edit"</b> to address them.',
		deleteConfirmLabel: 'Are you sure that you want to delete the selected adjustment? This action cannot be undone.',
		adjustmentHeader: 'Adjustment',
		validationTyeHeader: 'Validation type',
		validationTypeAmtMissmatch: 'Sum of the debit entries does not equal the sum of the credit entries',
		validationTypeNoEvidence: 'No related evidence',
	},
	[Entity.SampleItem]: {
		manageEntity: 'Manage sample tags',
		searchEntity: 'Search tags',
		createEntity: 'New tag',
		createManageTagEntity: 'Manage tag groups',
		entityName: 'Tag',
		entityNamePlural: 'Tags',
		entityNameForTagGroupPlural: 'Tag groups',
		placeholderText: 'Create new tags or edit and delete existing tags below.'
	},
	[Entity.SampleTagGroups]: {
		manageEntity: 'Manage sample tag groups',
		searchEntity: 'Search',
		createEntity: 'New tag group',
		entityName: 'Tag group',
		entityNameCaps: 'Tag group',
		entityNamePlural: 'Tag groups',
		placeholderText: 'Create new sample tag groups or edit and delete existing sample tag groups below.',
	}
};

export const executionType = [
	{ id: 1, label: '', toolTip: '', value: 'In this engagement' },
	{
		id: 2,
		label: 'CT',
		toolTip: 'Procedures in other engagement(s) [PT-only]',
		value: 'In other engagement(s) [PT-only]'
	},
	{
		id: 3,
		label: 'PT/CT',
		toolTip: 'Procedures in this and other engagement(s) [PT-only]',
		value: 'In this and other engagement(s) [PT-only]'
	}
];

export const AccountType = [
	{ id: 1, accounttypename: 'Significant account' },
	{ id: 2, accounttypename: 'Limited risk account' },
	{ id: 3, accounttypename: 'Insignificant account' },
	{ id: 4, accounttypename: 'Other account' },
	{ id: 5, accounttypename: 'Significant disclosure' }
];

export const statementTypes = [
	{ id: 1, name: 'Income Statement' },
	{ id: 2, name: 'Balance Sheet' },
	{ id: 3, name: 'Both' }
];

export const CreateEditAccountLabels = {
	createModalDescription: `Enter the new account details below and select '<b>{0}</b>' to finish. To create another account, select '<b>{1}</b>'.`,
	editModalDescription: `Edit the account details below and select '<b>{0}</b>' to finish.`,
	close: 'Close',
	cancel: 'Cancel',
	yes: 'Yes',
	no: 'No',
	createAccount: 'New account',
	editAccount: 'Edit account',
	delete: 'Delete',
	save: 'Save',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	accountNameLabel: 'Account name (required)',
	accountDesignationLabel: 'Designation',
	accountExecutionTypeLabel: 'In which Canvas engagement will procedures for this account be performed and documented?',
	accountEstimateLabel: 'Is this account impacted by an estimate?',
	accountStatementTypeLabel: 'Statement type',
	pspIndexDropdownLabel: 'PSP index (required, select up to 5)',
	removePSPIndexLabel: 'Remove PSP index',
	assertionsLabel: 'Select relevant assertions',
	assertionOptions: assertions,
	executionTypeOptions: executionType,
	accountTypeOptions: AccountType,
	statementTypeOptions: statementTypes,
	confirm: 'Confirm',
	pspIndexErrorMsg: 'Required',
	assertionWarningMessage:
		'You cannot make changes to assertion(s) that have a Significant risk, or Fraud risk, or Risk of material misstatement or an estimate related. You need to remove these relations first.',
	confirmChanges: 'Confirm changes',
	executionTypeWarningMessage:
		'The changes you are going to save to this account will affect the existing assertions and PSPs, the links will be broken. Are you sure that you want to proceed? This action cannot be undone.',
	contentUpdateToastMessage:
		'Content update is available for {0}. Please initiate the content update from the Content update page.',
	assertionsRequired: 'At least one assertion should be selected',
	pspIndexDisabledLabel: 'Select up to five PSP Indexes. Deselect one or more options to continue.',
	newSignificantDisclosure: 'New significant disclosure',
	noOptionsMessage: 'No results found',
	accountNameErrorMsg: 'Required'
};

export const CreateMestLabels = {
	createModalTitle: 'New entity',
	createModalDescription: `Enter entity below and select '<b>{0}</b>' to finish. To create another entity, select '<b>{1}</b>'.  Entities are how we plan to approach the audit and may not be legal entitles but instead business units or other combinations.`,
	close: 'Close',
	cancel: 'Cancel',
	save: 'Save',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	entityNameLabel: 'Entity name',
	entityStandardIndexLabel: 'Entity standard Index',
	entityDescriptionLabel: 'Entity description (optional)',
	entityNameErrorMsg: 'Required',
	entityStandardIndexErrorMsg: 'Required'
}

export const CreateEditSCOTLabels = {
	createModalTitle: 'New SCOT',
	editModalTitle: 'Edit SCOT',
	createModalDescription: `Enter the new SCOT details below and select '<b>{0}</b>' to finish. To create another SCOT, select '<b>{1}</b>'.`,
	editModalDescription: `Edit the SCOT details below and select '<b>{0}</b>' to finish.`,
	close: 'Close',
	cancel: 'Cancel',
	save: 'Save',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	scotNameLabel: 'SCOT name (required)',
	scotStrategyLabel: 'SCOT strategy',
	scotTypeLabel: 'SCOT type',
	scotTypeOptions: scotTypes,
	hasEstimateLabel: 'Is this SCOT impacted by an estimate?',
	itAPPUsedLabel: 'Are any IT applications used?',
	routine: 'Routine',
	nonRoutine: 'Non-Routine',
	controls: 'Controls',
	substantive: 'Substantive',
	yes: 'Yes',
	scotNameErrorMsg: 'Required',
	remove: 'Remove',
	noOptionsMessage: 'No results found',
	wtDetailPrefix: '<p>For all routine and non-routine SCOTs and significant disclosure processes, we confirm our understanding every period by performing walkthrough procedures. In addition, for PCAOB audits, we perform walkthrough procedures of estimation SCOTs.<br/>For all SCOTs when we take a controls reliance strategy, and for controls that address significant risks, we confirm that relevant controls have been appropriately designed and implemented. We confirm that our decision to take a controls reliance strategy is still appropriate.<br/><br/>We conclude that our documentation accurately describes the operation of the SCOT and we have identified all appropriate WCGWs, including risks that arise from using IT, and relevant controls (when applicable).<br/><br/> For estimation SCOTs when we use a substantive only strategy, we determine whether our understanding of the estimation SCOT is appropriate based on our substantive procedures.</p>',
	disabledTabTooltipMessage: 'Select "Are any IT applications used?" to relate IT applications',
	itAppLabels: {
		tabLabel: 'IT apps',
		dropdownLabel: 'Relate IT applications',
		noRelatedItems: 'No related IT applications',
		itApplications: 'IT applications'
	},
	soLabels: {
		tabLabel: 'SOs',
		dropdownLabel: 'Relate service organizations',
		noRelatedItems: 'No related service organizations',
		serviceOrganizations: 'Service organizations'
	}
};

export const CreateEditWCGWLabels = {
	wcgwName: "WCGW name (required)",
	editWCGW: "Edit WCGW",
	editTheWCGW: `Edit the WCGW details below and select '<b>{0}</b>' to finish.`,
	createNewWCGW: `Enter the new WCGW details below and select '<b>{0}</b>' to finish. To create another WCGW, select '<b>{1}</b>'.`,
	createEditWCGWModelScot: "SCOT",
	newWCGWTitel: "New WCGW",
	editWCGWSave: "Save",
	editWCGWClose: "Cancel",
	closeTitle: "Close",
	wcgwNameIsRequired: "Required",
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
};

export const controlFrequencyTypes = [
	{ value: 1, label: 'Many times per day' },
	{ value: 2, label: 'Daily' },
	{ value: 3, label: 'Weekly' },
	{ value: 4, label: 'Monthly' },
	{ value: 5, label: 'Quarterly' },
	{ value: 6, label: 'Annually' },
	{ value: 8, label: 'Other' }
];

export const controlTypes = [
	{ value: 1, label: 'IT application control' },
	{ value: 2, label: 'IT dependent manual control' },
	{ value: 3, label: 'Manual prevent' },
	{ value: 4, label: 'Manual detect' }
];

export const CreateEditControlLabels = {
	createModalTitle: 'New control',
	editModalTitle: 'Edit control',
	close: 'Close',
	cancel: 'Cancel',
	save: 'Save',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	controlNameLabel: 'Control name (required)',
	frequency: 'Frequency',
	controlType: 'Control type',
	frequencyTypeOptions: controlFrequencyTypes,
	controlTypeOptions: controlTypes,
	designEffectiveness: 'Design effectiveness',
	operatingEffectiveness: 'Operating effectiveness',
	testingLabel: 'Testing',
	lowerRiskLabel: 'Is control lower risk?',
	ITDMControlSubstantiveTestingOptionLabel: 'The automated portion of this ITDM control is only the use of system-generated report(s) that are tested substantively',
	effective: 'Effective',
	ineffective: 'Ineffective',
	yes: 'Yes',
	no: 'No',
	required: 'Required',
	remove: 'Remove',
	noOptionsMessage: 'No results found',
	disabledTabTooltipMessage: 'Select "Control type" as "IT application control" or "IT dependent manual control" to relate IT applications',
	itAppLabels: {
		tabLabel: 'IT apps',
		dropdownLabel: 'Relate IT applications',
		noRelatedItems: 'No related IT applications',
		itApplications: 'IT applications'
	},
	soLabels: {
		tabLabel: 'SOs',
		dropdownLabel: 'Relate service organizations',
		noRelatedItems: 'No related service organizations',
		serviceOrganizations: 'Service organizations'
	},
	controlNameErrorMsg: 'Required',
	createModalDescriptionLabel: `Enter the new control details below and select '<b>{0}</b>' to finish. To create another control, select '<b>{1}</b>'.`,
	editModalDescriptionLabel: `Edit the control details below and select '<b>{0}</b>' to finish.`,
	wcgwLabel: 'WCGW'
};

export const CreateEditITApplicationLabels = {
	close: 'Close',
	cancel: 'Cancel',
	yes: 'Yes',
	no: 'No',
	delete: 'Delete',
	save: 'Save',
	closeTitle: "Close",
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	iTApplicationNameLabel: 'IT application name (required)',
	iTSOApplicationNameLabel: 'Service organization name',
	newITApplicationLabel: 'New IT application',
	newITSOApplicationLabel: 'New Service Organization',
	editITApplicationLabel: 'Edit IT application',
	confirm: 'Confirm',
	confirmChanges: 'Confirm changes',
	noOptionsMessage: 'No results found',
	iTAppNameErrorMsg: 'Required',
	iTSOAppNameErrorMsg: 'Required',
	controls: 'Controls',
	substantive: 'Substantive',
	remove: 'Remove',
	iTApplicationStrategyLabel: 'IT application strategy',
	SCOTsLabel: 'SCOT names',
	StrategyLabel: 'Strategy',
	ControlsLabel: 'Control names',
	ControlTypeLabel: 'Type',
	addDescriptionLabel: `Enter the new IT application details below and select '<b>{0}</b>' to finish. To create another IT application, select '<b>{1}</b>'.`,

	editDescriptionLabel: `Edit the IT application details below and select '<b>{0}</b>' to finish.`,

	addSODescriptionLabel: `Enter the new service organization details below and select '<b>Save and close</b>' to finish. To create another service organization, select '<b>Save and create another</b>'.`,

	scotErrorMessage: 'SCOT may not be unrelated from the IT application, since there are controls related.',
	SCOTsLabels: {
		tabLabel: 'SCOTs',
		dropdownLabel: 'Relate SCOTs',
		noRelatedItems: 'No related SCOTs'
	},
	ControlsLabels: {
		tabLabel: 'Controls',
		dropdownLabel: 'Relate controls',
		noRelatedItems: 'No related controls'
	},
	strategyType: {
		1: 'Controls',
		2: 'Substantive',
		3: 'Rely',
		4: 'Not Rely'
	},
	controlType: {
		1: 'IT Application',
		2: 'IT Dependent Manual',
		3: 'Manual Prevent',
		4: 'Manual Detect'
	}
};

export const groupComponentAccountReportHeaderLabels = {
	primaryEngagementId: 'EngagementID', //show in only in excel
	gaScopeName: 'Scope',
	gaComponentId: "GAComponentID", //show in only in excel
	shortName: 'Component name',
	pocText: 'Point of contact',
	accountId: "AccountID", //show in only in excel
	accountName: 'Account name',
	accountType: 'Account designation',
	knowledgeAssertion: 'Assertion',
	inherentRiskType: 'Inherent risk',
	riskId: 'RiskID', //show in only in excel
	riskType: 'Risk type',
	riskName: 'Risk name',
	isHigherRiskText: 'Is higher risk'
};

export const AccountTypeIDs = {
	1: 'Significant Account',
	2: 'Limited Risk Account',
	3: 'Insignificant Account',
	4: 'Account - Other',
	5: 'Significant Disclosure'
};

export const InherentRiskTypeIDs = {
	1: 'Higher',
	2: 'Lower',
	3: 'Very Low'
};

export const riskTypeIDs = {
	1: 'Significant risks',
	2: 'Fraud risks',
	3: 'Risks of material misstatement'
};

export const riskTypeIDsShortForm = {
	1: 'SR',
	2: 'FR',
	3: 'ROMM'
};

export const ControlRiskTypeIDs = {
	1: 'Rely',
	2: 'Not Rely',
	3: 'Test MP'
};

export const knowledgeAssertions = {
	1: 'Completeness',
	2: 'Existence',
	3: 'Valuation',
	4: 'Rights and Obligations',
	5: 'Presentation and Disclosure',
	6: 'Completeness',
	7: 'Occurrence',
	8: 'Measurement',
	9: 'Presentation and Disclosure',
	10: 'Completeness',
	11: 'Existence/Occurrence',
	12: 'Measurement/Valuation',
	13: 'Rights and Obligations',
	14: 'Presentation and Disclosure'
};

export const gaInstructionStatuslabels = {
	0: 'Undefined',
	[instructionStatus.notSent]: 'Not sent',
	[instructionStatus.pending]: 'Pending',
	[instructionStatus.accepted]: 'Accepted',
	[instructionStatus.rejected]: 'Returned',
	[instructionStatus.systemError]: 'System error',
	[instructionStatus.expired]: 'Expired',
	[instructionStatus.sent]: 'Sent',
	[instructionStatus.unlinked]: 'Unlinked',
	[instructionStatus.queued]: 'Queued'
}
	;

export const financialStatementTypeLabels = {
	[financialStatementType.Asset]: 'Asset',
	[financialStatementType.CurrentAsset]: 'Current Asset',
	[financialStatementType.NonCurrentAsset]: 'Non-Current Asset',
	[financialStatementType.Liability]: 'Liability',
	[financialStatementType.CurrentLiability]: 'Current Liability',
	[financialStatementType.NonCurrentLiability]: 'Non-Current Liability',
	[financialStatementType.Equity]: 'Equity',
	[financialStatementType.Revenue]: 'Revenue',
	[financialStatementType.Expense]: 'Expense',
	[financialStatementType.NonOperatingIncome]: 'Non-Operating Income/(Expense)',
	[financialStatementType.OtherComprehensiveIncome]: 'Other Comprehensive Income',
	[financialStatementType.Other]: 'Other',
	[financialStatementType.AccountType]: 'Account Type',
	[financialStatementType.AccountSubType]: 'Account Sub-Type',
	[financialStatementType.AccountClass]: 'Account Class',
	[financialStatementType.AccountSubClass]: 'Account Sub-Class',
	[financialStatementType.NetIncomeExpense]: 'Net (Income) / Expense',
	18: 'GLAccount'
};

export const trialBalanceTypeLabels = {
	[trialBalanceType.Planning]: 'Planning'
};

export const createEditRiskModalLabels = {
	createModalDescription: `Enter the new risk details below and select '<b>{0}</b>' to finish. To create another risk, select '<b>{1}</b>'.`,
	editModalDescription: `Edit the risk details below and select '<b>{0}</b>' to finish.`,
	close: 'Close',
	cancel: 'Cancel',
	createRisk: 'New risk',
	editRisk: 'Edit risk',
	riskType: 'Risk type (required)',

	riskTypeOptions: [
		{ value: 1, label: 'Significant risk' },
		{ value: 2, label: 'Fraud risk' },
		{ value: 3, label: 'Risk of material misstatement' }
	],
	save: 'Save',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	riskNameLabel: 'Risk name (required)',
	relatedAccountsAssertionsLabel: 'Related accounts and assertions (optional)',
	relateAccounts: 'Relate accounts and assertions (optional)',
	assertionsLabel: 'Select relevant assertions',
	riskNameErrorMsg: 'Required',
	riskTypeErrorMsg: 'Required',
	assertionOptions: assertions,
	removeAccountLabel: 'Remove account',
	required: 'Required',
	assertionsRequired: 'At least one assertion should be selected'
};

export const activityTypeLabels = {
	104: 'Added',
	105: 'Removed'
};
export const superModalNavigationLabels = {
	identifyAccountsAndDisclosures: 'Identify accounts and disclosures',
	identifySCOTs: 'Identify SCOTs and relate to accounts',
	determineSCOTStrategy: 'Determine SCOT strategy',
	identifyWCGWAndControls: 'Identify WCGWs and controls',
	selectControlToTest: 'Select controls to test',
	identifyRisks: 'Identify risks',
	relateWCGWsToAssertions: 'Relate WCGWs to assertions',
	relateRisksToWCGWs: 'Relate risks to WCGWs',
	determineCRA: 'Determine CRA',
	timephase: 'Timephase',
	SCOTWT: 'Create WT',
	controlTOC: 'Create TOC',
	ITProcessUDP: 'Create UDP',
	ITGC_ITSP_TOC_OSP: 'Create IT TOC/OSP',
	accountPSP: 'Create PSP',
	accountOSP: 'Create OSP',
	relateWCGWTo: 'Relate WCGW to',
	relatedWCGWToTask: 'Relate WCGW to task',
	respondToSignificant_fraudRisks: 'Respond to significant/fraud risks',
	OST: 'OST',
	accountSummary: 'Account summary',
	SCOTSummary: 'SCOT summary',
	ITSummary: 'IT summary',
	understandITProcesses: 'Understand IT processes',
	evaluateIT: 'Evaluate IT',
	CRASummary: 'CRA summary',
	auditPlan: 'Audit plan',
	workplanSummary: 'Workplan summary',
	buildSteps: 'Build steps',
	ITApplicationsAndITProcesses: 'IT applications and IT processes',
	workPlan: 'Work plan',
	accounts: 'Accounts',
	scots: 'SCOTs',
	cra: 'CRA',
	openInNewTab: 'Open in new tab'
}
export const auditPlanITProcessLabels = {
	itProcess: 'IT process',
	itProcesses: 'IT processes',
	tasks: 'Tasks',
	sectionHeading: 'IT process and related understand the process (UDP) tasks',
	subHeader: 'Understand the IT process',
	visualDistinctMessage: 'Each IT process must have at least one related UDP. Create {0} or {1}.',
	addUdp: 'New UDP',
	relatedUdp: 'Relate UDPs',
	toggleFilter: 'Show only IT processes without any related UDP',
	noResultsFound: 'No results found',
	taskTitle: 'Understand and document the IT Process: {0}',
	taskDescription:
		'Document our understanding of the IT process. Attach the relevant form as evidence to support our understanding of the IT process. When ITGCs appear in the Task Attributes section, perform walkthrough procedures to confirm our understanding of the ITGCs and evaluate their design and implementation. Attach evidence of our procedures.',
	noRecordsAvailable: 'No IT processes available',
	unrelatedLabel: 'View unrelated UDPs',
	unrelatedModalHeader: 'Unrelated UDP tasks',
	noUnrelatedTaskPlaceholder: 'No unrelated UDP tasks available',
	noTaskselectedLabel: 'At least one task must be selected for deletion',
	relateITProcessTaskTitle: 'Relate UDPs to IT process',
	understandITProcesses: 'Understand IT processes',
	unrelatedTasksMustBeAssociated: 'Unrelated tasks must be associated to an IT process or deleted.'
}

export const noEvidenceReferencedReasonsLabels = {
	immaterialReason: 'Immaterial: Balance/activity does not meet testing scope - further investigation waived',
	strikethroughMText: 'm',
	waivedReason: 'Waived: Amount below SAD - further investigation waived',
	strikethroughWText: 'w'
}
export const auditPlanScotListLabels = {
	scot: 'SCOT',
	scots: 'SCOTs',
	tasks: 'Tasks',
	sectionHeading: 'SCOTs and related walkthrough tasks',
	subHeader: 'Walkthrough tasks',
	visualDistinctMessage: 'Each SCOT must have at least one related walkthrough. Create {0} or {1}.',
	newWT: 'New WT',
	relatedWT: 'Relate WTs',
	toggleFilter: 'Show only SCOTs without any related WT',
	noResultsFound: 'No results found',
	noRecordsAvailable: 'No SCOTs available',
	relateScotTaskTitle: 'Relate WTs to SCOT',
	taskTitle: 'Walkthrough: {0}',
	taskDescription: '<p>For all routine and non-routine SCOTs and significant disclosure processes, we confirm our understanding every period by performing walkthrough procedures. In addition, for PCAOB audits, we perform walkthrough procedures of estimation SCOTs.<br/>For all SCOTs when we take a controls reliance strategy, and for controls that address significant risks, we confirm that relevant controls have been appropriately designed and implemented. We confirm that our decision to take a controls reliance strategy is still appropriate.<br/><br/>We conclude that our documentation accurately describes the operation of the SCOT and we have identified all appropriate WCGWs, including risks that arise from using IT, and relevant controls (when applicable).<br/><br/> For estimation SCOTs when we use a substantive only strategy, we determine whether our understanding of the estimation SCOT is appropriate based on our substantive procedures.</p>',
	unrelatedLabel: 'View unrelated WTs',
	unrelatedModalHeader: 'Unrelated WT tasks',
	noUnrelatedTaskPlaceholder: 'No unrelated WT tasks available',
	noTaskselectedLabel: 'At least one task must be selected for deletion.',
	manageScots: 'Manage SCOTs',
	unrelatedTasksMustBeAssociated: 'Unrelated tasks must be associated to a SCOT or deleted.'
}
export const auditPlanControlsLabels = {
	control: 'Control',
	controls: 'Controls selected for testing',
	tasks: 'Tasks',
	sectionHeading: 'Controls and related test of controls',
	subHeader: 'Test of control tasks',
	visualDistinctMessage: 'Each control must have at least one related test of control. Create {0} or {1}.',
	addToc: 'New TOC',
	relatedToc: 'Relate TOCs',
	toggleFilter: 'Show only controls without any related TOC',
	noResultsFound: 'No results found',
	noRecordsAvailable: 'No controls selected for testing',
	unrelatedLabel: 'View unrelated TOCs',
	unrelatedModalHeader: 'Unrelated TOC tasks',
	noUnrelatedTaskPlaceholder: 'No unrelated TOC tasks available',
	noTaskselectedLabel: 'At least one task must be selected for deletion.',
	relateControlTaskTitle: 'Relate TOCs to Control',
	manageControl: 'Manage controls',
	taskTitleTOC: 'Test of control: {0}',
	taskDescriptionTOC:
		'Design the nature, timing and extent of our tests of controls to obtain sufficient appropriate audit evidence that the control operates effectively as designed throughout the period of reliance to prevent or detect and correct material misstatements at the assertion level.<br/>Conclude on the operating effectiveness of controls, by evaluating the results of our tests of controls including when we extended our sample size and performed tests of compensating controls.',
	manageControls: "Manage controls",
	unrelatedTasksMustBeAssociated: 'Unrelated tasks must be associated to a control or deleted.'
}
export const industrySelectionGroupLabels = {
	1: 'Selected industries',
	2: 'Other industries'
}


export const knowledgeDataLabels = {
	industry: 'Industry',
	showSelected: 'Show only selected',
	noContent: 'No content is available from Knowledge for the selected industry',
	importFromKnowledge: 'Import from Knowledge',
	importAccounts: 'Import Accounts',
	importAccountsAndDisclosures: 'Import accounts and disclosures',
	accountBuild1: 'Account build step 1',
	import: 'Import',
	close: 'Close',
	cancel: 'Cancel',
	selected: 'selected',
	scotTitle: 'SCOT build 1',
	importScots: 'Import SCOTs',
	noKnowledgeDataResult: 'No content is available for the selection',
	showOnlySelectedLabel: 'Show only selected',
	scot: 'SCOT',
	scotDropdownLabel: 'SCOT for selected Industry',
	importWcgw: 'Import WCGWs',
	importFailedLabel: 'Import failed. Try to Import again.',
	wtDetailPrefix: '<p>For all routine and non-routine SCOTs and significant disclosure processes, we confirm our understanding every period by performing walkthrough procedures. In addition, for PCAOB audits, we perform walkthrough procedures of estimation SCOTs.<br/>For all SCOTs when we take a controls reliance strategy, and for controls that address significant risks, we confirm that relevant controls have been appropriately designed and implemented. We confirm that our decision to take a controls reliance strategy is still appropriate.<br/><br/>We conclude that our documentation accurately describes the operation of the SCOT and we have identified all appropriate WCGWs, including risks that arise from using IT, and relevant controls (when applicable).<br/><br/> For estimation SCOTs when we use a substantive only strategy, we determine whether our understanding of the estimation SCOT is appropriate based on our substantive procedures.</p>',
	importOSP: 'Import OSPs',
	auditPlanBuild7: 'Audit Plan Build 7',
	account: 'Account',
	accountName: 'PSP Indexes',
	wcgwName: 'WCGWs',
	selectScot: 'Select SCOT',
	wcgwTitle: 'SCOT build 3',
	noResultFound: 'No results found',
	importValidationMessage: 'A selection is required',
	searchIconHoverLabel: 'Search',
	scotsHeader: 'SCOTs',
	controlsHeader: 'Controls',
	ospsHeader: 'OSPs',
	wcgw: 'WCGW',
	importControls: 'Import controls',
	accountAssertionsValidationMessage: 'Task assertions are missing',
	accountsAndDisclosures: 'Accounts and disclosures',
}

export const auditPlanITControlsLabels = {
	itcontrol: 'IT control',
	itcontrols: 'IT controls selected for testing',
	tasks: 'Tasks',
	type: 'Type',
	sectionHeading: 'ITGCs, ITSPs, and related test of controls and substantive tasks',
	subHeader: 'TOC/OSP tasks',
	visualTOCDistinctMessage: 'Each ITGC must have at least one related test of control. Create {0} or {2}.',
	visualOSPDistinctMessage: 'Each ITSP must have at least one related substantive procedure. Create {1} or {3}.',
	addTOC: 'New TOC',
	addOSP: 'New OSP',
	relatedTOCOSP: 'Relate TOCs/OSPs',
	relatedTOC: 'Relate TOCs',
	relatedOSP: 'Relate OSPs',
	toggleFilter: 'Show only IT controls without any related TOC/OSP',
	noResultsFound: 'No results found',
	noRecordsAvailable: 'No ITGCs selected for testing',
	taskTitleTOC: 'Test of control: {0}',
	taskDescriptionTOC: 'Perform our designed tests of ITGCs to obtain sufficient appropriate audit evidence of their operating effectiveness throughout the period of reliance.',
	taskTitleOSP: 'Other substantative procedure: {0}',
	taskDescriptionOSP: 'Customize this task description to design the nature, timing and extent of IT-substantive procedures to obtain sufficient appropriate audit evidence that the IT risks are addressed effectively throughout the period of reliance.<br>When the IT-substantive procedure is performed as of an interim date, design and perform procedures to obtain additional evidence that the IT risks are addressed for the period covered by our interim procedures through period-end.<br>We conclude on the results of our IT-substantive procedures.',
	relateITControlTaskTitle: 'Relate TOCs/OSPs to IT control',
	relateITControlTOCTaskTitle: 'Relate TOCs to ITGC',
	relateITControlOSPTaskTitle: 'Relate OSPs to ITSP',
	unrelatedModalHeader: 'Unrelated TOC/OSP tasks',
	noUnrelatedTaskPlaceholder: 'No unrelated TOC/OSP tasks available',
	noTaskselectedLabel: 'At least one task must be selected for deletion.',
	unrelatedLabel: 'View unrelated TOCs/OSPs',
	understandITProcesses: 'Understand IT processes',
	unrelatedTasksMustBeAssociated: 'Unrelated tasks must be associated to an IT control or deleted.'
}

export const generalLabelsForMobile = {
	noRecordsFound: 'No results found within this task category',
	taskListTitle: 'My tasks',
	taskEvidenceTitle: 'Evidence',
	cameraPagesTitle: 'Pages',
	cameraTitle: 'Camera',
	taskDetailsTitle: 'Task details',
	invalidPage: 'No Page Found',
	combinedTaskLabel: 'PIC/EQR',
	picTaskLabel: 'PIC',
	eqrTaskLabel: 'EQR',
	pageLabel: 'Page',
	ofLabel: 'of',
	noTasksAvailable: 'No tasks available',
	searchLabel: 'Search...',
	noDescriptionAvailable: 'No description available.',
	knowledge: 'Knowledge',
	description: 'Description',
	knowledgeDescription: 'Knowledge description',
	customized: 'Customized',
	taskDetailsTitle: 'Task details',
	unassigned: 'Unassigned',
	assignTo: 'Assigned to ',
	signOffLabel: 'Sign-offs',
	evidenceNoteLabel: 'Evidence Notes',
	attributeLabel: 'Attributes',
	addNoteLabel: 'New note',
	addCommentLabel: 'Add comment',
	editCommentLabel: 'Update comment',
	addReplyNoteLabel: 'Reply to this note',
	replyNoteLabel: 'Reply',
	replyEditNoteLabel: 'Edit Reply',
	enterReplyPlaceholder: 'Enter reply',
	editNoteLabel: 'Edit',
	deleteNoteLabel: 'Delete',
	reopenNoteLabel: 'Reopen',
	closeNoteLabel: 'Close',
	clearNoteLabel: 'Clear',
	preparerAbbrv: 'P',
	reviewerAbbrv: 'R',
	uploadPhoto: 'Upload photo',
	noEvidenceFound: 'No evidence is associated to the task',
	noRegionComponentFound: 'No documents received from regional or component team',
	noEvidenceMessage: 'Click Upload photo to upload evidences',
	noNotesFound: 'No notes found',
	noNotesStatement: 'Leave a note by using the inputs below. Assign the note to a user and specify the priority and due date.',
	regionComponentEvidence: 'Region and component evidence',
	documentWarning: 'Downloaded document will be read-only. Please dispose of the file when done.',
	preparerTitle: 'Preparer sign-offs',
	reviewerTitle: 'Reviewer sign-offs',
	teamLabel: 'Team',
	saveEvidenceTitle: 'Save evidence',
	saveButton: 'Save',
	cancelButton: 'Cancel',
	confirmButtonLabel: 'Confirm',
	previewButton: 'Preview',
	evidenceLable: 'Name of the evidence',
	mergingTitleLable: 'images merged to PDF.',
	showErrFileExistMsg: 'File name already exists.Please rename the file.',
	showErrForNoImgExist: 'No images available for PDF generation.',
	showErrBlankFileNameMsg: 'File name cannot be blank.',
	showIsCompletedMessage: 'File uploaded successfully.',
	uploadingTitle: 'Processing',
	showErrImgContext: 'useImages must be used within an ImagesProvider',
	PagePreviewTitle: 'Page',
	regionComponentEvidenceLabel: 'Region and component evidence',
	downloadProcessLabel: 'Downloading...',
	downloadCompleteLabel: 'Download Complete',
	taskNotes: 'Task notes',
	documentNotes: 'Document notes',
	dueDateLabel: 'Due date',
	view: 'View:',
	documentNotes: 'Document notes',
	newNote: 'Add note',
	editNote: 'Edit note',
	assignedTo: 'Assigned to',
	priority: 'Priority',
	select: 'Select',
	dueDate: 'Due date',
	addNewNote: 'Add a new note',
	addNote: 'Add note',
	updateNote: 'Update note',
	enterDescription: 'Enter a description...',
	allnotes: 'All notes',
	mynotes: 'My notes',
	assignedToMe: 'Assigned to me',
	hashValue: '#',
	showLessToggle: 'Show less',
	showMoreToggle: 'Show more',
	delete: 'Delete',
	deleteNoteModalTitle: 'Delete message',
	deleteReplyModalTitle: 'Delete reply',
	confirmDeleteNoteLabel: 'Are you sure that you want to delete the selected note?',
	confirmDeleteReplyLabel: 'Are you sure that you want to delete your reply to this note?',
	downloadInfo: 'Downloading a file containing # character is not allowed',
	evidenceFileValidationInfo: 'File Name cannot include */ : <>\?| " characters',
	previewPageTitle: 'Preview',
	redirecting: 'Redirecting to landing page in few seconds...',
	redirectingToTask: 'Redirecting to \'My Tasks\' page in few seconds...',
	errorApplyingConstraints: 'Error applying constraints:',
	zoomIsNotSupported: 'Zoom is not supported on this device.',
	errorCheckingCameraCapability: 'Error checking camera capabilities:',
	previous: 'previous',
	next: 'next',
	after: 'after',
	redirectingToTaskDetails: 'Redirecting to task details in few seconds',
	mobileURL: '/mobile'
};
export const RNHNoteMobileStatusOptions = [{
	value: 1,
	label: 'Open'
},
{
	value: 2,
	label: 'Cleared'
},
{
	value: 3,
	label: 'Closed'
}
];
export const auditPhaseTypes = [
	{ value: 1, label: 'Scope & Strategy' },
	{ value: 2, label: 'Execution' },
	{ value: 3, label: 'Conclusion' },
];
export const CreateEditTaskSectionLabels = {
	createModalTitle: 'New task group',
	editModalTitle: 'Edit task group',
	createModalDescription: `Enter task group details below and select '<b>{0}</b>' to finish. To create another task group, select '<b>{1}</b>'.`,
	editModalDescription: `Edit the task group details below and select '<b>{0}</b>' to finish.`,
	close: 'Close',
	cancel: 'Cancel',
	save: 'Save',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	taskSectionNameLabel: 'Task group name (required)',
	taskSectionNameErrorMsg: 'Required',
	engagementPhaseOptions: auditPhaseTypes,
	engagementPhaseLabel: 'Engagement phase (required)',
	engagementPhaseErrorMsg: 'Required',
};
export const auditPhaseLabels = {
	1: 'Scope & strategy',
	2: 'Execution',
	3: 'Conclusion',
	4: 'Perform preliminary engagement activities',
	5: 'Identify and assess risks',
	6: 'Respond to risks',
	7: 'Conclude and report'
};

export const ITApproachType = {
	1: 'ITGC',
	2: 'ITSP'
};

// taskbuildmilestoneid labels
export const taskBuildMilestoneId = [
	{
		id: 1,
		label: superModalNavigationLabels.identifyAccountsAndDisclosures
	},
	{
		id: 31,
		label: superModalNavigationLabels.identifyAccountsAndDisclosures
	},
	{
		id: 5,
		label: superModalNavigationLabels.identifySCOTs
	},
	{
		id: 32,
		label: superModalNavigationLabels.identifySCOTs
	},
	{
		id: 6,
		label: superModalNavigationLabels.determineSCOTStrategy
	},
	{
		id: 7,
		label: superModalNavigationLabels.identifyWCGWAndControls
	},
	{
		id: 38,
		label: superModalNavigationLabels.identifyWCGWAndControls
	},
	{
		id: 8,
		label: superModalNavigationLabels.selectControlToTest
	},
	{
		id: 2,
		label: superModalNavigationLabels.identifyRisks
	},
	{
		id: 15,
		label: superModalNavigationLabels.relateWCGWsToAssertions
	},
	{
		id: 30,
		label: superModalNavigationLabels.relateRisksToWCGWs
	},
	{
		id: 3,
		label: superModalNavigationLabels.determineCRA
	},
	{
		id: 18,
		label: superModalNavigationLabels.SCOTWT
	},
	{
		id: 19,
		label: superModalNavigationLabels.controlTOC
	},
	{
		id: 20,
		label: superModalNavigationLabels.ITProcessUDP
	},
	{
		id: 21,
		label: superModalNavigationLabels.ITGC_ITSP_TOC_OSP
	},
	{
		id: 25,
		label: superModalNavigationLabels.accountPSP
	},
	{
		id: 26,
		label: superModalNavigationLabels.accountOSP,
	},
	{
		id: 27,
		label: superModalNavigationLabels.respondToSignificant_fraudRisks
	},
	{
		id: 56,
		label: superModalNavigationLabels.respondToSignificant_fraudRisks
	},
	{
		id: 29,
		label: superModalNavigationLabels.relatedWCGWToTask
	},
	{
		id: 39,
		label: superModalNavigationLabels.respondToSignificant_fraudRisks
	},
	{
		id: 50,
		label: superModalNavigationLabels.OST
	}];

export const noEvidenceReferencedReasons = [
	{
		id: 1,
		reason: noEvidenceReferencedReasonsLabels.immaterialReason,
		glAccountTypeId: 12,
		strikethroughText: noEvidenceReferencedReasonsLabels.strikethroughMText
	},
	{
		id: 2,
		reason: noEvidenceReferencedReasonsLabels.waivedReason,
		glAccountTypeId: 13,
		strikethroughText: noEvidenceReferencedReasonsLabels.strikethroughWText
	}
];

export const createEditAdjustmentLabels = {
	createModalTitle: 'New adjustment',
	editModalTitle: 'Edit adjustment',
	createModalDescription: `Enter adjustment details below and select '<b>{0}</b>' to finish. To create another adjustment, select '<b>{1}</b>'.`,
	editModalDescription: `Edit adjustment details below and select '<b>{0}</b>' to finish. To delete the adjustment click '<b>{1}</b>'.`,
	close: 'Close',
	cancel: 'Cancel',
	save: 'Save',
	saveAndCloseLabel: 'Save and close',
	saveAndCreateLabel: 'Save and create another',
	delete: 'Delete',
	adjustmentNameLabel: 'Adjustment index (required)',
	adjustmentDescriptionLabel: 'Adjustment description (required)',
	adjustmentDescriptionPlaceholder: 'Adjustment description (required)',
	required: 'Required',
	editDescriptionModal: 'Edit adjustment description',
	descriptionRequired: 'Adjustment description is required',
	uploadDocumentPlaceholder: 'Adjustment must be saved before it can be related to the evidence.',
	generalLedgerAccount: 'GL accounts (required)',
	documentHeader: 'Documents (required)',
	addDocumentButton: 'Add evidence',
	glAccountPlaceholder: 'GL account is not available. To add the account click {0}.',
	adjustmentIndex: 'Adjustment index',
	addglaccountbutton: 'Add GL account',
	descriptionMaxLengthError: 'Response exceeds maximum allowed.',
	glaccountTotalError: 'Total of debit entries should equal the total of credit entries',
	glaccountIdDuplicate: 'Each GL account should be used only once in the adjustment',
	placeholderText: 'No related documents. To relate a document click <a>Add evidence<a>',
	editAdjustmentDescriptionHeader: 'Edit adjustment description',
	editAdjustmentDescriptionSubHead: 'Edit adjustment description details below and select \'<b>Save</b>\' to finish.'
};

export const addUpdateGlAccountLabels = {
	addGLaccountTitle: 'Add GL account',
	glaccountDescription: `Enter GL account details below and select '<b>{0}</b>' to finish. To add another GL Account, select '<b>{1}</b>'.`,
	addAndClose: 'Add and close',
	addAnother: 'Add another',
	accountSubClassPlaceholder: 'Account sub-class',
	glAccountsPlaceholder: 'Select account sub-class to see available GL accounts.',
	glAccountListHeaderColumn: 'GL Account',
	amountLabel: 'Amount (required)',
	debitCreditOptions: [
		{ id: 1, label: 'Debit' },
		{ id: 2, label: 'Credit' }
	],
	searchPlaceholder: 'Search',
	newGlAccount: 'New reconciling account',
	noResultsFound: 'No results found',
	noRecordsPlaceholder: `No reconciling accounts found for selected account sub-class. Select a different sub-class or click {0} to add reconciling account to selected account sub-class.`,
	editTitleTip: 'Edit reconciling account',
	removeTitleTip: 'Delete reconciling account',
	custom: "Custom",
	duplicateGLAccount: "Each GL account should be used only once in the adjustment",
	updateModalTitle: "Update reconciling account",
	updateModalDescription: `Update GL account amount and debit/credit details below and select '<b>{0}</b>' to finish.`,
	accountClassLabel: "Account class",
	glAccountLabel: "GL account",
	updateLabel: "Update",
	updateGlAccountModalTitle: "Update GL account",
}
export const deleteGLAccountLabels = {
	deleteConfirmationModallHeader: 'Delete reconciling account',
	deleteConfirmationModalBodyHeader: 'Are you sure that you want to delete the selected reconciling account? This action cannot be undone.',
	deleteConfirmationModalAccountSubClass: 'Account sub-class:',
	deleteConfirmationModalAccountName: 'Account name:',
	deleteConfirmationModalGLAccountName: 'Reconciling account name:',
	closeButtonTitle: 'Cancel',
	confirmBtnTitle: 'Delete'

}
export const glAccountListLabel = {
	accountClass: 'Account class',
	accountSubClass: 'Account sub-class',
	glAccount: 'GL account',
	debit: 'Debit',
	credit: 'Credit',
	actions: 'Actions',
	editTitleTip: 'Edit GL account',
	removeTitleTip: 'Remove GL account'
}

export const EngagementMapLabels = {
	objectivePreviewMessage: 'Hover over a map item to preview',
	noMapAvailableMessage: 'No map available.',
	takeContentUpdateMessage: 'Take a content update to get the latest map.',
	noRecordsLabel: 'No records found.',
	auditTopic: 'Audit topic',
	auditTopicPlaceholder: 'Select topic to view',
	numberSelected: '{0} topics selected',
	refreshMapTitletip: 'Click here to initiate the engagement map update',
	mapUpdateInProgress: 'Update in progress. It may take up to ten minutes for the update to complete.',
	refreshMapsLabel: "Refresh maps",
}

export const createEditGLAccountLabels = {
	createModalTitle: "New reconciling account",
	editModalTitle: "Edit reconciling account",
	createModalDescription: `Enter reconciling account details below and select '<b>{0}</b>' to finish. To add another reconciling account, select '<b>{1}</b>'.`,
	editModalDescription: `Edit reconciling account details below and select '<b>{0}</b>' to finish.`,
	accountSubClass: "Account sub-class",
	accountName: "Account name (required)",
	glAccountName: "Reconciling account name (required)",
	cancelbtn: "Cancel",
	saveAndAddbtn: "Save and add another",
	saveAndClosebtn: "Save and close",
	save: 'Save',
	required: 'Required',
}

//Receive instructions switcher
export const receiveInstructionSwitcherLabels = {

	[receiveInstructionSwitcherIds.groupInstructions]: 'Group instructions',
	[receiveInstructionSwitcherIds.groupRiskAssessment]: 'Group risk assessment',
	[receiveInstructionSwitcherIds.documents]: 'Documents'
};

export const misstatementEvidenceLabels = {
	placeholderText: 'No related evidence. At least one supporting evidence must be associated. To relate an evidence click {0}.',
	addEvidenceBtn: 'Add evidence',
};

export const misstatementTempLabels = {
	placeholderText: 'No related temporary documents. To relate a temporary document click {0}.',
	addEvidenceBtn: 'Add temporary file',
};

export const inherentRiskFactorTypes = [
	{ id: 1, label: 'Complexity', displayOrder: 1 },
	{ id: 2, label: 'Subjectivity Uncertainty', displayOrder: 2 },
	{ id: 3, label: 'Fraud or error', displayOrder: 3 },
	{ id: 4, label: 'Change', displayOrder: 4 },
	{ id: 5, label: 'Nature of account', displayOrder: 5 },
	{ id: 6, label: 'Related parties', displayOrder: 6 }
];

export const helixSettingsStepLabels = {
	title: 'Define connection settings',
	subTitle: 'Select the settings for your analyzer connection.',
	connectionNameLabel: 'Connection name',
	connectionNamePlaceholder: 'Connection name (required)',
	connetionTypesLabel: 'Connection types',
	connectionTypeScopeAndStrategy: 'Scope & Strategy',
	connectionTypeFinancionStatement: 'Financial Statements',
	includeAllBusinessUnitsField: 'Do you want to include all business units?',
	yes: 'Yes',
	no: 'No',
	businessUnitsLabel: 'Business unit(s)',
	businessUnitsPlaceholder: 'Business unit(s)',
	analysisPeriodLabel: 'Analysis date',
	analysisPeriodPlaceholder: 'Analysis date',
	comparativePeriod1Label: 'Comparative date 1',
	comparativePeriod1Placeholder: 'Comparative date 1 (optional)',
	comparativePeriod2Label: 'Comparative date 2',
	comparativePeriod2Placeholder: 'Comparative date 2 (optional)',
	currencyTypeField: 'Currency type',
	reporting: 'Reporting',
	functional: 'Functional',
	currencyCodeField: 'Currency code',
	currencyCodePlaceholder: 'Currency code (required)',
	scopeAndStrategyLabel: 'Scope & strategy',
	financialStatementLabel: 'Financial statement',

	required: 'Required',
	comparativePeriodError: 'Invalid date. Select a date prior to the analysis date.',

	dataConnectionLink: 'How to manage data connections',
	helixfiscalDropDownLabel: 'Date {0} - {1}',

	helixError: 'Could not connect to the selected analyzer. Refresh the page and try again. If the issue persists, contact the Help Desk.',
	businessUnitsSelectedCount: '{0} selected',
	allBusinessUnitsLabel: 'All business units'
};

export const importDataModalLabels = ({ title, description, buttonLabel }) => {
	return {
		title: title,
		description: description,
		entity: 'Entity',
		trialBalanceName: 'Trial balance name',
		reporting: 'Reporting',
		functional: 'Functional',
		analysisPeriod: 'Analysis date',
		comparativePeriod: 'Comparative date',
		secondComparativePeriod: 'Second comparative date (optional)',
		includeFinancialStatements: 'Include financial statements',
		carryForwardReferencesAndAdjustments: 'Carry forward references and adjustments to the new import?',
		import: buttonLabel,
		businessUnitSelectedCount: '{0} business unit',
		businessUnitsSelectedCount: '{0} business units',
		allBusinessUnitsLabel: 'All business units',
		businessUnitsPlaceholder: 'Business unit(s)',
		required: 'Required',
		comparativePeriodError: 'Invalid date. Select a date prior to the analysis date.',
		secondComparativePeriodError: 'Second comparative date greater or equal than comparative date.',
		equalComparativePeriodError: 'Dates cannot be the same.',
		analysisDateMustBeLaterError: 'Analysis date must be later than both comparative dates.'
	};
};

export const AnalyzerHelixErrors = {
	400: "The EY Helix project for the selected connection is no longer available. Contact an EY Helix administrator for more details. To permanently remove the connection, first remove all imports associated to the connection. Then, click 'Disconnect analyzer' in the more menu. Please consider if another analyzer should be connected.",
	403: "You are not an authorized team member of the connected analyzer. Contact the EY Helix project administrator to get access.",
	405: "Analytics are not available in the linked connection. Go to EY Helix and complete the data & analytics processing steps to continue.",
	406: "The EY Helix analyzer for the selected connection is no longer available. Contact an EY Helix administrator for more details. To permanently remove the connection, first remove all imports associated to the connection. Then, click 'Disconnect analyzer' in the more menu. Please consider if another analyzer should be connected.",
	408: "The EY Helix project for the selected connection is no longer available. Contact an EY Helix administrator for more details. To permanently remove the connection, first remove all imports associated to the connection. Then, click 'Disconnect analyzer' in the more menu. Please consider if another analyzer should be connected.",
	411: "The selected analyzer does not have all of the required parameters. Contact an EY Helix administrator for more details.",
	430: "The selected analyzer does not have all of the required parameters. Contact an EY Helix administrator for more details. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	800: "It looks like you have not accessed EY Helix before. Go to EY Helix, log in, and follow the instructions to set up your account.",
	801: "You are not an authorized team member of the linked project. Contact the EY Helix project administrator to get access.",
	901: "The EY Helix project for the selected connection is no longer available. Contact an EY Helix administrator for more details. To permanently delete the connection, click 'Delete' below in the more menu. Please consider if another analyzer should be connected.",
	902: "The EY Helix project for the selected connection is marked for deletion. Contact an EY Helix administrator for more details. To permanently delete the connection, click 'Delete' below in the more menu. Please consider if another analyzer should be connected.",
	903: "The EY Helix project for the selected connection is marked for storage. Contact an EY Helix administrator for more details. To permanently delete the connection, click 'Delete' below in the more menu. Please consider if another analyzer should be connected.",
	926: "The selected analyzer is not available in EY Helix. Refresh the page and try again. If the issue persists contact the Help Desk.",
	927: "Analytics are not available in the linked project. Go to EY Helix and complete the data & analytics processing steps to continue.",
	928: "Invalid or missing analyzer in EY Helix. Refresh the page and try again. If the issue persists contact the Help Desk.",
	929: "An error occurred related to the linked EY Helix project. Data cannot be imported.",
};

export const validationLabels = {
	viewAdjustmentWithValidations: 'View adjustments with validations {0}',
	validationTypeAmtMissmatch: 'Sum of the debit entries does not equal the sum of the credit entries',
	validationTypeNoEvidence: 'No related evidence',
};

export const canavsImportErrors = {
	400: "Import failed. The EY Helix project for the selected connection is no longer available. Contact an EY Helix administrator for more details. To permanently remove the connection, first remove all imports associated to the connection. Then, click 'Disconnect analyzer' in the more menu. Please consider if another analyzer should be connected.",
	403: "Import failed. You are not an authorized team member of the connected analyzer. Contact the EY Helix project administrator to get access then refresh the page and try again. If the issue persists, contact the Help Desk.",
	405: "Import failed. Analytics are not available in the linked connection. Go to EY Helix and complete the data & analytics processing steps to continue. Then refresh the page and try again. If the issue persists, contact the Help Desk.",
	406: "Import failed. The EY Helix analyzer for the selected connection is no longer available. Contact an EY Helix administrator for more details. To permanently remove the connection, first remove all imports associated to the connection. Then, click 'Disconnect analyzer' in the more menu. Please consider if another analyzer should be connected.",
	408: "Import failed. The EY Helix project for the selected connection is no longer available. Contact an EY Helix administrator for more details. To permanently remove the connection, first remove all imports associated to the connection. Then, click 'Disconnect analyzer' in the more menu. Please consider if another analyzer should be connected.",
	411: "Import failed. The selected analyzer does not have all of the required parameters. Contact an EY Helix administrator for more details and then refresh the page and try again. If the issue persists, contact the Help Desk.",
	430: "Import failed. The selected analyzer does not have all of the required parameters. Contact an EY Helix administrator for more details. Refresh the page and try again. If the issue persists, contact the Help Desk.",
	113082: "Analysis period must not be empty."
};
